webpackJsonp([0,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CATEGORIA_UNIDADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SITUACAO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TIPO_CONSULTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEXO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ESTADO_CIVIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TIPO_CERTIDAO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TIPO_ATENDIMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TIPO_AGRUPAMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COMPLEXIDADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TIPO_FINANCIAMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SITUACAO_SOLICITACAO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SITUACAO_SOLICITACAO_ANTIGA; });
/* unused harmony export FORM_ATENDIMENTOS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TIPO_UNIDADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TIPO_CONTRATO; });
var CATEGORIA_UNIDADE = {
    PUBLICA_LOCAL: 0,
    PACTUADA: 1,
    PRIVADA: 2
};
var SITUACAO = {
    INATIVA: 0,
    ATIVA: 1
};
var TIPO_CONSULTA = {
    PRIMEIRA: 0,
    RETORNO: 1,
    LOCAL: 2
};
var SEXO = {
    AMBOS: 0,
    MASCULINO: 1,
    FEMININO: 2
};
var ESTADO_CIVIL = {
    SOLTEIRO: 0,
    CASADO: 1,
    DESQUITADO: 2,
    DIVORCIADO: 3,
    VIUVO: 4
};
var TIPO_CERTIDAO = {
    NASCIMENTO: 0,
    CASAMENTO: 1,
    SEPARACAO: 2
};
var TIPO_ATENDIMENTO = {
    INDIVIDUAL: 0,
    AGRUPADO: 1
};
var TIPO_AGRUPAMENTO = {
    BIOQUIMICA: 0,
    OFTALMOLOGIA: 1
};
var COMPLEXIDADE = {
    BAIXA: 0,
    MEDIA: 1,
    ALTA: 2
};
var TIPO_FINANCIAMENTO = {
    ASSISTENCIA_FARMACEUTICA_E_MAC: 0,
    FAEC: 1,
    INCENTIVO: 2,
    MAC: 3,
    VIGILANCIA: 4,
    AB: 5,
    ASSISTENCIA_FARMACEUTICA: 6
};
var SITUACAO_SOLICITACAO = {
    MARCADA: 1,
    EM_REGULACAO: 2,
    REGULADA: 3,
    NEGATIVADA: 4,
    INFORMACAO_PENDENTE: 5,
    INFORMACAO_ADICIONAL: 6,
    CONFIRMADA: 7,
    CANCELADA: 8,
    FALTA: 9,
    REALIZADA: 10
};
var SITUACAO_SOLICITACAO_ANTIGA = {
    EM_ANALISE: 1,
    APROVADA: 2,
    CONFIRMADA: 3,
    NEGADA: 4,
    EM_PERICIA: 5,
    CANCELADA: 6,
    REALIZADA: 7,
    FALTA: 8,
    EM_SUPERVISAO: 9,
    SUPERVISIONADO: 10,
    EM_EXTRAPOLACAO: 11,
    TFD: 12,
    FALTA_AUTOMATICA: 18
};
var FORM_ATENDIMENTOS = {
    CRIAR: 0,
    BLOQUEAR: 1
};
var TIPO_UNIDADE = {
    UNIDADE_BASICA: 1,
    HOSPITAL: 2
};
var TIPO_CONTRATO = {
    SOLICITANTE: 0,
    PRESTADOR: 1
};

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(862),
  /* scopeId */
  "data-v-681ae087",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(609)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(890),
  /* scopeId */
  "data-v-a477c28c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(846),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(618)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(900),
  /* scopeId */
  "data-v-fa43fe0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(619)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(901),
  /* scopeId */
  "data-v-fe8cf61e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(859),
  /* scopeId */
  "data-v-65bc884e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(803),
  /* scopeId */
  "data-v-14c239bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(605)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(886),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(827),
  /* scopeId */
  "data-v-361ad087",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(592)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(873),
  /* scopeId */
  "data-v-7935aac0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(852),
  /* scopeId */
  "data-v-5a84bf88",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(615)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(897),
  /* scopeId */
  "data-v-d99a2d60",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(590)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(871),
  /* scopeId */
  "data-v-788a43d9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(594)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(875),
  /* scopeId */
  "data-v-7ad2629d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(556)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(836),
  /* scopeId */
  "data-v-45359e27",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(824),
  /* scopeId */
  "data-v-31a72bce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(785),
  /* scopeId */
  "data-v-02a21447",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(802),
  /* scopeId */
  "data-v-13e18030",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(580)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(861),
  /* scopeId */
  "data-v-668ce344",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */,
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);




__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale("pt-br");

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("tipoAtendimento", function (value) {
    switch (value) {
        case __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* TIPO_ATENDIMENTO */].INDIVIDUAL:
            return 'Individual';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* TIPO_ATENDIMENTO */].AGRUPADO:
            return 'Agrupado';
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("tipoConsulta", function (value) {
    switch (value) {
        case __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* TIPO_CONSULTA */].PRIMEIRA:
            return '1º';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* TIPO_CONSULTA */].RETORNO:
            return 'R';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* TIPO_CONSULTA */].LOCAL:
            return 'L';
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('codigoNomeProcedimento', function (value) {
    return value.codigo + " - " + value.nome;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('diasDaData', function (value) {
    var dias = Math.round((Date.now() - __WEBPACK_IMPORTED_MODULE_0_moment___default()(value)) / (1000 * 60 * 60 * 24));
    switch (dias) {
        case 0:
            return "Hoje";
        case 1:
            return dias + " dia";
        default:
            return dias + " dias";
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('horaFormatada', function (value) {
    return value.substr(0, 5);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("dataFormatada", function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format("L");
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("diaDaSemana", function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format("dddd");
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("mesPorExtenso", function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format("MMMM");
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("formatarCodigo", function (value) {
    if (value) {
        return value.toString().padStart(10, '0');
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("dataHoraFormatada", function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format("lll");
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("dataFormatadaHora", function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format("L LT");
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("dataFormatadaHoraCompleta", function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format("L LTS");
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("uppercase", function (value) {
    if (value) {
        return value.toUpperCase();
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("dinheiro", function (value) {
    if (value) {
        return "R$ " + value;
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("inteiro", function (value) {
    var valor = "";
    if (value != null) {
        valor = parseInt(value);
    }
    return valor;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("tipoContrato", function (value) {
    if (value == 0) {
        return 'Solicitante';
    } else if (value == 1) {
        return 'Prestador';
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("tipoAtendimento", function (value) {
    if (value == 0) {
        return 'Individual';
    } else if (value == 1) {
        return 'Agrupado';
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("sexo", function (value) {
    if (value == 0) {
        return 'Ambos';
    } else if (value == 1) {
        return 'Masculino';
    } else if (value == 2) {
        return 'Feminino';
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("tipoAgrupamento", function (value) {
    switch (value) {
        case 0:
            return 'BIOQUÍMICA';
        case 1:
            return 'OFTALMOLOGIA';
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("categoriaUnidade", function (value) {
    switch (value) {
        case __WEBPACK_IMPORTED_MODULE_2__constants__["n" /* CATEGORIA_UNIDADE */].PUBLICA_LOCAL:
            return 'Pública (Local)';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["n" /* CATEGORIA_UNIDADE */].PACTUADA:
            return 'Município Pactuado';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["n" /* CATEGORIA_UNIDADE */].PRIVADA:
            return 'Privada';
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("situacaoSolicitacao", function (value) {
    switch (value) {
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].MARCADA:
            return "Marcada";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].EM_REGULACAO:
            return "Em regulação";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].REGULADA:
            return "Regulada";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_PENDENTE:
            return "Informação pendente";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_ADICIONAL:
            return "Informação adicional";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].CONFIRMADA:
            return "Confirmada";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].CANCELADA:
            return "Cancelada";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].FALTA:
            return "Falta";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].REALIZADA:
            return "Realizada";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].NEGATIVADA:
            return "Negativada";
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("situacaoSolicitacaoAntiga", function (value) {
    switch (value) {
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].EM_ANALISE:
            return 'EM ANALISE';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].APROVADA:
            return 'APROVADA';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].CONFIRMADA:
            return 'CONFIRMADA';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].NEGADA:
            return 'NEGADA';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].EM_PERICIA:
            return 'EM PERÍCIA';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].CANCELADA:
            return 'CANCELADA';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].REALIZADA:
            return 'REALIZADA';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].FALTA:
            return 'FALTA';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].EM_SUPERVISAO:
            return 'EM SUPERVISÃO';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].SUPERVISIONADO:
            return 'SUPERVISIONADO';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].EM_EXTRAPOLACAO:
            return 'EM EXTRAPOLACAO';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].TFD:
            return 'TFD';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].FALTA_AUTOMATICA:
            return 'FALTA AUTOMÁTICA';
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("situacaoSolicitacaoAntigaColor", function (value) {
    switch (value) {
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].EM_ANALISE:
            return 'em_analise';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].APROVADA:
            return 'aprovada';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].CONFIRMADA:
            return 'confirmada';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].NEGADA:
            return 'negada';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].EM_PERICIA:
            return 'em_pericia';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].CANCELADA:
            return 'cancelada';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].REALIZADA:
            return 'realizada';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].FALTA:
            return 'falta';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].EM_SUPERVISAO:
            return 'em_supervisao';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].SUPERVISIONADO:
            return 'supervisionado';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].EM_EXTRAPOLACAO:
            return 'em_extrapolacao';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].TFD:
            return 'tfd';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */].FALTA_AUTOMATICA:
            return 'falta_automatica';}
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("situacaoSolicitacaoColor", function (value) {
    switch (value) {
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].MARCADA:
            return "marcada";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].EM_REGULACAO:
            return "regulacao";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].REGULADA:
            return "regulada";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_PENDENTE:
            return "pendente";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_ADICIONAL:
            return "adicional";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].CONFIRMADA:
            return "confirmada";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].CANCELADA:
            return "cancelada";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].FALTA:
            return "falta";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].REALIZADA:
            return "realizada";
        case __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SITUACAO_SOLICITACAO */].NEGATIVADA:
            return "negativada";
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("situacao", function (value) {
    switch (value) {
        case __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SITUACAO */].INATIVA:
            return 'Inativo (a)';
        case __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SITUACAO */].ATIVA:
            return 'Ativo (a)';
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("competencia", function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format("MM/YYYY");
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("idade", function (value) {
    if (value) {
        var hoje = new Date();
        var nascimento = new Date(value);
        var diferencaAnos = hoje.getFullYear() - nascimento.getFullYear();
        if (new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) < new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())) {
            diferencaAnos--;
        }

        return diferencaAnos > 1 ? diferencaAnos + " anos" : diferencaAnos + " ano";
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("numberFormat", function (number, decimals, decPoint, thousandsSep) {
    if (!number && number != 0) {
        return '';
    }
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number;
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
    var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
    var s = '';
    var toFixedFix = function toFixedFix(n, prec) {
        var k = Math.pow(10, prec);
        return '' + Math.round(n * k) / k;
    };

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return 'R$ ' + s.join(dec);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("intervaloIdade", function (idadesArray) {
    var idadeMinima = idadesArray[0];
    var idadeMaxima = idadesArray[1];
    if (idadeMinima === null && idadeMaxima === null) {
        return '-';
    } else if (idadeMinima !== null && idadeMaxima === null) {
        return '> ' + idadeMinima + ' anos';
    } else if (idadeMinima === null && idadeMaxima !== null) {
        return '< ' + idadeMaxima + ' anos';
    } else {
        return idadeMinima + ' a ' + idadeMaxima + ' anos';
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("intervaloHoras", function (horasArray) {
    var horaInicial = horasArray[0];
    var horaFinal = horasArray[1];
    return horaInicial.substr(0, 5) + ' às ' + horaFinal.substr(0, 5);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("quantidadeAtendimentos", function (quantidadeArray) {
    var quantidadeOriginal = quantidadeArray[0];
    var quantidadeDisponivel = quantidadeArray[1];
    return quantidadeOriginal + " | " + quantidadeDisponivel;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("zero", function (value) {
    if (!value) {
        return '0';
    } else {
        return value;
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("dia", function (value) {
    switch (value) {
        case 0:
            return 'Domingo';
        case 1:
            return 'Segunda-feira';
        case 2:
            return 'Terça-feira';
        case 3:
            return 'Quarta-feira';
        case 4:
            return 'Quinta-feira';
        case 5:
            return 'Sexta-feira';
        case 6:
            return 'Sábado';
    }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony export (immutable) */ __webpack_exports__["a"] = setup;



var isAlreadyFetchingAccessToken = false;
var subscribers = [];

function onAccessTokenFetched(token) {
	subscribers = subscribers.filter(function (callback) {
		return callback(token);
	});
}

function addSubscriber(callback) {
	subscribers.push(callback);
}

function setup(vm) {
	__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
		return config;
	}, function (err) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
	});
	__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
		return response;
	}, function (error) {
		var config = error.config,
		    _error$response = error.response,
		    status = _error$response.status,
		    data = _error$response.data;

		var originalRequest = config;
		if (status === 401 && vm.$store.state.user != null) {
			console.log(error);
			if (!isAlreadyFetchingAccessToken) {
				isAlreadyFetchingAccessToken = true;
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(vm.$store.state.serverURI + '/api/login/refresh', null, vm.$store.getters.getHeader).then(function (response) {
					var token = response.data.access_token;
					vm.$store.commit('SET_TOKEN', token);
					if (window.localStorage) {
						localStorage.setItem('token', token);
					}
					isAlreadyFetchingAccessToken = false;
					onAccessTokenFetched(token);
				});
			} else {
				if (data.message.includes('refresh_token')) {
					console.log('Not authenticated');
					isAlreadyFetchingAccessToken = false;
					localStorage.setItem('route', error.path);
					vm.logout();
					return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
				}
				if (data.message.includes('fora do horário')) {
					console.log('Fora do horário');
					vm.logout();
					return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
				}
			}
			var retryOriginalRequest = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
				addSubscriber(function (token) {
					originalRequest.headers.Authorization = 'Bearer ' + token;
					resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(originalRequest));
				});
			});
			return retryOriginalRequest;
		}
		if (error.response.data instanceof Blob) {
			var erro = error.response.data;
			var blob = new Blob([erro], { type: 'application/json' });
			var reader = new FileReader();
			reader.addEventListener("loadend", function () {
				erro = JSON.parse(reader.result);
				vm.$store.commit('SET_ALERT_MESSAGE', erro.mensagem);
				vm.$store.commit('SET_ALERT_DETAIL', erro.erros);
				vm.$store.commit('SHOW_ALERT_ERROR');
			});
			reader.readAsText(blob);
		} else {
			vm.$store.commit('SET_ALERT_MESSAGE', error.response.data.mensagem);
			vm.$store.commit('SET_ALERT_DETAIL', error.response.data.erros);
			vm.$store.commit('SHOW_ALERT_ERROR');
		}
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
	});
}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);






var AppPlugin = {};

AppPlugin.install = function (Vue, options) {
	Vue.prototype.hasPermission = function hasPermission(parametros) {
		var permissoes = [];
		permissoes = permissoes.concat(parametros);
		var teste = false;
		var self = this;
		permissoes.forEach(function (element) {
			teste = teste || self.$acl.get.indexOf(element) > -1;
		});
		return teste;
	};

	Vue.prototype.setUsuarioAtual = function setUsuarioAtual(userCurrent) {
		this.$store.commit('SET_USER', userCurrent);
		if (window.localStorage) {
			window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(userCurrent));
		}
		this.$acl.change(['public'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(userCurrent.permissoes)));
	};

	Vue.prototype.logout = function logout() {
		this.$store.commit('SET_USER', null);
		this.$store.commit('SET_TOKEN', null);

		if (window.localStorage) {
			window.localStorage.removeItem('user');
			window.localStorage.removeItem('token');
		}

		this.$router.push('/login');
	};

	Vue.prototype.nivelNumber = function nivelNumber(nivel) {
		var niveis = ['usuario', 'gerente', 'administrador'];
		return niveis.indexOf(nivel);
	};

	Vue.prototype.nivelCompare = function nivelCompare(nivel1, operador, nivel2) {
		var foo = window;

		nivel1 = this.nivelNumber(nivel1);
		nivel2 = this.nivelNumber(nivel2);
		var operadores = ['==', '!=', '>=', '<=', '>', '<'];
		var aux = null;
		if (operadores.indexOf(operador) > -1) {
			aux = foo.eval(nivel1 + ' ' + operador + ' ' + nivel2);
		}
		return aux;
	};

	Vue.prototype.formatDates = function formatDates(dateOne, dateTwo, ope) {
		var formattedDates = '';
		if (dateOne) {
			formattedDates = __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateOne).format("DD/MM/YYYY");
		}
		if (dateTwo && ope == '><') {
			formattedDates += ' a ' + __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateTwo).format("DD/MM/YYYY");
		}
		return formattedDates;
	};

	Vue.prototype.mergeRecursivo = function mergeRecursivo(target) {
		for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			sources[_key - 1] = arguments[_key];
		}

		if (!sources.length) return target;
		var source = sources.shift();

		if (this.isObject(target) && this.isObject(source)) {
			for (var key in source) {
				if (this.isObject(source[key])) {
					if (!target[key]) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(target, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, {}));
					this.mergeRecursivo(target[key], source[key]);
				} else {
					__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(target, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, source[key]));
				}
			}
		}

		return this.mergeRecursivo.apply(this, [target].concat(sources));
	};

	Vue.prototype.isObject = function isObject(item) {
		return item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' && !Array.isArray(item);
	};
};

/* harmony default export */ __webpack_exports__["a"] = AppPlugin;

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_acl__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_acl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_acl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dash_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_vue__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dashboard_Dashboard_vue__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dashboard_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dashboard_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_administracao_contratos___ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_administracao_contratos____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_administracao_contratos___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_administracao_contratos_form__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_administracao_contratos_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_administracao_contratos_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_administracao_contratos_contratoProcedimento__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_administracao_contratos_contratoProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_administracao_contratos_contratoProcedimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_administracao_contratos_contratoProcedimentoForm__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_administracao_contratos_contratoProcedimentoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_administracao_contratos_contratoProcedimentoForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_administracao_contratos_contratoSubgrupo__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_administracao_contratos_contratoSubgrupo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_administracao_contratos_contratoSubgrupo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_administracao_contratos_contratoSubgrupoForm__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_administracao_contratos_contratoSubgrupoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_administracao_contratos_contratoSubgrupoForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_administracao_agendas___ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_administracao_agendas____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_administracao_agendas___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_administracao_agendas_agendasProcedimentos__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_administracao_agendas_agendasProcedimentos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_administracao_agendas_agendasProcedimentos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_administracao_agendas_agendasSubgrupos__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_administracao_agendas_agendasSubgrupos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_administracao_agendas_agendasSubgrupos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_administracao_agendas_novaAgendaProcedimentos__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_administracao_agendas_novaAgendaProcedimentos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_administracao_agendas_novaAgendaProcedimentos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_administracao_agendas_novaAgendaSubgrupos__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_administracao_agendas_novaAgendaSubgrupos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_administracao_agendas_novaAgendaSubgrupos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_distribuicoes_index__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_distribuicoes_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_distribuicoes_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_distribuicoes_atendimentos_index__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_distribuicoes_atendimentos_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_distribuicoes_atendimentos_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_distribuicoes_atendimentos_agendasProcedimentos__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_distribuicoes_atendimentos_agendasProcedimentos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_distribuicoes_atendimentos_agendasProcedimentos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_distribuicoes_atendimentos_agendasSubgrupos__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_distribuicoes_atendimentos_agendasSubgrupos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_distribuicoes_atendimentos_agendasSubgrupos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_distribuicoes_atendimentos_form__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_distribuicoes_atendimentos_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_distribuicoes_atendimentos_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_distribuicoes_contratos___ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_distribuicoes_contratos____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_distribuicoes_contratos___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_distribuicoes_contratos_form__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_distribuicoes_contratos_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_distribuicoes_contratos_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_distribuicoes_contratos_contratoProcedimento__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_distribuicoes_contratos_contratoProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_distribuicoes_contratos_contratoProcedimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_distribuicoes_contratos_contratoProcedimentoForm__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_distribuicoes_contratos_contratoProcedimentoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_distribuicoes_contratos_contratoProcedimentoForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_distribuicoes_contratos_contratoSubgrupo__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_distribuicoes_contratos_contratoSubgrupo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_distribuicoes_contratos_contratoSubgrupo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_distribuicoes_contratos_contratoSubgrupoForm__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_distribuicoes_contratos_contratoSubgrupoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_distribuicoes_contratos_contratoSubgrupoForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_administracao_parametros___ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_administracao_parametros____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_administracao_parametros___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_administracao_comunicados__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_administracao_comunicados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_administracao_comunicados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_administracao_comunicados_form__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_administracao_comunicados_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_administracao_comunicados_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_administracao_relatorios_solicitacoes___ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_administracao_relatorios_solicitacoes____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_administracao_relatorios_solicitacoes___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_administracao_relatorios_escalas___ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_administracao_relatorios_escalas____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_administracao_relatorios_escalas___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_administracao_relatorios_ofertas___ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_administracao_relatorios_ofertas____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_administracao_relatorios_ofertas___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_administracao_relatorios_ofertas_anual___ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_administracao_relatorios_ofertas_anual____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_administracao_relatorios_ofertas_anual___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_administracao_relatorios_ofertas_subgrupo_anual___ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_administracao_relatorios_ofertas_subgrupo_anual____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_administracao_relatorios_ofertas_subgrupo_anual___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_administracao_relatorios_usuarios___ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_administracao_relatorios_usuarios____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_administracao_relatorios_usuarios___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_administracao_relatorios_agenda_prestador___ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_administracao_relatorios_agenda_prestador____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_administracao_relatorios_agenda_prestador___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_administracao_relatorios_consumo_limites___ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_administracao_relatorios_consumo_limites____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_administracao_relatorios_consumo_limites___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_administracao_relatorios_solicitacoes_sintetico___ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_administracao_relatorios_solicitacoes_sintetico____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_administracao_relatorios_solicitacoes_sintetico___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_atendimentos_solicitacao___ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_atendimentos_solicitacao____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_atendimentos_solicitacao___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_atendimentos_solicitacao_resolucao__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_atendimentos_solicitacao_resolucao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_atendimentos_solicitacao_resolucao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_atendimentos_comuns_impressaoBoleto__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_atendimentos_comuns_impressaoBoleto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_atendimentos_comuns_impressaoBoleto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_atendimentos_verificacao___ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_atendimentos_verificacao____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_atendimentos_verificacao___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_atendimentos_regulacao___ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_atendimentos_regulacao____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_atendimentos_regulacao___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_atendimentos_regulacao_solicitacao__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_atendimentos_regulacao_solicitacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_atendimentos_regulacao_solicitacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_atendimentos_faltas___ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_atendimentos_faltas____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_atendimentos_faltas___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_cadastros_pacientes___ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_cadastros_pacientes____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_cadastros_pacientes___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_cadastros_pacientes_form__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_cadastros_pacientes_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_cadastros_pacientes_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_cadastros_pacientes_historico__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_cadastros_pacientes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_cadastros_pacientes_historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_cadastros_profissionais___ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_cadastros_profissionais____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_cadastros_profissionais___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_cadastros_profissionais_form__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_cadastros_profissionais_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_cadastros_profissionais_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_cadastros_unidades___ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_cadastros_unidades____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_cadastros_unidades___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_cadastros_unidades_form__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_cadastros_unidades_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_cadastros_unidades_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_cadastros_procedimentos_grupos__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_cadastros_procedimentos_grupos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_cadastros_procedimentos_grupos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_cadastros_procedimentos_grupos_form__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_cadastros_procedimentos_grupos_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_cadastros_procedimentos_grupos_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_cadastros_procedimentos_subgrupos__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_cadastros_procedimentos_subgrupos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_cadastros_procedimentos_subgrupos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_cadastros_procedimentos_subgrupos_form__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_cadastros_procedimentos_subgrupos_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_cadastros_procedimentos_subgrupos_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_cadastros_procedimentos_formas_organizacao___ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_cadastros_procedimentos_formas_organizacao____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_cadastros_procedimentos_formas_organizacao___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_cadastros_procedimentos_formas_organizacao_form__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_cadastros_procedimentos_formas_organizacao_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_cadastros_procedimentos_formas_organizacao_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_cadastros_procedimentos___ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_cadastros_procedimentos____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_cadastros_procedimentos___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_cadastros_procedimentos_form__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_cadastros_procedimentos_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_cadastros_procedimentos_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_cadastros_usuarios__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_cadastros_usuarios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_cadastros_usuarios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_cadastros_usuarios_Form__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_cadastros_usuarios_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_cadastros_usuarios_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_cadastros_usuarios_alterarSenha__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_cadastros_usuarios_alterarSenha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_cadastros_usuarios_alterarSenha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_integracao_pacientes___ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_integracao_pacientes____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_integracao_pacientes___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_integracao_pacientes_historico__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_integracao_pacientes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_integracao_pacientes_historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_integracao_pacientes_form__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_integracao_pacientes_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_integracao_pacientes_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_cadastros_preparos___ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_cadastros_preparos____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_cadastros_preparos___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_cadastros_preparos_form__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_cadastros_preparos_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_cadastros_preparos_form__);





























































































var routes = [{
	path: "/login",
	component: __WEBPACK_IMPORTED_MODULE_2__components_Login_vue___default.a,
	meta: {
		rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("public").generate()
	}
}, {
	path: "/boleto/:solicitacaoId",
	component: __WEBPACK_IMPORTED_MODULE_41__components_atendimentos_comuns_impressaoBoleto___default.a,
	meta: {
		rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("public").generate()
	}
}, {
	path: "/",
	component: __WEBPACK_IMPORTED_MODULE_1__components_Dash_vue___default.a,
	meta: {
		requiresAuth: true,
		rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]('usuario.basico').generate()
	},
	children: [{
		path: "dashboard",
		alias: "",
		component: __WEBPACK_IMPORTED_MODULE_4__components_dashboard_Dashboard_vue___default.a,
		name: "CMC1",
		meta: {
			description: "Início",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]('usuario.basico').generate()
		}
	}, {
		path: "administracao/contratos",
		component: __WEBPACK_IMPORTED_MODULE_5__components_administracao_contratos____default.a,
		name: "CMC2",
		meta: {
			description: "Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.read").generate()
		}
	}, {
		path: "administracao/contratos/novo",
		component: __WEBPACK_IMPORTED_MODULE_6__components_administracao_contratos_form___default.a,
		name: "CMC3",
		meta: {
			description: "Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.write").generate()
		}
	}, {
		path: "administracao/contratos/atualizacao/:contrato_id",
		component: __WEBPACK_IMPORTED_MODULE_6__components_administracao_contratos_form___default.a,
		name: "CMC4",
		meta: {
			description: "Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.write").generate()
		}
	}, {
		path: "administracao/contratos/procedimentos/:contrato_id",
		component: __WEBPACK_IMPORTED_MODULE_7__components_administracao_contratos_contratoProcedimento___default.a,
		name: "CMC5",
		meta: {
			description: "Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.read").generate()
		}
	}, {
		path: "administracao/contratos/procedimentos/novo/:contrato_id",
		component: __WEBPACK_IMPORTED_MODULE_8__components_administracao_contratos_contratoProcedimentoForm___default.a,
		name: "CMC6",
		meta: {
			description: "Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.write").generate()
		}
	}, {
		path: "administracao/contratos/procedimentos/atualizacao/:contrato_procedimento_id",
		component: __WEBPACK_IMPORTED_MODULE_8__components_administracao_contratos_contratoProcedimentoForm___default.a,
		name: "CMC7",
		meta: {
			description: "Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.write").generate()
		}
	}, {
		path: "administracao/contratos/subgrupos/:contrato_id",
		component: __WEBPACK_IMPORTED_MODULE_9__components_administracao_contratos_contratoSubgrupo___default.a,
		name: "CMC8",
		meta: {
			description: "Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.read").generate()
		}
	}, {
		path: "administracao/contratos/subgrupos/novo/:contrato_id",
		component: __WEBPACK_IMPORTED_MODULE_10__components_administracao_contratos_contratoSubgrupoForm___default.a,
		name: "CMC9",
		meta: {
			description: "Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.write").generate()
		}
	}, {
		path: "administracao/contratos/subgrupos/atualizacao/:contrato_subgrupo_id",
		component: __WEBPACK_IMPORTED_MODULE_10__components_administracao_contratos_contratoSubgrupoForm___default.a,
		name: "CMC10",
		meta: {
			description: "Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.write").generate()
		}
	}, {
		path: "administracao/agendas",
		component: __WEBPACK_IMPORTED_MODULE_11__components_administracao_agendas____default.a,
		name: "CMC11",
		meta: {
			description: "Agendas",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("agenda.read").generate()
		}
	}, {
		path: "administracao/agendas/visualizar-procedimentos/:contratoId",
		component: __WEBPACK_IMPORTED_MODULE_12__components_administracao_agendas_agendasProcedimentos___default.a,
		name: "CMC12",
		meta: {
			description: "Agendas",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("agenda.read").generate()
		}
	}, {
		path: "administracao/agendas/visualizar-subgrupos/:contratoId",
		component: __WEBPACK_IMPORTED_MODULE_13__components_administracao_agendas_agendasSubgrupos___default.a,
		name: "CMC13",
		meta: {
			description: "Agendas",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("agenda.read").generate()
		}
	}, {
		path: "administracao/agendas/novo-procedimento/:contratoId",
		component: __WEBPACK_IMPORTED_MODULE_14__components_administracao_agendas_novaAgendaProcedimentos___default.a,
		name: "CMC14",
		meta: {
			description: "Agendas",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("agenda.write").generate()
		}
	}, {
		path: "administracao/agendas/novo-subgrupo/:contratoId",
		component: __WEBPACK_IMPORTED_MODULE_15__components_administracao_agendas_novaAgendaSubgrupos___default.a,
		name: "CMC15",
		meta: {
			description: "Agendas",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("agenda.write").generate()
		}
	}, {
		path: "administracao/parametros",
		component: __WEBPACK_IMPORTED_MODULE_27__components_administracao_parametros____default.a,
		name: "CMC16",
		meta: {
			description: "Parâmetros Gerais",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.write").generate()
		}
	}, {
		path: "administracao/comunicados",
		component: __WEBPACK_IMPORTED_MODULE_28__components_administracao_comunicados___default.a,
		name: "CMC20231",
		meta: {
			description: "Comunicados",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.write").generate()
		}
	}, {
		path: "administracao/comunicados/novo",
		component: __WEBPACK_IMPORTED_MODULE_29__components_administracao_comunicados_form___default.a,
		name: "CMC20232",
		meta: {
			description: "Comunicados",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.write").generate()
		}
	}, {
		path: "administracao/comunicados/atualizacao/:comunicado_id",
		component: __WEBPACK_IMPORTED_MODULE_29__components_administracao_comunicados_form___default.a,
		name: "CMC20233",
		meta: {
			description: "Comunicados",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("contrato.write").generate()
		}
	}, {
		path: "distribuicao/distribuir",
		component: __WEBPACK_IMPORTED_MODULE_16__components_distribuicoes_index___default.a,
		name: "CMC17",
		meta: {
			description: "Distribuições",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.read").generate()
		}
	}, {
		path: "distribuicao/controle-contratos",
		component: __WEBPACK_IMPORTED_MODULE_21__components_distribuicoes_contratos____default.a,
		name: "CMC18",
		meta: {
			description: "Controle de Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.contrato.read").generate()
		}
	}, {
		path: "distribuicoes/contratos/novo",
		component: __WEBPACK_IMPORTED_MODULE_22__components_distribuicoes_contratos_form___default.a,
		name: "CMC19",
		meta: {
			description: "Controle de Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.contrato.write").generate()
		}
	}, {
		path: "distribuicoes/contratos/atualizacao/:contrato_id",
		component: __WEBPACK_IMPORTED_MODULE_22__components_distribuicoes_contratos_form___default.a,
		name: "CMC20",
		meta: {
			description: "Controle de Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.contrato.write").generate()
		}
	}, {
		path: "distribuicoes/contratos/procedimentos/:contrato_id",
		component: __WEBPACK_IMPORTED_MODULE_23__components_distribuicoes_contratos_contratoProcedimento___default.a,
		name: "CMC21",
		meta: {
			description: "Controle de Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.contrato.write").generate()
		}
	}, {
		path: "distribuicoes/contratos/procedimentos/novo/:contrato_id",
		component: __WEBPACK_IMPORTED_MODULE_24__components_distribuicoes_contratos_contratoProcedimentoForm___default.a,
		name: "CMC22",
		meta: {
			description: "Controle de Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.contrato.write").generate()
		}
	}, {
		path: "distribuicoes/contratos/procedimentos/atualizacao/:contrato_procedimento_id",
		component: __WEBPACK_IMPORTED_MODULE_24__components_distribuicoes_contratos_contratoProcedimentoForm___default.a,
		name: "CMC23",
		meta: {
			description: "Controle de Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.contrato.write").generate()
		}
	}, {
		path: "distribuicoes/contratos/subgrupos/:contrato_id",
		component: __WEBPACK_IMPORTED_MODULE_25__components_distribuicoes_contratos_contratoSubgrupo___default.a,
		name: "CMC24",
		meta: {
			description: "Controle de Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.contrato.write").generate()
		}
	}, {
		path: "distribuicoes/contratos/subgrupos/novo/:contrato_id",
		component: __WEBPACK_IMPORTED_MODULE_26__components_distribuicoes_contratos_contratoSubgrupoForm___default.a,
		name: "CMC25",
		meta: {
			description: "Controle de Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.contrato.write").and('usuario.read').generate()
		}
	}, {
		path: "distribuicoes/contratos/subgrupos/atualizacao/:contrato_subgrupo_id",
		component: __WEBPACK_IMPORTED_MODULE_26__components_distribuicoes_contratos_contratoSubgrupoForm___default.a,
		name: "CMC26",
		meta: {
			description: "Controle de Contratos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.contrato.write").and('usuario.read').generate()
		}
	}, {
		path: "distribuicao/controle-atendimentos",
		component: __WEBPACK_IMPORTED_MODULE_17__components_distribuicoes_atendimentos_index___default.a,
		name: "CMC27",
		meta: {
			description: "Controle da Agenda",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.agenda.read").and('usuario.read').generate()
		}
	}, {
		path: "distribuicao/controle-atendimentos/visualizar-procedimentos/:distribuicaoContratoId",
		component: __WEBPACK_IMPORTED_MODULE_18__components_distribuicoes_atendimentos_agendasProcedimentos___default.a,
		name: "CMC28",
		meta: {
			description: "Controle da Agenda",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.agenda.write").and('usuario.read').generate()
		}
	}, {
		path: "distribuicao/controle-atendimentos/criar-atendimentos/:id",
		component: __WEBPACK_IMPORTED_MODULE_20__components_distribuicoes_atendimentos_form___default.a,
		name: "CMC29",
		meta: {
			description: "Controle da Agenda",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.agenda.write").and('usuario.read').generate(),
			titulo: "Criar",
			acao: "criar"
		}
	}, {
		path: "distribuicao/controle-atendimentos/visualizar-subgrupos/:distribuicaoContratoId",
		component: __WEBPACK_IMPORTED_MODULE_19__components_distribuicoes_atendimentos_agendasSubgrupos___default.a,
		name: "CMC30",
		meta: {
			description: "Controle da Agenda",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("distribuicao.agenda.write").and('usuario.read').generate()
		}
	}, {
		path: "administracao/relatorios/solicitacoes",
		component: __WEBPACK_IMPORTED_MODULE_30__components_administracao_relatorios_solicitacoes____default.a,
		name: "CMC31",
		meta: {
			description: "Relatórios",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("relatorio.solicitacao").generate()
		}
	}, {
		path: "administracao/relatorios/solicitacoes-sintetico",
		component: __WEBPACK_IMPORTED_MODULE_38__components_administracao_relatorios_solicitacoes_sintetico____default.a,
		name: "CMC74",
		meta: {
			description: "Relatórios",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("relatorio.solicitacao").generate()
		}
	}, {
		path: "administracao/relatorios/escalas",
		component: __WEBPACK_IMPORTED_MODULE_31__components_administracao_relatorios_escalas____default.a,
		name: "CMC32",
		meta: {
			description: "Relatórios",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("relatorio.escalas").generate()
		}
	}, {
		path: "administracao/relatorios/ofertas",
		component: __WEBPACK_IMPORTED_MODULE_32__components_administracao_relatorios_ofertas____default.a,
		name: "CMC33",
		meta: {
			description: "Relatórios",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("relatorio.ofertas").generate()
		}
	}, {
		path: "administracao/relatorios/ofertas-anual",
		component: __WEBPACK_IMPORTED_MODULE_33__components_administracao_relatorios_ofertas_anual____default.a,
		name: "CMC100",
		meta: {
			description: "Relatórios",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("relatorio.ofertas").generate()
		}
	}, {
		path: "administracao/relatorios/ofertas-subgrupos-anual",
		component: __WEBPACK_IMPORTED_MODULE_34__components_administracao_relatorios_ofertas_subgrupo_anual____default.a,
		name: "CMC101",
		meta: {
			description: "Relatórios",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("relatorio.ofertas").generate()
		}
	}, {
		path: "administracao/relatorios/usuarios",
		component: __WEBPACK_IMPORTED_MODULE_35__components_administracao_relatorios_usuarios____default.a,
		name: "CMC34",
		meta: {
			description: "Relatórios",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("relatorio.usuarios").generate()
		}
	}, {
		path: "administracao/relatorios/agenda-prestador",
		component: __WEBPACK_IMPORTED_MODULE_36__components_administracao_relatorios_agenda_prestador____default.a,
		name: "CMC35",
		meta: {
			description: "Relatórios",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("relatorio.agenda.prestador").generate()
		}
	}, {
		path: "administracao/relatorios/consumo-limites",
		component: __WEBPACK_IMPORTED_MODULE_37__components_administracao_relatorios_consumo_limites____default.a,
		name: "CMC31",
		meta: {
			description: "Relatórios",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("relatorio.solicitacao").generate()
		}
	}, {
		path: "atendimentos/solicitacao",
		component: __WEBPACK_IMPORTED_MODULE_39__components_atendimentos_solicitacao____default.a,
		name: "CMC36",
		meta: {
			description: "Solicitação de Atendimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("solicitacao.create").generate()
		}
	}, {
		path: "atendimentos/solicitacao/resolucao/:solicitacaoId?",
		component: __WEBPACK_IMPORTED_MODULE_40__components_atendimentos_solicitacao_resolucao___default.a,
		name: "CMC37",
		meta: {
			description: "Solicitação de Atendimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("solicitacao.create").or('solicitacao.regular').generate()
		}
	}, {
		path: "atendimentos/regulacao",
		component: __WEBPACK_IMPORTED_MODULE_43__components_atendimentos_regulacao____default.a,
		name: "CMC38",
		meta: {
			description: "Regulação de Atendimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("solicitacao.regular").generate()
		}
	}, {
		path: "atendimentos/regulacao/solicitacao/:solicitacaoId",
		component: __WEBPACK_IMPORTED_MODULE_44__components_atendimentos_regulacao_solicitacao___default.a,
		name: "CMC39",
		meta: {
			description: "Regulação de Atendimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("solicitacao.regular").generate()
		}
	}, {
		path: "atendimentos/verificacao",
		component: __WEBPACK_IMPORTED_MODULE_42__components_atendimentos_verificacao____default.a,
		name: "CMC40",
		meta: {
			description: "Regulação de Atendimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("solicitacao.read").generate()
		}
	}, {
		path: "atendimentos/atendido-falta",
		component: __WEBPACK_IMPORTED_MODULE_45__components_atendimentos_faltas____default.a,
		name: "CMC41",
		meta: {
			description: "Regulação de Atendimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("solicitacao.atendidoFalta").generate()
		}
	}, {
		path: "cadastros/pacientes",
		component: __WEBPACK_IMPORTED_MODULE_46__components_cadastros_pacientes____default.a,
		name: "CMC42",
		meta: {
			description: "Pacientes",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("paciente.read").generate()
		}
	}, {
		path: "cadastros/pacientes/novo",
		component: __WEBPACK_IMPORTED_MODULE_47__components_cadastros_pacientes_form___default.a,
		name: "CMC43",
		meta: {
			description: "Pacientes",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("paciente.write").generate()
		}
	}, {
		path: "/cadastros/pacientes/editar/:pacienteId",
		component: __WEBPACK_IMPORTED_MODULE_47__components_cadastros_pacientes_form___default.a,
		name: "CMC44",
		meta: {
			description: "Pacientes",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("paciente.write").generate()
		}
	}, {
		path: "/cadastros/pacientes/historico/:pacienteId",
		component: __WEBPACK_IMPORTED_MODULE_48__components_cadastros_pacientes_historico___default.a,
		name: "CMC45",
		meta: {
			description: "Pacientes",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("paciente.read").generate()
		}
	}, {
		path: "cadastros/profissionais",
		component: __WEBPACK_IMPORTED_MODULE_49__components_cadastros_profissionais____default.a,
		name: "CMC46",
		meta: {
			description: "Profissionais",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("profissional.read").generate()
		}
	}, {
		path: "cadastros/profissionais/novo",
		component: __WEBPACK_IMPORTED_MODULE_50__components_cadastros_profissionais_form___default.a,
		name: "CMC47",
		meta: {
			description: "Profissionais",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("profissional.write").generate()
		}
	}, {
		path: "cadastros/profissionais/editar/:profissionalId",
		component: __WEBPACK_IMPORTED_MODULE_50__components_cadastros_profissionais_form___default.a,
		name: "CMC48",
		meta: {
			description: "Profissionais",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("profissional.write").generate()
		}
	}, {
		path: "cadastros/unidades",
		component: __WEBPACK_IMPORTED_MODULE_51__components_cadastros_unidades____default.a,
		name: "CMC49",
		meta: {
			description: "Unidades",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("unidade.read").generate()
		}
	}, {
		path: "cadastros/unidades/novo",
		component: __WEBPACK_IMPORTED_MODULE_52__components_cadastros_unidades_form___default.a,
		name: "CMC50",
		meta: {
			description: "Unidades",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("unidade.write").generate()
		}
	}, {
		path: "cadastros/unidades/editar/:unidade_id",
		component: __WEBPACK_IMPORTED_MODULE_52__components_cadastros_unidades_form___default.a,
		name: "CMC51",
		meta: {
			description: "Unidades",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("unidade.write").generate()
		}
	}, {
		path: "cadastros/grupos-procedimento",
		component: __WEBPACK_IMPORTED_MODULE_53__components_cadastros_procedimentos_grupos___default.a,
		name: "CMC52",
		meta: {
			description: "Grupos de Procedimento",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("grupo.read").generate()
		}
	}, {
		path: "cadastros/grupos-procedimento/novo",
		component: __WEBPACK_IMPORTED_MODULE_54__components_cadastros_procedimentos_grupos_form___default.a,
		name: "CMC53",
		meta: {
			description: "Grupos de Procedimento",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("grupo.write").generate()
		}
	}, {
		path: "cadastros/grupos-procedimento/editar/:grupoId",
		component: __WEBPACK_IMPORTED_MODULE_54__components_cadastros_procedimentos_grupos_form___default.a,
		name: "CMC54",
		meta: {
			description: "Grupos de Procedimento",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("grupo.write").generate()
		}
	}, {
		path: "cadastros/subgrupos-procedimento",
		component: __WEBPACK_IMPORTED_MODULE_55__components_cadastros_procedimentos_subgrupos___default.a,
		name: "CMC55",
		meta: {
			description: "Subgrupos de Procedimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("subgrupo.read").generate()
		}
	}, {
		path: "cadastros/subgrupos-procedimento/novo",
		component: __WEBPACK_IMPORTED_MODULE_56__components_cadastros_procedimentos_subgrupos_form___default.a,
		name: "CMC56",
		meta: {
			description: "Subgrupos de Procedimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("subgrupo.write").generate()
		}
	}, {
		path: "cadastros/subgrupos-procedimento/editar/:subgrupoId",
		component: __WEBPACK_IMPORTED_MODULE_56__components_cadastros_procedimentos_subgrupos_form___default.a,
		name: "CMC57",
		meta: {
			description: "Subgrupos de Procedimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("subgrupo.write").generate()
		}
	}, {
		path: "cadastros/formas-organizacao-procedimento",
		component: __WEBPACK_IMPORTED_MODULE_57__components_cadastros_procedimentos_formas_organizacao____default.a,
		name: "CMC58",
		meta: {
			description: "Formas de Organização dos Procedimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("forma.organizacao.read").generate()
		}
	}, {
		path: "cadastros/formas-organizacao-procedimento/novo",
		component: __WEBPACK_IMPORTED_MODULE_58__components_cadastros_procedimentos_formas_organizacao_form___default.a,
		name: "CMC59",
		meta: {
			description: "Formas de Organização dos Procedimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("forma.organizacao.write").generate()
		}
	}, {
		path: "cadastros/formas-organizacao-procedimento/editar/:formaOrganizacaoId",
		component: __WEBPACK_IMPORTED_MODULE_58__components_cadastros_procedimentos_formas_organizacao_form___default.a,
		name: "CMC60",
		meta: {
			description: "Formas de Organização dos Procedimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("forma.organizacao.write").generate()
		}
	}, {
		path: "cadastros/procedimentos",
		component: __WEBPACK_IMPORTED_MODULE_59__components_cadastros_procedimentos____default.a,
		name: "CMC61",
		meta: {
			description: "Procedimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("procedimento.read").generate()
		}
	}, {
		path: "cadastros/procedimentos/novo",
		component: __WEBPACK_IMPORTED_MODULE_60__components_cadastros_procedimentos_form___default.a,
		name: "CMC62",
		meta: {
			description: "Procedimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("procedimento.write").generate()
		}
	}, {
		path: "cadastros/procedimentos/editar/:procedimentoId",
		component: __WEBPACK_IMPORTED_MODULE_60__components_cadastros_procedimentos_form___default.a,
		name: "CMC63",
		meta: {
			description: "Procedimentos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("procedimento.write").generate()
		}
	}, {
		path: "cadastros/usuarios",
		component: __WEBPACK_IMPORTED_MODULE_61__components_cadastros_usuarios___default.a,
		name: "CMC64",
		meta: {
			description: "Usuários do Sistema",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("usuario.getAll").generate()
		}
	}, {
		path: "cadastros/usuarios/novo",
		component: __WEBPACK_IMPORTED_MODULE_62__components_cadastros_usuarios_Form___default.a,
		name: "CMC65",
		meta: {
			description: "Usuários do Sistema",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("usuario.write").generate()
		}
	}, {
		path: "cadastros/usuarios/atualizacao/:idUsuario",
		component: __WEBPACK_IMPORTED_MODULE_62__components_cadastros_usuarios_Form___default.a,
		name: "CMC66",
		meta: {
			description: "Usuários do Sistema",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("usuario.write").generate()
		}
	}, {
		path: "cadastros/usuarios/alterar-senha",
		component: __WEBPACK_IMPORTED_MODULE_63__components_cadastros_usuarios_alterarSenha___default.a,
		name: "CMC67",
		meta: {
			description: "Alterar senha",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("usuario.updatePassword").generate()
		}
	}, {
		path: "integracao/pacientes",
		component: __WEBPACK_IMPORTED_MODULE_64__components_integracao_pacientes____default.a,
		name: "CMC68",
		meta: {
			description: "Integração",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("paciente-integracao.read").generate()
		}
	}, {
		path: "integracao/pacientes/historico/:cdPessoa",
		component: __WEBPACK_IMPORTED_MODULE_65__components_integracao_pacientes_historico___default.a,
		name: "CMC69",
		meta: {
			description: "Integração",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("usuario.getAll").generate()
		}
	}, {
		path: "integracao/pacientes/visualizar/:cdPessoa",
		component: __WEBPACK_IMPORTED_MODULE_66__components_integracao_pacientes_form___default.a,
		name: "CMC70",
		meta: {
			description: "Integração",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("usuario.getAll").generate()
		}
	}, {
		path: "cadastros/preparos",
		component: __WEBPACK_IMPORTED_MODULE_67__components_cadastros_preparos____default.a,
		name: "CMC71",
		meta: {
			description: "Preparos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("usuario.getAll").generate()
		}
	}, {
		path: "cadastros/preparos/novo",
		component: __WEBPACK_IMPORTED_MODULE_68__components_cadastros_preparos_form___default.a,
		name: "CMC72",
		meta: {
			description: "Preparos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("usuario.getAll").generate()
		}
	}, {
		path: "cadastros/preparos/editar/:preparoId",
		component: __WEBPACK_IMPORTED_MODULE_68__components_cadastros_preparos_form___default.a,
		name: "CMC73",
		meta: {
			description: "Preparos",
			rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("usuario.getAll").generate()
		}
	}]
}, {
	path: "*",
	component: __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default.a,
	meta: {
		description: "Error",
		rule: new __WEBPACK_IMPORTED_MODULE_0_vue_acl__["AclRule"]("public").generate()
	}
}];

/* harmony default export */ __webpack_exports__["a"] = routes;

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex___default.a);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vuex___default.a.Store({
	state: {
		callingAPI: true,
		searching: "",
		alert_success: false,
		alert_error: false,
		alert_message: '',

		serverURI: "https://cmcprodapi.pmvc.ba.gov.br",
		user: null,
		token: null,
		userInfo: {
			messages: [{ 1: "test", 2: "test" }],
			notifications: [],
			tasks: []
		},
		solicitacao: {
			dadosResolucao: null,
			ultimoContratoSolicitanteSelecionado: null,
			ultimaDistribuicaoSelecionada: null
		},
		filtrosRegulador: {
			procedimentoSelecionado: {},
			categoriaUnidadeSelecionada: {},
			unidadeSelecionada: {},
			pacienteSelecionado: {},
			marcadorSelecionado: {}
		}
	},
	mutations: {
		TOGGLE_LOADING: function TOGGLE_LOADING(state) {
			state.callingAPI = !state.callingAPI;
		},
		TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
			state.searching = state.searching === "" ? "loading" : "";
		},
		SET_ALERT_MESSAGE: function SET_ALERT_MESSAGE(state, message) {
			state.alert_message = message;
		},
		SHOW_ALERT_SUCCESS: function SHOW_ALERT_SUCCESS(state) {
			state.alert_success = true;
			setTimeout(function () {
				state.alert_success = false;
				state.alert_message = '';
			}, 3000);
		},
		SHOW_ALERT_ERROR: function SHOW_ALERT_ERROR(state) {
			state.alert_error = true;
			setTimeout(function () {
				state.alert_error = false;
				state.alert_message = '';
			}, 3000);
		},
		SET_USER: function SET_USER(state, user) {
			state.user = user;
		},
		SET_TOKEN: function SET_TOKEN(state, token) {
			state.token = token;
		}
	},
	getters: {
		getHeader: function getHeader(state) {
			var header = {
				Accept: "application/json",
				withCredentials: true
			};
			return header;
		},
		getHeaderAuth: function getHeaderAuth(state) {
			var options = {
				headers: {
					"Access-Control-Allow-Headers": ["Origin", "X-Requested-With", "Content-Type", "Accept"],
					Authorization: "Bearer " + state.token
				},
				withCredentials: true
			};
			return options;
		},
		getHeaderAuthFile: function getHeaderAuthFile(state) {
			var options = {
				headers: {
					"Access-Control-Allow-Headers": ["Origin", "X-Requested-With", "Content-Type", "Accept"],
					Authorization: "Bearer " + state.token
				},
				responseType: "blob",
				withCredentials: true
			};
			return options;
		}
	}
});

/***/ }),
/* 267 */,
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(529)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(806),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
	fixedLayout: false,
	hideLogoOnMobile: false,
	devtool: 'source-map'
};

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
	name: 'NotFound',
	data: function data(router) {
		return {
			logo: this.$store.state.serverURI + '/images/almox-logo.png'
		};
	}
};

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {};

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
	name: 'App',
	data: function data() {
		return {
			section: 'Head'
		};
	},

	methods: {}
};

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarMenu__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SidebarMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hideseek__);









/* harmony default export */ __webpack_exports__["default"] = {
  name: "Dash",
  created: function created() {
    if (sessionStorage.getItem('logeed')) {
      sessionStorage.removeItem('logeed');
      this.$router.go(0);
    }
  },
  mounted: function mounted() {
    var fullHeight = window.innerHeight - this.$refs.mainFooter.clientHeight - this.$refs.mainHeader.clientHeight - 2;
    var sideBarHeight = this.$refs.mainSideBar.clientHeight;
    if (sideBarHeight > fullHeight) {
      this.fullHeight = sideBarHeight - this.$refs.mainHeader.clientHeight - 2;
    } else {
      this.fullHeight = fullHeight;
    }
    this.$store.state.definiuTamanhoTela = true;

    this.getUserCurrent();
  },

  data: function data() {
    return {
      section: "Dash",
      logo: this.$store.state.serverURI + "/images/almox-logo.png",
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].hideLogoOnMobile
      },
      error: "",
      fullHeight: "",
      userCurrent: {
        id: null,
        name: null,
        email: null,
        setor: null
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])(["userInfo"]), {
    user_current: function user_current() {
      return {
        id: this.userCurrent.id,
        displayName: this.userCurrent.name,
        avatar: this.$store.state.serverURI + "/images/default-avatar.png",
        email: this.userCurrent.email,
        setor: this.userCurrent.setor
      };
    }
  }),
  methods: {
    getUserCurrent: function getUserCurrent() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/usuario/getUserCurrent", this.$store.getters.getHeaderAuth).then(function (response) {
        _this.userCurrent = response.data;
        _this.setUsuarioAtual(_this.userCurrent);
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeloading: function changeloading() {
      this.$store.commit("TOGGLE_SEARCHING");
    }
  },
  components: {
    SidebarMenu: __WEBPACK_IMPORTED_MODULE_4__SidebarMenu___default.a
  }
};

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__ = __webpack_require__(902);





/* harmony default export */ __webpack_exports__["default"] = {
	components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__["a" /* default */] },
	name: "Login",
	data: function data(router) {
		return {
			finalizado: false,
			section: "Login",
			loading: "",
			username: "",
			password: "",
			response: "",
			captchaResponse: ""
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.$nextTick(function () {
			_this.$refs.username.focus();
		});
	},

	methods: {
		onSubmitLogin: function onSubmitLogin() {
			var _this2 = this;

			this.finalizado = true;
			var username = this.username,
			    password = this.password;

			this.toggleLoading();
			this.resetResponse();
			this.$store.commit("TOGGLE_LOADING");

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.serverURI + "/api/login", {
				username: username,
				password: password
			}, this.$store.getters.getHeader).then(function (response) {
				_this2.toggleLoading();
				if (response.status === 401) {
					_this2.flash("Usuário ou senha inválidos", "error", {
						timeout: 10000
					});
					return;
				}

				var data = response.data;

				if (data.access_token) {
					var token = data.access_token;
					_this2.$store.commit("SET_TOKEN", token);
					__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_this2.$store.state.serverURI + "/api/usuario/getUserCurrent", _this2.$store.getters.getHeaderAuth).then(function (resp) {
						var userCurrent = resp.data;
						_this2.setUsuarioAtual(userCurrent);
						if (window.localStorage) {
							window.localStorage.setItem("token", token);
						}
					}).then(function (a) {
						var route = "/";
						if (localStorage.getItem("route") && localStorage.getItem("route") != "undefined") {
							var path = localStorage.getItem("route").split("/", 3);
							route = path.join("/");
							if (!route) {
								route = "/";
							}
						}
						localStorage.removeItem("route");
						console.log(route);
						window.sessionStorage.setItem("logeed", true);
						_this2.$router.push(data.redirect ? data.redirect : route);
					}).catch(function (error) {
						console.log(error);
					});
				}
			}).catch(function (error) {
				_this2.finalizado = false;
				if (error.response.status === 401) {
					if (error.response.data.message && !error.response.data.message.includes("Unauthenticated")) {
						_this2.flash(error.response.data.message, "error", {
							timeout: 10000
						});
					} else {
						_this2.flash("Usuário ou senha inválidos", "error", {
							timeout: 10000
						});
					}
					return;
				}
				if (error.response.status === 403) {
					_this2.flash("Captcha inválido", "error", {
						timeout: 10000
					});
					return;
				}
				_this2.$store.commit("TOGGLE_LOADING");
				console.log(error);

				_this2.response = "Ocorreu uma falha na autenticação!";
				_this2.toggleLoading();
			});
		},
		verify: function verify(response) {
			this.captchaResponse = response;
		},
		toggleLoading: function toggleLoading() {
			this.loading = this.loading === "" ? "loading" : "";
		},
		resetResponse: function resetResponse() {
			this.response = "";
		},
		recaptcha: function recaptcha() {
			this.$recaptcha("login").then(function (token) {
				console.log(token);
			});
		}
	}
};

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    name: "SidebarMenu",
    data: function data() {
        return {};
    },
    methods: {}
};

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modalEditarProcedimentoAtendimento__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modalEditarProcedimentoAtendimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modalEditarProcedimentoAtendimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contratos_cabecarioContrato__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contratos_cabecarioContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__contratos_cabecarioContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = {
	filters: {
		sexo: function sexo(val) {
			switch (val) {
				case 0:
					return 'Ambos';
				case 1:
					return 'Masculino';
				case 2:
					return 'Feminino';
			}
		}
	},
	computed: {
		SEXO: function SEXO() {
			return __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* SEXO */];
		}
	},
	data: function data() {
		return {
			currentPage: undefined,
			showModalEditarProcedimento: false,
			dataTable: {},
			indexAtivo: undefined,
			atendimentos: [],
			atendimento: {
				contrato_procedimento: {
					procedimento: {
						nome: ''
					}
				},
				hora_final: '',
				hora_inicial: '',
				idade_maxima: '',
				idade_minima: '',
				profissional: {
					nome: ''
				},
				quantidade_local: '',
				quantidade_primeira: '',
				quantidade_retorno: '',
				sexo: ''
			},
			filtros: {
				nome_profissional: '',
				nome_procedimento: '',
				sexo: '',
				idade_maxima: '',
				idade_minima: ''
			}
		};
	},
	mounted: function mounted() {
		this.getDataTable();
	},

	methods: {
		getDataTable: function getDataTable(page, limpar) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}
			this.currentPage = page;
			this.filtros.page = page;
			this.filtros.id = this.$route.params.contratoId;
			this.$store.commit('TOGGLE_LOADING');

			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/agendas/getAllPaginateProcedimentos", config).then(function (response) {
				_this.dataTable = response.data;
				if (typeof limpar === 'undefined') {
					_this.atendimentos = [];
					_this.indexAtivo = undefined;
				}
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			});
		},
		getAtendimentos: function getAtendimentos(index, item) {
			var _this2 = this;

			this.$swal({
				title: "Aguarde...",
				imageUrl: "/static/img/Rolling-green.gif",
				showConfirmButton: false,
				allowOutsideClick: false
			});
			this.indexAtivo = index;
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/agendas/getProcedimentoAtendimentos", item, this.$store.getters.getHeaderAuth).then(function (response) {
				_this2.atendimentos = response.data;
				_this2.$swal.close();
			}).catch(function (error) {
				_this2.$swal.close();
				console.log(error);
			});
		},
		editar: function editar(item) {
			this.atendimento = this.clonar(item);
			this.showModalEditarProcedimento = true;
		},
		deletar: function deletar(item, index) {
			var _this3 = this;

			this.$swal({
				title: 'Excluir este atendimento?',
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
				cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					_this3.$swal({
						title: "Aguarde...",
						imageUrl: "/static/img/Rolling-green.gif",
						showConfirmButton: false,
						allowOutsideClick: false
					});
					__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(_this3.$store.state.serverURI + "/api/administracao/agendas/deleteProcedimentoAtendimento/" + item.id, _this3.$store.getters.getHeaderAuth).then(function (response) {
						_this3.atendimentos.splice(index, 1);
						_this3.$swal({
							type: "success",
							title: "Atendimento deletado com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
					}).catch(function (error) {
						console.log(error);
					});
				}
			});
		},
		atendimentoProcedimentoAtualizado: function atendimentoProcedimentoAtualizado(procedimento) {
			var _this4 = this;

			this.showModalEditarProcedimento = false;
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/agendas/getProcedimentoAtendimentos", procedimento, this.$store.getters.getHeaderAuth).then(function (response) {
				_this4.atendimentos = response.data;
			}).catch(function (error) {
				console.log(error);
			});
			this.getDataTable(this.currentPage, false);
		},
		clonar: function clonar(obj) {
			if (obj == null || (typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) != 'object') {
				return obj;
			}

			var temp = new obj.constructor();
			for (var key in obj) {
				temp[key] = this.clonar(obj[key]);
			}

			return temp;
		}
	},
	watch: {},
	components: {
		modalEditarProcedimentoAtendimento: __WEBPACK_IMPORTED_MODULE_2__modalEditarProcedimentoAtendimento___default.a,
		cabecalhoContrato: __WEBPACK_IMPORTED_MODULE_3__contratos_cabecarioContrato___default.a
	}
};

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modalEditarSubgrupoAtendimento__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modalEditarSubgrupoAtendimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modalEditarSubgrupoAtendimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contratos_cabecarioContrato__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contratos_cabecarioContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__contratos_cabecarioContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = {
  filters: {
    sexo: function sexo(val) {
      switch (val) {
        case 0:
          return "Ambos";
        case 1:
          return "Masculino";
        case 2:
          return "Feminino";
      }
    }
  },
  computed: {
    SEXO: function SEXO() {
      return __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* SEXO */];
    }
  },
  data: function data() {
    return {
      currentPage: undefined,
      showModalEditarSubgrupo: false,
      dataTable: {},
      indexAtivo: undefined,
      atendimentos: [],
      atendimento: {
        contrato_subgrupo: {
          subgrupo: {
            nome: ""
          }
        },
        hora_final: "",
        hora_inicial: "",
        idade_maxima: "",
        idade_minima: "",
        profissional: {
          nome: ""
        },
        quantidade_local: "",
        quantidade_primeira: "",
        sexo: ""
      },
      filtros: {
        nome_subgrupo: "",
        sexo: "",
        idade_maxima: "",
        idade_minima: ""
      }
    };
  },
  mounted: function mounted() {
    this.getDataTable();
  },

  methods: {
    getDataTable: function getDataTable(page, limpar) {
      var _this = this;

      if (typeof page === "undefined") {
        page = 1;
      }
      this.currentPage = page;
      this.filtros.page = page;
      this.filtros.id = this.$route.params.contratoId;
      this.$store.commit("TOGGLE_LOADING");

      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/agendas/getAllPaginateSubgrupos", config).then(function (response) {
        _this.dataTable = response.data;
        if (typeof limpar === "undefined") {
          _this.atendimentos = [];
          _this.indexAtivo = undefined;
        }
        _this.$store.commit("TOGGLE_LOADING");
      }).catch(function (error) {
        console.log(error);
      });
    },
    getAtendimentos: function getAtendimentos(index, item) {
      var _this2 = this;

      this.$swal({
        title: "Aguarde...",
        imageUrl: "/static/img/Rolling-green.gif",
        showConfirmButton: false,
        allowOutsideClick: false
      });
      this.indexAtivo = index;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/agendas/getSubgrupoAtendimentos", item, this.$store.getters.getHeaderAuth).then(function (response) {
        _this2.atendimentos = response.data;
        _this2.$swal.close();
      }).catch(function (error) {
        _this2.$swal.close();
        console.log(error);
      });
    },
    editar: function editar(item) {
      this.atendimento = this.clonar(item);
      this.showModalEditarSubgrupo = true;
    },
    deletar: function deletar(item, index) {
      var _this3 = this;

      this.$swal({
        title: "Excluir este atendimento?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this3.$swal({
            title: "Aguarde...",
            imageUrl: "/static/img/Rolling-green.gif",
            showConfirmButton: false,
            allowOutsideClick: false
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(_this3.$store.state.serverURI + "/api/administracao/agendas/deleteSubgrupoAtendimento/" + item.id, _this3.$store.getters.getHeaderAuth).then(function (response) {
            _this3.atendimentos.splice(index, 1);
            _this3.$swal({
              type: "success",
              title: "Atendimento deletado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    },
    subgrupoAtendimentoAtualizado: function subgrupoAtendimentoAtualizado(subgrupo) {
      var _this4 = this;

      this.showModalEditarSubgrupo = false;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/agendas/getSubgrupoAtendimentos", subgrupo, this.$store.getters.getHeaderAuth).then(function (response) {
        _this4.atendimentos = response.data;
      }).catch(function (error) {
        console.log(error);
      });
      this.getDataTable(this.currentPage, false);
    },
    clonar: function clonar(obj) {
      if (obj == null || (typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) != "object") {
        return obj;
      }

      var temp = new obj.constructor();
      for (var key in obj) {
        temp[key] = this.clonar(obj[key]);
      }

      return temp;
    }
  },
  watch: {},
  components: {
    modalEditarSubgrupoAtendimento: __WEBPACK_IMPORTED_MODULE_2__modalEditarSubgrupoAtendimento___default.a,
    cabecalhoContrato: __WEBPACK_IMPORTED_MODULE_3__contratos_cabecarioContrato___default.a
  }
};

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = {
    data: function data() {
        return {
            filtros: {
                pesquisa: "",
                coluna: null,
                ordem: null
            },
            dataTable: {}
        };
    },
    mounted: function mounted() {
        this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
        this.getDataTable();
    },

    methods: {
        sortByKey: function sortByKey(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getDataTable();
        },
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
                page = 1;
            }
            this.filtros.page = page;
            this.filtros.tipo = 1;
            this.$router.push({ query: this.filtros });

            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/contratos/getAllPaginate?tipo=1", config).then(function (response) {
                _this.dataTable = response.data;
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
            });
        }
    },
    watch: {
        page: function page(val) {
            this.getDataTable();
        }
    },
    components: {}
};

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contratos_selectProcedimentosContrato__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contratos_selectProcedimentosContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__contratos_selectProcedimentosContrato__);







/* harmony default export */ __webpack_exports__["default"] = {
    props: ["show", "atendimento"],
    filters: {},
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        salvar: function salvar() {
            var _this = this;

            this.$swal({
                title: "Salvando, aguarde...",
                imageUrl: "/static/img/Rolling-green.gif",
                showConfirmButton: false,
                allowOutsideClick: false
            });
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/agendas/updateProcedimentoAtendimento/" + this.$props.atendimento.id, this.$props.atendimento, this.$store.getters.getHeaderAuth).then(function (response) {
                _this.$swal({
                    type: "success",
                    title: "Atendimento atualizado com sucesso!",
                    showConfirmButton: false,
                    timer: 1500
                });
                _this.$emit("atendimentoProcedimentoAtualizado", _this.$props.atendimento);
            }).catch(function (error) {
                var erros = error.response.data.message + " ";
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var erro = _step.value;

                        erros += erro + " \n";
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                _this.$swal({
                    type: "error",
                    title: "Houve uma falha!",
                    text: erros
                });
                console.log(error);
            });
        }
    },
    watch: {},
    components: {
        selectProcedimento: __WEBPACK_IMPORTED_MODULE_4__contratos_selectProcedimentosContrato___default.a,
        selectProfissional: __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional___default.a
    }
};

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contratos_selectSubgruposContrato__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contratos_selectSubgruposContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__contratos_selectSubgruposContrato__);






/* harmony default export */ __webpack_exports__["default"] = {
	props: ["show", "atendimento"],
	filters: {},
	data: function data() {
		return {};
	},
	mounted: function mounted() {},

	methods: {
		salvar: function salvar() {
			var _this = this;

			this.$swal({
				title: "Salvando, aguarde...",
				imageUrl: "/static/img/Rolling-green.gif",
				showConfirmButton: false,
				allowOutsideClick: false
			});
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/agendas/updateSubgrupoAtendimento/" + this.$props.atendimento.id, this.$props.atendimento, this.$store.getters.getHeaderAuth).then(function (response) {
				_this.$swal({
					type: "success",
					title: "Atendimento atualizado com sucesso!",
					showConfirmButton: false,
					timer: 1500
				});
				_this.$emit("subgrupoAtendimentoAtualizado", _this.$props.atendimento);
			}).catch(function (error) {
				var erros = error.response.data.message + " ";
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var erro = _step.value;

						erros += erro + " \n";
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				_this.$swal({
					type: "error",
					title: "Houve uma falha!",
					text: erros
				});
				console.log(error);
			});
		}
	},
	watch: {},
	components: {
		selectSubgrupo: __WEBPACK_IMPORTED_MODULE_3__contratos_selectSubgruposContrato___default.a
	}
};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contratos_selectProcedimentosContrato__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contratos_selectProcedimentosContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__contratos_selectProcedimentosContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contratos_cabecarioContrato__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contratos_cabecarioContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__contratos_cabecarioContrato__);








/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},
	data: function data() {
		return {
			showTextDangerProcedimento: false,
			showTextDangerProfissional: false,
			showTextDangerDias: false,
			showTextDangerHoraInicial: false,
			showTextDangerHoraFinal: false,
			dados: {
				profissional_id: '',
				contrato_procedimento_id: '',
				sexo: 0,
				idade_maxima: '',
				idade_minima: '',
				quantidade_primeira: '',
				quantidade_retorno: '',
				quantidade_local: '',
				hora_inicial: '',
				hora_final: ''
			},
			dias: [],
			selectDias: [{
				label: 'Domingo',
				value: '0'
			}, {
				label: 'Segunda-feira',
				value: '1'
			}, {
				label: 'Terça-feira',
				value: '2'
			}, {
				label: 'Quarta-feira',
				value: '3'
			}, {
				label: 'Quinta-feira',
				value: '4'
			}, {
				label: 'Sexta-feira',
				value: '5'
			}, {
				label: 'Sábado',
				value: '6'
			}]
		};
	},
	mounted: function mounted() {},

	methods: {
		validar: function validar() {
			if (this.isEmpty(this.dados.profissional_id)) {
				this.showTextDangerProfissional = true;
			}
			if (this.isEmpty(this.dados.contrato_procedimento_id)) {
				this.showTextDangerProcedimento = true;
			}
			if (this.isEmpty(this.dados.hora_inicial)) {
				this.showTextDangerHoraInicial = true;
			}
			if (this.isEmpty(this.dados.hora_final)) {
				this.showTextDangerHoraFinal = true;
			}
			if (!this.hasDay()) {
				this.showTextDangerDias = true;
			}
			return true;
		},
		setProfissionalSelecionado: function setProfissionalSelecionado(profissionalSelecionado) {
			this.dados.profissional_id = profissionalSelecionado.id;
		},
		setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
			this.dados.contrato_procedimento_id = procedimentoSelecionado.id;
		},
		salvar: function salvar() {
			var _this = this;

			if (this.validar()) {
				this.$store.commit('TOGGLE_LOADING');
				__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/agendas/createProcedimentoAtendimento", {
					dados: this.dados,
					dias: this.dias
				}, this.$store.getters.getHeaderAuth).then(function (response) {
					_this.$store.commit('TOGGLE_LOADING');
					_this.$swal({
						type: "success",
						title: "Atendimento criado com sucesso!",
						showConfirmButton: false,
						timer: 1500
					});
					_this.$router.go(-1);
				}).catch(function (error) {
					_this.$store.commit('TOGGLE_LOADING');
					var erros = error.response.data.message + " ";
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var erro = _step.value;

							erros += erro + " \n";
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}

					_this.$swal({
						type: "error",
						title: "Houve uma falha!",
						text: erros
					});
				});
			} else {
				this.$swal({
					type: "error",
					title: "Informações pendentes",
					text: "Preencha corretamente os campos destacados em vermelho!"
				});
			}
		},
		isEmpty: function isEmpty(valor) {
			return valor === '';
		},
		hasDay: function hasDay() {
			return false;
		}
	},
	watch: {
		'dados.profissional_id': function dadosProfissional_id() {
			this.showTextDangerProfissional = false;
		},
		'dados.contrato_procedimento_id': function dadosContrato_procedimento_id() {
			this.showTextDangerProcedimento = false;
		}
	},
	components: {
		selectProfissional: __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional___default.a,
		selectProcedimentoContrato: __WEBPACK_IMPORTED_MODULE_4__contratos_selectProcedimentosContrato___default.a,
		cabecalhoContrato: __WEBPACK_IMPORTED_MODULE_5__contratos_cabecarioContrato___default.a
	}
};

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contratos_selectSubgruposContrato__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contratos_selectSubgruposContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__contratos_selectSubgruposContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contratos_cabecarioContrato__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contratos_cabecarioContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__contratos_cabecarioContrato__);







/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},
	data: function data() {
		return {
			dados: {
				contrato_subgrupo_id: '',
				sexo: 0,
				idade_maxima: '',
				idade_minima: '',
				tipo_consumo: 0,
				quantidade_atendimento: '',
				quantidade_local: '',
				hora_inicial: '',
				hora_final: ''
			},
			dias: [],
			selectDias: [{
				label: 'Domingo',
				value: '0'
			}, {
				label: 'Segunda-feira',
				value: '1'
			}, {
				label: 'Terça-feira',
				value: '2'
			}, {
				label: 'Quarta-feira',
				value: '3'
			}, {
				label: 'Quinta-feira',
				value: '4'
			}, {
				label: 'Sexta-feira',
				value: '5'
			}, {
				label: 'Sábado',
				value: '6'
			}]
		};
	},
	mounted: function mounted() {},

	methods: {
		trocaTipoConsumo: function trocaTipoConsumo() {
			if (this.dados.tipo_consumo == '1') {
				this.dados.quantidade_atendimento = 0;
				this.dados.quantidade_local = 0;
			}
		},
		setSubgrupoSelecionado: function setSubgrupoSelecionado(subgrupoSelecionado) {
			this.dados.contrato_subgrupo_id = subgrupoSelecionado.id;
		},
		salvar: function salvar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/agendas/createSubgrupoAtendimento", {
				dados: this.dados,
				dias: this.dias
			}, this.$store.getters.getHeaderAuth).then(function (response) {
				console.log(response.data);
				_this.$swal({
					type: "success",
					title: "Atendimento criado com sucesso!",
					showConfirmButton: false,
					timer: 1500
				});
				_this.$router.go(-1);
			}).catch(function (error) {
				var erros = error.response.data.message + " ";
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var erro = _step.value;

						erros += erro + " \n";
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				_this.$swal({
					type: "error",
					title: "Houve uma falha!",
					text: erros
				});
			});
		}
	},
	watch: {},
	components: {
		selectSubgrupo: __WEBPACK_IMPORTED_MODULE_3__contratos_selectSubgruposContrato___default.a,
		cabecalhoContrato: __WEBPACK_IMPORTED_MODULE_4__contratos_cabecarioContrato___default.a
	}
};

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(904);







/* harmony default export */ __webpack_exports__["default"] = {
    filters: {},
    data: function data() {
        return {
            atualizacao: false,
            showTextDangerTitulo: false,
            showTextDangerDataInicial: false,
            showTextDangerDataFinal: false,
            showTextDangerSituacao: false,
            showTextDangerDescricao: false,

            dados: {
                titulo: "",
                data_inicial: "",
                data_final: "",
                descricao: "",
                situacao: 'ATIVO',
                marcador_visualiza: true,
                prestador_visualiza: true,
                regulador_visualiza: true,
                administrador_visualiza: true
            }
        };
    },
    mounted: function mounted() {
        if (this.$route.params.comunicado_id) {
            this.getById(this.$route.params.comunicado_id);
            this.atualizacao = true;
        }
    },

    methods: {
        salvar: function salvar() {
            var _this = this;

            if (this.validar()) {
                if (this.atualizacao) {
                    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/comunicados/" + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
                        _this.$swal({
                            type: "success",
                            title: "Comunicado atualizado com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this.$router.go(-1);
                    }).catch(function (error) {
                        var erros = error.response.data.message + " ";
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var erro = _step.value;

                                erros += erro + " \n";
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this.$swal({
                            type: "error",
                            title: "Houve uma falha!",
                            text: erros
                        });
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/comunicados", this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
                        if (response.data.status) {
                            _this.$swal({
                                type: "success",
                                title: response.data.msg,
                                showConfirmButton: false,
                                timer: 1500
                            });
                            _this.$router.go(-1);
                        } else {
                            _this.$swal({
                                type: "error",
                                title: response.data.titulo_msg,
                                text: response.data.msg,
                                showConfirmButton: true
                            }).then(function () {
                                _this.$router.go(-1);
                            });
                        }
                    }).catch(function (error) {
                        var erros = error.response.data.message + " ";
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var erro = _step2.value;

                                erros += erro + " \n";
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        _this.$swal({
                            type: "error",
                            title: "Houve uma falha!",
                            text: erros
                        });
                    });
                }
            } else {
                this.$swal({
                    type: "error",
                    title: "Informações pendentes",
                    text: "Preencha corretamente os campos destacados em vermelho!"
                });
            }
        },
        getById: function getById(comunicadoId) {
            var _this2 = this;

            this.$store.commit("TOGGLE_LOADING");
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/comunicados/" + comunicadoId, this.$store.getters.getHeaderAuth).then(function (response) {
                _this2.dados = response.data;
                _this2.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                console.log(error);
            });
        },
        validar: function validar() {
            var validou = true;
            if (this.dados.titulo === "") {
                this.showTextDangerTitulo = true;
                validou = false;
            }
            if (this.dados.descricao === "") {
                this.showTextDangerDescricao = true;
                validou = false;
            }
            if (this.dados.data_inicial === "") {
                this.showTextDangerDataInicial = true;
                validou = false;
            }
            if (this.dados.data_final === "") {
                this.showTextDangerDataFinal = true;
                validou = false;
            }
            if (this.dados.situacao === "") {
                this.showTextDangerSituacao = true;
                validou = false;
            }

            return validou;
        }
    },
    components: {
        VueEditor: __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["a" /* VueEditor */]
    }
};

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},
	data: function data() {
		return {
			filtros: {
				pesquisa: "",
				situacao: ""
			},
			dataTable: {}
		};
	},
	mounted: function mounted() {
		this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
		this.filtros.situacao = this.$route.query.situacao ? this.$route.query.situacao : "";
		this.getDataTable();
	},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
				page = 1;
			}
			this.filtros.page = page;
			this.$router.push({ query: this.filtros });

			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/comunicados", config).then(function (response) {
				_this.dataTable = response.data;
			}).catch(function (error) {
				_this.$store.commit("throwException", error);
			});
		},
		deletar: function deletar(item, index) {
			var _this2 = this;

			this.$swal({
				title: 'Exclusão!',
				text: "Confirma exclus\xE3o do comunicado " + item.titulo + "?",
				type: "question",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
				cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					_this2.$swal({
						title: "Aguarde...",
						imageUrl: "/static/img/Rolling-green.gif",
						showConfirmButton: false,
						allowOutsideClick: false
					});
					__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(_this2.$store.state.serverURI + "/api/administracao/comunicados/" + item.id, _this2.$store.getters.getHeaderAuth).then(function (response) {
						_this2.getDataTable();
						_this2.$swal({
							type: "success",
							title: "Confirmado!",
							text: "Comunicado excluído com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
					}).catch(function (error) {
						console.log(error);
					});
				}
			});
		}
	},
	watch: {
		page: function page(val) {
			this.getDataTable();
		}
	},

	components: {}
};

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
    props: ["contratoId"],
    filters: {},
    data: function data() {
        return {
            contratoSelecionado: {
                tipo: null,
                data_inicial: null,
                data_final: null,
                limite_geral: null,

                unidade: {
                    nome: ""
                }
            }
        };
    },
    mounted: function mounted() {
        this.getDataContrato(this.$props.contratoId);
    },

    methods: {
        getDataContrato: function getDataContrato(contratoId) {
            var _this = this;

            if (contratoId) {
                var config = this.$store.getters.getHeaderAuth;
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/contratos/getById/" + contratoId, config).then(function (response) {
                    _this.contratoSelecionado = response.data;
                    _this.$store.commit("TOGGLE_LOADING");
                }).catch(function (error) {
                    _this.$store.commit("throwException", error);
                });
            }
        }
    },
    watch: {
        "$props.contratoId": function $propsContratoId(val) {
            this.getDataContrato(val);
        }
    },
    components: {}
};

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cabecarioContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtroContratoProcedimento__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtroContratoProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filtroContratoProcedimento__);








/* harmony default export */ __webpack_exports__["default"] = {
    filters: {
        tipo_limite: function tipo_limite(val) {
            if (val == 0) {
                return "Procedimento";
            } else if (val == 1) {
                return "Subgrupo";
            } else if (val == 2) {
                return "Geral";
            }
        }
    },
    data: function data() {
        return {
            filtros: {
                contrato_id: null,
                ordem: null,
                coluna: null
            },

            dataTable: {}
        };
    },

    mounted: function mounted() {
        this.filtros.contrato_id = this.$route.params.contrato_id;
        this.getDataTable();
    },


    methods: {
        sortByKey: function sortByKey(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getDataTable();
        },

        filtrar: function filtrar(filtros) {
            this.filtros = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtros, filtros);
            this.getDataTable();
        },

        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined") {
                page = 1;
            }

            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");

            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/contratos/getContratoProcedimentosPaginateOrdenado", config).then(function (response) {
                _this.dataTable = response.data;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
            });
        },
        deletar: function deletar(item) {
            var _this2 = this;

            this.$swal({
                title: "Confirma exclus\xE3o do procedimento " + item.nome + "?",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    _this2.$swal({
                        title: "Aguarde...",
                        imageUrl: "/static/img/Rolling-green.gif",
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });
                    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(_this2.$store.state.serverURI + "/api/administracao/contratos/deleteContratoProcedimento/" + item.id, _this2.$store.getters.getHeaderAuth).then(function (response) {
                        _this2.getDataTable();
                        _this2.$swal({
                            type: "success",
                            title: "Procedimento excluído com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        }
    },
    watch: {
        page: function page(val) {
            this.getDataTable();
        }
    },

    components: {
        Alert: __WEBPACK_IMPORTED_MODULE_2__Alert___default.a,
        CabecarioContrato: __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato___default.a,
        FiltroContratoProcedimento: __WEBPACK_IMPORTED_MODULE_4__filtroContratoProcedimento___default.a
    }
};

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_selectProcedimento__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_selectProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_selectProcedimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_preparos_selectPreparo__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_preparos_selectPreparo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cadastros_preparos_selectPreparo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cabecarioContrato__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cabecarioContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__cabecarioContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_money__);











/* harmony default export */ __webpack_exports__["default"] = {
	props: ['contratoId'],
	filters: {},
	data: function data() {
		return {
			atualizacao: false,
			showTextDangerValor: false,
			showTextDangerProcedimento: false,
			showTextDangerPreparo: false,
			showTextDangerTipoLimite: false,
			showTextDangerLimite: false,

			procedimentoSelecionado: {},
			preparoSelecionado: {},
			money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				precision: 2,
				masked: false
			},
			dados: {
				valor: 0,
				tipo_limite: null,
				procedimento_id: null,
				preparo_id: null,
				contrato_id: null,
				procedimento: {
					nome: null
				},
				preparo: {
					nome: null
				},
				limite: {
					quantidade: null
				},
				contrato: {
					id: null
				}
			},

			controle: {
				limite_financeiro: null
			}

		};
	},
	mounted: function mounted() {
		var _this = this;

		if (this.$route.params.contrato_procedimento_id) {
			this.$nextTick(function () {
				_this.getById(_this.$route.params.contrato_procedimento_id);
				_this.atualizacao = true;
			});
		} else {
			this.dados.contrato_id = this.$route.params.contrato_id;
		}
	},

	methods: {
		salvar: function salvar() {
			var _this2 = this;

			if (this.validar()) {
				if (this.atualizacao) {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/contratos/updateContratoProcedimento/" + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
						_this2.$swal({
							type: "success",
							title: "Procedimento atualizado com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
						_this2.$router.push("/administracao/contratos/procedimentos/" + _this2.dados.contrato_id);
					}).catch(function (error) {
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;

						try {
							for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var erro = _step.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}

						_this2.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				} else {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/contratos/createContratoProcedimento", this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
						if (response.data.status) {
							_this2.$swal({
								type: "success",
								title: response.data.msg,
								showConfirmButton: false,
								timer: 1500
							});
							_this2.$router.push("/administracao/contratos/procedimentos/" + _this2.dados.contrato_id);
						} else {
							_this2.$swal({
								type: "error",
								title: response.data.titulo_msg,
								text: response.data.msg,
								showConfirmButton: true
							}).then(function () {
								_this2.$router.push("/administracao/contratos/procedimentos/" + _this2.dados.contrato_id);
							});
						}
					}).catch(function (error) {
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {
							for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var erro = _step2.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}

						_this2.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				}
			} else {
				this.$swal({
					type: "error",
					title: "Informações pendentes",
					text: "Preencha corretamente os campos destacados em vermelho!"
				});
			}
		},
		getById: function getById(contratoProcedimentoId) {
			var _this3 = this;

			this.$store.commit('TOGGLE_LOADING');
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/contratos/getContratoProcedimentoById/" + contratoProcedimentoId, this.$store.getters.getHeaderAuth).then(function (response) {
				if (!response.data.limite) {
					response.data.limite = {
						quantidade: null
					};
				}
				if (!response.data.preparo) {
					response.data.preparo = {
						nome: ''
					};
				}
				_this3.dados = response.data;
				_this3.procedimentoSelecionado = _this3.dados.procedimento;
				_this3.preparoSelecionado = _this3.dados.preparo;
				_this3.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			});
		},
		setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
			this.procedimentoSelecionado = procedimentoSelecionado;
			this.dados.procedimento_id = procedimentoSelecionado.id;
			this.dados.valor = procedimentoSelecionado.valor_referencia;

			if (procedimentoSelecionado.tipo_atendimento == 0) {
				this.dados.tipo_limite = 0;
			} else if (procedimentoSelecionado.tipo_atendimento == 1) {
				this.dados.tipo_limite = 1;
			}
		},
		setPreparoSelecionado: function setPreparoSelecionado(preparoSelecionado) {
			this.preparoSelecionado = preparoSelecionado;
			this.dados.preparo_id = preparoSelecionado.id;
		},
		validar: function validar() {
			var validou = true;
			if (this.dados.valor === '') {
				this.showTextDangerValor = true;
				validou = false;
			}
			if (this.dados.tipo_limite === null) {
				this.showTextDangerTipoLimite = true;
				validou = false;
			}
			if (this.dados.procedimento_id === null) {
				this.showTextDangerProcedimento = true;
				validou = false;
			}

			if (this.dados.tipo_limite === 0 && this.dados.limite.quantidade === null) {
				this.showTextDangerLimite = true;
				validou = false;
			}
			return validou;
		}
	},
	watch: {

		"dados.valor": function dadosValor(newValue) {
			if (this.dados.valor > 0 && this.dados.limite.quantidade > 0) {
				this.controle.limite_financeiro = this.dados.valor * this.dados.limite.quantidade;
			}
		},

		"dados.limite.quantidade": function dadosLimiteQuantidade(newValue) {
			if (this.dados.valor && this.dados.limite.quantidade) {
				this.controle.limite_financeiro = this.dados.valor * this.dados.limite.quantidade;
			}
		},

		"dados.tipo_limite": function dadosTipo_limite(newValue) {
			var _this4 = this;

			if (newValue > 0) {
				this.dados.limite.quantidade = null;
				this.controle.limite_financeiro = null;
			}
			this.$nextTick(function () {
				_this4.$refs.limite_fisico.focus();
			});
		}

	},
	components: {
		selectProcedimento: __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_selectProcedimento___default.a,
		Money: __WEBPACK_IMPORTED_MODULE_6_v_money__["Money"],
		selectPreparo: __WEBPACK_IMPORTED_MODULE_4__cadastros_preparos_selectPreparo___default.a,
		CabecarioContrato: __WEBPACK_IMPORTED_MODULE_5__cabecarioContrato___default.a
	}
};

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cabecarioContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtroContratoSubgrupo__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtroContratoSubgrupo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filtroContratoSubgrupo__);








/* harmony default export */ __webpack_exports__["default"] = {
    filters: {},
    data: function data() {
        return {
            filtros: {
                contrato_id: null,
                ordem: null,
                coluna: null
            },
            dataTable: {}
        };
    },

    mounted: function mounted() {
        this.filtros.contrato_id = this.$route.params.contrato_id;
        this.getDataTable();
    },


    methods: {
        sortByKey: function sortByKey(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getDataTable();
        },

        filtrar: function filtrar(filtros) {
            this.filtros = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtros, filtros);
            this.getDataTable();
        },

        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined") {
                page = 1;
            }

            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");

            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/contratos/getContratoSubgruposPaginateOrdenado", config).then(function (response) {
                _this.dataTable = response.data;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
            });
        },
        deletar: function deletar(item) {
            var _this2 = this;

            this.$swal({
                title: "Confirma exclus\xE3o do subgrupo " + item.nome + "?",
                text: "Todos os procedimentos do contrato vinculado a esse subgrupo ser\xE3o exclu\xEDdos",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    _this2.$swal({
                        title: "Aguarde...",
                        imageUrl: "/static/img/Rolling-green.gif",
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });
                    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(_this2.$store.state.serverURI + "/api/administracao/contratos/deleteContratoSubgrupo/" + item.id, _this2.$store.getters.getHeaderAuth).then(function (response) {
                        _this2.getDataTable();
                        _this2.$swal({
                            type: "success",
                            title: "Subgrupo excluído com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        }
    },
    watch: {
        page: function page(val) {
            this.getDataTable();
        }
    },

    components: {
        Alert: __WEBPACK_IMPORTED_MODULE_2__Alert___default.a,
        CabecarioContrato: __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato___default.a,
        FiltroContratoSubgrupo: __WEBPACK_IMPORTED_MODULE_4__filtroContratoSubgrupo___default.a
    }
};

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_subgrupos_selectSubgrupo__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_subgrupos_selectSubgrupo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_subgrupos_selectSubgrupo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cabecarioContrato__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cabecarioContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__cabecarioContrato__);









/* harmony default export */ __webpack_exports__["default"] = {
	props: ['contratoId'],
	filters: {},
	data: function data() {
		return {
			showTextDangerSubgrupo: false,
			showTextDangerLimite: false,

			procedimentoSelecionado: {},
			money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				precision: 2,
				masked: false
			},
			dados: {
				limite: {
					valor: 0
				},
				procedimento_subgrupo_id: null,
				contrato_id: null,
				subgrupo: {
					nome: null
				}
			}

		};
	},
	mounted: function mounted() {

		if (this.$route.params.contrato_subgrupo_id) {
			this.getById(this.$route.params.contrato_subgrupo_id);
			this.atualizacao = true;
		} else {
			this.dados.contrato_id = this.$route.params.contrato_id;
		}
	},

	methods: {
		salvar: function salvar() {
			var _this = this;

			if (this.validar()) {
				if (this.atualizacao) {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/contratos/updateContratoSubgrupo/" + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
						_this.$swal({
							type: "success",
							title: "Subgrupo atualizado com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
						_this.$router.push("/administracao/contratos/subgrupos/" + _this.dados.contrato_id);
					}).catch(function (error) {
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;

						try {
							for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var erro = _step.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}

						_this.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				} else {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/contratos/createContratoSubgrupo", this.dados, this.$store.getters.getHeaderAuth).then(function (response) {

						if (response.data.status) {
							_this.$swal({
								type: "success",
								title: response.data.msg,
								showConfirmButton: false,
								timer: 1500
							});
							_this.$router.push("/administracao/contratos/subgrupos/" + _this.dados.contrato_id);
						} else {
							_this.$swal({
								type: "error",
								title: response.data.titulo_msg,
								text: response.data.msg,
								showConfirmButton: true
							}).then(function () {
								_this.$router.push("/administracao/contratos/subgrupos/" + _this.dados.contrato_id);
							});
						}
					}).catch(function (error) {
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {
							for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var erro = _step2.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}

						_this.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				}
			} else {
				this.$swal({
					type: "error",
					title: "Informações pendentes",
					text: "Preencha corretamente os campos destacados em vermelho!"
				});
			}
		},
		getById: function getById(contratoSubgrupoId) {
			var _this2 = this;

			this.$store.commit('TOGGLE_LOADING');
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/contratos/getContratoSubgrupoById/" + contratoSubgrupoId, this.$store.getters.getHeaderAuth).then(function (response) {

				_this2.dados = response.data;

				_this2.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			});
		},
		setSubgrupoSelecionado: function setSubgrupoSelecionado(subgrupoSelecionado) {
			this.subgrupoSelecionado = subgrupoSelecionado;
			this.dados.procedimento_subgrupo_id = subgrupoSelecionado.id;
		},
		validar: function validar() {

			var validou = true;
			if (this.dados.procedimento_subgrupo_id === null) {
				this.showTextDangerSubgrupo = true;
				validou = false;
			}
			if (this.dados.limite.valor === null) {
				this.showTextDangerLimite = true;
				validou = false;
			}
			return validou;
		}
	},
	watch: {},
	components: {
		selectSubgrupo: __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_subgrupos_selectSubgrupo___default.a,
		Money: __WEBPACK_IMPORTED_MODULE_4_v_money__["Money"],
		CabecarioContrato: __WEBPACK_IMPORTED_MODULE_5__cabecarioContrato___default.a
	}
};

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  filters: {},
  data: function data() {
    return {
      filtros: {
        pesquisa: '',
        tipo_limite: ''
      }
    };
  },

  mounted: function mounted() {},


  methods: {
    filtrar: function filtrar() {
      this.$emit('filtrar', this.filtros);
    }
  },
  watch: {},

  components: {}

};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  filters: {},
  data: function data() {
    return {
      filtros: {
        pesquisa: ''
      }
    };
  },

  mounted: function mounted() {},


  methods: {
    filtrar: function filtrar() {
      this.$emit('filtrar', this.filtros);
    }
  },
  watch: {},

  components: {}

};

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalCopiarContrato__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalCopiarContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modalCopiarContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_money__);










/* harmony default export */ __webpack_exports__["default"] = {
    filters: {},
    data: function data() {
        return {
            atualizacao: false,
            selectUnidades: [],

            showModalCopiarContrato: false,
            showTextDangerDataInicial: false,
            showTextDangerDataFinal: false,
            showTextDangerSituacao: false,
            showTextDangerTipoPessoa: false,
            showTextDangerTipo: false,
            showTextDangerLimiteCancelamento: false,
            showTextDangerLimiteRegulacao: false,
            showTextDangerLimiteGeral: false,
            showTextDangerUnidade: false,

            money: {
                decimal: ",",
                thousands: ".",
                prefix: "R$ ",
                precision: 2,
                masked: false
            },
            dados: {
                data_inicial: "",
                data_final: "",
                situacao: 1,
                tipo_pessoa: "",
                tipo: 0,
                limite_cancelamento: 0,
                limite_regulacao: 0,
                limite_geral: 0,
                unidade_id: "",
                restricao: 0,
                unidade: {
                    nome: null
                },
                restricao_unidades: []
            }
        };
    },
    mounted: function mounted() {
        this.getUnidades();
        if (this.$route.params.contrato_id) {
            this.getById(this.$route.params.contrato_id);
            this.atualizacao = true;
        }
    },

    methods: {
        getUnidades: function getUnidades() {
            var _this = this;

            this.$store.commit("TOGGLE_LOADING");
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/unidades/dataForSelect/", this.$store.getters.getHeaderAuth).then(function (response) {
                var unidades = response.data;

                var stringified = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data);
                stringified = stringified.replace(/nome/g, "label");
                stringified = stringified.replace(/id/g, "value");

                unidades = JSON.parse(stringified);

                _this.selectUnidades = unidades;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this.$store.commit("SHOW_ALERT_ERROR");
                _this.$store.commit("SET_ALERT_MESSAGE", error.response.data.message);
                _this.$router.push("/cadastros/usuarios");
                console.log(error);
            });
        },
        salvar: function salvar() {
            var _this2 = this;

            if (this.validar()) {
                if (this.atualizacao) {
                    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/contratos/update/" + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
                        _this2.$swal({
                            type: "success",

                            title: "Contrato atualizado com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this2.$router.go(-1);
                    }).catch(function (error) {
                        var erros = error.response.data.message + " ";
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var erro = _step.value;

                                erros += erro + " \n";
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this2.$swal({
                            type: "error",
                            title: "Houve uma falha!",
                            text: erros
                        });
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$store.state.serverURI + "/api/administracao/contratos/create", this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
                        if (response.data.status) {
                            _this2.$swal({
                                type: "success",
                                title: response.data.msg,
                                showConfirmButton: false,
                                timer: 1500
                            });
                            _this2.$router.go(-1);
                        } else {
                            _this2.$swal({
                                type: "error",
                                title: response.data.titulo_msg,
                                text: response.data.msg,
                                showConfirmButton: true
                            }).then(function () {
                                _this2.$router.go(-1);
                            });
                        }
                    }).catch(function (error) {
                        var erros = error.response.data.message + " ";
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var erro = _step2.value;

                                erros += erro + " \n";
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        _this2.$swal({
                            type: "error",
                            title: "Houve uma falha!",
                            text: erros
                        });
                    });
                }
            } else {
                this.$swal({
                    type: "error",
                    title: "Informações pendentes",
                    text: "Preencha corretamente os campos destacados em vermelho!"
                });
            }
        },
        getById: function getById(contratoId) {
            var _this3 = this;

            this.$store.commit("TOGGLE_LOADING");
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/contratos/getById/" + contratoId, this.$store.getters.getHeaderAuth).then(function (response) {
                _this3.dados = response.data;
                var stringified = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this3.dados.restricao_unidades);
                stringified = stringified.replace(/nome/g, "label");
                stringified = stringified.replace(/id/g, "value");
                _this3.dados.restricao_unidades = JSON.parse(stringified);

                _this3.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                console.log(error);
            });
        },
        setUnidadeSelecionada: function setUnidadeSelecionada(unidadeSelecionada) {
            this.dados.unidade_id = unidadeSelecionada.id;
        },
        validar: function validar() {
            var validou = true;
            if (this.dados.tipo_pessoa != "0" && this.dados.tipo_pessoa != "1") {
                this.showTextDangerTipoPessoa = true;
                validou = false;
            }
            if (this.dados.data_inicial === "") {
                this.showTextDangerDataInicial = true;
                validou = false;
            }
            if (this.dados.data_final === "") {
                this.showTextDangerDataFinal = true;
                validou = false;
            }
            if (this.dados.situacao === "") {
                this.showTextDangerSituacao = true;
                validou = false;
            }
            if (this.dados.tipo === "") {
                this.showTextDangerTipo = true;
                validou = false;
            }
            if (this.dados.limite_cancelamento === "") {
                this.showTextDangerLimiteCancelamento = true;
                validou = false;
            }
            if (this.dados.limite_regulacao === "") {
                this.showTextDangerLimiteRegulacao = true;
                validou = false;
            }
            if (this.dados.limite_geral === "") {
                this.showTextDangerLimiteGeral = true;
                validou = false;
            }
            if (this.dados.unidade_id === "") {
                this.showTextDangerUnidade = true;
                validou = false;
            }

            return validou;
        }
    },
    watch: {
        "dados.restricao": function dadosRestricao(val) {
            if (val == 0) {
                this.dados.restricao_unidades = [];
            }
        }
    },
    components: {
        selectUnidade: __WEBPACK_IMPORTED_MODULE_4__cadastros_unidades_selectUnidade___default.a,
        Money: __WEBPACK_IMPORTED_MODULE_6_v_money__["Money"],
        modalCopiarContrato: __WEBPACK_IMPORTED_MODULE_5__modalCopiarContrato___default.a
    }
};

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = {
    filters: {},
    data: function data() {
        return {
            filtros: {
                pesquisa: "",
                categoria_unidade: "",
                tipo: "",
                situacao: "",
                coluna: null,
                ordem: null
            },
            dataTable: {}
        };
    },
    mounted: function mounted() {
        this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
        this.filtros.categoria_unidade = this.$route.query.categoria_unidade ? this.$route.query.categoria_unidade : "";
        this.filtros.tipo = this.$route.query.tipo ? this.$route.query.tipo : "";
        this.filtros.situacao = this.$route.query.situacao ? this.$route.query.situacao : "";
        this.getDataTable();
    },

    methods: {
        sortByKey: function sortByKey(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == 'asc') {
                this.filtros.ordem = 'desc';
            } else {
                this.filtros.ordem = 'asc';
            }
            this.getDataTable();
        },
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
                page = 1;
            }
            this.filtros.page = page;
            this.$router.push({ query: this.filtros });

            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/contratos/getAllPaginate", config).then(function (response) {
                _this.dataTable = response.data;
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
            });
        },
        delete: function _delete(id, nome) {}
    },
    watch: {
        page: function page(val) {
            this.getDataTable();
        }
    },

    components: {}
};

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
    props: ["show", "contratoAtualId"],
    filters: {},
    data: function data() {
        return {
            filtros: {
                pesquisa: "",
                categoria_unidade: "",
                tipo: "",
                coluna: null,
                ordem: null
            },
            dataTable: {},
            contratoSelecionadoIndex: 0
        };
    },
    mounted: function mounted() {
        this.getDataTable();
    },

    methods: {
        sortByKey: function sortByKey(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getDataTable();
        },
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
                page = 1;
            }
            this.filtros.page = page;

            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/contratos/getAllPaginate", config).then(function (response) {
                _this.dataTable = response.data;
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
            });
        },
        copiar: function copiar(contrato, index) {
            var _this2 = this;

            this.contratoSelecionadoIndex = index;
            this.$swal({
                title: "Copiar os procedimentos e subgrupos do contrato de " + this.$options.filters.tipoContrato(contrato.tipo).toUpperCase() + " da unidade " + contrato.nome + "?",
                html: '<b style="color: red">TODOS OS SUBGRUPOS E PROCEDIMENTOS ATUAIS SERÃO EXCLUÍDOS E ESTA OPERAÇÃO NÃO PODERÁ SER DESFEITA.</b>',
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    _this2.$swal({
                        title: "Copiando, aguarde...",
                        imageUrl: "/static/img/Rolling-green.gif",
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });
                    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this2.$store.state.serverURI + "/api/administracao/contratos/copiar", {
                        contrato_origem_id: contrato.id,
                        contrato_destino_id: _this2.$props.contratoAtualId
                    }, _this2.$store.getters.getHeaderAuth).then(function (response) {
                        _this2.$emit("close");
                        _this2.$swal({
                            type: "success",
                            title: "Informações copiadas com sucesso!",
                            text: "Para visualizar, vá para os procedimentos ou subgrupos deste contrato."
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        up: function up() {
            if (this.contratoSelecionadoIndex > 0) {
                this.contratoSelecionadoIndex--;
            }
        },
        down: function down() {
            if (this.contratoSelecionadoIndex < this.dataTable.data.length - 1) {
                this.contratoSelecionadoIndex++;
            }
        },
        enter: function enter() {}
    },
    watch: {}
};

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},

	props: {
		disableClear: false,
		contratoId: {},
		nomeProcedimento: {},
		showTextDangerProcedimento: {
			default: false
		},
		semAgrupados: {},
		placeholder: {
			type: String,
			default: ''
		}
	},
	data: function data() {
		return {
			loading: false,
			validado: false,
			procedimentoSelecionado: {
				procedimento: {
					nome: ''
				}
			},
			filtros: {
				pesquisa: ''
			},
			showModal: false,
			dataTable: {
				data: []
			}
		};
	},
	mounted: function mounted() {
		this.validado = this.showTextDangerSubgrupo;
	},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}

			this.filtros.page = page;
			this.filtros.contrato_id = this.$props.contratoId;
			console.log("this.filtros.contrato_id");
			console.log(this.filtros.contrato_id);
			this.$store.commit('TOGGLE_LOADING');

			var config = this.$store.getters.getHeaderAuth;
			this.filtros.semAgrupados = this.semAgrupados;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/administracao/contratos/getContratoProcedimentosPaginate', config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			});
		},
		limpar: function limpar() {
			this.seleciona({ id: null, procedimento: { nome: '' } });
		},
		seleciona: function seleciona(item) {
			this.procedimentoSelecionado = item;
			this.showModal = false;
			this.$emit('setProcedimentoSelecionado', item);
		}
	},
	watch: {
		"$props.nomeProcedimento": function $propsNomeProcedimento() {
			if (this.$props.nomeProcedimento) {
				this.procedimentoSelecionado.procedimento.nome = this.$props.nomeProcedimento;
			}
		},
		procedimentoSelecionado: function procedimentoSelecionado(value) {
			if (value.procedimento.nome) {
				this.showTextDangerProcedimento = false;
			} else if (this.validado) {
				this.showTextDangerProcedimento = true;
			}
		}
	},
	components: {}
};

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},

	props: {
		disableClear: false,
		contratoId: {},
		nomeSubgrupo: {},
		showTextDangerSubgrupo: {
			default: false
		},
		placeholder: {
			type: String,
			default: ''
		}
	},
	data: function data() {
		return {
			loading: false,
			validado: false,
			subgrupoSelecionado: {
				subgrupo: {
					nome: ''
				}
			},
			filtros: {
				pesquisa: ''
			},
			showModal: false,
			dataTable: {
				data: []
			}
		};
	},
	mounted: function mounted() {
		this.validado = this.showTextDangerSubgrupo;
		this.getDataTable();
	},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}

			this.filtros.page = page;
			this.filtros.contrato_id = this.$props.contratoId;
			this.$store.commit('TOGGLE_LOADING');

			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/administracao/contratos/getContratoSubgruposPaginate', config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			});
		},
		limpar: function limpar() {
			this.seleciona({ id: null, subgrupo: { nome: '' } });
		},
		seleciona: function seleciona(item) {
			this.subgrupoSelecionado = item;
			this.showModal = false;
			this.$emit('setSubgrupoSelecionado', item);
		}
	},
	watch: {
		"$props.nomeSubgrupo": function $propsNomeSubgrupo() {
			if (this.$props.nomeSubgrupo) {
				this.subgrupoSelecionado.subgrupo.nome = this.$props.nomeSubgrupo;
			}
		},
		subgrupoSelecionado: function subgrupoSelecionado(value) {
			if (value.subgrupo.nome) {
				this.showTextDangerSubgrupo = false;
			} else if (this.validado) {
				this.showTextDangerSubgrupo = true;
			}
		}
	},
	components: {}
};

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);






/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},
	data: function data() {
		return {
			dados: {
				dias_visao_regulador: 45,
				procedimentos_agrupados_regulador: 0,
				procedimentos_nao_pactuados_regulador: 0,
				horario_abertura_regulador: '',
				horario_fechamento_regulador: '',
				habilita_ppi_marcador: 1,
				habilita_demais_marcador: 1,
				dias_visao_marcador: 10,
				dias_visao_agrupados_marcador: 10,
				dias_visao_retorno_marcador: 10,
				obriga_diagnosticos_marcador: 0,
				horario_abertura_marcador: '',
				horario_fechamento_marcador: '',
				horario_abertura_prestador: '',
				horario_fechamento_prestador: '',
				horario_abertura_admin: '',
				horario_fechamento_admin: ''
			}
		};
	},
	mounted: function mounted() {
		this.getParametros();
	},

	methods: {
		getParametros: function getParametros() {
			var _this = this;

			this.$store.commit("TOGGLE_LOADING");
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + '/api/administracao/parametros/getParametros', this.$store.getters.getHeaderAuth).then(function (response) {
				_this.dados.dias_visao_regulador = response.data.dias_visao_regulador;
				_this.dados.dias_visao_marcador = response.data.dias_visao_marcador;
				_this.dados.dias_visao_retorno_marcador = response.data.dias_visao_retorno_marcador;
				_this.dados.dias_visao_agrupados_marcador = response.data.dias_visao_agrupados_marcador;
				_this.dados.horario_abertura_marcador = response.data.horario_abertura_marcador ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(response.data.horario_abertura_marcador, "HH:mm:ss").format('HH:mm') : '';
				_this.dados.horario_fechamento_marcador = response.data.horario_fechamento_marcador ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(response.data.horario_fechamento_marcador, "HH:mm:ss").format('HH:mm') : '';
				_this.dados.horario_abertura_regulador = response.data.horario_abertura_regulador ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(response.data.horario_abertura_regulador, "HH:mm:ss").format('HH:mm') : '';
				_this.dados.horario_fechamento_regulador = response.data.horario_fechamento_regulador ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(response.data.horario_fechamento_regulador, "HH:mm:ss").format('HH:mm') : '';
				_this.dados.horario_abertura_prestador = response.data.horario_abertura_prestador ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(response.data.horario_abertura_prestador, "HH:mm:ss").format('HH:mm') : '';
				_this.dados.horario_fechamento_prestador = response.data.horario_fechamento_prestador ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(response.data.horario_fechamento_prestador, "HH:mm:ss").format('HH:mm') : '';
				_this.dados.horario_abertura_admin = response.data.horario_abertura_admin ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(response.data.horario_abertura_admin, "HH:mm:ss").format('HH:mm') : '';
				_this.dados.horario_fechamento_admin = response.data.horario_fechamento_admin ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(response.data.horario_fechamento_admin, "HH:mm:ss").format('HH:mm') : '';
				_this.$store.commit("TOGGLE_LOADING");
			}).catch(function (error) {
				console.log(error);
			});
		},
		salvar: function salvar() {
			var _this2 = this;

			this.$validator.validate().then(function (result) {
				if (result) {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$store.state.serverURI + '/api/administracao/parametros/update', _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
						_this2.$swal({
							type: "success",
							title: "Parâmetros atualizados com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
					}).catch(function (error) {
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;

						try {
							for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var erro = _step.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}

						_this2.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				}
			});
		}
	},
	watch: {},
	components: {}
};

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_cadastros_profissionais_selectProfissional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cadastros_procedimentos_selectProcedimento__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cadastros_procedimentos_selectProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cadastros_procedimentos_selectProcedimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_componentes_DataFiltro__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_componentes_DataFiltro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_componentes_DataFiltro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = {
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_7__constants__["i" /* SITUACAO_SOLICITACAO */];
        }
    },
    data: function data() {
        return {
            pdf: null,
            heigthPdf: 900,
            finalizado: false,
            filtros: {
                unidade_id: "",
                unidade: "",
                profissional_id: "",
                profissional: "",
                procedimento_id: "",
                procedimento: "",
                subgrupo_id: "",
                subgrupo: "",
                periodo: "",
                periodo2: "",
                periodoOperador: "",
                modelo: "",
                ativos: null
            },
            dataTable: {},
            ativos: {
                situacao: true,
                data_realizacao: true,
                paciente: true,
                rg: true,
                cartao_sus: true,
                data_nascimento: true,
                idade: true,
                procedimento: true,
                unidade_solicitante: true,
                profissional: true,
                telefone: true,
                sexo: true,
                tipo: true,
                endereco: true,
                municipio: true,
                subgrupo: true
            }
        };
    },
    mounted: function mounted() {},

    methods: {
        disabledBtnFalta: function disabledBtnFalta(item) {
            var dataAtendimento = item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento;
            if (item.solicitacao.situacao == __WEBPACK_IMPORTED_MODULE_7__constants__["i" /* SITUACAO_SOLICITACAO */].MARCADA || item.solicitacao.situacao == __WEBPACK_IMPORTED_MODULE_7__constants__["i" /* SITUACAO_SOLICITACAO */].CONFIRMADA) {
                return new Date() < new Date(dataAtendimento);
            }
            return true;
        },
        lancarFalta: function lancarFalta(item) {
            var _this = this;

            var dados = {
                solicitacaoId: item.solicitacao.id,
                situacao: __WEBPACK_IMPORTED_MODULE_7__constants__["i" /* SITUACAO_SOLICITACAO */].FALTA
            };
            this.$swal({
                title: "Confirmar falta?",
                text: "Está ação não poderá ser desfeita.",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this.$store.state.serverURI + "/api/atendimentos/atualizarSituacao", dados, _this.$store.getters.getHeaderAuth).then(function (response) {
                        _this.solicitacao = response.data;
                        _this.$swal({
                            type: "success",
                            title: "Solicitação atualizada com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this.getDataTable();
                        _this.$store.commit("TOGGLE_LOADING");
                    }).catch(function (error) {
                        _this.$store.commit("throwException", error);
                    });
                }
            });
        },
        getDataTable: function getDataTable(page) {
            var _this2 = this;

            var loader = this.$loading.show();
            if (!this.filtros.unidade_id || !this.filtros.periodo) {
                this.$swal({
                    type: "warning",
                    title: "Atenção!",
                    text: "É necessário selecionar a unidade prestadora e o período!",
                    showConfirmButton: true
                });
                return;
            }
            this.finalizado = true;
            this.pdf = null;
            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;

            this.$store.commit("TOGGLE_LOADING");
            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/agendaPrestador", config).then(function (response) {
                _this2.dataTable = response.data;
                _this2.$store.commit("TOGGLE_LOADING");
                _this2.finalizado = false;
                loader.hide();
            }).catch(function (error) {
                _this2.$store.commit("throwException", error);
                _this2.finalizado = false;
                loader.hide();
            });
        },
        setUnidadeSelecionada: function setUnidadeSelecionada(unidadeSelecionada) {
            this.filtros.unidade_id = unidadeSelecionada.id;
            this.filtros.unidade = unidadeSelecionada.nome;
        },
        setProfissionalSelecionado: function setProfissionalSelecionado(profissionalSelecionado) {
            this.filtros.profissional_id = profissionalSelecionado.id;
            this.filtros.profissional = profissionalSelecionado.nome;
        },
        setSubgrupoSelecionado: function setSubgrupoSelecionado(subgrupoSelecionado) {
            this.filtros.subgrupo_id = subgrupoSelecionado.id;
            this.filtros.subgrupo = subgrupoSelecionado.nome;
        },
        setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
            this.filtros.procedimento_id = procedimentoSelecionado.id;
            this.filtros.procedimento = procedimentoSelecionado.nome;
        },
        isEmpty: function isEmpty(objeto) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(objeto).every(function (valor) {
                return valor === "";
            });
        },
        getPDF: function getPDF(modelo) {
            var _this3 = this;

            this.finalizado = true;
            this.filtros.modelo = modelo;
            if (modelo == 1) {
                this.filtros.ativos = this.ativos;
            }
            this.$store.commit("TOGGLE_LOADING");
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$store.state.serverURI + "/api/relatorios/agendaPrestadorImprimir", this.filtros, this.$store.getters.getHeaderAuthFile).then(function (response) {
                _this3.$store.commit("TOGGLE_LOADING");
                var file = new Blob([response.data], {
                    type: "application/pdf"
                });
                var fileURL = window.URL.createObjectURL(file);
                _this3.pdf = fileURL;
                var self = _this3;
                _this3.heigthPdf = window.innerHeight - 65;
                console.log(window.innerHeight);
                setTimeout(function () {
                    self.$refs.filtrar.scrollIntoView();
                }, 300);
                _this3.finalizado = false;
            }).catch(function (error) {
                _this3.$store.commit("throwException", error);
                _this3.finalizado = false;
            });
        }
    },
    watch: {},
    components: {
        selectUnidade: __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade___default.a,
        selectProfissional: __WEBPACK_IMPORTED_MODULE_3__components_cadastros_profissionais_selectProfissional___default.a,
        selectProcedimento: __WEBPACK_IMPORTED_MODULE_4__components_cadastros_procedimentos_selectProcedimento___default.a,
        selectSubgrupo: __WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo___default.a,
        DataFiltro: __WEBPACK_IMPORTED_MODULE_6__components_componentes_DataFiltro___default.a
    }
};

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade__);





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    selectUnidade: __WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade___default.a
  },

  data: function data() {
    return {
      pdf: null,
      heigthPdf: 900,
      filtros: {
        distribuicao_id: '',
        unidade_id: ''
      },
      distribuicoes: [],
      dataTable: {},
      finalizado: true
    };
  },

  mounted: function mounted() {
    this.getDistribuicoes();
  },


  methods: {
    getDataTable: function getDataTable(page) {
      var _this = this;

      this.$swal({
        title: "Aguarde!",
        text: "Essa consulta pode demorar um pouco",
        imageUrl: "/static/img/Rolling-green.gif",
        showConfirmButton: false,
        allowOutsideClick: false
      });
      if (typeof page === "undefined") {
        page = 1;
      }

      this.filtros.page = page;
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/consumo-limites", config).then(function (response) {
        _this.dataTable = response.data;
      }).catch(function (error) {
        console.log(error);
      }).finally(function () {
        _this.$swal.close();
      });
    },
    getDistribuicoes: function getDistribuicoes() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
        _this2.distribuicoes = response.data;
        _this2.filtros.distribuicao_id = _this2.distribuicoes[0].id;
        _this2.getDataTable();
      }).catch(function (error) {
        console.log(error);
      });
    },
    setUnidadeSolicitante: function setUnidadeSolicitante(unidadeSolicitante) {
      this.filtros.unidade_id = unidadeSolicitante.id;
    }
  }
};

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cadastros_profissionais_selectProfissional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_procedimentos_selectProcedimento__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_procedimentos_selectProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cadastros_procedimentos_selectProcedimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);








/* harmony default export */ __webpack_exports__["default"] = {
	computed: {
		SITUACAO: function SITUACAO() {
			return __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SITUACAO */];
		},
		TIPO_CONTRATO: function TIPO_CONTRATO() {
			return __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* TIPO_CONTRATO */];
		}
	},
	data: function data() {
		return {
			pdf: null,
			heigthPdf: 900,
			finalizado: false,
			filtros: {
				unidade_id: null,
				unidade: '',
				profissional_id: null,
				profissional: '',
				procedimento_id: null,
				procedimento: '',
				situacao: null
			},
			dataTable: {}
		};
	},
	mounted: function mounted() {},


	methods: {
		sortByKey: function sortByKey(field) {
			this.filtros.coluna = field;
			if (this.filtros.ordem == 'asc') {
				this.filtros.ordem = 'desc';
			} else {
				this.filtros.ordem = 'asc';
			}
		},
		getDataTable: function getDataTable(page) {
			var _this = this;

			this.finalizado = true;
			this.pdf = null;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.filtros.page = page;
			this.$store.commit('TOGGLE_LOADING');
			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/escalas", config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit('TOGGLE_LOADING');
				_this.finalizado = false;
			}).catch(function (error) {
				_this.$store.commit('throwException', error);
				_this.finalizado = false;
			});
		},
		getPDF: function getPDF() {
			var _this2 = this;

			this.finalizado = true;
			this.$store.commit('TOGGLE_LOADING');
			var config = this.$store.getters.getHeaderAuthFile;
			config.params = this.filtros;
			__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/escalasImprimir", config).then(function (response) {
				_this2.$store.commit('TOGGLE_LOADING');
				var file = new Blob([response.data], { type: 'application/pdf' });
				var fileURL = window.URL.createObjectURL(file);
				_this2.pdf = fileURL;
				var self = _this2;
				_this2.heigthPdf = window.innerHeight - 65;
				console.log(window.innerHeight);
				setTimeout(function () {
					self.$refs.filtrar.scrollIntoView();
				}, 300);
				_this2.finalizado = false;
			}).catch(function (error) {
				_this2.$store.commit('throwException', error);
				_this2.finalizado = false;
			});
		},
		setUnidadeSelecionada: function setUnidadeSelecionada(unidadeSelecionada) {
			this.filtros.unidade = unidadeSelecionada.nome;
			this.filtros.unidade_id = unidadeSelecionada.id;
		},
		setProfissionalSelecionado: function setProfissionalSelecionado(profissionalSelecionado) {
			this.filtros.profissional = profissionalSelecionado.nome;
			this.filtros.profissional_id = profissionalSelecionado.id;
		},
		setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
			this.filtros.procedimento = procedimentoSelecionado.nome;
			this.filtros.procedimento_id = procedimentoSelecionado.id;
		}
	},
	watch: {
		page: function page(val) {
			this.getDataTable();
		}
	},

	components: {
		selectUnidade: __WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade___default.a,
		selectProfissional: __WEBPACK_IMPORTED_MODULE_1__components_cadastros_profissionais_selectProfissional___default.a,
		selectProcedimento: __WEBPACK_IMPORTED_MODULE_2__components_cadastros_procedimentos_selectProcedimento___default.a
	}

};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_cadastros_profissionais_selectProfissional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cadastros_procedimentos_selectProcedimento__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cadastros_procedimentos_selectProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cadastros_procedimentos_selectProcedimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_componentes_DataFiltro__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_componentes_DataFiltro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_componentes_DataFiltro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);











/* harmony default export */ __webpack_exports__["default"] = {
	data: function data() {
		return {
			pdf: null,
			heigthPdf: 900,
			finalizado: false,
			grupos: [],
			grupoSelecionado: '',
			filtros: {
				unidade_id: null,
				unidade: '',
				profissional_id: null,
				profissional: '',
				procedimento_id: null,
				procedimento: '',
				grupo_id: '',
				grupo: '',
				subgrupo_id: null,
				subgrupo: '',
				periodo: null,
				periodo2: null,
				periodoOperador: null,
				agrupamento: 'procedimento',
				separacao: '',
				ignorar_profissional: false,
				ignorar_prestador: false,
				contadores: {
					toogle: {
						primeira: false,
						retorno: false,
						local: false,
						total: false
					},
					disponivel: {
						toogle: true,
						primeira: true,
						retorno: true,
						local: true,
						total: true
					},
					agendado: {
						toogle: false,
						primeira: false,
						retorno: false,
						local: false,
						total: false
					},
					bloqueado: {
						toogle: false,
						primeira: false,
						retorno: false,
						local: false,
						total: false
					}
				}
			},

			dataTable: {}
		};
	},
	mounted: function mounted() {
		this.getGrupos();
	},

	methods: {
		getDataTable: function getDataTable() {
			var _this = this;

			this.finalizado = true;
			this.pdf = null;

			this.$store.commit('TOGGLE_LOADING');
			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/ofertas", config).then(function (response) {
				console.log(response.data);
				_this.dataTable = response.data;
				for (var key in _this.dataTable) {
					if (_this.dataTable[key] && _this.filtros.separacao == 'data') {
						_this.dataTable[key] = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(_this.dataTable[key], ['data_atendimento'], ['asc']);
					}
					if (_this.dataTable[key] && _this.filtros.separacao == 'horario') {
						_this.dataTable[key] = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(_this.dataTable[key], ['data_atendimento', 'hora_inicial', 'hora_final'], ['asc', 'asc', 'asc']);
					}
					if (_this.dataTable[key] && _this.filtros.separacao == 'dia') {
						_this.dataTable[key] = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(_this.dataTable[key], ['dia_semana'], ['asc']);
					}
				}
				_this.$store.commit('TOGGLE_LOADING');
				_this.finalizado = false;
			}).catch(function (error) {
				_this.$store.commit('throwException', error);
				_this.finalizado = false;
			});
		},
		getGrupos: function getGrupos() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/grupos-procedimento/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
				_this2.grupos = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		setUnidadeSelecionada: function setUnidadeSelecionada(unidadeSelecionada) {
			this.filtros.unidade_id = unidadeSelecionada.id;
			this.filtros.unidade = unidadeSelecionada.nome;
		},
		setProfissionalSelecionado: function setProfissionalSelecionado(profissionalSelecionado) {
			this.filtros.profissional_id = profissionalSelecionado.id;
			this.filtros.profissional = profissionalSelecionado.nome;
		},
		setSubgrupoSelecionado: function setSubgrupoSelecionado(subgrupoSelecionado) {
			this.filtros.subgrupo_id = subgrupoSelecionado.id;
			this.filtros.subgrupo = subgrupoSelecionado.nome;
		},
		setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
			this.filtros.procedimento_id = procedimentoSelecionado.id;
			this.filtros.procedimento = procedimentoSelecionado.nome;
		},
		setGrupoSelecionado: function setGrupoSelecionado() {
			this.filtros.grupo_id = this.grupoSelecionado.id;
			this.filtros.grupo = this.grupoSelecionado.nome;
		},
		isVisible: function isVisible(contador) {
			var qtdSelecionado = this.getColSpan(contador);
			if (qtdSelecionado > 0) {
				return true;
			}

			return false;
		},
		getColSpan: function getColSpan(contador) {
			var colspan = 0;
			if (this.filtros.contadores[contador].primeira) {
				colspan++;
			}
			if (this.filtros.contadores[contador].retorno) {
				colspan++;
			}
			if (this.filtros.contadores[contador].local) {
				colspan++;
			}
			if (this.filtros.contadores[contador].total) {
				colspan++;
			}

			return colspan;
		},
		toogleAll: function toogleAll(contador) {
			if (this.filtros.contadores[contador].toogle) {
				this.filtros.contadores[contador].primeira = false;
				this.filtros.contadores[contador].retorno = false;
				this.filtros.contadores[contador].local = false;
				this.filtros.contadores[contador].total = false;
				this.filtros.contadores[contador].toogle = false;
			} else {
				this.filtros.contadores[contador].primeira = true;
				this.filtros.contadores[contador].retorno = true;
				this.filtros.contadores[contador].local = true;
				this.filtros.contadores[contador].total = true;
				this.filtros.contadores[contador].toogle = true;
			}
		},
		toogleLinhaAll: function toogleLinhaAll(linha) {
			if (this.filtros.contadores.toogle[linha]) {
				this.filtros.contadores.disponivel[linha] = false;
				this.filtros.contadores.agendado[linha] = false;
				this.filtros.contadores.bloqueado[linha] = false;
			} else {
				this.filtros.contadores.disponivel[linha] = true;
				this.filtros.contadores.agendado[linha] = true;
				this.filtros.contadores.bloqueado[linha] = true;
			}
		},
		isEmpty: function isEmpty(objeto) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(objeto).every(function (valor) {
				return valor === '';
			});
		},
		getPDF: function getPDF() {
			var _this3 = this;

			this.finalizado = true;
			this.$store.commit('TOGGLE_LOADING');
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$store.state.serverURI + "/api/relatorios/ofertasImprimir", this.filtros, this.$store.getters.getHeaderAuthFile).then(function (response) {
				_this3.$store.commit('TOGGLE_LOADING');
				var file = new Blob([response.data], {
					type: 'application/pdf'
				});
				var fileURL = window.URL.createObjectURL(file);
				_this3.pdf = fileURL;
				var self = _this3;
				_this3.heigthPdf = window.innerHeight - 65;
				console.log(window.innerHeight);
				setTimeout(function () {
					self.$refs.filtrar.scrollIntoView();
				}, 300);
				_this3.finalizado = false;
			}).catch(function (error) {
				_this3.$store.commit('throwException', error);
				_this3.finalizado = false;
			});
		}
	},
	components: {
		selectUnidade: __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade___default.a,
		selectProfissional: __WEBPACK_IMPORTED_MODULE_3__components_cadastros_profissionais_selectProfissional___default.a,
		selectProcedimento: __WEBPACK_IMPORTED_MODULE_4__components_cadastros_procedimentos_selectProcedimento___default.a,
		selectSubgrupo: __WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo___default.a,
		DataFiltro: __WEBPACK_IMPORTED_MODULE_6__components_componentes_DataFiltro___default.a
	}

};

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade__);







/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      pdf: null,
      heigthPdf: 900,
      finalizado: false,
      filtros: {
        ano: new Date().getFullYear(),
        mes: (new Date().getMonth() + 1).toString().padStart(2, '0'),
        unidade_id: ''
      },

      dataTable: []
    };
  },
  mounted: function mounted() {},

  methods: {
    getDataTable: function getDataTable() {
      var _this = this;

      var loader = this.$loading.show();
      this.finalizado = true;
      this.pdf = null;

      this.$store.commit("TOGGLE_LOADING");
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/ofertasAnual", config).then(function (response) {
        _this.dataTable = response.data;
        _this.$store.commit("TOGGLE_LOADING");
        _this.finalizado = false;
        loader.hide();
      }).catch(function (error) {
        _this.$store.commit("throwException", error);
        _this.finalizado = false;
        loader.hide();
      });
    },
    setUnidadeSelecionada: function setUnidadeSelecionada(unidadeSelecionada) {
      this.filtros.unidade_id = unidadeSelecionada.id;
    },
    getPDF: function getPDF() {},
    isEmpty: function isEmpty(objeto) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(objeto).every(function (valor) {
        return valor === "";
      });
    }
  },
  components: {
    selectUnidade: __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade___default.a
  }
};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade__);







/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      pdf: null,
      heigthPdf: 900,
      finalizado: false,
      filtros: {
        ano: new Date().getFullYear(),
        mes: (new Date().getMonth() + 1).toString().padStart(2, '0'),
        unidade_id: ''
      },

      dataTable: []
    };
  },
  mounted: function mounted() {},

  methods: {
    getDataTable: function getDataTable() {
      var _this = this;

      var loader = this.$loading.show();
      this.finalizado = true;
      this.pdf = null;

      this.$store.commit("TOGGLE_LOADING");
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/ofertasSubgrupoAnual", config).then(function (response) {
        _this.dataTable = response.data;
        _this.$store.commit("TOGGLE_LOADING");
        _this.finalizado = false;
        loader.hide();
      }).catch(function (error) {
        _this.$store.commit("throwException", error);
        _this.finalizado = false;
        loader.hide();
      });
    },
    setUnidadeSelecionada: function setUnidadeSelecionada(unidadeSelecionada) {
      this.filtros.unidade_id = unidadeSelecionada.id;
    },
    getPDF: function getPDF() {},
    isEmpty: function isEmpty(objeto) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(objeto).every(function (valor) {
        return valor === '';
      });
    }
  },
  components: {
    selectUnidade: __WEBPACK_IMPORTED_MODULE_2__components_cadastros_unidades_selectUnidade___default.a
  }
};

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cadastros_profissionais_selectProfissional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cadastros_procedimentos_selectProcedimento__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cadastros_procedimentos_selectProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_cadastros_procedimentos_selectProcedimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cadastros_pacientes_selectPaciente__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cadastros_pacientes_selectPaciente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cadastros_pacientes_selectPaciente__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cadastros_usuarios_selectUsuario__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cadastros_usuarios_selectUsuario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_cadastros_usuarios_selectUsuario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_componentes_DataFiltro__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_componentes_DataFiltro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_componentes_DataFiltro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);













/* harmony default export */ __webpack_exports__["default"] = {
    components: {
        selectUnidade: __WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade___default.a,
        selectProfissional: __WEBPACK_IMPORTED_MODULE_2__components_cadastros_profissionais_selectProfissional___default.a,
        selectProcedimento: __WEBPACK_IMPORTED_MODULE_3__components_cadastros_procedimentos_selectProcedimento___default.a,
        selectPaciente: __WEBPACK_IMPORTED_MODULE_4__components_cadastros_pacientes_selectPaciente___default.a,
        selectSubgrupo: __WEBPACK_IMPORTED_MODULE_5__components_cadastros_procedimentos_subgrupos_selectSubgrupo___default.a,
        selectUsuario: __WEBPACK_IMPORTED_MODULE_6__components_cadastros_usuarios_selectUsuario___default.a,
        DataFiltro: __WEBPACK_IMPORTED_MODULE_7__components_componentes_DataFiltro___default.a
    },

    data: function data() {
        return {
            pdf: null,
            heigthPdf: 900,
            finalizado: false,
            showTextDangerUnidadeSolicitante: false,
            showTextDangerProfissionalSolicitante: false,
            grupos: [],
            grupoSelecionado: "",
            filtros: {
                sintetico: false,
                solicitado: null,
                solicitado2: null,
                solicitadoOperador: null,
                agendado: null,
                agendado2: null,
                agendadoOperador: null,
                regulado: null,
                regulado2: null,
                reguladoOperador: null,
                unidade_solicitante_id: null,
                unidade_solicitande: "",
                unidade_prestadora_id: null,
                unidade_prestadora: "",
                profissional_solicitante_id: null,
                profissional_solicitante: "",
                profissional_prestador_id: null,
                profissional_prestador: "",
                procedimento_id: null,
                procedimento: "",
                paciente_id: null,
                paciente: "",
                marcador_id: null,
                marcador: "",
                regulador_id: null,
                regulador: "",
                grupo_id: null,
                grupo: "",
                subgrupo_id: null,
                subgrupo: "",

                tipo_atendimento: null,
                tipo_unidade: null,
                agrupamentos: null,
                ativos: null,
                situacoes: [__WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].MARCADA, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].EM_REGULACAO, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].REGULADA, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].NEGATIVADA, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_PENDENTE, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_ADICIONAL, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].CONFIRMADA, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].CANCELADA, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].FALTA, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].REALIZADA]
            },
            selectAgrupamentos: [{
                label: "Unidade solicitante",
                value: "unidade_solicitante"
            }, {
                label: "Unidade prestadora",
                value: "unidade_prestadora"
            }, {
                label: "Profissional solicitante",
                value: "profissional_solicitante"
            }, {
                label: "Profissional prestador",
                value: "profissional_prestador"
            }, {
                label: "Procedimento",
                value: "procedimento"
            }, {
                label: "Paciente",
                value: "paciente"
            }, {
                label: "Nome do pai",
                value: "nome_pai"
            }, {
                label: "Nome da mãe",
                value: "nome_ae"
            }, {
                label: "Nome do pai",
                value: "nome_pai"
            }, {
                label: "Nome do pai",
                value: "nome_pai"
            }, {
                label: "RG",
                value: "rg"
            }, {
                label: "Idade",
                value: "nome_pai"
            }, {
                label: "Situação da solicitação",
                value: "situacao_solicitacao"
            }, {
                label: "Tipo de solicitação",
                value: "tipo_solicitacao"
            }, {
                label: "Data da solicitação",
                value: "data_solicitacao"
            }, {
                label: "Data da realização",
                value: "data_realizacao"
            }, {
                label: "Marcador",
                value: "marcador"
            }, {
                label: "Regulador",
                value: "regulador"
            }, {
                label: "Agrupamentos de Unidades",
                value: "agrupamento_unidades"
            }, {
                label: "Grupo de Procedimento",
                value: "grupo"
            }, {
                label: "Subgrupo de Procedimento",
                value: "subgrupo"
            }, {
                label: "Município do Paciente",
                value: "municipio"
            }, {
                label: "Bairro do Paciente",
                value: "bairro"
            }, {
                label: "Horário da Solicitação",
                value: "horario_solicitacao"
            }, {
                label: "Horário da Realização",
                value: "horario_realizacao"
            }, {
                label: "Usuário Cancelamento",
                value: "usuario_cancelamento"
            }, {
                label: "Tipo de Agendamento",
                value: "tipo_agendamento"
            }, {
                label: "Data de Nascimento",
                value: "data_nascimento"
            }, {
                label: "Data de Cancelamento",
                value: "data_cancelamento"
            }],
            dataTable: {},
            ativos: {
                situacao: true,
                tipo: true,
                dt_solicitacao: true,
                dt_realizacao: true,
                cidadao: true,
                endereco: true,
                cidade: true,
                bairro: true,
                telefone: true,
                rg: true,
                nome_mae: true,
                dt_nascimento: true,
                idade: true,
                id: true,
                quantidade: true,
                tipo_consulta: true,
                procedimento: true,
                valor_prestador: true,
                valor: true,
                valor_s: true,
                unid_solic: true,
                unid_prest: true,
                prof_prest: true,
                prof_solic: true,
                marcador: true,
                regulador: true,
                agp_unidades: true,
                usu_cancelamento: true,
                dt_cancelamento: true
            }
        };
    },
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */];
        },
        TIPO_ATENDIMENTO: function TIPO_ATENDIMENTO() {
            return __WEBPACK_IMPORTED_MODULE_8__constants__["e" /* TIPO_ATENDIMENTO */];
        },
        TIPO_UNIDADE: function TIPO_UNIDADE() {
            return __WEBPACK_IMPORTED_MODULE_8__constants__["m" /* TIPO_UNIDADE */];
        }
    },
    mounted: function mounted() {
        if (this.$store.state.user.nivel == "prestador") {
            this.ativos.id = false;
            this.ativos.valor = false;
            this.ativos.valor_s = false;
            this.dt_solicitacao = false;
            this.marcador = false;
            this.regulador = false;
            this.agp_unidades = false;
            this.usu_cancelamento = false;
            this.filtros.situacoes = [__WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].MARCADA, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].CONFIRMADA, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].CANCELADA, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].FALTA, __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* SITUACAO_SOLICITACAO */].REALIZADA];
        }
        this.getGrupos();
    },


    methods: {
        getPDF: function getPDF(modelo) {
            var _this = this;

            this.finalizado = true;
            this.filtros.ativos = this.ativos;
            this.$store.commit("TOGGLE_LOADING");
            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(this.$store.state.serverURI + "/api/relatorios/solicitacaoImprimir", this.filtros, this.$store.getters.getHeaderAuthFile).then(function (response) {
                _this.$store.commit("TOGGLE_LOADING");
                var file = new Blob([response.data], {
                    type: "application/pdf"
                });
                var fileURL = window.URL.createObjectURL(file);
                _this.pdf = fileURL;
                var self = _this;
                _this.heigthPdf = window.innerHeight - 65;
                console.log(window.innerHeight);
                setTimeout(function () {
                    self.$refs.filtrar.scrollIntoView();
                }, 300);
                _this.finalizado = false;
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
                _this.finalizado = false;
            });
        },
        getCSV: function getCSV() {
            var _this2 = this;

            this.$swal({
                title: "Fazer download das informa\xE7\xF5es num arquivo CSV?",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    _this2.finalizado = true;
                    _this2.filtros.ativos = _this2.ativos;
                    __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(_this2.$store.state.serverURI + "/api/relatorios/solicitacaoCSV", _this2.filtros, _this2.$store.getters.getHeaderAuthFile).then(function (response) {
                        console.log(response.data);
                        var file = new Blob([response.data]);
                        var fileURL = window.URL.createObjectURL(file);
                        var fileLink = document.createElement("a");
                        fileLink.href = fileURL;
                        fileLink.setAttribute("download", "relatorio_solicitacoes" + new Date().toString() + ".csv");
                        document.body.appendChild(fileLink);
                        fileLink.click();

                        _this2.finalizado = false;
                    }).catch(function (error) {
                        console.log(error);
                        _this2.finalizado = false;
                    });
                }
            });
        },
        isEmpty: function isEmpty(objeto) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(objeto).every(function (valor) {
                return valor === "";
            });
        },
        verificarCancelamento: function verificarCancelamento(solicitacao) {
            var _this3 = this;

            var text = "Não foi cancelada";
            var data = "Não foi cancelada";
            solicitacao.solicitacao_historicos.forEach(function (element) {
                if (element.situacao == _this3.SITUACAO_SOLICITACAO.CANCELADA) {
                    text = element.usuario.name;
                    data = element.data.split("-").reverse().join("/");
                }
            });

            var info = {
                text: text,
                data: data
            };

            return info;
        },
        verificarRegulacao: function verificarRegulacao(solicitacao) {
            var _this4 = this;

            var text = "Não foi regulada";
            solicitacao.solicitacao_historicos.forEach(function (element) {
                if (element.situacao == _this4.SITUACAO_SOLICITACAO.REGULADA) {
                    text = element.usuario.name;
                }
            });

            if (text == 'Não foi regulada') {
                solicitacao.solicitacao_historicos.forEach(function (element) {
                    if (element.situacao == _this4.SITUACAO_SOLICITACAO.NEGATIVADA) {
                        text = element.usuario.name;
                    }
                });
            }

            return text;
        },
        getDataTable: function getDataTable(page) {
            var _this5 = this;

            if (!this.filtros.solicitado) {
                this.$swal({
                    type: "warning",
                    title: "Atenção!",
                    text: "É necessário selecionar o período em que as solicitações foram feitas!",
                    showConfirmButton: true
                });
                return;
            }

            if (typeof page === "undefined") {
                page = 1;
            }

            this.finalizado = true;
            this.pdf = null;

            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");
            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/solicitacao", config).then(function (response) {
                _this5.dataTable = response.data;
                _this5.finalizado = false;
                _this5.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this5.finalizado = false;
                _this5.$store.commit("throwException", error);
            });
        },
        getGrupos: function getGrupos() {
            var _this6 = this;

            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/grupos-procedimento/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
                _this6.grupos = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        },
        setUnidadeSolicitante: function setUnidadeSolicitante(unidadeSolicitante) {
            this.filtros.unidade_solicitante_id = unidadeSolicitante.id;
            this.filtros.undidade_solicitante = unidadeSolicitante.nome;
        },
        setUnidadePrestadora: function setUnidadePrestadora(unidadePrestadora) {
            this.filtros.unidade_prestadora_id = unidadePrestadora.id;
            this.filtros.unidade_prestadora = unidadePrestadora.nome;
        },
        setProfissionalSolicitante: function setProfissionalSolicitante(profissionalSolicitante) {
            this.filtros.profissional_solicitante_id = profissionalSolicitante.id;
            this.filtros.profissional_solicitante = profissionalSolicitante.nome;
        },
        setProfissionalPrestador: function setProfissionalPrestador(profissionalPrestador) {
            this.filtros.profissional_prestador_id = profissionalPrestador.id;
            this.filtros.profissional_prestador = profissionalPrestador.nome;
        },
        setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
            this.filtros.procedimento_id = procedimentoSelecionado.id;
            this.filtros.procedimento = procedimentoSelecionado.nome;
        },
        setPacienteSelecionado: function setPacienteSelecionado(paciente) {
            this.filtros.paciente_id = paciente.id;
            this.filtros.paciente = paciente.nome;
        },
        setSubgrupoSelecionado: function setSubgrupoSelecionado(subgrupoSelecionado) {
            this.filtros.subgrupo_id = subgrupoSelecionado.id;
            this.filtros.subgrupo = subgrupoSelecionado.nome;
        },
        setUsuarioMarcadorSelecionado: function setUsuarioMarcadorSelecionado(usuario) {
            this.filtros.marcador_id = usuario.id;
            this.filtros.marcador = usuario.name;
        },
        setUsuarioReguladorSelecionado: function setUsuarioReguladorSelecionado(usuario) {
            this.filtros.regulador_id = usuario.id;
            this.filtros.regulador = usuario.name;
        },
        setGrupoSelecionado: function setGrupoSelecionado() {
            this.filtros.grupo_id = this.grupoSelecionado.id;
            this.filtros.grupo = this.grupoSelecionado.nome;
        }
    }
};

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cadastros_procedimentos_selectProcedimento__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cadastros_procedimentos_selectProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cadastros_procedimentos_selectProcedimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    selectUnidade: __WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade___default.a,
    selectProcedimento: __WEBPACK_IMPORTED_MODULE_1__components_cadastros_procedimentos_selectProcedimento___default.a
  },
  computed: {
    SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
      return __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */];
    }
  },
  data: function data() {
    return {
      filtros: {
        distribuicao_id: null,
        unidade_id: "",
        procedimento_id: "",
        situacoes: [__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].MARCADA, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].EM_REGULACAO, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].REGULADA, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].NEGATIVADA, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_PENDENTE, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_ADICIONAL, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].CONFIRMADA, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].CANCELADA, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].FALTA, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].REALIZADA]
      },
      dataTable: {},
      finalizado: true,
      distribuicoes: []
    };
  },
  mounted: function mounted() {
    this.getDistribuicoes();
    if (this.$store.state.user.nivel == "prestador") {
      this.filtros.situacoes = [__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].MARCADA, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].CONFIRMADA, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].CANCELADA, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].FALTA, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SITUACAO_SOLICITACAO */].REALIZADA];
    }
  },

  methods: {
    getDataTable: function getDataTable(page) {
      var _this = this;

      if (typeof page === "undefined") {
        page = 1;
      }

      this.filtros.page = page;
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      this.finalizado = false;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/solicitacao-sintetico", config).then(function (response) {
        _this.dataTable = response.data;
        _this.finalizado = true;
      }).catch(function (error) {
        console.log(error);
        _this.finalizado = true;
      });
    },
    setUnidadeSolicitante: function setUnidadeSolicitante(unidadeSolicitante) {
      this.filtros.unidade_id = unidadeSolicitante.id;
    },
    setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
      this.filtros.procedimento_id = procedimentoSelecionado.id;
    },
    getDistribuicoes: function getDistribuicoes() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
        _this2.distribuicoes = response.data;
        _this2.filtros.distribuicao_id = _this2.distribuicoes[0].id;
        _this2.getDataTable();
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  watch: {}
};

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = {
	computed: {
		TIPO_CONTRATO: function TIPO_CONTRATO() {
			return __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* TIPO_CONTRATO */];
		}
	},
	filters: {
		unidades: function unidades(val) {
			var unidades = "";
			for (var i = 0; i < val.length; i++) {
				unidades += val[i].nome;
				if (i + 1 < val.length) {
					unidades += ", ";
				}
			}

			return unidades;
		},
		situacao: function situacao(val) {
			if (val == 1) return "ATIVO";
			return "INATIVO";
		}
	},
	data: function data() {
		return {
			pdf: null,
			heigthPdf: 900,
			finalizado: false,
			filtros: {
				nivel: "",
				unidade_id: null,
				situacao: ""
			},
			dataTable: {}
		};
	},
	mounted: function mounted() {},


	methods: {
		sortByKey: function sortByKey(field) {
			this.filtros.coluna = field;
			if (this.filtros.ordem == "asc") {
				this.filtros.ordem = "desc";
			} else {
				this.filtros.ordem = "asc";
			}
		},
		getDataTable: function getDataTable(page) {
			var _this = this;

			this.finalizado = true;
			this.pdf = null;
			if (typeof page === "undefined") {
				page = 1;
			}
			this.filtros.page = page;
			this.$store.commit("TOGGLE_LOADING");
			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/usuarios", config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit("TOGGLE_LOADING");
				_this.finalizado = false;
			}).catch(function (error) {
				_this.$store.commit("throwException", error);
				_this.finalizado = false;
			});
		},
		getPDF: function getPDF() {
			var _this2 = this;

			this.finalizado = true;
			this.$store.commit("TOGGLE_LOADING");
			var config = this.$store.getters.getHeaderAuthFile;
			config.params = this.filtros;
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/relatorios/usuariosImprimir", config).then(function (response) {
				_this2.$store.commit("TOGGLE_LOADING");
				var file = new Blob([response.data], {
					type: "application/pdf"
				});
				var fileURL = window.URL.createObjectURL(file);
				_this2.pdf = fileURL;
				var self = _this2;
				_this2.heigthPdf = window.innerHeight - 65;
				console.log(window.innerHeight);
				setTimeout(function () {
					self.$refs.filtrar.scrollIntoView();
				}, 300);
				_this2.finalizado = false;
			}).catch(function (error) {
				_this2.$store.commit("throwException", error);
				_this2.finalizado = false;
			});
		},
		setUnidadeSelecionada: function setUnidadeSelecionada(unidadeSelecionada) {
			this.filtros.unidade_id = unidadeSelecionada.id;
		}
	},
	watch: {
		page: function page(val) {
			this.getDataTable();
		}
	},

	components: {
		selectUnidade: __WEBPACK_IMPORTED_MODULE_0__components_cadastros_unidades_selectUnidade___default.a
	}
};

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoBoleto__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoBoleto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoBoleto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
    data: function data() {
        return {
            solicitacao: {
                created_at: "",
                id: "",
                paciente: {
                    nome: ""
                },
                itens: [{
                    contrato_procedimento: {
                        contrato: {
                            unidade: {
                                nome: ""
                            }
                        },
                        procedimento: {
                            nome: ""
                        }
                    },
                    contrato_procedimento_atendimento: {
                        profissional: {
                            nome: ""
                        }
                    }
                }],
                paciente_id: "",
                profissional: "",
                profissional_solicitante_id: "",
                situacao: "",
                solicitacao_historicos: [],
                diagnosticos: [],
                updated_at: "",
                usuario: "",
                usuario_solicitante_id: ""
            }
        };
    },
    mounted: function mounted() {
        this.getSolicitacao();
    },
    updated: function updated() {
        window.print();
        window.close();
    },

    methods: {
        getSolicitacao: function getSolicitacao() {
            var _this = this;

            this.$store.commit("TOGGLE_LOADING");
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/atendimentos/boleto/" + this.$route.params.solicitacaoId, this.$store.getters.getHeaderAuth).then(function (response) {
                _this.solicitacao = response.data;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    watch: {},
    components: {
        solicitacaoBoleto: __WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoBoleto___default.a
    }
};

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    props: ["show", "naoRealizados", "regulacao"],
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {},
    watch: {
        "$props.show": function $propsShow(val) {
            var _this = this;

            if (val) {
                this.$nextTick(function () {
                    return _this.$refs.selecionarProfissional.focus();
                });
            }
        }
    }
};

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_barcode__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = {
    props: ["solicitacao"],
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* SITUACAO_SOLICITACAO */];
        }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        nomeProfissionalCancelar: function nomeProfissionalCancelar(solicitacao) {
            var _this = this;

            var text = "";
            solicitacao.solicitacao_historicos.forEach(function (element) {
                if (element.situacao == _this.SITUACAO_SOLICITACAO.CANCELADA) {
                    text = element.usuario.name;
                }
            });
            return text;
        },
        justificativaCancelamento: function justificativaCancelamento(solicitacao) {
            var _this2 = this;

            var text = "";
            solicitacao.solicitacao_historicos.forEach(function (element) {
                if (element.situacao == _this2.SITUACAO_SOLICITACAO.CANCELADA) {
                    text = element.observacao;
                }
            });
            return text;
        },
        adicionarDiasData: function adicionarDiasData(data, dias) {
            var entrada = new Date(data);
            var dataVenc = new Date(entrada.getTime() + dias * 24 * 60 * 60 * 1000);
            return dataVenc;
        }
    },
    watch: {},
    components: {
        barcode: __WEBPACK_IMPORTED_MODULE_0_vue_barcode___default.a
    }
};

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    props: ["solicitacao", "showInfo"],
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {},
    watch: {},
    components: {}
};

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
	props: ['solicitacao'],
	data: function data() {
		return {};
	},
	mounted: function mounted() {},

	methods: {},
	watch: {},
	components: {}
};

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = {
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* SITUACAO_SOLICITACAO */];
        },
        dataRealizacao: function dataRealizacao() {
            if (this.solicitacao.itens[0].contrato_procedimento_atendimento) {
                return this.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento;
            } else {
                return this.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento;
            }
        }
    },
    data: function data() {
        return {
            codigo: "",
            dataAtual: new Date(),
            solicitacao: {
                created_at: "",
                diagnosticos: "",
                id: "",
                itens: [{
                    contrato_procedimento: {
                        contrato: {
                            unidade: {
                                nome: ""
                            }
                        },
                        procedimento: {
                            codigo: "",
                            nome: ""
                        }
                    },
                    contrato_procedimento_atendimento: {
                        profissional: {
                            nome: ""
                        }
                    }
                }],
                paciente: {
                    cartao_sus: "",
                    cartorio_auxiliar: "",
                    cpf: "",
                    created_at: "",
                    data_emissao_auxiliar: "",
                    data_emissao_rg: "",
                    data_nascimento: "",
                    endereco: "",
                    estado_civil: "",
                    folha_auxiliar: "",
                    id: "",
                    livro_auxiliar: "",
                    naturalidade: "",
                    nome: "",
                    nome_mae: "",
                    nome_pai: "",
                    nome_responsavel: "",
                    ocupacao: "",
                    orgao_emissor_rg: "",
                    registro_auxiliar: "",
                    rg: "",
                    sexo: "",
                    situacao: "",
                    telefone: "",
                    tipo_certidao_auxiliar: "",
                    uf_rg: "",
                    updated_at: "",
                    cidade: {
                        nome: "",
                        uf: {
                            uf: ""
                        }
                    }
                },
                paciente_id: "",
                profissional: "",
                situacao: "",
                solicitacao_historicos: "",
                tipo_atendimento: "",
                updated_at: "",
                usuario: ""
            }
        };
    },
    mounted: function mounted() {},

    methods: {
        getById: function getById() {
            var _this = this;

            this.$swal({
                title: "Aguarde...",
                imageUrl: "/static/img/Rolling-green.gif",
                showConfirmButton: false,
                allowOutsideClick: false
            });
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/atendimentos/atendidoFalta/" + this.codigo, this.$store.getters.getHeaderAuth).then(function (response) {
                if (response.data) {
                    _this.solicitacao = response.data;
                    _this.$swal.close();
                } else {
                    _this.$swal({
                        title: "Solicitação não encontrada!",
                        text: "A solicitação não existe ou não foi realizada nesta unidade.",
                        type: "warning"
                    });
                }
            }).catch(function (error) {
                _this.$swal.close();
                _this.$store.commit("throwException", error);
            });
        },
        atualizarSituacao: function atualizarSituacao(situacaoAtual, title) {
            var _this2 = this;

            var dados = {
                solicitacaoId: this.solicitacao.id,
                situacao: situacaoAtual
            };
            this.$swal({
                title: title,
                text: "Esta ação não poderá ser desfeita.",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this2.$store.state.serverURI + "/api/atendimentos/atualizarSituacao", dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
                        _this2.solicitacao = response.data;
                        _this2.$swal({
                            type: "success",
                            title: "Solicitação atualizada com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this2.$store.commit("TOGGLE_LOADING");
                    }).catch(function (error) {
                        _this2.$store.commit("throwException", error);
                    });
                }
            });
        }
    },
    watch: {},
    components: {}
};

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabelaSolicitacoes__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabelaSolicitacoes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tabelaSolicitacoes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = {
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* SITUACAO_SOLICITACAO */];
        }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {},
    watch: {},
    components: { TabelaSolicitacoes: __WEBPACK_IMPORTED_MODULE_0__tabelaSolicitacoes___default.a }
};

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comuns_solicitacaoDetalhes__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comuns_solicitacaoDetalhes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__comuns_solicitacaoDetalhes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comuns_modalNaoRealizados__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comuns_modalNaoRealizados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__comuns_modalNaoRealizados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__comuns_solicitacaoHistorico__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__comuns_solicitacaoHistorico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__comuns_solicitacaoHistorico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = {
    components: { solicitacaoDetalhes: __WEBPACK_IMPORTED_MODULE_1__comuns_solicitacaoDetalhes___default.a, solicitacaoHistorico: __WEBPACK_IMPORTED_MODULE_3__comuns_solicitacaoHistorico___default.a, modalNaoRealizados: __WEBPACK_IMPORTED_MODULE_2__comuns_modalNaoRealizados___default.a },
    data: function data() {
        return {
            showModalNaoRealizados: false,
            showInfo: false,
            naoRealizados: [],
            solicitacao: {
                created_at: "",
                id: "",
                itens: [{
                    contrato_procedimento: {
                        contrato: {
                            unidade: {
                                nome: ""
                            }
                        },
                        procedimento: {
                            nome: ""
                        }
                    },
                    contrato_procedimento_atendimento: {
                        profissional: {
                            nome: ""
                        }
                    }
                }],
                paciente: "",
                paciente_id: "",
                profissional: "",
                profissional_solicitante_id: "",
                situacao: "",
                solicitacao_historicos: [],
                diagnosticos: [],
                updated_at: "",
                usuario: "",
                usuario_solicitante_id: ""
            },
            filtros: {
                pesquisa: "",
                coluna: null,
                ordem: null
            },
            dataTable: {},
            dados: { observacao: "" },
            historicoAntigo: {},
            historico: {}
        };
    },
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_4__constants__["i" /* SITUACAO_SOLICITACAO */];
        }
    },
    mounted: function mounted() {
        this.solicitacaoId = this.$route.params.solicitacaoId;
        if (this.solicitacaoId) {
            this.boxTitle = "Regulação de Atendimentos";
            this.getSolicitacao(this.solicitacaoId);
        }
    },

    methods: {
        getNaoRealizados: function getNaoRealizados() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/pacientes/getNaoRealizados/" + this.solicitacao.paciente_id, this.$store.getters.getHeaderAuth).then(function (response) {
                _this.naoRealizados = response.data;
                if (_this.naoRealizados.length > 0) {
                    _this.showModalNaoRealizados = true;
                    _this.showInfo = true;
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        getSolicitacao: function getSolicitacao(solicitacaoId) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/atendimentos/getById/" + this.solicitacaoId, this.$store.getters.getHeaderAuth).then(function (response) {
                _this2.solicitacao = response.data;
                _this2.getHistorico();
                _this2.getHistoricoAntigo();
                _this2.getNaoRealizados();
            }).catch(function (error) {
                console.log(error);
            });
        },
        negativar: function negativar() {
            var _this3 = this;

            this.$swal({
                title: "Justificativa da negativa:",
                type: "error",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: function inputValidator(value) {
                    return !value && "Insira a justificativa!";
                },
                preConfirm: function preConfirm(observacao) {
                    _this3.dados.observacao = observacao;
                }
            }).then(function (result) {
                var loader = _this3.$loading.show();
                _this3.$store.commit("TOGGLE_LOADING");
                _this3.dados.solicitacaoId = _this3.solicitacaoId;
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this3.$store.state.serverURI + "/api/atendimentos/negativar", _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
                        loader.hide();
                        _this3.$store.commit("TOGGLE_LOADING");
                        _this3.$swal({
                            type: "success",
                            title: "Solicitação negativada com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this3.$router.go(-1);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        informacaoPendente: function informacaoPendente() {
            var _this4 = this;

            this.dados.situacao = this.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE;
            this.$swal({
                title: "Mensagem para o marcador:",
                type: "info",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-paper-plane"></i> Enviar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: function inputValidator(value) {
                    return !value && "Insira a mensagem!";
                },
                preConfirm: function preConfirm(observacao) {
                    _this4.dados.observacao = observacao;
                }
            }).then(function (result) {
                var loader = _this4.$loading.show();
                _this4.$store.commit("TOGGLE_LOADING");
                _this4.dados.solicitacaoId = _this4.solicitacaoId;
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this4.$store.state.serverURI + "/api/atendimentos/atualizarSituacao", _this4.dados, _this4.$store.getters.getHeaderAuth).then(function (response) {
                        loader.hide();
                        _this4.$store.commit("TOGGLE_LOADING");
                        _this4.$swal({
                            type: "success",
                            title: "Mensagem enviada com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this4.$router.go(-1);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        agendar: function agendar() {
            this.$router.push("/atendimentos/solicitacao/resolucao/" + this.solicitacaoId);
        },
        getHistorico: function getHistorico(page) {
            var _this5 = this;

            if (typeof page === "undefined") {
                page = 1;
            }

            var config = this.$store.getters.getHeaderAuth;
            config.params = {
                page: page
            };

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/pacientes/getHistorico/" + this.solicitacao.paciente_id, config).then(function (response) {
                _this5.historico = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        },
        getHistoricoAntigo: function getHistoricoAntigo(page) {
            var _this6 = this;

            if (typeof page === "undefined") {
                page = 1;
            }

            var config = this.$store.getters.getHeaderAuth;
            config.params = {
                page: page
            };

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/pacientes/getHistoricoAntigo/" + this.solicitacao.paciente_id, config).then(function (response) {
                _this6.historicoAntigo = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    watch: {}
};

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_pacientes_selectPaciente__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_pacientes_selectPaciente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cadastros_pacientes_selectPaciente__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cadastros_usuarios_selectMarcador__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cadastros_usuarios_selectMarcador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_cadastros_usuarios_selectMarcador__);







/* harmony default export */ __webpack_exports__["default"] = {
    props: ["situacao"],
    data: function data() {
        return {
            filtros: {
                unidade_id: "",
                procedimento_id: "",
                paciente_id: "",
                categoria_unidade: "",
                usuario_solicitante_id: "",
                coluna: null,
                ordem: null
            },
            procedimentos: [],
            procedimentoSelecionado: {},

            categoriaUnidadeSelecionada: {},

            unidades: [],
            categorias: [{ nome: "PÚBLICA (LOCAL)", id: 0 }, { nome: "MUNICÍPIO PACTUADO", id: 1 }, { nome: "PRIVADA", id: 2 }],
            unidadeSelecionada: {},
            dataTable: {}
        };
    },
    mounted: function mounted() {
        this.filtros.unidade_id = this.$route.query.unidade_id ? this.$route.query.unidade_id : "";
        this.filtros.procedimento_id = this.$route.query.procedimento_id ? this.$route.query.procedimento_id : "";
        this.filtros.categoria_unidade = this.$route.query.categoria_unidade ? this.$route.query.categoria_unidade : "";
        this.filtros.usuario_solicitante_id = this.$route.query.usuario_solicitante_id ? this.$route.query.usuario_solicitante_id : "";
        this.filtros.paciente_id = this.$route.query.paciente_id ? this.$route.query.paciente_id : "";
        this.unidadeSelecionada = this.$store.state.filtrosRegulador.unidadeSelecionada;
        this.procedimentoSelecionado = this.$store.state.filtrosRegulador.procedimentoSelecionado;
        this.categoriaUnidadeSelecionada = this.$store.state.filtrosRegulador.categoriaUnidadeSelecionada;
        this.getDataTable();
        this.getProcedimentos();
        this.getUnidades();
    },

    methods: {
        sortByKey: function sortByKey(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getDataTable();
        },
        setPacienteSelecionado: function setPacienteSelecionado(paciente) {
            this.filtros.paciente_id = paciente.id;
            this.$store.state.filtrosRegulador.pacienteSelecionado = paciente;
        },
        setMarcadorSelecionado: function setMarcadorSelecionado(marcador) {
            this.filtros.usuario_solicitante_id = marcador.id;
            this.$store.state.filtrosRegulador.marcadorSelecionado = marcador;
        },
        getProcedimentos: function getProcedimentos() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/procedimentos/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
                _this.procedimentos = response.data;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
            });
        },
        getUnidades: function getUnidades() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/unidades/dataForSelect", this.$store.getters.getHeaderAuth).then(function (response) {
                _this2.unidades = response.data;
                _this2.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this2.$store.commit("throwException", error);
            });
        },
        getDataTable: function getDataTable(page) {
            var _this3 = this;

            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.$router.push({ query: this.filtros });
            this.$store.commit("TOGGLE_LOADING");
            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            config.params.situacao = this.situacao;
            config.params.doDia = config.params.situacao.length == 1 && config.params.situacao[0] == __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* SITUACAO_SOLICITACAO */].REGULADA ? 1 : 0;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/atendimentos/getSolicitacoes", config).then(function (response) {
                _this3.dataTable = response.data;
                _this3.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this3.$store.commit("throwException", error);
            });
        }
    },
    watch: {
        page: function page(val) {
            if (val > 1) {
                this.getDataTable();
            }
        },
        procedimentoSelecionado: function procedimentoSelecionado(val) {
            if (val) {
                this.filtros.procedimento_id = val.id;
            } else {
                this.filtros.procedimento_id = null;
            }
            this.$store.state.filtrosRegulador.procedimentoSelecionado = val;
        },

        unidadeSelecionada: function unidadeSelecionada(val) {
            if (val) {
                this.filtros.unidade_id = val.id;
            } else {
                this.filtros.unidade_id = null;
            }
            this.$store.state.filtrosRegulador.unidadeSelecionada = val;
        },
        categoriaUnidadeSelecionada: function categoriaUnidadeSelecionada(val) {
            if (val) {
                this.filtros.categoria_unidade = val.id;
            } else {
                this.filtros.categoria_unidade = null;
            }
            this.$store.state.filtrosRegulador.categoriaUnidadeSelecionada = val;
        }
    },
    components: { selectPaciente: __WEBPACK_IMPORTED_MODULE_2__components_cadastros_pacientes_selectPaciente___default.a, selectMarcador: __WEBPACK_IMPORTED_MODULE_3__components_cadastros_usuarios_selectMarcador___default.a }
};

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_usuarios_selectUsuario__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_usuarios_selectUsuario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cadastros_usuarios_selectUsuario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cadastros_procedimentos_selectProcedimento__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cadastros_procedimentos_selectProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_cadastros_procedimentos_selectProcedimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cadastros_profissionais_selectProfissional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = {
    props: ["pacienteId", "showInfo"],
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* SITUACAO_SOLICITACAO */];
        },
        SITUACAO_SOLICITACAO_ANTIGA: function SITUACAO_SOLICITACAO_ANTIGA() {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["j" /* SITUACAO_SOLICITACAO_ANTIGA */];
        }
    },
    components: { selectProfissional: __WEBPACK_IMPORTED_MODULE_4__cadastros_profissionais_selectProfissional___default.a, selectUnidade: __WEBPACK_IMPORTED_MODULE_1__components_cadastros_unidades_selectUnidade___default.a, selectProcedimento: __WEBPACK_IMPORTED_MODULE_3__components_cadastros_procedimentos_selectProcedimento___default.a, selectUsuario: __WEBPACK_IMPORTED_MODULE_2__components_cadastros_usuarios_selectUsuario___default.a },
    data: function data() {
        return {
            historicoAntigo: {},
            historico: {},
            filtros: {
                unidade_solicitante_id: "",
                unidade_realizadora_id: "",
                procedimento_id: "",
                profissional_realizador_id: "",
                profissional_solicitante_id: "",
                profissional_marcador_id: "",
                situacao: "",
                data_solicitacao: "",
                data_realizacao: ""
            },
            filtrosAntigo: {
                unidade_solicitante: "",
                unidade_realizadora: "",
                procedimento: "",
                profissional_realizador: "",
                profissional_solicitante: "",
                profissional_marcador: "",
                situacao: "",
                data_solicitacao: "",
                data_realizacao: ""
            }
        };
    },
    mounted: function mounted() {},

    methods: {
        setUnidadeSolicitante: function setUnidadeSolicitante(unidadeSolicitante) {
            this.filtros.unidade_solicitante_id = unidadeSolicitante.id;
        },
        setUnidadePrestadora: function setUnidadePrestadora(unidadePrestadora) {
            this.filtros.unidade_realizadora_id = unidadePrestadora.id;
        },
        setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
            this.filtros.procedimento_id = procedimentoSelecionado.id;
        },
        setProfissionalSolicitanteSelecionado: function setProfissionalSolicitanteSelecionado(profissional) {
            this.filtros.profissional_solicitante_id = profissional.id;
        },
        setUsuarioSelecionado: function setUsuarioSelecionado(usuario) {
            this.filtros.profissional_marcador_id = usuario.id;
        },
        setProfissionalRealizadorSelecionado: function setProfissionalRealizadorSelecionado(profissional) {
            this.filtros.profissional_realizador_id = profissional.id;
        },
        getHistorico: function getHistorico(page) {
            var _this = this;

            if (typeof page === "undefined") {
                page = 1;
            }

            var config = this.$store.getters.getHeaderAuth;
            this.filtros.page = page;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/pacientes/getHistorico/" + this.$props.pacienteId, config).then(function (response) {
                _this.historico = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        },
        getHistoricoAntigo: function getHistoricoAntigo(page) {
            var _this2 = this;

            if (typeof page === "undefined") {
                page = 1;
            }

            var config = this.$store.getters.getHeaderAuth;
            this.filtrosAntigo.page = page;
            config.params = this.filtrosAntigo;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/pacientes/getHistoricoAntigo/" + this.$props.pacienteId, config).then(function (response) {
                _this2.historicoAntigo = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    watch: {
        "$props.pacienteId": function $propsPacienteId(val) {
            if (val) {
                this.getHistorico();
                this.getHistoricoAntigo();
            }
        }
    }
};

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cadastros_pacientes_selectPaciente__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cadastros_pacientes_selectPaciente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cadastros_pacientes_selectPaciente__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modalAddProcedimentos__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modalAddProcedimentos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modalAddProcedimentos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalQuantidadeProcedimentos__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalQuantidadeProcedimentos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modalQuantidadeProcedimentos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__comuns_modalNaoRealizados__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__comuns_modalNaoRealizados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__comuns_modalNaoRealizados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__historicos__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__historicos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__historicos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modalAddDiagnosticos__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modalAddDiagnosticos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__modalAddDiagnosticos__);











/* harmony default export */ __webpack_exports__["default"] = {
    filters: {
        tipo_consulta: function tipo_consulta(val) {
            if (val == 0) {
                return "Primeira";
            } else if (val == 1) {
                return "Retorno";
            } else if (val == 2) {
                return "Local";
            }
        }
    },
    components: {
        selectPaciente: __WEBPACK_IMPORTED_MODULE_2__cadastros_pacientes_selectPaciente___default.a,
        selectProfissional: __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional___default.a,
        modalAddProcedimentos: __WEBPACK_IMPORTED_MODULE_4__modalAddProcedimentos___default.a,
        modalQuantidadeProcedimentos: __WEBPACK_IMPORTED_MODULE_5__modalQuantidadeProcedimentos___default.a,
        modalAddDiagnosticos: __WEBPACK_IMPORTED_MODULE_8__modalAddDiagnosticos___default.a,
        historicos: __WEBPACK_IMPORTED_MODULE_7__historicos___default.a,
        modalNaoRealizados: __WEBPACK_IMPORTED_MODULE_6__comuns_modalNaoRealizados___default.a
    },
    data: function data() {
        return {
            showModalNaoRealizados: false,
            showInfo: false,
            showModalAddDiagnosticos: false,
            showModalAddProcedimentos: false,
            showModalQuantidadeProcedimentos: false,
            showTextDangerPaciente: false,
            showTextDangerProcedimento: false,
            showTextDangerProfissional: false,
            focusAdicionarDiagnositico: false,
            unidades: [],
            profissionais: [],
            naoRealizados: [],
            procedimentos: [],
            distribuicoes: [],
            distribuicaoId: "",
            contratoSolicitanteSelecionado: null,
            contratoProcedimentoTemp: {
                procedimento: {
                    codigo: "",
                    nome: ""
                }
            },
            dados: {
                unidadeSolicitante: null,
                paciente: {
                    nome: "",
                    nome_mae: "",
                    data_nascimento: "",
                    rg: "",
                    cartao_sus: "",
                    cidade: {
                        nome: ""
                    }
                },
                profissionalSolicitante: {
                    nome: "",
                    situacao: "",
                    data_admissao: "",
                    data_desligamento: "",
                    data_nascimento: "",
                    sexo: "",
                    rg: "",
                    orgao_emissor: "",
                    uf_orgao_emissor: "",
                    data_emissao: "",
                    cpf: "",
                    telefone: "",
                    hora_inicial: "",
                    hora_final: ""
                },
                diagnosticos: [],
                procedimentos: [],
                solicitacao_regulacao: false,
                dados_recuperados: false
            }
        };
    },
    mounted: function mounted() {
        if (this.$store.state.solicitacao.dadosResolucao) {
            if (!this.$store.state.solicitacao.dadosResolucao.dados_recuperados) {
                this.$store.state.solicitacao.dadosResolucao = null;
            } else {
                this.dados = this.$store.state.solicitacao.dadosResolucao;
            }
        }
        this.getDistribuicoes();
        this.focoUnidades();
    },

    methods: {
        mudarDistribuicao: function mudarDistribuicao() {
            this.contratoSolicitanteSelecionado = null;
            this.dados = this.estadoInicial();
        },
        estadoInicial: function estadoInicial() {
            var dados = {
                unidadeSolicitante: null,
                paciente: {
                    nome: "",
                    nome_mae: "",
                    data_nascimento: "",
                    rg: "",
                    cartao_sus: "",
                    cidade: {
                        nome: ""
                    }
                },
                profissionalSolicitante: {
                    nome: "",
                    situacao: "",
                    data_admissao: "",
                    data_desligamento: "",
                    data_nascimento: "",
                    sexo: "",
                    rg: "",
                    orgao_emissor: "",
                    uf_orgao_emissor: "",
                    data_emissao: "",
                    cpf: "",
                    telefone: "",
                    hora_inicial: "",
                    hora_final: ""
                },
                diagnosticos: [],
                procedimentos: [],
                solicitacao_regulacao: false,
                dados_recuperados: false
            };

            return dados;
        },
        getNaoRealizados: function getNaoRealizados() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/pacientes/getNaoRealizados/" + this.dados.paciente.id, this.$store.getters.getHeaderAuth).then(function (response) {
                _this.naoRealizados = response.data;
                if (_this.naoRealizados.length > 0) {
                    _this.showModalNaoRealizados = true;
                    _this.showInfo = true;
                } else {
                    _this.showInfo = false;
                    _this.$refs.btnProfissional.abrirModal();
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        validar: function validar() {
            if (this.isEmpty(this.dados.paciente)) {
                this.showTextDangerPaciente = true;
            }

            if (this.isEmpty(this.dados.profissionalSolicitante)) {
                this.showTextDangerProfissional = true;
            }

            if (this.dados.procedimentos.length === 0) {
                this.showTextDangerProcedimento = true;
            }

            if (!this.showTextDangerPaciente && !this.showTextDangerProfissional && !this.showTextDangerProcedimento) {
                return true;
            }

            return false;
        },
        resolver: function resolver() {
            if (this.validar()) {
                if (this.dados.paciente.cidade_id != this.contratoSolicitanteSelecionado.unidade.cidade_id && this.contratoSolicitanteSelecionado.unidade.paciente_outro_municipio != 1) {
                    this.$swal({
                        type: "error",
                        title: "Não podemos continuar!",
                        text: "O paciente não pode ser de município diferente da unidade solicitante"
                    });
                    return false;
                }
                this.dados.dados_recuperados = true;
                this.$store.state.solicitacao.dadosResolucao = this.dados;
                this.$router.push("/atendimentos/solicitacao/resolucao");
            } else {
                this.$swal({
                    type: "error",
                    title: "Informações pendentes",
                    text: "Preencha corretamente os campos destacados em vermelho!"
                });
            }
        },
        limparProcedimentos: function limparProcedimentos() {
            var _this2 = this;

            if (!this.dados.dados_recuperados) {
                this.dados.procedimentos = [];
                this.$nextTick(function () {
                    _this2.focoPaciente();
                });
            } else {
                this.$refs.selectUnidade.$el.querySelector("input").blur();
            }
            this.$store.state.solicitacao.dadosResolucao = null;
            this.dados.dados_recuperados = false;
        },
        getDistribuicoes: function getDistribuicoes() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getUltimas", this.$store.getters.getHeaderAuth).then(function (response) {
                _this3.distribuicoes = response.data;

                if (_this3.$store.state.solicitacao.ultimaDistribuicaoSelecionada) {
                    _this3.distribuicaoId = _this3.$store.state.solicitacao.ultimaDistribuicaoSelecionada;
                } else {
                    _this3.distribuicaoId = _this3.distribuicoes[0].id;
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        getContratos: function getContratos() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/contratos/getAllPaginate?distribuicao_id=" + this.distribuicaoId + "&tipo=0&paginate=false&coluna=nome&ordem=asc", this.$store.getters.getHeaderAuth).then(function (response) {
                _this4.unidades = response.data;
                if (_this4.$store.state.solicitacao.ultimoContratoSolicitanteSelecionado) {
                    _this4.contratoSolicitanteSelecionado = _this4.$store.state.solicitacao.ultimoContratoSolicitanteSelecionado;
                    _this4.dados.unidadeSolicitante = _this4.contratoSolicitanteSelecionado.unidade.id;
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        setPacienteSelecionado: function setPacienteSelecionado(paciente) {
            this.dados.paciente = paciente;
            this.showTextDangerPaciente = false;
            if (this.dados.paciente.id) {
                this.getNaoRealizados();
            }
        },
        setProfissionalSelecionado: function setProfissionalSelecionado(profissional) {
            this.dados.profissionalSolicitante = profissional;
            this.showTextDangerProfissional = false;
            this.mostrarModalProcedimento();
        },
        incluirProcedimentoSelecionado: function incluirProcedimentoSelecionado(contratoProcedimento) {
            this.contratoProcedimentoTemp = contratoProcedimento;
            this.showModalQuantidadeProcedimentos = true;
        },
        addProcedimentoSelecionado: function addProcedimentoSelecionado(contratoProcedimento) {
            if (this.dados.procedimentos.filter(function (e) {
                return e.id == contratoProcedimento.id;
            }).length == 0) {
                this.dados.procedimentos.push(contratoProcedimento);
                this.showTextDangerProcedimento = false;
                this.$swal({
                    type: "success",
                    title: "Procedimento adicionado com sucesso!",
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                this.$swal({
                    type: "error",
                    title: "Procedimento duplicado",
                    text: "Este procedimento já foi adicionado!",
                    showConfirmButton: true
                });
            }
            this.showModalQuantidadeProcedimentos = false;
        },
        addDiagnosticoSelecionado: function addDiagnosticoSelecionado(diagnostico) {
            if (!this.dados.diagnosticos.includes(diagnostico)) {
                this.dados.diagnosticos.push(diagnostico);
                this.$swal({
                    type: "success",
                    title: "Diagnostico adicionado com sucesso!",
                    showConfirmButton: false,
                    timer: 1500
                });
                this.showModalAddDiagnosticos = false;
            } else {
                this.$swal({
                    type: "error",
                    title: "Diagnóstico duplicado",
                    text: "Este diagnóstico já foi adicionado!",
                    showConfirmButton: true
                });
            }
        },
        removerProcedimento: function removerProcedimento(index) {
            var _this5 = this;

            this.$swal({
                title: "Remover este procedimento da solicitação?",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    if (index > -1) {
                        _this5.dados.procedimentos.splice(index, 1);
                    }
                }
            });
        },
        removerDiagnostico: function removerDiagnostico(index) {
            var _this6 = this;

            this.$swal({
                title: "Remover este diagnostico da solicitação?",
                type: "question",

                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    if (index > -1) {
                        _this6.dados.diagnosticos.splice(index, 1);
                    }
                }
            });
        },
        mostrarModalProcedimento: function mostrarModalProcedimento() {
            if (this.isEmpty(this.dados.paciente) && this.isEmpty(this.dados.profissionalSolicitante)) {
                this.$swal({
                    type: "warning",
                    title: "Atenção!",
                    text: "É necessário selecionar o paciente e o profissional!",
                    showConfirmButton: true
                });
                return;
            }
            if (this.isEmpty(this.dados.paciente)) {
                this.$swal({
                    type: "warning",
                    title: "Atenção!",
                    text: "É necessário selecionar o paciente!",
                    showConfirmButton: true
                });
                return;
            }
            if (this.isEmpty(this.dados.profissionalSolicitante)) {
                this.$swal({
                    type: "warning",
                    title: "Atenção!",
                    text: "É necessário selecionar o profissional!",
                    showConfirmButton: true
                });
                return;
            }

            this.showModalAddProcedimentos = true;
        },
        isEmpty: function isEmpty(objeto) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(objeto).every(function (valor) {
                return valor === "";
            });
        },
        focoUnidades: function focoUnidades() {
            this.$refs.selectUnidade.$el.querySelector("input").focus();
        },
        focoPaciente: function focoPaciente() {
            this.$refs.btnPaciente.abrirModal();
        },
        focoDiagnostico: function focoDiagnostico() {
            this.$nextTick(function () {
                this.$refs.btnAdicionarDiagnostico.focus();
            });
        }
    },
    updated: function updated() {
        this.$nextTick(function () {
            if (this.focusAdicionarDiagnositico == true) {
                this.$refs.btnAdicionarDiagnostico.focus();
                this.focusAdicionarDiagnositico = false;
            }
        });
    },
    watch: {
        contratoSolicitanteSelecionado: function contratoSolicitanteSelecionado(val) {
            if (val) {
                this.dados.unidadeSolicitante = val.unidade.id;
            }
            this.$store.state.solicitacao.ultimoContratoSolicitanteSelecionado = val;
        },
        distribuicaoId: function distribuicaoId(val) {
            if (val) {
                this.$store.state.solicitacao.ultimaDistribuicaoSelecionada = val;
                this.getContratos();
            }
        }
    }
};

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = {
	props: ["show", "unidadeId"],

	watch: {
		"$props.show": function $propsShow() {
			this.$nextTick(function () {
				this.$refs.nmDiagnostico.focus();
			});
		}
	},

	filters: {
		"sexo": function sexo(val) {
			if (val == 0) {
				return 'Ambos';
			} else if (val == 1) {
				return 'Masculino';
			} else if (val == 2) {
				return 'Feminino';
			}
		}
	},
	data: function data() {
		return {
			loading: false,
			diagnosticoSelecionadoIndex: 0,
			dataTable: {
				data: []
			},
			filtros: {
				pesquisa: ''
			}
		};
	},
	mounted: function mounted() {
		this.getDataTable();
	},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}
			this.loading = true;
			this.filtros.page = page;
			this.$store.commit('TOGGLE_LOADING');
			this.diagnosticoSelecionadoIndex = 0;

			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/diagnosticos/getAllPaginate", config).then(function (response) {
				_this.dataTable = response.data;
				_this.loading = false;
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				_this.loading = false;
				console.log(error);
			});
		},
		up: function up() {
			if (this.diagnosticoSelecionadoIndex > 0) {
				this.diagnosticoSelecionadoIndex--;
			}
			console.log("diagnosticoSelecionadoIndex : " + this.diagnosticoSelecionadoIndex);
		},
		down: function down() {
			if (this.diagnosticoSelecionadoIndex < this.dataTable.data.length - 1) {
				this.diagnosticoSelecionadoIndex++;
			}
			console.log("diagnosticoSelecionadoIndex : " + this.diagnosticoSelecionadoIndex);
		},
		enter: function enter() {
			this.seleciona(this.dataTable.data[this.diagnosticoSelecionadoIndex]);
		},
		seleciona: function seleciona(diagnostico) {
			this.showModal = false;
			this.$emit('addDiagnosticoSelecionado', diagnostico);
		}
	},
	components: {}
};

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = {
    props: ["show", "contratoSolicitanteSelecionado", "profissionalSolicitanteSelecionado"],
    filters: {
        tipo_atendimento: function tipo_atendimento(val) {
            if (val == 0) {
                return "Individual";
            } else if (val == 1) {
                return "Agrupado";
            }
        }
    },
    data: function data() {
        return {
            loading: false,
            procedimentoSelecionadoIndex: 0,
            dataTable: {
                data: []
            },
            filtros: {
                pesquisa: ""
            }
        };
    },
    mounted: function mounted() {},

    methods: {
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined") {
                page = 1;
            }
            this.loading = true;
            this.filtros.page = page;
            this.filtros.contrato_id = this.$props.contratoSolicitanteSelecionado.id;
            this.filtros.tipo_contrato = 0;
            this.$store.commit("TOGGLE_LOADING");

            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getDistribuicaoContratoProcedimentosPaginate", config).then(function (response) {
                _this.dataTable = response.data;
                _this.loading = false;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this.loading = false;
                console.log(error);
            });
        },
        seleciona: function seleciona(procedimento) {
            this.showModal = false;
            this.$emit("incluirProcedimentoSelecionado", procedimento);
        },
        focoNomeProcedimento: function focoNomeProcedimento(procedimento) {
            this.$nextTick(function () {
                this.$refs.nmProcedimento.focus();
            });
        },
        up: function up() {
            if (this.procedimentoSelecionadoIndex > 0) {
                this.procedimentoSelecionadoIndex--;
            }
        },
        down: function down() {
            if (this.procedimentoSelecionadoIndex < this.dataTable.data.length - 1) {
                this.procedimentoSelecionadoIndex++;
            }
        },
        enter: function enter() {
            this.seleciona(this.dataTable.data[this.procedimentoSelecionadoIndex]);
        }
    },
    watch: {
        "$props.show": function $propsShow() {
            this.focoNomeProcedimento();
        }
    },
    components: {}
};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoBoleto__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoBoleto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoBoleto__);



/* harmony default export */ __webpack_exports__["default"] = {
	props: ["solicitacao"],

	data: function data() {
		return {};
	},
	mounted: function mounted() {},

	methods: {},
	watch: {},
	components: {
		SolicitacaoBoleto: __WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoBoleto___default.a
	}
};

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
  props: ["solicitacoesNaoResolvidas"],

  data: function data() {
    return {
      senhaInvalida: false,
      justificativaInvalida: false,
      justificativa: "",
      senha: ""
    };
  },
  mounted: function mounted() {},

  methods: {
    confirma: function confirma() {
      var _this = this;

      if (this.justificativa == '') {
        this.justificativaInvalida = true;
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.serverURI + "/api/confirmaSenha", { senha: this.senha }, this.$store.getters.getHeaderAuth).then(function (response) {
        if (response.data) {
          _this.$emit('confirma', _this.justificativa);
        } else {
          _this.senhaInvalida = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  watch: {},
  components: {}
};

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
	props: [],
	filters: {},
	data: function data() {
		return {
			dados: {
				observacao: ''
			}
		};
	},
	mounted: function mounted() {
		this.$refs.motivo.focus();
	},

	methods: {},
	components: {}
};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
  props: ["vagaSelecionada"],

  data: function data() {
    return {
      titulo: 'Extrapolação!',
      msg: '',
      senhaInvalida: false,
      justificativaInvalida: false,
      justificativa: "",
      senha: ""
    };
  },
  mounted: function mounted() {
    var msg = "";
    if (this.vagaSelecionada.vagaPrestador == false) {
      if (msg != "") {
        msg += ", ";
      }

      msg += "atendimento disponível (vaga será criada)";
      this.titulo = "Extrapolação (Com criação de vaga)";
    }

    if (this.vagaSelecionada.cotaPrestador == false) {
      if (msg != "") {
        msg += ", ";
      }

      msg += "limite do prestador (cota será adicionada)";
    }

    if (this.cotaSolicitante == false) {
      if (msg != "") {
        msg += " e do ";
      }
      msg += "limite do solicitante (cota será adicionada)";
    }
    this.msg = msg;
  },

  methods: {
    confirma: function confirma() {
      var _this = this;

      if (this.justificativa == '') {
        this.justificativaInvalida = true;
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.serverURI + "/api/confirmaSenha", { senha: this.senha }, this.$store.getters.getHeaderAuth).then(function (response) {
        if (response.data) {
          _this.$emit('confirma', _this.justificativa);
        } else {
          _this.senhaInvalida = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  watch: {},
  components: {}
};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = {
    props: ["show", "contratoProcedimento"],
    filters: {},
    data: function data() {
        return {
            showMsgQtdMax: false,
            quantidade: 1,
            tipoConsulta: 0
        };
    },
    mounted: function mounted() {
        if (this.$store.state.user.nivel == "prestador") {
            this.tipoConsulta = 2;
        }
    },

    methods: {
        adiciona: function adiciona() {
            var _this = this;

            if (this.$props.contratoProcedimento.procedimento.quantidade_maxima > 1) {
                if (this.quantidade > this.$props.contratoProcedimento.procedimento.quantidade_maxima) {
                    this.showMsgQtdMax = true;
                    setInterval(function () {
                        _this.showMsgQtdMax = false;
                    }, 4000);
                    return false;
                }
            }

            this.$props.contratoProcedimento.procedimento.quantidade = this.quantidade;
            this.$props.contratoProcedimento.procedimento.tipo_consulta = this.tipoConsulta;
            this.$emit("addProcedimentoSelecionado", this.$props.contratoProcedimento);
            this.quantidade = 1;
            this.tipoConsulta = 0;

            if (this.$store.state.user.nivel == "prestador") {
                this.tipoConsulta = 2;
            }
        }
    },
    computed: {
        TIPO_CONSULTA: function TIPO_CONSULTA() {
            return __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* TIPO_CONSULTA */];
        }
    },
    components: {}
};

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_json_groupby__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_json_groupby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_json_groupby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resolucaoIndividual__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resolucaoIndividual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__resolucaoIndividual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resolucaoAgrupado__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resolucaoAgrupado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__resolucaoAgrupado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modalBoleto__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modalBoleto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modalBoleto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modalDuplicacao__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modalDuplicacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modalDuplicacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modalExtrapolacao__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modalExtrapolacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modalExtrapolacao__);
















/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      vagaSelecionada: null,
      showModalBoleto: false,
      showModalDuplicacao: false,
      showModalExtrapolacao: false,
      justificativaDuplicacao: "",
      justificativaExtrapolacao: "",
      inputTemp: {},
      ultimaSolicitacao: null,
      procedimentoSelecionado: {
        index: null,
        tipo: null,
        itens: [] },
      filtros: {
        pesquisa: "",
        coluna: 3,
        ordem: 4
      },
      procedimentos: {
        individual: [],
        agrupado: []
      },
      vagasApi: [],
      solicitacaoRegulacao: {
        created_at: "",
        id: "",
        itens: [{
          contrato_procedimento: {
            contrato: {
              unidade: {
                nome: ""
              }
            },
            procedimento: {
              nome: ""
            }
          },
          contrato_procedimento_atendimento: {
            profissional: {
              nome: ""
            }
          }
        }],
        paciente: "",
        paciente_id: "",
        profissional: "",
        profissional_solicitante_id: "",
        situacao: "",
        solicitacao_historicos: [],
        diagnosticos: [],
        updated_at: "",
        usuario: "",
        usuario_solicitante_id: ""
      },
      solicitacao: {
        dadosResolucao: {
          paciente: {
            nome: "",
            nome_mae: "",
            data_nascimento: "",
            rg: "",
            cartao_sus: "",
            municipio: ""
          },
          profissionalSolicitante: {
            nome: "",
            situacao: "",
            data_admissao: "",
            data_desligamento: "",
            data_nascimento: "",
            sexo: "",
            rg: "",
            orgao_emissor: "",
            uf_orgao_emissor: "",
            data_emissao: "",
            cpf: "",
            telefone: "",
            hora_inicial: "",
            hora_final: ""
          },
          procedimentos: [],
          diagnosticos: [],
          solicitacao_regulacao: false,
          solicitacaoId: null,
          solicitacoesNaoResolvidas: []
        }
      }
    };
  },
  mounted: function mounted() {
    if (this.$route.params.solicitacaoId > 0) {
      this.solicitacaoId = this.$route.params.solicitacaoId;
      this.getSolicitacaoRegulacao(this.$route.params.solicitacaoId);
      console.log("SolicitacaoID " + this.$route.params.solicitacaoId);
    } else {
      this.trataDadosResolucao();
    }
  },

  methods: {
    teste: function teste() {
      console.log(this.$store.state.solicitacao);
    },
    trataDadosResolucao: function trataDadosResolucao() {
      var _this = this;

      var procedimentosIndividual = [];
      var procedimentosAgrupado = [];
      this.$store.state.solicitacao.dadosResolucao.procedimentos.map(function (contratoProcedimento) {
        var obj = {
          id: contratoProcedimento.id,
          procedimento_codigo: contratoProcedimento.procedimento.codigo,
          procedimento_nome: contratoProcedimento.procedimento.nome,
          procedimento_id: contratoProcedimento.procedimento.id,
          procedimento_quantidade: contratoProcedimento.procedimento.quantidade,
          procedimento_tipo_atendimento: contratoProcedimento.procedimento.tipo_atendimento,
          procedimento_tipo_agrupamento: contratoProcedimento.procedimento.tipo_agrupamento,
          procedimento_tipo_consulta: contratoProcedimento.procedimento.tipo_consulta,
          status: "pendente"
        };
        if (obj.procedimento_tipo_atendimento == 0) {
          procedimentosIndividual.push(obj);
        } else if (obj.procedimento_tipo_atendimento == 1) {
          procedimentosAgrupado.push(obj);
        }
      });

      this.procedimentos.individual = procedimentosIndividual;
      this.procedimentos.agrupado = __WEBPACK_IMPORTED_MODULE_7_json_groupby___default()(procedimentosAgrupado, ["procedimento_tipo_agrupamento"]);

      this.$nextTick(function () {
        if (_this.procedimentos.individual.length > 0) {
          _this.selecionaProcedimentoIndividual(0, procedimentosIndividual[0]);
        } else {
          var agrupadoIndex = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(_this.procedimentos.agrupado);
          var temp = [];
          procedimentosAgrupado.map(function (procedimento) {
            if (procedimento.procedimento_tipo_agrupamento == agrupadoIndex[0]) {
              temp.push(procedimento);
            }
          });
          _this.selecionaProcedimentoAgrupado(agrupadoIndex[0], temp);
        }
      });
    },

    selecionaProximo: function selecionaProximo() {
      var _this2 = this;

      var proximaSelecao = null;
      var contIndividual = 0;
      var contAgrupado = 0;
      for (var i = 0; i < this.procedimentos.individual.length; i++) {
        if (this.procedimentos.individual[i].status != "resolvido") {
          proximaSelecao = this.procedimentos.individual[i];
          break;
        }
        contIndividual++;
      }
      if (proximaSelecao) {
        this.selecionaProcedimentoIndividual(contIndividual, proximaSelecao);
        proximaSelecao = null;
      } else {
        var procedimentosAgrupados = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(this.procedimentos.agrupado);
        for (var _i = 0; _i < procedimentosAgrupados.length; _i++) {
          if (this.procedimentos.agrupado[_i][0].status != "resolvido") {
            proximaSelecao = this.procedimentos.agrupado[0];
            break;
          }
          contAgrupado++;
        }
        if (proximaSelecao) {
          this.selecionaProcedimentoAgrupado(String(contAgrupado), proximaSelecao);
          proximaSelecao = null;
        } else {
          this.$swal({
            type: "success",
            title: "Todos os procedimentos foram resolvidos!",
            showConfirmButton: false,
            timer: 2000
          }).then(function () {
            _this2.$store.state.solicitacao.dadosResolucao = null;
            _this2.$router.push("/atendimentos/solicitacao");
          });
        }
      }
    },
    sortByKey: function sortByKey(field) {
      this.dados.coluna = field;
      if (this.dados.ordem == "asc") {
        this.dados.ordem = "desc";
      } else {
        this.dados.ordem = "asc";
      }
    },
    selecionaProcedimentoIndividual: function selecionaProcedimentoIndividual(index, contratoProcedimento) {
      if (contratoProcedimento.status != "resolvido") {
        this.procedimentoSelecionado = {
          index: null,
          tipo: null,
          itens: []
        };
        this.procedimentoSelecionado.index = index;
        this.procedimentoSelecionado.tipo = "individual";
        this.procedimentoSelecionado.contrato_procedimento_id = contratoProcedimento.id;
        this.procedimentoSelecionado.quantidade = contratoProcedimento.procedimento_quantidade;
        this.procedimentoSelecionado.tipo_atendimento = contratoProcedimento.procedimento_tipo_atendimento;
        this.procedimentoSelecionado.tipo_consulta = contratoProcedimento.procedimento_tipo_consulta;
        this.procedimentoSelecionado.paciente_sexo = this.$store.state.solicitacao.dadosResolucao.paciente.sexo;
        this.procedimentoSelecionado.paciente_idade = this.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento;
        this.getAtendimentosIndividual(contratoProcedimento.id);
      }
    },
    selecionaProcedimentoAgrupado: function selecionaProcedimentoAgrupado(index, contratoProcedimentoArray) {
      var _this3 = this;

      this.procedimentoSelecionado = {
        index: null,
        tipo: null,
        itens: []
      };

      this.procedimentoSelecionado.index = index;
      this.procedimentoSelecionado.tipo = "agrupado";
      contratoProcedimentoArray.map(function (contratoProcedimento) {
        _this3.procedimentoSelecionado.itens.push({
          contrato_procedimento_id: contratoProcedimento.id,
          quantidade: contratoProcedimento.procedimento_quantidade,
          tipo_atendimento: contratoProcedimento.procedimento_tipo_atendimento,
          tipo_consulta: contratoProcedimento.procedimento_tipo_consulta,
          procedimento_id: contratoProcedimento.procedimento_id,
          paciente_sexo: _this3.$store.state.solicitacao.dadosResolucao.paciente.sexo,
          paciente_idade: _this3.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento,
          procedimento_nome: contratoProcedimento.procedimento_nome
        });
      });
      this.getAtendimentosAgrupado(this.procedimentoSelecionado.itens);
    },
    getAtendimentosIndividual: function getAtendimentosIndividual(contratoProcedimento) {
      var _this4 = this;

      this.loading = true;
      var config = this.$store.getters.getHeaderAuth;
      config.params = {
        procedimentoSelecionado: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.procedimentoSelecionado)
      };

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getAtendimentosByContratoProcedimento/" + contratoProcedimento, config).then(function (response) {
        console.log(response);
        if (!Array.isArray(response.data) || !response.data.length) {
          _this4.$swal({
            type: "warning",
            title: "Não há atendimentos disponíveis!",
            text: "Não encontramos nenhum atendimento disponível para o procedimento selecionado!",
            showConfirmButton: true
          });
          _this4.vagasApi = null;
        } else {
          _this4.vagasApi = response.data;
        }
        _this4.loading = false;
      }).catch(function (error) {
        _this4.loading = false;
        console.log(error);
      });
    },
    getAtendimentosAgrupado: function getAtendimentosAgrupado(contratoProcedimentoArray) {
      var _this5 = this;

      this.loading = true;
      var config = this.$store.getters.getHeaderAuth;
      config.params = {
        contrato_procedimentos: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(contratoProcedimentoArray)
      };

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getAtendimentosByArrayContratoProcedimentos", config).then(function (response) {
        console.log(response);
        _this5.vagasApi = response.data;
        _this5.loading = false;
        _this5.$store.commit("TOGGLE_LOADING");
      }).catch(function (error) {
        _this5.loading = false;
        console.log(error);
      });
    },
    getSolicitacoesNaoResolvidasByPacienteAndSolicitacaoItens: function getSolicitacoesNaoResolvidasByPacienteAndSolicitacaoItens(obj) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var solicitacoes;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                solicitacoes = void 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(_this6.$store.state.serverURI + "/api/atendimentos/getSolicitacoesNaoResolvidasByPacienteAndSolicitacaoItens", obj, _this6.$store.getters.getHeaderAuth).then(function (response) {
                  solicitacoes = response.data;
                }).catch(function (error) {
                  console.log(error);
                });

              case 3:
                return _context.abrupt("return", solicitacoes);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    preparaRequestIndividual: function preparaRequestIndividual(vagaSelecionada) {
      var _this7 = this;

      var obj = {
        profissionalSolicitanteId: this.$store.state.solicitacao.dadosResolucao.profissionalSolicitante.id,
        pacienteId: this.$store.state.solicitacao.dadosResolucao.paciente.id,
        tipoAtendimento: 0,
        itens: [],
        diagnosticos: this.$store.state.solicitacao.dadosResolucao.diagnosticos
      };
      obj.itens.push({
        distribuicao_contrato_procedimento_solicitante_id: this.procedimentoSelecionado.contrato_procedimento_id,
        distribuicao_contrato_procedimento_atendimento_prestador_id: vagaSelecionada.tipoVaga == "procedimento" ? vagaSelecionada.atendimento_id : null,
        distribuicao_contrato_subgrupo_atendimento_prestador_id: vagaSelecionada.tipoVaga == "subgrupo" ? vagaSelecionada.atendimento_id : null,
        quantidade: this.procedimentoSelecionado.quantidade,
        tipo_consulta: this.procedimentoSelecionado.tipo_consulta,
        paciente_idade: this.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento,
        paciente_sexo: this.$store.state.solicitacao.dadosResolucao.paciente.sexo
      });

      var promise = this.getSolicitacoesNaoResolvidasByPacienteAndSolicitacaoItens(obj);
      promise.then(function (solicitacoes) {
        if (solicitacoes.length > 0) {
          _this7.inputTemp = obj;
          _this7.solicitacoesNaoResolvidas = solicitacoes;
          _this7.showModalDuplicacao = true;
        } else {
          _this7.marcaIndividual(obj);
        }
      });
    },
    confirmaDuplicacao: function confirmaDuplicacao(justificativa) {
      this.justificativaDuplicacao = justificativa;
      var obj = this.inputTemp;
      obj.justificativa = this.justificativaDuplicacao;
      this.marcaIndividual(obj);
      this.showModalDuplicacao = false;
      this.inputTemp = {};
      this.justificativaDuplicacao = "";
    },
    marcaIndividual: function marcaIndividual(obj) {
      var _this8 = this;

      var loader = this.$loading.show();
      if (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) {
        obj.justificativa_extrapolacao = this.justificativaExtrapolacao;
        obj.solicitacaoId = this.$route.params.solicitacaoId;
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.$store.state.serverURI + "/api/atendimentos/regular", obj, this.$store.getters.getHeaderAuth).then(function (response) {
          loader.hide();
          if (response.data.status == false) {
            _this8.$swal({
              type: "warning",
              title: response.data.title,
              text: response.data.msg,
              showConfirmButton: true
            });
          } else {
            _this8.justificativaExtrapolacao = "";
            _this8.vagaSelecionada = null;

            _this8.procedimentos.individual[_this8.procedimentoSelecionado.index].status = "resolvido";
            _this8.$swal({
              type: "success",
              title: "Regulação realizada com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(function () {
              _this8.$router.go(-2);
            });
          }
        }).catch(function (error) {
          loader.hide();
          var erros = error.response.data.message + " ";
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var erro = _step.value;

              erros += erro + " \n";
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this8.$swal({
            type: "error",
            title: "Houve uma falha!",
            text: erros
          });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.$store.state.serverURI + "/api/atendimentos/marcar", obj, this.$store.getters.getHeaderAuth).then(function (response) {
          loader.hide();
          if (response.data.status == false) {
            _this8.$swal({
              type: "warning",
              title: response.data.title,
              text: response.data.msg,
              showConfirmButton: true
            });
          } else {
            var solicitacao = response.data.obj;
            _this8.procedimentos.individual[_this8.procedimentoSelecionado.index].status = "resolvido";
            _this8.$swal({
              type: "success",
              title: "Marcação realizada com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(function () {
              _this8.showBoleto(solicitacao);
            });
          }
        }).catch(function (error) {
          loader.hide();
          var erros = error.response.data.message + " ";
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var erro = _step2.value;

              erros += erro + " \n";
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this8.$swal({
            type: "error",
            title: "Houve uma falha!",
            text: erros
          });
        });
      }
    },
    confirmaIndividual: function confirmaIndividual(vagaSelecionada) {
      if (vagaSelecionada.vagaPrestador == false || vagaSelecionada.cotaPrestador == false || vagaSelecionada.cotaSolicitante == false) {
        this.vagaSelecionada = vagaSelecionada;
        this.showModalExtrapolacao = true;
      } else {
        this.preparaRequestIndividual(vagaSelecionada);
      }
    },
    confirmaExtrapolacao: function confirmaExtrapolacao(justificativa) {
      this.justificativaExtrapolacao = justificativa;
      this.preparaRequestIndividual(this.vagaSelecionada);
      this.showModalExtrapolacao = false;
    },
    enviaRegulacaoIndividual: function enviaRegulacaoIndividual(vagaSelecionada, motivo) {
      var _this9 = this;

      var loader = this.$loading.show();
      var obj = {
        profissionalSolicitanteId: this.$store.state.solicitacao.dadosResolucao.profissionalSolicitante.id,
        pacienteId: this.$store.state.solicitacao.dadosResolucao.paciente.id,
        tipoAtendimento: 0,
        itens: [],
        diagnosticos: this.$store.state.solicitacao.dadosResolucao.diagnosticos,
        observacao: motivo
      };

      if (vagaSelecionada) {
        obj.itens.push({
          distribuicao_contrato_procedimento_solicitante_id: this.procedimentoSelecionado.contrato_procedimento_id,
          distribuicao_contrato_procedimento_atendimento_prestador_id: vagaSelecionada.tipoVaga == "procedimento" ? vagaSelecionada.atendimento_id : null,
          distribuicao_contrato_subgrupo_atendimento_prestador_id: vagaSelecionada.tipoVaga == "subgrupo" ? vagaSelecionada.atendimento_id : null,
          quantidade: this.procedimentoSelecionado.quantidade,
          tipo_consulta: this.procedimentoSelecionado.tipo_consulta
        });
      } else {
        obj.itens.push({
          distribuicao_contrato_procedimento_solicitante_id: this.procedimentoSelecionado.contrato_procedimento_id,
          quantidade: this.procedimentoSelecionado.quantidade,
          tipo_consulta: this.procedimentoSelecionado.tipo_consulta
        });
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.$store.state.serverURI + "/api/atendimentos/enviarRegulacao", obj, this.$store.getters.getHeaderAuth).then(function (response) {
        loader.hide();
        if (response.data.status) {
          var solicitacao = response.data.obj;
          _this9.procedimentos.individual[_this9.procedimentoSelecionado.index].status = "resolvido";

          _this9.$swal({
            type: "success",
            title: response.data.msg,
            showConfirmButton: false,
            timer: 1500
          }).then(function () {
            _this9.showBoleto(solicitacao);
          });
        } else {
          _this9.$swal({
            type: "error",
            title: "Impossível prosseguir!",
            text: response.data.msg
          });
        }
      }).catch(function (error) {
        loader.hide();
        var erros = error.response.data.message + " ";
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var erro = _step3.value;

            erros += erro + " \n";
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        _this9.$swal({
          type: "error",
          title: "Houve uma falha!",
          text: erros
        });
      });
    },
    confirmaAgrupado: function confirmaAgrupado(vagasSelecionadas) {
      var _this10 = this;

      var loader = this.$loading.show();
      var obj = {
        profissionalSolicitanteId: this.$store.state.solicitacao.dadosResolucao.profissionalSolicitante.id,
        pacienteId: this.$store.state.solicitacao.dadosResolucao.paciente.id,
        tipoAtendimento: 1,
        itens: [],
        diagnosticos: this.$store.state.solicitacao.dadosResolucao.diagnosticos
      };

      vagasSelecionadas.map(function (vagaSelecionada) {
        _this10.procedimentoSelecionado.itens.map(function (proc) {
          if (vagaSelecionada.procedimento_id == proc.procedimento_id && vagaSelecionada.ativo) {
            obj.itens.push({
              distribuicao_contrato_procedimento_solicitante_id: proc.contrato_procedimento_id,
              distribuicao_contrato_procedimento_atendimento_prestador_id: vagaSelecionada.tipoVaga == "procedimento" ? vagaSelecionada.atendimento_id : null,
              distribuicao_contrato_subgrupo_atendimento_prestador_id: vagaSelecionada.tipoVaga == "subgrupo" ? vagaSelecionada.atendimento_id : null,
              quantidade: proc.quantidade,
              tipo_consulta: proc.tipo_consulta,
              paciente_idade: _this10.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento,
              paciente_sexo: _this10.$store.state.solicitacao.dadosResolucao.paciente.sexo
            });
          }
        });
      });

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.$store.state.serverURI + "/api/atendimentos/marcar", obj, this.$store.getters.getHeaderAuth).then(function (response) {
        loader.hide();
        if (response.data.status == false) {
          _this10.$swal({
            type: "warning",
            title: "Limite Excedido!",
            text: response.data.msg,
            showConfirmButton: true
          });
        } else {
          var solicitacao = response.data.obj;
          _this10.procedimentos.agrupado[_this10.procedimentoSelecionado.index][0].status = "resolvido";

          _this10.$swal({
            type: "success",
            title: response.data.msg,
            showConfirmButton: false,
            timer: 1500
          }).then(function () {
            _this10.showBoleto(solicitacao);
          });
        }
      }).catch(function (error) {
        loader.hide();
        var erros = error.response.data.message + " ";
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var erro = _step4.value;

            erros += erro + " \n";
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        _this10.$swal({
          type: "error",
          title: "Houve uma falha!",
          text: erros
        });
      });
    },
    enviaRegulacaoAgrupado: function enviaRegulacaoAgrupado(vagasSelecionadas, motivo) {
      var _this11 = this;

      var loader = this.$loading.show();
      var obj = {
        profissionalSolicitanteId: this.$store.state.solicitacao.dadosResolucao.profissionalSolicitante.id,
        pacienteId: this.$store.state.solicitacao.dadosResolucao.paciente.id,
        tipoAtendimento: 1,
        itens: [],
        diagnosticos: this.$store.state.solicitacao.dadosResolucao.diagnosticos,
        observacao: motivo
      };

      vagasSelecionadas.map(function (vagaSelecionada) {
        _this11.procedimentoSelecionado.itens.map(function (proc) {
          if (vagaSelecionada.procedimento_id == proc.procedimento_id) {
            obj.itens.push({
              distribuicao_contrato_procedimento_solicitante_id: proc.contrato_procedimento_id,
              distribuicao_contrato_procedimento_atendimento_prestador_id: vagaSelecionada.tipoVaga == "procedimento" ? vagaSelecionada.atendimento_id : null,
              distribuicao_contrato_subgrupo_atendimento_prestador_id: vagaSelecionada.tipoVaga == "subgrupo" ? vagaSelecionada.atendimento_id : null,
              quantidade: proc.quantidade,
              tipo_consulta: proc.tipo_consulta
            });
          }
        });
      });
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.$store.state.serverURI + "/api/atendimentos/enviarRegulacao", obj, this.$store.getters.getHeaderAuth).then(function (response) {
        loader.hide();
        if (response.data.status) {
          var solicitacao = response.data.obj;
          _this11.procedimentos.agrupado[_this11.procedimentoSelecionado.index][0].status = "resolvido";
          _this11.$swal({
            type: "success",
            title: response.data.msg,
            showConfirmButton: false,
            timer: 1500
          }).then(function () {
            _this11.showBoleto(solicitacao);
          });
        } else {
          _this11.$swal({
            type: "error",
            title: "Impossível prosseguir!",
            text: response.data.msg
          });
        }
      }).catch(function (error) {
        loader.hide();
        var erros = error.response.data.message + " ";
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var erro = _step5.value;

            erros += erro + " \n";
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        _this11.$swal({
          type: "error",
          title: "Houve uma falha!",
          text: erros
        });
      });
    },
    showBoleto: function showBoleto(solicitacao) {
      this.ultimaSolicitacao = solicitacao;
      this.showModalBoleto = true;
    },
    getPaciente: function getPaciente(pacienteId) {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/pacientes/getById/" + pacienteId, this.$store.getters.getHeaderAuth).then(function (response) {
        _this12.$store.state.dadosResolucao.paciente = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getProfissional: function getProfissional(profissionalId) {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/profissionais/getById/" + profissionalId, this.$store.getters.getHeaderAuth).then(function (response) {
        _this13.$store.state.dadosResolucao.profissionalSolicitante = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getContratoProcedimento: function getContratoProcedimento(contratoProcedimentoId) {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getDistribuicaoContratoProcedimentosPaginate" + contratoProcedimentoId, this.$store.getters.getHeaderAuth).then(function (response) {
        _this14.solicitacao.dadosResolucao.procedimentos.push(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    getSolicitacaoRegulacao: function getSolicitacaoRegulacao(solicitacaoId) {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.$store.state.serverURI + "/api/atendimentos/getById/" + solicitacaoId, this.$store.getters.getHeaderAuth).then(function (response) {
        var itensSolicitacao = response.data.itens;
        var procedimentos = [];
        itensSolicitacao.map(function (item) {
          item.contrato_procedimento.procedimento.quantidade = item.quantidade;
          item.contrato_procedimento.procedimento.tipo_consulta = item.tipo_consulta;
          procedimentos.push(item.contrato_procedimento);
        });

        _this15.solicitacao.dadosResolucao.solicitacao_regulacao = true;
        _this15.solicitacao.dadosResolucao.regulacao = procedimentos;
        _this15.solicitacao.dadosResolucao.procedimentos = procedimentos;
        _this15.solicitacao.dadosResolucao.paciente = response.data.paciente;
        _this15.solicitacao.dadosResolucao.profissionalSolicitante = response.data.profissional;
        _this15.$store.state.solicitacao.dadosResolucao = _this15.solicitacao.dadosResolucao;

        _this15.$nextTick(function () {
          _this15.trataDadosResolucao();
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  watch: {
    page: function page(val) {
      this.getDataTable();
    }
  },

  components: {
    ResolucaoIndividual: __WEBPACK_IMPORTED_MODULE_8__resolucaoIndividual___default.a,
    ResolucaoAgrupado: __WEBPACK_IMPORTED_MODULE_9__resolucaoAgrupado___default.a,
    ModalBoleto: __WEBPACK_IMPORTED_MODULE_10__modalBoleto___default.a,
    ModalDuplicacao: __WEBPACK_IMPORTED_MODULE_11__modalDuplicacao___default.a,
    ModalExtrapolacao: __WEBPACK_IMPORTED_MODULE_12__modalExtrapolacao___default.a
  }
};

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_json_groupby__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_json_groupby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_json_groupby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modalEnviarRegulacao__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modalEnviarRegulacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modalEnviarRegulacao__);














/* harmony default export */ __webpack_exports__["default"] = {
    props: ["vagasApi", "solicitacaoId"],
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */];
        }
    },
    data: function data() {
        return {
            showModalEnviarRegulacao: false,
            disableBtConfirmar: true,
            optionsCalendario: {
                format: "YYYY-MM-DD",
                useCurrent: false,
                inline: true,
                locale: "pt-br",
                enabledDates: null,
                defaultDate: false
            },
            filtros: {
                pesquisa: "",
                coluna: null,
                ordem: null
            },

            selecionados: {
                indexUnidadeAtiva: null,
                data: null,
                procedimentos: []
            },

            vagas_unidade: [],
            atendimentos_unidade: [],
            procedimentos: [],
            vagas: [],
            dados: { observacao: "" }
        };
    },
    created: function created() {},


    methods: {
        negativar: function negativar() {
            var _this = this;

            this.$swal({
                title: "Justificativa da negativa:",
                type: "error",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: function inputValidator(value) {
                    return !value && "Insira a justificativa!";
                },
                preConfirm: function preConfirm(observacao) {
                    _this.dados.observacao = observacao;
                }
            }).then(function (result) {
                _this.$store.commit("TOGGLE_LOADING");
                _this.dados.solicitacaoId = _this.$props.solicitacaoId;
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(_this.$store.state.serverURI + "/api/atendimentos/negativar", _this.dados, _this.$store.getters.getHeaderAuth).then(function (response) {
                        _this.$store.commit("TOGGLE_LOADING");
                        _this.$swal({
                            type: "success",
                            title: "Solicitação negativada com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this.$router.go(-2);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        informacaoPendente: function informacaoPendente() {
            var _this2 = this;

            this.dados.situacao = this.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE;
            this.$swal({
                title: "Mensagem para o marcador:",
                type: "info",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-paper-plane"></i> Enviar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: function inputValidator(value) {
                    return !value && "Insira a mensagem!";
                },
                preConfirm: function preConfirm(observacao) {
                    _this2.dados.observacao = observacao;
                }
            }).then(function (result) {
                var loader = _this2.$loading.show();
                _this2.$store.commit("TOGGLE_LOADING");
                _this2.dados.solicitacaoId = _this2.$props.solicitacaoId;
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(_this2.$store.state.serverURI + "/api/atendimentos/atualizarSituacao", _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
                        loader.hide();
                        _this2.$store.commit("TOGGLE_LOADING");
                        _this2.$swal({
                            type: "success",
                            title: "Mensagem enviada com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this2.$router.go(-2);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        confirma: function confirma() {
            var obj = this.procedimentos;
            this.$emit("confirma", obj);
        },
        enviaRegulacao: function enviaRegulacao(motivo) {
            this.showModalEnviarRegulacao = false;
            var obj = this.procedimentos;
            this.$emit("enviaRegulacao", obj, motivo);
        },

        formataVagas: function formataVagas() {
            var _this3 = this;

            var vagas = [];
            this.vagasApi.map(function (item, indice) {
                item.map(function (atendimento) {
                    vagas.push({
                        procedimento_id: atendimento.procedimento_id,
                        procedimento_nome: atendimento.procedimento_nome,
                        atendimento_id: atendimento.id,
                        contrato_procedimento_id: atendimento.distribuicao_contrato_procedimento_id,
                        quantidade: atendimento.quantidade_primeira ? atendimento.quantidade_primeira : atendimento.quantidade_atendimento,
                        hora_inicial: atendimento.hora_inicial,
                        hora_final: atendimento.hora_final,
                        data_atendimento: atendimento.data_atendimento,
                        profissional_id: atendimento.profissional_id ? atendimento.profissional_id : -1,
                        unidade_id: atendimento.contrato_procedimento ? atendimento.contrato_procedimento.contrato.unidade_id : atendimento.contrato_subgrupo.contrato.unidade_id,
                        profissional: {
                            nome: atendimento.profissional_id ? atendimento.profissional.nome : "SEM PROFISSIONAL"
                        },
                        unidade: {
                            nome: atendimento.contrato_procedimento ? atendimento.contrato_procedimento.contrato.unidade.nome : atendimento.contrato_subgrupo.contrato.unidade.nome
                        },
                        tipoVaga: item.contrato_procedimento ? "procedimento" : "subgrupo"
                    });
                });
            });

            this.vagas = vagas;
            this.$nextTick(function () {
                _this3.getDias();
                _this3.getProcedimentos();
            });
        },
        selecionaProcedimentos: function selecionaProcedimentos() {
            var _this4 = this;

            var atendimentosIndex = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.atendimentos_unidade);

            this.procedimentos.map(function (procedimento) {
                atendimentosIndex.map(function (indice) {
                    _this4.disableBtConfirmar = false;
                    procedimento.ativo = false;
                    procedimento.atendimento_id = null;
                    procedimento.hora_inicial = null;
                    procedimento.hora_final = null;
                    procedimento.data_atendimento = null;
                    procedimento.profissinal_id = null;
                    procedimento.unidade_id = null;
                    procedimento.profissional = null;
                    procedimento.unidade = null;
                });
            });

            this.procedimentos.map(function (procedimento) {
                atendimentosIndex.map(function (indice) {
                    if (procedimento.procedimento_id == indice) {
                        _this4.disableBtConfirmar = false;
                        procedimento.ativo = true;
                        procedimento.atendimento_id = _this4.atendimentos_unidade[indice][0]["atendimento_id"];
                        procedimento.hora_inicial = _this4.atendimentos_unidade[indice][0]["hora_inicial"];
                        procedimento.hora_final = _this4.atendimentos_unidade[indice][0]["hora_final"];
                        procedimento.data_atendimento = _this4.atendimentos_unidade[indice][0]["data_atendimento"];
                        procedimento.profissinal_id = _this4.atendimentos_unidade[indice][0]["profissinal_id"];
                        procedimento.unidade_id = _this4.atendimentos_unidade[indice][0]["unidade_id"];
                        procedimento.profissional = _this4.atendimentos_unidade[indice][0]["profissional"];
                        procedimento.unidade = _this4.atendimentos_unidade[indice][0]["unidade"];
                    }
                });
            });
        },
        getDias: function getDias() {
            var _this5 = this;

            this.optionsCalendario.enabledDates = null;
            this.selecionados.data = null;

            var vagasDias = __WEBPACK_IMPORTED_MODULE_2_json_groupby___default()(this.vagas, ["data_atendimento"]);
            this.$nextTick(function () {
                _this5.optionsCalendario.enabledDates = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(vagasDias);
                _this5.selecionados.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(vagasDias)[0];
                _this5.getUnidadesByDia();
            });
        },
        getProcedimentos: function getProcedimentos() {
            this.procedimentos = [];
            var procedimentos = __WEBPACK_IMPORTED_MODULE_2_json_groupby___default()(this.vagas, ["procedimento_id"]);
            var indexProcedimentos = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(procedimentos);

            var procedimentosArray = [];
            indexProcedimentos.map(function (indice, index) {
                var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, procedimentos[indice][0], {
                    ativo: false
                });
                procedimentosArray.push(obj);
            });
            this.procedimentos = procedimentosArray;
        },
        getUnidadesByDia: function getUnidadesByDia() {
            var _this6 = this;

            this.atendimentos_unidade = [];
            var vagasUnidade = [];
            this.vagas.map(function (vaga) {
                if (vaga.data_atendimento == _this6.selecionados.data) {
                    vagasUnidade.push(vaga);
                }
            });
            this.$nextTick(function () {
                var temp = __WEBPACK_IMPORTED_MODULE_2_json_groupby___default()(vagasUnidade, ["unidade_id"]);
                _this6.vagas_unidade = temp;
                var indices = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(temp);
                _this6.getAtendimentosByUnidade(temp[indices[0]][0].unidade_id);
            });
        },
        getAtendimentosByUnidade: function getAtendimentosByUnidade(unidadeId) {
            var _this7 = this;

            this.selecionados.indexUnidadeAtiva = unidadeId;
            var atendimentosUnidade = [];
            this.vagas.map(function (vaga) {
                if (vaga.unidade_id == unidadeId && vaga.data_atendimento == _this7.selecionados.data) {
                    atendimentosUnidade.push(vaga);
                }
            });
            this.atendimentos_unidade = __WEBPACK_IMPORTED_MODULE_2_json_groupby___default()(atendimentosUnidade, ["procedimento_id"]);
        },


        sortByKey: function sortByKey(field) {
            this.dados.coluna = field;
            if (this.dados.ordem == "asc") {
                this.dados.ordem = "desc";
            } else {
                this.dados.ordem = "asc";
            }
        },

        getQtdProcedimentosAtendidos: function getQtdProcedimentosAtendidos(unidadeId) {
            var _this8 = this;

            var qtdProcedimentos = this.vagasApi.length;
            var qtdAtendidas = 0;
            this.vagas.map(function (vaga) {
                if (vaga["unidade_id"] == unidadeId && vaga["data_atendimento"] == _this8.selecionados.data) {
                    qtdAtendidas++;
                }
            });
            return qtdAtendidas + "/" + qtdProcedimentos;
        }
    },
    watch: {
        page: function page(val) {
            this.getDataTable();
        },
        vagasApi: function vagasApi(newValue) {
            this.formataVagas();
        }
    },

    components: {
        datePicker: __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default.a,
        modalEnviarRegulacao: __WEBPACK_IMPORTED_MODULE_7__modalEnviarRegulacao___default.a
    }
};

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_groupby__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_groupby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json_groupby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalEnviarRegulacao__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalEnviarRegulacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modalEnviarRegulacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);











/* harmony default export */ __webpack_exports__["default"] = {
    props: ["vagasApi", "dataNascimentoPaciente", "tipoVaga", "solicitacaoId"],
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_4__constants__["i" /* SITUACAO_SOLICITACAO */];
        }
    },
    data: function data() {
        return {
            showModalEnviarRegulacao: false,
            idadePacienteSelecionado: 0,
            nomeBuscaUnidade: "",
            optionsCalendario: {
                format: "YYYY-MM-DD",
                useCurrent: false,
                inline: true,
                locale: "pt-br",
                enabledDates: null,
                defaultDate: false
            },
            filtros: {
                pesquisa: "",
                coluna: null,
                ordem: null
            },

            selecionados: {
                unidade_id: null,
                profissional_id: null,
                indexUnidadeAtiva: null,
                indexProfissionalAtivo: null,
                indexVagaAtiva: null,
                data: null
            },

            vagas_unidade: [],

            vagas_profissional: [],

            vagas_filtradas: [],

            vagas: [],
            dados: { observacao: '' }
        };
    },
    mounted: function mounted() {},


    methods: {
        negativar: function negativar() {
            var _this = this;

            this.$swal({
                title: "Justificativa da negativa:",
                type: "error",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: function inputValidator(value) {
                    return !value && "Insira a justificativa!";
                },
                preConfirm: function preConfirm(observacao) {
                    _this.dados.observacao = observacao;
                }
            }).then(function (result) {
                var loader = _this.$loading.show();
                _this.$store.commit("TOGGLE_LOADING");
                _this.dados.solicitacaoId = _this.$props.solicitacaoId;
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(_this.$store.state.serverURI + "/api/atendimentos/negativar", _this.dados, _this.$store.getters.getHeaderAuth).then(function (response) {
                        loader.hide();
                        _this.$store.commit("TOGGLE_LOADING");
                        _this.$swal({
                            type: "success",
                            title: "Solicitação negativada com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this.$router.go(-2);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        informacaoPendente: function informacaoPendente() {
            var _this2 = this;

            this.dados.situacao = this.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE;
            this.$swal({
                title: "Mensagem para o marcador:",
                type: "info",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-paper-plane"></i> Enviar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: function inputValidator(value) {
                    return !value && "Insira a mensagem!";
                },
                preConfirm: function preConfirm(observacao) {
                    _this2.dados.observacao = observacao;
                }
            }).then(function (result) {
                _this2.$store.commit("TOGGLE_LOADING");
                _this2.dados.solicitacaoId = _this2.$props.solicitacaoId;
                if (result.value) {
                    var loader = _this2.$loading.show();
                    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(_this2.$store.state.serverURI + "/api/atendimentos/atualizarSituacao", _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
                        loader.hide();
                        _this2.$store.commit("TOGGLE_LOADING");
                        _this2.$swal({
                            type: "success",
                            title: "Mensagem enviada com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this2.$router.go(-2);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        confirma: function confirma() {
            var vagaSelecionada = this.vagas_filtradas[this.selecionados.indexVagaAtiva];
            this.$emit("confirma", vagaSelecionada);
        },
        enviaRegulacao: function enviaRegulacao(motivo) {
            this.showModalEnviarRegulacao = false;
            var vagaSelecionada = this.vagas_filtradas[this.selecionados.indexVagaAtiva];
            this.$emit("enviaRegulacao", vagaSelecionada, motivo);
        },


        formataVagas: function formataVagas() {
            var _this3 = this;

            var vagas = [];
            this.vagasApi.map(function (item) {
                vagas.push({
                    atendimento_id: item.id,
                    contrato_procedimento_id: item.distribuicao_contrato_procedimento_id,
                    quantidade_primeira: item.quantidade_primeira ? item.quantidade_primeira : item.quantidade_atendimento,
                    quantidade_retorno: item.quantidade_retorno ? item.quantidade_retorno : 0,
                    quantidade_local: item.quantidade_local ? item.quantidade_local : 0,
                    hora_inicial: item.hora_inicial,
                    hora_final: item.hora_final,
                    idade_minima: item.idade_minima,
                    idade_maxima: item.idade_maxima,
                    data_atendimento: item.data_atendimento,
                    profissional_id: item.profissional_id ? item.profissional_id : -1,
                    unidade_id: item.contrato_procedimento ? item.contrato_procedimento.contrato.unidade_id : item.contrato_subgrupo.contrato.unidade_id,
                    profissional: {
                        nome: item.profissional_id ? item.profissional.nome : "SEM PROFISSIONAL"
                    },
                    unidade: {
                        nome: item.contrato_procedimento ? item.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo.contrato.unidade.nome
                    },
                    tipoVaga: item.contrato_procedimento ? "procedimento" : "subgrupo",
                    cotaSolicitante: item.cota_solicitante,
                    cotaPrestador: item.cota_prestador,
                    vagaPrestador: item.vaga_prestador
                });
            });

            this.vagas = vagas;
            this.vagas_unidade = __WEBPACK_IMPORTED_MODULE_0_json_groupby___default()(this.vagas, ["unidade_id"]);

            this.$nextTick(function () {
                _this3.getProfissionaisAndDiasByUnidade(String(vagas[0].unidade_id), vagas[0].unidade_id);
            });
        },

        getQtdVagasPrimeira: function getQtdVagasPrimeira(item) {
            var qtd = 0;
            item.map(function (obj) {
                qtd += obj.quantidade_primeira;
            });
            return qtd;
        },

        getQtdVagasRetorno: function getQtdVagasRetorno(item) {
            var qtd = 0;
            item.map(function (obj) {
                qtd += obj.quantidade_retorno;
            });
            return qtd;
        },

        getQtdVagasLocal: function getQtdVagasLocal(item) {
            var qtd = 0;
            item.map(function (obj) {
                qtd += obj.quantidade_local;
            });
            return qtd;
        },

        getProfissionaisAndDiasByUnidade: function getProfissionaisAndDiasByUnidade(index, unidadeId) {
            var _this4 = this;

            this.vagas_filtradas = [];
            this.selecionados.profissional_id = null;
            this.selecionados.indexProfissionalAtivo = null;
            this.selecionados.data = null;
            this.optionsCalendario.enabledDates = null;

            this.selecionados.unidade_id = unidadeId;
            this.selecionados.indexUnidadeAtiva = index;

            var profissionaisByUnidade = [];
            var diasByUnidade = [];
            this.vagas.map(function (item) {
                if (item.unidade_id == _this4.selecionados.unidade_id) {
                    profissionaisByUnidade.push(item);
                    diasByUnidade.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.data_atendimento));
                }
            });

            this.$nextTick(function () {
                _this4.vagas_profissional = __WEBPACK_IMPORTED_MODULE_0_json_groupby___default()(profissionaisByUnidade, ["profissional_id"]);
                _this4.optionsCalendario.enabledDates = diasByUnidade;

                _this4.getVagasDisponiveis();
            });
        },
        getDiasByUnidadeAndProfissional: function getDiasByUnidadeAndProfissional(index, profissionalId) {
            var _this5 = this;

            this.vagas_filtradas = [];
            this.selecionados.profissional_id = profissionalId;
            this.selecionados.indexProfissionalAtivo = index;

            var diasByUnidadeAndProfissional = [];

            this.vagas.map(function (item) {
                if (item.unidade_id == _this5.selecionados.unidade_id && item.profissional_id == _this5.selecionados.profissional_id) {
                    diasByUnidadeAndProfissional.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.data_atendimento));
                }
            });

            this.$nextTick(function () {
                _this5.optionsCalendario.enabledDates = diasByUnidadeAndProfissional;

                _this5.getVagasDisponiveis();
            });
        },
        getProfissionaisByUnidadeAndDia: function getProfissionaisByUnidadeAndDia() {
            var _this6 = this;

            this.vagas_filtradas = [];
            var profissionaisByUnidadeAndDia = [];

            this.vagas.map(function (item) {
                if (item.unidade_id == _this6.selecionados.unidade_id && item.data_atendimento == _this6.selecionados.data) {
                    profissionaisByUnidadeAndDia.push(item);
                }
            });
            this.$nextTick(function () {
                _this6.vagas_profissional = __WEBPACK_IMPORTED_MODULE_0_json_groupby___default()(profissionaisByUnidadeAndDia, ["profissional_id"]);

                _this6.getVagasDisponiveis();
            });
        },
        getVagasDisponiveis: function getVagasDisponiveis() {
            var _this7 = this;

            if (this.selecionados.profissional_id && this.selecionados.unidade_id && this.selecionados.data) {
                this.vagas_filtradas = [];
                var vagasDisponiveis = [];
                this.vagas.map(function (item) {
                    if (item.unidade_id == _this7.selecionados.unidade_id && item.profissional_id == _this7.selecionados.profissional_id && item.data_atendimento == _this7.selecionados.data) {
                        vagasDisponiveis.push(item);
                    }
                });

                this.$nextTick(function () {
                    _this7.vagas_filtradas = vagasDisponiveis;
                    _this7.selecionados.indexVagaAtiva = 0;
                });
            }
        },


        selecionaVaga: function selecionaVaga(index) {
            this.selecionados.indexVagaAtiva = index;
        },

        setIdadePaciente: function setIdadePaciente() {
            var hoje = new Date();
            var nascimento = new Date(this.dataNascimentoPaciente);
            var diferencaAnos = hoje.getFullYear() - nascimento.getFullYear();
            if (new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) < new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())) {
                diferencaAnos--;
            }

            this.idadePacienteSelecionado = diferencaAnos;
        },
        buscarUnidade: function buscarUnidade() {}
    },
    watch: {
        page: function page(val) {
            this.getDataTable();
        },
        vagasApi: function vagasApi(newValue) {
            if (newValue) {
                this.formataVagas();
                this.setIdadePaciente();
            } else {
                this.selecionados = {
                    unidade_id: null,
                    profissional_id: null,
                    indexUnidadeAtiva: null,
                    indexProfissionalAtivo: null,
                    indexVagaAtiva: null,
                    data: null
                };
                this.optionsCalendario = {
                    format: "YYYY-MM-DD",
                    useCurrent: false,
                    inline: true,
                    locale: "pt-br",
                    enabledDates: null,
                    defaultDate: false
                };

                this.vagas_unidade = [];
                this.vagas_profissional = [];
                this.vagas_filtradas = [];
                this.vagas = [];
            }
        }
    },

    components: {
        datePicker: __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default.a,
        modalEnviarRegulacao: __WEBPACK_IMPORTED_MODULE_5__modalEnviarRegulacao___default.a
    }
};

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cadastros_pacientes_selectPaciente__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cadastros_pacientes_selectPaciente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cadastros_pacientes_selectPaciente__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cadastros_profissionais_selectProfissional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_usuarios_selectUsuario__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_usuarios_selectUsuario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cadastros_usuarios_selectUsuario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalDetalhesSolicitacao__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalDetalhesSolicitacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modalDetalhesSolicitacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["default"] = {
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */];
        }
    },
    data: function data() {
        return {
            showModalDetalhesSolicitacao: false,
            solicitacao: {
                created_at: "",
                id: "",
                itens: [{
                    contrato_procedimento: {
                        contrato: {
                            unidade: {
                                nome: ""
                            }
                        },
                        procedimento: {
                            nome: ""
                        }
                    },
                    contrato_procedimento_atendimento: {
                        profissional: {
                            nome: ""
                        },
                        contrato_procedimento: {}
                    }
                }],
                paciente: {
                    nome: "",
                    cidade: {
                        nome: ""
                    }
                },
                paciente_id: "",
                profissional: "",
                profissional_solicitante_id: "",
                situacao: "",
                solicitacao_historicos: [],
                diagnosticos: [],
                updated_at: "",
                usuario: "",
                usuario_solicitante_id: ""
            },
            dataTable: {},
            filtros: {
                pacienteId: "",
                codigo: "",
                dataInicial: "",
                dataFinal: "",
                unidadeId: "",
                situacao: "",
                dataRegulacao: "",
                profissionalSolicitanteId: "",
                usuarioSolicitanteId: "",
                profissionalRealizadorId: "" }
        };
    },
    mounted: function mounted() {},

    methods: {
        situacaoSolicitacao: function situacaoSolicitacao(value) {
            switch (value) {
                case __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */].MARCADA:
                    return "Marcada";
                case __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */].EM_REGULACAO:
                    return "Em regulação";
                case __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */].REGULADA:
                    return "Regulada";
                case __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_PENDENTE:
                    return "Informação pendente";
                case __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_ADICIONAL:
                    return "Informação adicional";
                case __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */].CONFIRMADA:
                    return "Confirmada";
                case __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */].CANCELADA:
                    return "Cancelada";
                case __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */].FALTA:
                    return "Falta";
                case __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */].REALIZADA:
                    return "Realizada";
                case __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SITUACAO_SOLICITACAO */].NEGATIVADA:
                    return "Negativada";
            }
        },
        detalheSolicitacao: function detalheSolicitacao(solicitacao) {
            this.solicitacao = solicitacao;
            this.showModalDetalhesSolicitacao = true;
        },
        verificarCancelamento: function verificarCancelamento(solicitacao) {
            var _this = this;

            var text = this.situacaoSolicitacao(solicitacao.situacao);
            solicitacao.solicitacao_historicos.forEach(function (element) {
                if (element.situacao == _this.SITUACAO_SOLICITACAO.CANCELADA) {
                    text = "Cancelada por " + element.usuario.name;
                }
            });

            return text;
        },
        getDataTable: function getDataTable(page) {
            var _this2 = this;

            if (typeof page === "undefined") {
                page = 1;
            }

            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");

            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/atendimentos/getAllPaginate", config).then(function (response) {
                _this2.dataTable = response.data;
                _this2.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                console.log(error);
            });
        },
        setPacienteSelecionado: function setPacienteSelecionado(paciente) {
            this.filtros.pacienteId = paciente.id;
        },
        setUnidadeSelecionada: function setUnidadeSelecionada(unidade) {
            this.filtros.unidadeId = unidade.id;
        },
        setProfissionalSolicitanteSelecionado: function setProfissionalSolicitanteSelecionado(profissional) {
            this.filtros.profissionalSolicitanteId = profissional.id;
        },
        setUsuarioSelecionado: function setUsuarioSelecionado(usuario) {
            this.filtros.usuarioSolicitanteId = usuario.id;
        },
        setProfissionalRealizadorSelecionado: function setProfissionalRealizadorSelecionado(profissional) {
            this.filtros.profissionalRealizadorId = profissional.id;
        }
    },
    watch: {},
    components: {
        selectPaciente: __WEBPACK_IMPORTED_MODULE_1__cadastros_pacientes_selectPaciente___default.a,
        selectProfissional: __WEBPACK_IMPORTED_MODULE_2__cadastros_profissionais_selectProfissional___default.a,
        selectUnidade: __WEBPACK_IMPORTED_MODULE_3__cadastros_unidades_selectUnidade___default.a,
        selectUsuario: __WEBPACK_IMPORTED_MODULE_4__cadastros_usuarios_selectUsuario___default.a,
        modalDetalhesSolicitacao: __WEBPACK_IMPORTED_MODULE_5__modalDetalhesSolicitacao___default.a
    }
};

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = {
	props: ['show', 'solicitacao', 'cancelar', 'confirmar', 'adicionarInformacao'],
	filters: {},
	data: function data() {
		return {
			dados: {
				observacao: ''
			}
		};
	},
	mounted: function mounted() {},

	methods: {
		cancelarSolicitacao: function cancelarSolicitacao() {
			var _this = this;

			if (!this.dados.observacao) {
				this.$swal({
					type: "warning",
					title: "Atenção!",
					text: "Não é possível cancelar sem uma justificativa. Preencha o motivo do cancelamento."
				});
			} else {
				var loader = this.$loading.show();
				this.$store.commit('TOGGLE_LOADING');
				this.dados.solicitacaoId = this.$props.solicitacao.id;

				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.serverURI + '/api/atendimentos/cancelar', this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
					loader.hide();
					_this.$emit("solicitacaoCancelada", response.data);
					_this.dados.observacao = "";
					_this.$store.commit('TOGGLE_LOADING');
				}).catch(function (error) {
					console.log(error);
				});
			}
		},
		confirmarSolicitacao: function confirmarSolicitacao() {
			var _this2 = this;

			var loader = this.$loading.show();
			this.$store.commit('TOGGLE_LOADING');
			this.dados.solicitacaoId = this.$props.solicitacao.id;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.serverURI + '/api/atendimentos/confirmar', this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
				loader.hide();
				_this2.$emit("solicitacaoConfirmada", response.data);
				_this2.dados.observacao = "";
				_this2.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			});
		},
		addInformacao: function addInformacao() {
			var _this3 = this;

			if (!this.dados.observacao) {
				this.$swal({
					type: "warning",
					title: "Atenção!",
					text: "Preencha o campo com as informações adicionais."
				});
			} else {
				var loader = this.$loading.show();
				this.$store.commit('TOGGLE_LOADING');
				this.dados.solicitacaoId = this.$props.solicitacao.id;

				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.serverURI + '/api/atendimentos/adicionarInformacao', this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
					loader.hide();
					_this3.$emit("informacaoAdicionada", response.data);
					_this3.dados.observacao = "";
					_this3.$store.commit('TOGGLE_LOADING');
				}).catch(function (error) {
					console.log(error);
				});
			}
		}
	},
	components: {}
};

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoDetalhes__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoDetalhes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoDetalhes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comuns_solicitacaoHistorico__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comuns_solicitacaoHistorico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__comuns_solicitacaoHistorico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comuns_solicitacaoBoleto__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comuns_solicitacaoBoleto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__comuns_solicitacaoBoleto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalConfirmarCancelar__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalConfirmarCancelar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modalConfirmarCancelar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = {
    props: ["show", "solicitacao"],
    computed: {
        SITUACAO_SOLICITACAO: function SITUACAO_SOLICITACAO() {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* SITUACAO_SOLICITACAO */];
        }
    },
    data: function data() {
        return {
            showModalConfirmarCancelar: false,
            cancelar: false,
            confirmar: false,
            adicionarInformacao: false
        };
    },
    mounted: function mounted() {},

    methods: {
        verificarCancelamento: function verificarCancelamento() {
            switch (this.$props.solicitacao.situacao) {
                case __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* SITUACAO_SOLICITACAO */].MARCADA:
                case __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* SITUACAO_SOLICITACAO */].CONFIRMADA:
                case __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* SITUACAO_SOLICITACAO */].REGULADA:
                    if (this.$store.state.user.nivel != "administrador") {
                        var dataAtendimento = this.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? this.$props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento : this.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento;
                        var horaIncial = this.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? this.$props.solicitacao.itens[0].contrato_procedimento_atendimento.hora_inicial : this.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.hora_inicial;
                        var dataRealizacao = new Date(dataAtendimento + " " + horaIncial);
                        if (__WEBPACK_IMPORTED_MODULE_4_moment___default()(dataRealizacao).isBefore(new Date())) {
                            return false;
                        }
                    }
                    return true;
                case __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* SITUACAO_SOLICITACAO */].INFORMACAO_PENDENTE:
                case __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* SITUACAO_SOLICITACAO */].EM_REGULACAO:
                    return true;
            }
            return false;
        },
        confirmarSolicitacao: function confirmarSolicitacao() {
            this.showModalConfirmarCancelar = true;
            this.cancelar = false;
            this.confirmar = true;
            this.adicionarInformacao = false;
        },
        cancelarSolicitacao: function cancelarSolicitacao() {
            this.showModalConfirmarCancelar = true;
            this.cancelar = true;
            this.confirmar = false;
            this.adicionarInformacao = false;
        },
        addInformacao: function addInformacao() {
            this.showModalConfirmarCancelar = true;
            this.cancelar = false;
            this.confirmar = false;
            this.adicionarInformacao = true;
        },
        solicitacaoCancelada: function solicitacaoCancelada(solicitacao) {
            this.$swal({
                type: "success",
                title: "Solicitação cancelada com sucesso!",
                showConfirmButton: false,
                timer: 1500
            });
            this.atualizar(solicitacao);
        },
        solicitacaoConfirmada: function solicitacaoConfirmada(solicitacao) {
            this.$swal({
                type: "success",
                title: "Solicitação confirmada com sucesso!",
                showConfirmButton: false,
                timer: 1500
            });
            this.atualizar(solicitacao);
        },
        informacaoAdicionada: function informacaoAdicionada(solicitacao) {
            this.$swal({
                type: "success",
                title: "Informações enviadas com sucesso!",
                showConfirmButton: false,
                timer: 1500
            });
            this.atualizar(solicitacao);
        },
        atualizar: function atualizar(solicitacao) {
            this.showModalConfirmarCancelar = false;
            this.$props.solicitacao.situacao = solicitacao.situacao;
            this.$props.solicitacao.solicitacao_historicos = solicitacao.solicitacao_historicos;
        }
    },
    watch: {},
    components: {
        modalConfirmarCancelar: __WEBPACK_IMPORTED_MODULE_3__modalConfirmarCancelar___default.a,
        solicitacaoDetalhes: __WEBPACK_IMPORTED_MODULE_0__comuns_solicitacaoDetalhes___default.a,
        solicitacaoHistorico: __WEBPACK_IMPORTED_MODULE_1__comuns_solicitacaoHistorico___default.a,
        solicitacaoBoleto: __WEBPACK_IMPORTED_MODULE_2__comuns_solicitacaoBoleto___default.a
    }
};

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gerador_validador_cpf__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gerador_validador_cpf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gerador_validador_cpf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_the_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = {
  directives: {
    mask: __WEBPACK_IMPORTED_MODULE_4_vue_the_mask__["mask"]
  },
  inject: ["$validator"],
  computed: {
    SEXO: function SEXO() {
      return __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* SEXO */];
    },
    SITUACAO: function SITUACAO() {
      return __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SITUACAO */];
    },
    ESTADO_CIVIL: function ESTADO_CIVIL() {
      return __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* ESTADO_CIVIL */];
    },
    TIPO_CERTIDAO: function TIPO_CERTIDAO() {
      return __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* TIPO_CERTIDAO */];
    }
  },
  data: function data() {
    return {
      dados: {
        nome: "",
        cemae: "",
        situacao: 1,
        telefone: "",
        cartao_sus: "",
        data_nascimento: "",
        naturalidade: "",
        sexo: "",
        rg: "",
        orgao_emissor_rg: "",
        uf_rg: "",
        data_emissao_rg: "",
        cpf: "",
        estado_civil: 0,
        nome_mae: "",
        nome_pai: "",
        nome_responsavel: "",
        ocupacao: "",
        cep: "",
        endereco: "",
        numero_endereco: "",
        bairro: "",
        complemento_endereco: "",
        cidade: "",
        uf: "",
        tipo_certidao_auxiliar: "",
        cartorio_auxiliar: "",
        livro_auxiliar: "",
        folha_auxiliar: "",
        registro_auxiliar: "",
        data_emissao_auxiliar: "",
        anotacoes: ""
      },
      withoutCpf: false,
      showHistorico: false,
      pacienteId: "",
      boxTitle: "Novo Paciente"
    };
  },
  mounted: function mounted() {
    this.pacienteId = this.$route.params.pacienteId;
    if (this.pacienteId) {
      this.boxTitle = "Editar Paciente";
      this.getPaciente(this.pacienteId);
    }
  },
  created: function created() {
    this.$validator.extend("validarCpf", {
      getMessage: function getMessage(field) {
        return "O CPF informado não é válido.";
      },
      validate: function validate(value) {
        return __WEBPACK_IMPORTED_MODULE_3_gerador_validador_cpf___default.a.validate(value);
      }
    });
  },

  methods: {
    getEndereco: function getEndereco() {
      var _this = this;

      if (this.dados.cep && this.dados.cep != "") {
        this.$store.commit("TOGGLE_LOADING");
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://viacep.com.br/ws/" + this.dados.cep + "/json/").then(function (response) {
          console.log(response.data);
          if (response.data.erro) {
            _this.$swal({
              type: "warning",
              title: "Digite um CEP válido!",
              text: ""
            }).then(function () {
              _this.dados.cep = "";
              _this.dados.endereco = "";
              _this.dados.bairro = "";
              _this.dados.cidade = "";
              _this.dados.uf = "";
              _this.$refs.cep.focus();
            });
            return false;
          }

          _this.dados.endereco = response.data.logradouro;
          _this.dados.bairro = response.data.bairro;
          _this.dados.cidade = response.data.localidade;
          _this.dados.uf = response.data.uf;
          _this.$store.commit("TOGGLE_LOADING");

          _this.$refs.numero_endereco.focus();
        }).catch(function () {
          _this.$swal({
            type: "warning",
            title: "Não conseguimos buscar seu endereço!",
            text: "Por favor, digite um CEP válido!"
          });
        });
      }
    },
    getPaciente: function getPaciente(pacienteId) {
      var _this2 = this;

      var config = this.$store.getters.getHeaderAuth;
      config.params = [];
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/pacientes/getById/" + this.pacienteId, config).then(function (response) {
        var dados = response.data;
        dados.uf = response.data.cidade.uf.uf;
        dados.cidade = response.data.cidade.nome;
        _this2.dados = dados;
      }).catch(function (error) {
        console.log(error);
      });
    },
    salvar: function salvar() {
      var _this3 = this;

      this.$validator.validate().then(function (result) {

        if (result) {
          if (_this3.pacienteId) {
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$store.state.serverURI + "/api/cadastros/pacientes/update/" + _this3.pacienteId, _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
              _this3.$swal({
                type: "success",
                title: "Paciente atualizado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              });
              _this3.$router.go(-1);
            }).catch(function (error) {
              var erros = error.response.data.message + " ";
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var erro = _step.value;

                  erros += erro + " \n";
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              _this3.$swal({
                type: "error",
                title: "Houve uma falha!",
                text: erros
              });
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$store.state.serverURI + "/api/cadastros/pacientes/create", _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
              _this3.$swal({
                type: "success",
                title: "Paciente criado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              });
              _this3.$router.go(-1);
            }).catch(function (error) {
              var erros = error.response.data.message + " ";
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var erro = _step2.value;

                  erros += erro + " \n";
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              _this3.$swal({
                type: "error",
                title: "Houve uma falha!",
                text: erros
              });
            });
          }
        }
      });
    }
  },
  watch: {},
  components: {}
};

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gerador_validador_cpf__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gerador_validador_cpf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gerador_validador_cpf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_the_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = {
	directives: {
		mask: __WEBPACK_IMPORTED_MODULE_4_vue_the_mask__["mask"]
	},
	inject: ["$validator"],
	props: ['cidadeUnidadeSolicitante'],
	computed: {
		SEXO: function SEXO() {
			return __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* SEXO */];
		},
		SITUACAO: function SITUACAO() {
			return __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SITUACAO */];
		},
		ESTADO_CIVIL: function ESTADO_CIVIL() {
			return __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* ESTADO_CIVIL */];
		},
		TIPO_CERTIDAO: function TIPO_CERTIDAO() {
			return __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* TIPO_CERTIDAO */];
		}
	},
	data: function data() {
		return {
			withoutCpf: false,
			dados: {
				nome: "",
				situacao: 1,
				telefone: "",
				cartao_sus: "",
				data_nascimento: "",
				naturalidade: "",
				sexo: "",
				rg: "",
				orgao_emissor_rg: "",
				uf_rg: "",
				data_emissao_rg: "",
				cpf: "",
				estado_civil: 0,
				nome_mae: "",
				nome_pai: "",
				nome_responsavel: "",
				ocupacao: "",
				cep: "",
				endereco: "",
				numero_endereco: "",
				bairro: "",
				complemento_endereco: "",
				cidade: "",
				uf: "",
				tipo_certidao_auxiliar: "",
				cartorio_auxiliar: "",
				livro_auxiliar: "",
				folha_auxiliar: "",
				registro_auxiliar: "",
				data_emissao_auxiliar: "",
				anotacoes: "",
				cidadeUnidadeSolicitante: null
			}
		};
	},
	created: function created() {
		this.$validator.extend("validarCpf", {
			getMessage: function getMessage(field) {
				return "O CPF informado não é válido.";
			},
			validate: function validate(value) {
				return __WEBPACK_IMPORTED_MODULE_3_gerador_validador_cpf___default.a.validate(value);
			}
		});
	},

	methods: {
		reset: function reset() {
			this.dados = {
				nome: "",
				situacao: 1,
				telefone: "",
				cartao_sus: "",
				data_nascimento: "",
				naturalidade: "",
				sexo: 1,
				rg: "",
				orgao_emissor_rg: "",
				uf_rg: "",
				data_emissao_rg: "",
				cpf: "",
				estado_civil: 0,
				nome_mae: "",
				nome_pai: "",
				nome_responsavel: "",
				ocupacao: "",
				cep: "",
				endereco: "",
				numero_endereco: "",
				bairro: "",
				complemento_endereco: "",
				cidade: "",
				uf: "",
				tipo_certidao_auxiliar: "",
				cartorio_auxiliar: "",
				livro_auxiliar: "",
				folha_auxiliar: "",
				registro_auxiliar: "",
				data_emissao_auxiliar: "",
				anotacoes: "",
				cidadeUnidadeSolicitante: null
			};
		},
		getEndereco: function getEndereco() {
			var _this = this;

			if (this.dados.cep && this.dados.cep != '') {
				this.$store.commit('TOGGLE_LOADING');
				__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://viacep.com.br/ws/" + this.dados.cep + "/json/").then(function (response) {
					if (response.data.erro) {
						_this.$swal({
							type: "warning",
							title: "Digite um CEP válido!",
							text: ""
						}).then(function () {
							_this.dados.cep = '';
							_this.dados.endereco = '';
							_this.dados.bairro = '';
							_this.dados.cidade = '';
							_this.dados.uf = '';
							_this.$refs.cep.focus();
						});
						return false;
					}

					_this.dados.endereco = response.data.logradouro;
					_this.dados.bairro = response.data.bairro;
					_this.dados.cidade = response.data.localidade;
					_this.dados.uf = response.data.uf;
					_this.$store.commit('TOGGLE_LOADING');

					_this.$refs.numero_endereco.focus();
				}).catch(function () {
					_this.$swal({
						type: "warning",
						title: "Não conseguimos buscar seu endereço!",
						text: "Por favor, digite um CEP válido!"
					});
				});
			}
		},
		salvar: function salvar() {
			var _this2 = this;

			this.$validator.validate().then(function (result) {
				_this2.dados.cidadeUnidadeSolicitante = _this2.$props.cidadeUnidadeSolicitante;
				if (result) {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$store.state.serverURI + "/api/cadastros/pacientes/create", _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
						if (response.data.created_at) {
							_this2.$swal({
								type: "success",
								title: "Paciente criado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this2.reset();
							_this2.$emit("pacienteSelecionado", response.data);
						} else {
							_this2.$swal({
								type: "warning",
								title: "Não foi possível cadastrar!",
								text: "O paciente não reside no mesmo munícipio da unidade solicitante."
							});
						}
					}).catch(function (error) {
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;

						try {
							for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var erro = _step.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}

						_this2.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				}
			});
		}
	}
};

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	data: function data() {
		return {
			historico: {
				data: []
			},
			historicoAntigo: {}
		};
	},
	mounted: function mounted() {
		this.getHistorico();
		this.getHistoricoAntigo();
	},

	methods: {
		getHistorico: function getHistorico(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}

			var config = this.$store.getters.getHeaderAuth;
			config.params = {
				page: page
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/cadastros/pacientes/getHistorico/' + this.$route.params.pacienteId, config).then(function (response) {
				_this.historico = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		getHistoricoAntigo: function getHistoricoAntigo(page) {
			var _this2 = this;

			if (typeof page === 'undefined') {
				page = 1;
			}

			var config = this.$store.getters.getHeaderAuth;
			config.params = {
				page: page
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/cadastros/pacientes/getHistoricoAntigo/' + this.$route.params.pacienteId, config).then(function (response) {
				_this2.historicoAntigo = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		situacao: function situacao(item) {
			switch (item.st_solicitacao) {
				case 1:
					return 'EM ANALISE';
				case 2:
					return 'APROVADA';
				case 3:
					return 'CONFIRMADA';
				case 4:
					return 'NEGADA';
				case 5:
					return 'EM PERÍCIA';
				case 6:
					return 'CANCELADA';
				case 7:
					return 'REALIZADA';
				case 8:
					return 'FALTA';
				case 9:
					return 'EM SUPERVISÃO';
				case 10:
					return 'SUPERVISIONADO';
				case 11:
					return 'EM EXTRAPOLACAO';
				case 12:
					return 'TFD';
				case 18:
					return 'FALTA AUTOMÁTICA';
			}
		}
	},
	watch: {},
	components: {}
};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask__);





/* harmony default export */ __webpack_exports__["default"] = {
    directives: {
        mask: __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__["mask"]
    },
    data: function data() {
        return {
            filtros: {
                nome: "",
                nome_mae: "",
                data_nascimento: "",
                rg: "",
                cartao_sus: "",
                municipio: "",
                cpf: ""
            },
            dataTable: {}
        };
    },
    mounted: function mounted() {
        this.filtros.nome = this.$route.query.nome ? this.$route.query.nome : "";
        this.filtros.nome_mae = this.$route.query.nome_mae ? this.$route.query.nome_mae : "";
        this.filtros.cemae = this.$route.query.cemae ? this.$route.query.cemae : "";
        this.filtros.data_nascimento = this.$route.query.data_nascimento ? this.$route.query.data_nascimento : "";
        this.filtros.rg = this.$route.query.rg ? this.$route.query.rg : "";
        this.filtros.cartao_sus = this.$route.query.cartao_sus ? this.$route.query.cartao_sus : "";
        this.filtros.municipio = this.$route.query.municipio ? this.$route.query.municipio : "";
        this.getDataTable();
    },

    methods: {
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
                page = 1;
            }
            this.filtros.page = page;
            this.$router.push({ query: this.filtros });

            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/pacientes/getAllPaginate", config).then(function (response) {
                _this.dataTable = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    watch: {},

    components: {}
};

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formAddPaciente__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formAddPaciente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__formAddPaciente__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask__);





/* harmony default export */ __webpack_exports__["default"] = {
    props: ["regulador", "nomePaciente", "showTextDangerPaciente", "cidadeUnidadeSolicitante", "nomePacienteRecuperado", "unidadeSolicitante"],
    components: {
        formAddPaciente: __WEBPACK_IMPORTED_MODULE_1__formAddPaciente___default.a
    },
    directives: {
        mask: __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__["mask"]
    },
    data: function data() {
        return {
            showFormAddPaciente: false,
            loading: false,
            pacienteSelecionadoIndex: 0,
            pacienteSelecionado: {
                nome: null
            },
            filtros: {
                nome: "",
                nome_mae: "",
                data_nascimento: "",
                rg: "",
                cartao_sus: "",
                municipio: "",
                cpf: ""
            },
            showModal: false,
            dataTable: {
                data: []
            }
        };
    },
    mounted: function mounted() {
        this.pacienteSelecionadoIndex = 0;
    },

    methods: {
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.filtros.cidadeUnidadeSolicitante = this.$props.cidadeUnidadeSolicitante;
            this.filtros.unidadeSolicitante = this.$props.unidadeSolicitante;
            this.$store.commit("TOGGLE_LOADING");

            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/pacientes/getAllPaginate", config).then(function (response) {
                _this.dataTable = response.data;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                console.log(error);
            });
        },
        limpar: function limpar() {
            this.seleciona({
                id: null,
                nome: "",
                nome_mae: "",
                data_nascimento: "",
                rg: "",
                cartao_sus: "",
                cidade: {
                    nome: ""
                }
            });
            this.$emit("limpar");
        },
        seleciona: function seleciona(item) {
            this.pacienteSelecionado = item;
            this.showModal = false;
            this.showFormAddPaciente = false;
            this.$emit("setPacienteSelecionado", item);
        },
        focus: function focus() {
            this.$refs.btnBuscarPaciente.focus();
        },
        abrirModal: function abrirModal() {
            this.$refs.btnBuscarPaciente.click();
        },
        focoNomePaciente: function focoNomePaciente() {
            this.$nextTick(function () {
                this.$refs.inputPaciente.focus();
            });
        },
        up: function up() {
            if (this.pacienteSelecionadoIndex > 0) {
                this.pacienteSelecionadoIndex--;
            }
        },
        down: function down() {
            if (this.pacienteSelecionadoIndex < this.dataTable.data.length - 1) {
                this.pacienteSelecionadoIndex++;
            }
        },
        enter: function enter() {
            if (!this.showFormAddPaciente) {
                if (this.dataTable.data[this.pacienteSelecionadoIndex]) {
                    this.seleciona(this.dataTable.data[this.pacienteSelecionadoIndex]);
                }
            }
        }
    },
    watch: {
        "$props.nomePaciente": function $propsNomePaciente(value) {
            if (value) {
                this.pacienteSelecionado.nome = value;
            }
        }
    }
};

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = {
	inject: ["$validator"],
	data: function data() {
		return {
			dados: {
				nome: "",
				descricao: ""
			},
			preparoId: "",
			boxTitle: "Novo Preparo"
		};
	},
	mounted: function mounted() {
		this.preparoId = this.$route.params.preparoId;
		if (this.preparoId) {
			this.boxTitle = "Editar Preparo";
			this.getPreparo(this.preparoId);
		}
	},

	methods: {
		getPreparo: function getPreparo(preparoId) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/preparos/getById/" + this.preparoId, this.$store.getters.getHeaderAuth).then(function (response) {
				_this.dados = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		salvar: function salvar() {
			var _this2 = this;

			this.$validator.validate().then(function (result) {
				if (result) {
					if (_this2.preparoId) {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$store.state.serverURI + "/api/cadastros/preparos/update/" + _this2.preparoId, _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
							_this2.$swal({
								type: "success",
								title: "Preparo atualizado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this2.$router.push("/cadastros/preparos/");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion = true;
							var _didIteratorError = false;
							var _iteratorError = undefined;

							try {
								for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
									var erro = _step.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError = true;
								_iteratorError = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion && _iterator.return) {
										_iterator.return();
									}
								} finally {
									if (_didIteratorError) {
										throw _iteratorError;
									}
								}
							}

							_this2.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					} else {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$store.state.serverURI + "/api/cadastros/preparos/create", _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
							_this2.$swal({
								type: "success",
								title: "Preparo criado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this2.$router.push("/cadastros/preparos");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion2 = true;
							var _didIteratorError2 = false;
							var _iteratorError2 = undefined;

							try {
								for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
									var erro = _step2.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError2 = true;
								_iteratorError2 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion2 && _iterator2.return) {
										_iterator2.return();
									}
								} finally {
									if (_didIteratorError2) {
										throw _iteratorError2;
									}
								}
							}

							_this2.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					}
				}
			});
		}
	},
	watch: {},
	components: {}
};

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
    data: function data() {
        return {
            filtros: {
                pesquisa: "",
                id: ""
            },
            dataTable: {}
        };
    },
    mounted: function mounted() {
        this.getDataTable();
    },

    methods: {
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");
            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/preparos/getAllPaginate", config).then(function (response) {
                _this.dataTable = response.data;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                console.log(error);
            }).finally(function () {});
        }
    },
    components: {}
};

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	props: ['nomePreparo', 'showTextDangerPreparo'],
	filters: {},
	data: function data() {
		return {
			loading: false,
			preparoSelecionado: {
				nome: null
			},
			filtros: {
				id: '',
				pesquisa: ''
			},
			showModal: false,
			dataTable: {
				data: []
			}
		};
	},
	mounted: function mounted() {
		this.getDataTable();
	},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}
			this.loading = true;
			this.filtros.page = page;
			this.$store.commit('TOGGLE_LOADING');
			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/cadastros/preparos/getAllPaginate', config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			}).finally(function () {
				_this.loading = false;
			});
		},
		limpar: function limpar() {
			this.seleciona({
				id: null,
				nome: ''
			});
		},
		seleciona: function seleciona(item) {
			this.preparoSelecionado = item;
			this.showModal = false;
			this.$emit('setPreparoSelecionado', item);
		}
	},
	watch: {
		"$props.nomePreparo": function $propsNomePreparo() {
			if (this.$props.nomePreparo) {
				this.preparoSelecionado.nome = this.$props.nomePreparo;
			}
		}
	},
	components: {}
};

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = {
	directives: { mask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["mask"] },
	inject: ["$validator"],
	computed: {
		SEXO: function SEXO() {
			return __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* SEXO */];
		},
		SITUACAO: function SITUACAO() {
			return __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* SITUACAO */];
		},
		TIPO_ATENDIMENTO: function TIPO_ATENDIMENTO() {
			return __WEBPACK_IMPORTED_MODULE_4__constants__["e" /* TIPO_ATENDIMENTO */];
		},
		TIPO_AGRUPAMENTO: function TIPO_AGRUPAMENTO() {
			return __WEBPACK_IMPORTED_MODULE_4__constants__["f" /* TIPO_AGRUPAMENTO */];
		},
		COMPLEXIDADE: function COMPLEXIDADE() {
			return __WEBPACK_IMPORTED_MODULE_4__constants__["g" /* COMPLEXIDADE */];
		},
		TIPO_FINANCIAMENTO: function TIPO_FINANCIAMENTO() {
			return __WEBPACK_IMPORTED_MODULE_4__constants__["h" /* TIPO_FINANCIAMENTO */];
		}
	},
	data: function data() {
		return {
			dados: {
				nome: '',
				codigo: '',
				tipo_atendimento: 0,
				situacao: 1,
				tipo_agrupamento: '',
				sexo: 0,
				quantidade_maxima: 0,
				idade_minima: '',
				idade_maxima: '',
				valor_referencia: '',
				complexidade: '',
				tipo_financiamento: '',
				procedimento_forma_organizacao_id: ''
			},
			formasOrganizacao: [],
			procedimentoId: "",
			boxTitle: "Novo Procedimento"
		};
	},
	mounted: function mounted() {
		this.procedimentoId = this.$route.params.procedimentoId;
		if (this.procedimentoId) {
			this.boxTitle = "Editar Procedimento";
			this.getProcedimento(this.procedimentoId);
		}
		this.getFormasOrganizacao();
	},

	methods: {
		getFormasOrganizacao: function getFormasOrganizacao() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/formas-organizacao-procedimento/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
				_this.formasOrganizacao = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		getProcedimento: function getProcedimento(procedimentoId) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/procedimentos/getById/" + this.procedimentoId, this.$store.getters.getHeaderAuth).then(function (response) {
				_this2.dados = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		salvar: function salvar() {
			var _this3 = this;

			this.$validator.validate().then(function (result) {
				if (result) {
					if (_this3.procedimentoId) {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$store.state.serverURI + "/api/cadastros/procedimentos/update/" + _this3.procedimentoId, _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
							_this3.$swal({
								type: "success",
								title: "Procedimento atualizado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this3.$router.push("/cadastros/procedimentos/");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion = true;
							var _didIteratorError = false;
							var _iteratorError = undefined;

							try {
								for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
									var erro = _step.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError = true;
								_iteratorError = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion && _iterator.return) {
										_iterator.return();
									}
								} finally {
									if (_didIteratorError) {
										throw _iteratorError;
									}
								}
							}

							_this3.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					} else {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$store.state.serverURI + "/api/cadastros/procedimentos/create", _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
							_this3.$swal({
								type: "success",
								title: "Procedimento criado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this3.$router.push("/cadastros/procedimentos");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion2 = true;
							var _didIteratorError2 = false;
							var _iteratorError2 = undefined;

							try {
								for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
									var erro = _step2.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError2 = true;
								_iteratorError2 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion2 && _iterator2.return) {
										_iterator2.return();
									}
								} finally {
									if (_didIteratorError2) {
										throw _iteratorError2;
									}
								}
							}

							_this3.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					}
				}
			});
		}
	},
	watch: {},
	components: {}
};

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = {
	inject: ["$validator"],
	data: function data() {
		return {
			dados: {
				nome: "",
				codigo: "",
				procedimento_subgrupo_id: ""
			},
			subgrupos: [],
			formaOrganizacaoId: "",
			boxTitle: "Nova Forma de organização"
		};
	},
	mounted: function mounted() {
		this.formaOrganizacaoId = this.$route.params.formaOrganizacaoId;
		if (this.formaOrganizacaoId) {
			this.boxTitle = "Editar Forma de organização";
			this.getFormaOrganizacao(this.formaOrganizacaoId);
		}
		this.getSubrupos();
	},

	methods: {
		getSubrupos: function getSubrupos() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/subgrupos-procedimento/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
				_this.subgrupos = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		getFormaOrganizacao: function getFormaOrganizacao(formaOrganizacaoId) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/formas-organizacao-procedimento/getById/" + this.formaOrganizacaoId, this.$store.getters.getHeaderAuth).then(function (response) {
				_this2.dados = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		salvar: function salvar() {
			var _this3 = this;

			this.$validator.validate().then(function (result) {
				if (result) {
					if (_this3.formaOrganizacaoId) {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$store.state.serverURI + "/api/cadastros/formas-organizacao-procedimento/update/" + _this3.formaOrganizacaoId, _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
							_this3.$swal({
								type: "success",
								title: "Forma de organização atualizada com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this3.$router.push("/cadastros/formas-organizacao-procedimento/");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion = true;
							var _didIteratorError = false;
							var _iteratorError = undefined;

							try {
								for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
									var erro = _step.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError = true;
								_iteratorError = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion && _iterator.return) {
										_iterator.return();
									}
								} finally {
									if (_didIteratorError) {
										throw _iteratorError;
									}
								}
							}

							_this3.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					} else {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$store.state.serverURI + "/api/cadastros/formas-organizacao-procedimento/create", _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
							_this3.$swal({
								type: "success",
								title: "Forma de organização criada com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this3.$router.push("/cadastros/formas-organizacao-procedimento");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion2 = true;
							var _didIteratorError2 = false;
							var _iteratorError2 = undefined;

							try {
								for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
									var erro = _step2.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError2 = true;
								_iteratorError2 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion2 && _iterator2.return) {
										_iterator2.return();
									}
								} finally {
									if (_didIteratorError2) {
										throw _iteratorError2;
									}
								}
							}

							_this3.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					}
				}
			});
		}
	},
	watch: {},
	components: {}
};

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      filtros: {
        pesquisa: ""
      },
      dataTable: {}
    };
  },
  mounted: function mounted() {
    this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
    this.getDataTable();
  },


  methods: {
    getDataTable: function getDataTable(page) {
      var _this = this;

      if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
        page = 1;
      }
      this.filtros.page = page;
      this.$router.push({ query: this.filtros });
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/formas-organizacao-procedimento/getAllPaginate", config).then(function (response) {
        _this.dataTable = response.data;
      }).catch(function (error) {
        _this.$store.commit("throwException", error);
      });
    }
  },
  watch: {},

  components: {}
};

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = {
	inject: ["$validator"],
	data: function data() {
		return {
			dados: {
				nome: "",
				codigo: ""
			},
			grupoId: "",
			boxTitle: "Novo Grupo"
		};
	},
	mounted: function mounted() {
		this.grupoId = this.$route.params.grupoId;
		if (this.grupoId) {
			this.boxTitle = "Editar Grupo";
			this.getGrupo(this.grupoId);
		}
	},

	methods: {
		getGrupo: function getGrupo(grupoId) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/grupos-procedimento/getById/" + this.grupoId, this.$store.getters.getHeaderAuth).then(function (response) {
				_this.dados = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		salvar: function salvar() {
			var _this2 = this;

			this.$validator.validate().then(function (result) {
				if (result) {
					if (_this2.grupoId) {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$store.state.serverURI + "/api/cadastros/grupos-procedimento/update/" + _this2.grupoId, _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
							_this2.$swal({
								type: "success",
								title: "Grupo atualizado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this2.$router.push("/cadastros/grupos-procedimento/");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion = true;
							var _didIteratorError = false;
							var _iteratorError = undefined;

							try {
								for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
									var erro = _step.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError = true;
								_iteratorError = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion && _iterator.return) {
										_iterator.return();
									}
								} finally {
									if (_didIteratorError) {
										throw _iteratorError;
									}
								}
							}

							_this2.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					} else {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$store.state.serverURI + "/api/cadastros/grupos-procedimento/create", _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
							_this2.$swal({
								type: "success",
								title: "Grupo criado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this2.$router.push("/cadastros/grupos-procedimento");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion2 = true;
							var _didIteratorError2 = false;
							var _iteratorError2 = undefined;

							try {
								for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
									var erro = _step2.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError2 = true;
								_iteratorError2 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion2 && _iterator2.return) {
										_iterator2.return();
									}
								} finally {
									if (_didIteratorError2) {
										throw _iteratorError2;
									}
								}
							}

							_this2.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					}
				}
			});
		}
	},
	watch: {},
	components: {}
};

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      filtros: {
        pesquisa: ""
      },
      dataTable: {}
    };
  },
  mounted: function mounted() {
    this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
    this.getDataTable();
  },


  methods: {
    getDataTable: function getDataTable(page) {
      var _this = this;

      if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
        page = 1;
      }
      this.filtros.page = page;
      this.$router.push({ query: this.filtros });

      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/grupos-procedimento/getAllPaginate", config).then(function (response) {
        _this.dataTable = response.data;
      }).catch(function (error) {
        _this.$store.commit("throwException", error);
      });
    }
  },
  watch: {},

  components: {}
};

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      filtros: {
        pesquisa: ""
      },
      dataTable: {}
    };
  },
  mounted: function mounted() {
    this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
    this.getDataTable();
  },


  methods: {
    getDataTable: function getDataTable(page) {
      var _this = this;

      if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
        page = 1;
      }
      this.filtros.page = page;
      this.$router.push({ query: this.filtros });
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/procedimentos/getAllPaginate", config).then(function (response) {
        _this.dataTable = response.data;
      }).catch(function (error) {
        _this.$store.commit("throwException", error);
      });
    }
  },
  watch: {},

  components: {}
};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['nomeProcedimento', 'showTextDangerProcedimento'],
  filters: {},
  data: function data() {
    return {
      loading: false,
      procedimentoSelecionado: {
        nome: null
      },
      filtros: {
        pesquisa: ''
      },
      showModal: false,
      dataTable: {
        data: []
      }
    };
  },
  mounted: function mounted() {
    this.getDataTable();
  },

  methods: {
    getDataTable: function getDataTable(page) {
      var _this = this;

      if (typeof page === 'undefined') {
        page = 1;
      }

      this.filtros.page = page;
      this.$store.commit('TOGGLE_LOADING');

      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/cadastros/procedimentos/getAllPaginate', config).then(function (response) {
        _this.dataTable = response.data;

        _this.$store.commit('TOGGLE_LOADING');
      }).catch(function (error) {
        _this.$store.commit('throwException', error);
      });
    },
    limpar: function limpar() {
      this.seleciona({ id: null, nome: '' });
    },
    seleciona: function seleciona(item) {
      this.procedimentoSelecionado = item;
      this.showModal = false;
      this.$emit('setProcedimentoSelecionado', item);
    },
    focoNomeProcedimentol: function focoNomeProcedimentol() {
      this.$nextTick(function () {
        this.$refs.inputProcedimento.focus();
      });
    }
  },
  watch: {
    "$props.nomeProcedimento": function $propsNomeProcedimento() {
      if (this.$props.nomeProcedimento) {
        this.procedimentoSelecionado.nome = this.$props.nomeProcedimento;
      }
    }
  },
  components: {}
};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = {
	inject: ["$validator"],
	data: function data() {
		return {
			dados: {
				nome: "",
				codigo: "",
				procedimento_grupo_id: ""
			},
			grupos: [],
			subgrupoId: "",
			boxTitle: "Novo Subgrupo"
		};
	},
	mounted: function mounted() {
		this.subgrupoId = this.$route.params.subgrupoId;
		if (this.subgrupoId) {
			this.boxTitle = "Editar Subgrupo";
			this.getSubgrupo(this.subgrupoId);
		}
		this.getGrupos();
	},

	methods: {
		getGrupos: function getGrupos() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/grupos-procedimento/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
				_this.grupos = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		getSubgrupo: function getSubgrupo(subgrupoId) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/subgrupos-procedimento/getById/" + this.subgrupoId, this.$store.getters.getHeaderAuth).then(function (response) {
				_this2.dados = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		salvar: function salvar() {
			var _this3 = this;

			this.$validator.validate().then(function (result) {
				if (result) {
					if (_this3.subgrupoId) {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$store.state.serverURI + "/api/cadastros/subgrupos-procedimento/update/" + _this3.subgrupoId, _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
							_this3.$swal({
								type: "success",
								title: "Subgrupo atualizado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this3.$router.push("/cadastros/subgrupos-procedimento/");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion = true;
							var _didIteratorError = false;
							var _iteratorError = undefined;

							try {
								for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
									var erro = _step.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError = true;
								_iteratorError = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion && _iterator.return) {
										_iterator.return();
									}
								} finally {
									if (_didIteratorError) {
										throw _iteratorError;
									}
								}
							}

							_this3.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					} else {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$store.state.serverURI + "/api/cadastros/subgrupos-procedimento/create", _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
							_this3.$swal({
								type: "success",
								title: "Subgrupo criado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this3.$router.push("/cadastros/subgrupos-procedimento");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion2 = true;
							var _didIteratorError2 = false;
							var _iteratorError2 = undefined;

							try {
								for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
									var erro = _step2.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError2 = true;
								_iteratorError2 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion2 && _iterator2.return) {
										_iterator2.return();
									}
								} finally {
									if (_didIteratorError2) {
										throw _iteratorError2;
									}
								}
							}

							_this3.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					}
				}
			});
		}
	},
	watch: {},
	components: {}
};

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      filtros: {
        pesquisa: ""
      },
      dataTable: {}
    };
  },
  mounted: function mounted() {
    this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
    this.getDataTable();
  },


  methods: {
    getDataTable: function getDataTable(page) {
      var _this = this;

      if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
        page = 1;
      }
      this.filtros.page = page;
      this.$router.push({ query: this.filtros });
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/subgrupos-procedimento/getAllPaginate", config).then(function (response) {
        _this.dataTable = response.data;
        _this.$store.commit("TOGGLE_LOADING");
      }).catch(function (error) {
        _this.$store.commit("throwException", error);
      });
    }
  },
  watch: {},

  components: {}
};

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['nomeSubgrupo', 'showTextDangerSubgrupo'],

  data: function data() {
    return {
      loading: false,
      subgrupoSelecionado: {
        nome: null
      },
      filtros: {
        pesquisa: ''
      },
      showModal: false,
      dataTable: {
        data: []
      }
    };
  },
  mounted: function mounted() {
    this.getDataTable();
  },

  methods: {
    getDataTable: function getDataTable(page) {
      var _this = this;

      if (typeof page === 'undefined') {
        page = 1;
      }

      this.filtros.page = page;
      this.$store.commit('TOGGLE_LOADING');

      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/cadastros/subgrupos-procedimento/getAllPaginate', config).then(function (response) {
        _this.dataTable = response.data;
        _this.$store.commit('TOGGLE_LOADING');
      }).catch(function (error) {
        _this.$store.commit('throwException', error);
      });
    },
    limpar: function limpar() {
      this.seleciona({ id: null, nome: '' });
    },
    seleciona: function seleciona(item) {
      this.subgrupoSelecionado = item;
      this.showModal = false;
      this.$emit('setSubgrupoSelecionado', item);
    }
  },
  watch: {
    "$props.nomeSubgrupo": function $propsNomeSubgrupo() {
      if (this.$props.nomeSubgrupo) {
        this.subgrupoSelecionado.nome = this.$props.nomeSubgrupo;
      }
    }
  },
  components: {}
};

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = {
	directives: {
		mask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["mask"]
	},
	inject: ["$validator"],
	computed: {
		SEXO: function SEXO() {
			return __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* SEXO */];
		},
		SITUACAO: function SITUACAO() {
			return __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* SITUACAO */];
		}
	},
	data: function data() {
		return {
			dados: {
				nome: "",
				conselho: "CRM",
				registro_conselho: '',
				situacao: 1,
				cns: "",
				email: "",
				data_admissao: "",
				data_desligamento: "",
				data_nascimento: "",
				sexo: 1,
				rg: "",
				orgao_emissor_rg: "",
				uf_rg: "",
				data_emissao_rg: "",
				cpf: "",
				telefone: "",
				profissionais: "",
				hora_final: ""
			},
			profissionalId: "",
			boxTitle: "Novo Profissional"
		};
	},
	mounted: function mounted() {
		this.profissionalId = this.$route.params.profissionalId;
		if (this.profissionalId) {
			this.boxTitle = "Editar Profissional";
			this.getProfissional(this.profissionalId);
		}
	},

	methods: {
		getProfissional: function getProfissional(profissionalId) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/profissionais/getById/" + this.profissionalId, this.$store.getters.getHeaderAuth).then(function (response) {
				_this.dados = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		salvar: function salvar() {
			var _this2 = this;

			this.$validator.validate().then(function (result) {
				if (result) {
					if (_this2.profissionalId) {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$store.state.serverURI + "/api/cadastros/profissionais/update/" + _this2.profissionalId, _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
							_this2.$swal({
								type: "success",
								title: "Profissional atualizado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this2.$router.push("/cadastros/profissionais/");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion = true;
							var _didIteratorError = false;
							var _iteratorError = undefined;

							try {
								for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
									var erro = _step.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError = true;
								_iteratorError = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion && _iterator.return) {
										_iterator.return();
									}
								} finally {
									if (_didIteratorError) {
										throw _iteratorError;
									}
								}
							}

							_this2.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					} else {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$store.state.serverURI + "/api/cadastros/profissionais/create", _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
							_this2.$swal({
								type: "success",
								title: "Profissional criado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							_this2.$router.push("/cadastros/profissionais");
						}).catch(function (error) {
							var erros = error.response.data.message + " ";
							var _iteratorNormalCompletion2 = true;
							var _didIteratorError2 = false;
							var _iteratorError2 = undefined;

							try {
								for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
									var erro = _step2.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError2 = true;
								_iteratorError2 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion2 && _iterator2.return) {
										_iterator2.return();
									}
								} finally {
									if (_didIteratorError2) {
										throw _iteratorError2;
									}
								}
							}

							_this2.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
					}
				}
			});
		}
	},
	watch: {},
	components: {}
};

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      filtros: {
        pesquisa: ""
      },
      dataTable: {}
    };
  },
  mounted: function mounted() {
    this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
    this.getDataTable();
  },


  methods: {
    getDataTable: function getDataTable(page) {
      var _this = this;

      if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
        page = 1;
      }
      this.filtros.page = page;
      this.$router.push({ query: this.filtros });
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/profissionais/getAllPaginate", config).then(function (response) {
        _this.dataTable = response.data;
        _this.$store.commit("TOGGLE_LOADING");
      }).catch(function (error) {
        _this.$store.commit("throwException", error);
      });
    }
  },
  watch: {},

  components: {}
};

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	$_veeValidate: {
		name: function name() {
			return this.name;
		},
		value: function value() {
			return this.profissionalSelecionado.nome;
		}
	},
	filters: {},

	props: {
		disableClear: false,
		unidadeSolicitanteSelecionada: {
			default: null
		},
		nomeProfissional: {},
		nomeProfissionalRecuperado: {},
		showTextDangerProfissional: {
			default: false
		},
		tipoProfissional: {},
		placeholder: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		}
	},
	data: function data() {
		return {
			loading: false,
			profissionalSelecionadoIndex: 0,
			profissionalSelecionado: {},
			filtros: {
				pesquisa: ''
			},
			showModal: false,
			dataTable: {
				data: []
			}
		};
	},
	mounted: function mounted() {},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}

			this.filtros.page = page;
			this.$store.commit('TOGGLE_LOADING');

			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/cadastros/profissionais/getAllPaginate', config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				_this.$store.commit('throwException', error);
			});
		},
		limpar: function limpar() {
			this.seleciona({ id: null, nome: '' });
		},
		seleciona: function seleciona(item) {
			this.$emit("input", item.nome);
			this.profissionalSelecionado = item;
			this.showModal = false;
			if (this.$props.tipoProfissional) {
				this.$emit('setProfissional' + this.$props.tipoProfissional + 'Selecionado', item);
			} else {
				this.$emit('setProfissionalSelecionado', item);
			}
		},
		abrirModal: function abrirModal() {
			this.$refs.btnBuscarProfissional.click();
		},
		focoNomeProfissional: function focoNomeProfissional() {
			this.$nextTick(function () {
				this.$refs.inputProfissional.focus();
			});
		},
		up: function up() {
			if (this.profissionalSelecionadoIndex > 0) {
				this.profissionalSelecionadoIndex--;
			}
			console.log("profissionalSelecionadoIndex : " + this.profissionalSelecionadoIndex);
		},
		down: function down() {
			if (this.profissionalSelecionadoIndex < this.dataTable.data.length - 1) {
				this.profissionalSelecionadoIndex++;
			}
			console.log("profissionalSelecionadoIndex : " + this.profissionalSelecionadoIndex);
		},
		enter: function enter() {
			this.seleciona(this.dataTable.data[this.profissionalSelecionadoIndex]);
		},
		selecionaIndex: function selecionaIndex() {
			console.log("Enter ");
			console.log(this.dataTable[1]);
		}
	},
	watch: {
		"$props.nomeProfissional": function $propsNomeProfissional(value) {
			if (value) {
				this.profissionalSelecionado.nome = value;
			}
		}
	},
	components: {}
};

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Alert__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_the_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_the_mask__);









/* harmony default export */ __webpack_exports__["default"] = {
    directives: {
        mask: __WEBPACK_IMPORTED_MODULE_5_vue_the_mask__["mask"]
    },
    filters: {},
    data: function data() {
        return {
            dados: {
                nome: "",
                unidade_tipo_id: "",
                categoria: 0,
                cnpj: "",
                cnes: "",
                telefone: "",
                situacao: 1,
                cep: "",
                endereco: "",
                numero_endereco: "",
                bairro: "",
                complemento_endereco: "",
                cidade: "",
                uf: "",
                ponto_referencia: "",
                paciente_outro_municipio: 0,
                anotacoes: ""
            },
            tiposUnidade: [],
            unidadeId: "",
            boxTitle: "Nova Unidade"
        };
    },
    mounted: function mounted() {
        this.unidadeId = this.$route.params.unidade_id;
        if (this.unidadeId) {
            this.boxTitle = "Editar Unidade";
            this.getUnidade(this.unidadeId);
        }
        this.getTiposUnidade();
    },

    methods: {
        getEndereco: function getEndereco() {
            var _this = this;

            if (this.dados.cep && this.dados.cep != "") {
                this.$store.commit("TOGGLE_LOADING");
                __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://viacep.com.br/ws/" + this.dados.cep + "/json/").then(function (response) {
                    console.log(response.data);
                    if (response.data.erro) {
                        _this.$swal({
                            type: "warning",
                            title: "Digite um CEP válido!",
                            text: ""
                        }).then(function () {
                            _this.dados.cep = "";
                            _this.dados.endereco = "";
                            _this.dados.bairro = "";
                            _this.dados.cidade = "";
                            _this.dados.uf = "";
                            _this.$refs.cep.focus();
                        });
                        return false;
                    }

                    _this.dados.endereco = response.data.logradouro;
                    _this.dados.bairro = response.data.bairro;
                    _this.dados.cidade = response.data.localidade;
                    _this.dados.uf = response.data.uf;
                    _this.$store.commit("TOGGLE_LOADING");

                    _this.$refs.numero_endereco.focus();
                }).catch(function () {
                    _this.$swal({
                        type: "warning",
                        title: "Não conseguimos buscar seu endereço!",
                        text: "Por favor, digite um CEP válido!"
                    });
                });
            }
        },
        getUnidade: function getUnidade(unidadeId) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/unidades/getById/" + this.unidadeId, this.$store.getters.getHeaderAuth).then(function (response) {
                var dados = response.data;
                dados.uf = response.data.cidade.uf.uf;
                dados.cidade = response.data.cidade.nome;
                _this2.dados = dados;
            });
        },
        getTiposUnidade: function getTiposUnidade() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/tipos-unidade/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
                _this3.tiposUnidade = response.data;
            });
        },
        salvar: function salvar() {
            var _this4 = this;

            if (this.unidadeId) {
                __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/cadastros/unidades/update/" + this.unidadeId, this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
                    _this4.$swal({
                        type: "success",
                        title: "Unidade atualizada com sucesso!",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    _this4.$router.push("/cadastros/unidades/");
                }).catch(function (error) {
                    var erros = error.response.data.message + " ";
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var erro = _step.value;

                            erros += erro + " \n";
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this4.$swal({
                        type: "error",
                        title: "Houve uma falha!",
                        text: erros
                    });
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/cadastros/unidades/create", this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
                    _this4.$swal({
                        type: "success",
                        title: "Unidade criada com sucesso!",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    _this4.$router.push("/cadastros/unidades/");
                }).catch(function (error) {
                    var erros = error.response.data.message + " ";
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var erro = _step2.value;

                            erros += erro + " \n";
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    _this4.$swal({
                        type: "error",
                        title: "Houve uma falha!",
                        text: erros
                    });
                });
            }
        }
    },
    watch: {},
    components: {
        Alert: __WEBPACK_IMPORTED_MODULE_3__Alert___default.a,
        selectUnidade: __WEBPACK_IMPORTED_MODULE_4__cadastros_unidades_selectUnidade___default.a
    }
};

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = {
  filters: {},
  data: function data() {
    return {
      filtros: {
        pesquisa: "",
        categoria: "",
        situacao: "",
        tipo_unidade_id: ""
      },
      dataTable: {},
      tiposUnidade: []
    };
  },
  mounted: function mounted() {
    this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
    this.filtros.categoria = this.$route.query.categoria ? this.$route.query.categoria : "";
    this.filtros.situacao = this.$route.query.situacao ? this.$route.query.situacao : "";
    this.filtros.tipo_unidade_id = this.$route.query.tipo_unidade_id ? this.$route.query.tipo_unidade_id : "";
    this.getTiposUnidade();
    this.getDataTable();
  },

  methods: {
    getTiposUnidade: function getTiposUnidade() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/tipos-unidade/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
        _this.tiposUnidade = response.data;
      });
    },
    getDataTable: function getDataTable(page) {
      var _this2 = this;

      if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
        page = 1;
      }
      this.filtros.page = page;
      this.$router.push({ query: this.filtros });
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/unidades/getAllPaginate", config).then(function (response) {
        _this2.dataTable = response.data;
      }).catch(function (error) {
        _this2.$store.commit("throwException", error);
      });
    }
  },
  watch: {},
  components: {}
};

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	props: ['nomeUnidade', 'showTextDangerUnidade', 'tipo'],
	filters: {
		categoria: function categoria(val) {
			if (val == 0) {
				return 'Pública Local';
			} else if (val == 1) {
				return 'Pactuada';
			} else if (val == 2) {
				return 'Privada';
			}
		}
	},
	data: function data() {
		return {
			loading: false,
			unidadeSelecionada: {
				nome: null
			},
			filtros: {
				pesquisa: '',
				tipo: null
			},
			showModal: false,
			dataTable: {
				data: []
			}
		};
	},
	mounted: function mounted() {
		this.getDataTable();
	},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}
			this.filtros.page = page;
			if (this.tipo) {
				this.filtros.tipo = this.tipo;
			}
			this.$store.commit('TOGGLE_LOADING');

			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/cadastros/unidades/getAllPaginate', config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				_this.$store.commit('throwException', error);
			});
		},
		limpar: function limpar() {
			this.seleciona({ id: null, nome: '' });
		},
		seleciona: function seleciona(item) {
			this.unidadeSelecionada = item;
			this.showModal = false;
			this.$emit('setUnidadeSelecionada', item);
		}
	},
	watch: {
		"$props.nomeUnidade": function $propsNomeUnidade() {
			if (this.$props.nomeUnidade) {
				this.unidadeSelecionada.nome = this.$props.nomeUnidade;
			}
		}
	},
	components: {}
};

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask__);





/* harmony default export */ __webpack_exports__["default"] = {
    directives: {
        mask: __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__["mask"]
    },
    data: function data() {
        return {
            finalizado: false,
            viewPermissions: true,
            dados: {
                id: null,
                name: "",
                login: "",
                email: "",
                telefone: "",
                anotacoes: "",
                password: "",
                nivel: "",
                setor_id: null,
                permissoes: [],
                unidades: []
            },
            confirmacaoSenha: "",
            atualizacao: false,

            selectUnidades: []
        };
    },
    mounted: function mounted() {
        this.getUnidades();
        if (this.$route.params.idUsuario) {
            this.getUserById(this.$route.params.idUsuario);
            this.atualizacao = true;
            this.viewPermissions = false;
        }
    },

    methods: {
        getUserById: function getUserById(id) {
            var _this = this;

            this.$store.commit("TOGGLE_LOADING");
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/usuario/getById/" + id, this.$store.getters.getHeaderAuth).then(function (response) {
                _this.dados.id = response.data.id;
                _this.dados.name = response.data.name;
                _this.dados.login = response.data.login;
                _this.dados.email = response.data.email;
                _this.dados.setor_id = response.data.setor_id;
                _this.dados.permissoes = response.data.permissoes;
                _this.dados.nivel = response.data.nivel;
                _this.dados.situacao = response.data.situacao;
                _this.dados.telefone = response.data.telefone;
                _this.dados.anotacoes = response.data.anotacoes;
                var stringified = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.unidades);
                stringified = stringified.replace(/nome/g, "label");
                stringified = stringified.replace(/id/g, "value");
                _this.dados.unidades = JSON.parse(stringified);
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this.$store.commit("SHOW_ALERT_ERROR");
                _this.$store.commit("SET_ALERT_MESSAGE", error.response.data.message);
                _this.$router.push("/cadastros/usuarios");
                console.log(error);
            });
        },
        getUnidades: function getUnidades() {
            var _this2 = this;

            this.$store.commit("TOGGLE_LOADING");
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/cadastros/unidades/dataForSelect/", this.$store.getters.getHeaderAuth).then(function (response) {
                var unidades = response.data;

                var stringified = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data);
                stringified = stringified.replace(/nome/g, "label");
                stringified = stringified.replace(/id/g, "value");

                unidades = JSON.parse(stringified);

                _this2.selectUnidades = unidades;
                _this2.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this2.$store.commit("SHOW_ALERT_ERROR");
                _this2.$store.commit("SET_ALERT_MESSAGE", error.response.data.message);
                _this2.$router.push("/cadastros/usuarios");
                console.log(error);
            });
        },
        commit: function commit() {
            var _this3 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this3.finalizado = true;
                    _this3.$store.commit("TOGGLE_LOADING");
                    if (_this3.atualizacao) {
                        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this3.$store.state.serverURI + "/api/usuario/update/" + _this3.dados.id, _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
                            _this3.$store.commit("SHOW_ALERT_SUCCESS");
                            _this3.$router.push("/cadastros/usuarios");
                        }).catch(function (error) {
                            _this3.$store.commit("SHOW_ALERT_ERROR");
                            _this3.finalizado = false;
                            console.log(error);
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this3.$store.state.serverURI + "/api/usuario/create", _this3.dados, _this3.$store.getters.getHeaderAuth).then(function (response) {
                            _this3.$store.commit("SHOW_ALERT_SUCCESS");
                            _this3.$router.push("/cadastros/usuarios");
                        }).catch(function (error) {
                            _this3.$store.commit("SHOW_ALERT_ERROR");
                            _this3.finalizado = false;
                            console.log(error);
                        });
                    }
                }
                _this3.$store.commit("TOGGLE_LOADING");
                return false;
            });
        }
    }
};

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = {
	name: "alterarSenha",
	data: function data() {
		return {
			dados: {
				old_password: "",
				password: ""
			},
			confirmacaoSenha: ""
		};
	},

	methods: {
		atualizarSenha: function atualizarSenha() {
			var _this = this;

			this.$validator.validateAll().then(function (result) {
				if (result) {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this.$store.state.serverURI + "/api/usuario/updatePassword/" + _this.$store.state.user.id, _this.dados, _this.$store.getters.getHeaderAuth).then(function (response) {
						_this.$swal({
							position: "center",
							type: "success",
							title: "Senha atualizada com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
						_this.$router.push("/");
					}).catch(function (e) {
						if (e.response.data.errors) {
							var erros = e.response.data.message + " ";
							var _iteratorNormalCompletion = true;
							var _didIteratorError = false;
							var _iteratorError = undefined;

							try {
								for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(e.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
									var erro = _step.value;

									erros += erro + " \n";
								}
							} catch (err) {
								_didIteratorError = true;
								_iteratorError = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion && _iterator.return) {
										_iterator.return();
									}
								} finally {
									if (_didIteratorError) {
										throw _iteratorError;
									}
								}
							}

							_this.$swal({
								position: "center",
								type: "error",
								title: erros,
								showConfirmButton: true
							});
						} else {
							console.log(e);
							_this.$swal({
								position: "center",
								type: "error",
								title: e.response.data.message + ". Verifique as informações e tente novamente!",
								showConfirmButton: true
							});
						}
						console.log(e);
					});
				}
			});
		}
	}
};

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Alert__);






/* harmony default export */ __webpack_exports__["default"] = {
    filters: {
        unidades: function unidades(val) {
            var unidades = "";
            for (var i = 0; i < val.length; i++) {
                unidades += val[i].nome;
                if (i + 1 < val.length) {
                    unidades += ", ";
                }
            }

            return unidades;
        }
    },
    data: function data() {
        return {
            filtros: {
                pesquisa: "",
                coluna: null,
                ordem: null
            },
            apiData: {
                data: []
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
        this.getUsers();
        this.$nextTick(function () {
            _this.$refs.filtro_pesquisa.focus();
        });
    },


    methods: {
        sortByKey: function sortByKey(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getUsers();
        },
        getUsers: function getUsers(page) {
            var _this2 = this;

            if (typeof page === "undefined" || (typeof page === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) === "object") {
                page = 1;
            }
            this.filtros.page = page;
            this.$router.push({ query: this.filtros });
            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/usuario/getAllPaginate", config).then(function (response) {
                _this2.apiData = response.data;
            }).catch(function (error) {
                _this2.$store.commit("throwException", error);
            });
        },
        desativarUsuario: function desativarUsuario(id, nome) {
            var _this3 = this;

            this.$swal({
                title: "Tem certeza que deseja desativar o usu\xE1rio \"" + nome + "\"?",
                text: "Obs.: Nenhum dado pode ser apagado permanentemente do sistema!",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(_this3.$store.state.serverURI + "/api/usuario/desativar/" + id, _this3.$store.getters.getHeaderAuth).then(function (response) {
                        _this3.$swal({
                            type: "success",
                            title: "Usuário desativado com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this3.getUsers();
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        ativarUsuario: function ativarUsuario(id, nome) {
            var _this4 = this;

            this.$swal({
                title: "Tem certeza que deseja ativar o usu\xE1rio \"" + nome + "\"?",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this4.$store.state.serverURI + "/api/usuario/ativar/" + id, {}, _this4.$store.getters.getHeaderAuth).then(function (response) {
                        _this4.$swal({
                            type: "success",
                            title: "Usuário ativado com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this4.getUsers();
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        }
    },
    watch: {
        page: function page(val) {
            this.getUsers();
        }
    },

    components: {
        Alert: __WEBPACK_IMPORTED_MODULE_2__Alert___default.a
    }
};

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_the_mask__);





/* harmony default export */ __webpack_exports__["default"] = {
    props: ["regulador", "nomeMarcador", "showTextDangerMarcador", "cidadeUnidadeSolicitante", "nomeMarcadorRecuperado", "unidadeSolicitante"],
    components: {},
    directives: {
        mask: __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__["mask"]
    },
    data: function data() {
        return {
            showFormAddMarcador: false,
            loading: false,
            marcadorSelecionadoIndex: 0,
            marcadorSelecionado: {
                nome: null
            },
            filtros: {
                nome: "",
                login: ""
            },
            showModal: false,
            dataTable: {
                data: []
            }
        };
    },
    mounted: function mounted() {
        this.marcadorSelecionadoIndex = 0;
    },

    methods: {
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.filtros.cidadeUnidadeSolicitante = this.$props.cidadeUnidadeSolicitante;
            this.filtros.unidadeSolicitante = this.$props.unidadeSolicitante;
            this.$store.commit("TOGGLE_LOADING");

            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/usuario/getAllPaginate", config).then(function (response) {
                _this.dataTable = response.data;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                console.log(error);
            });
        },
        limpar: function limpar() {
            this.seleciona({
                id: null,
                nome: "",
                login: ""
            });
            this.$emit("limpar");
        },
        seleciona: function seleciona(item) {
            this.marcadorSelecionado = item;
            this.showModal = false;
            this.$emit("setMarcadorSelecionado", item);
        },
        focus: function focus() {
            this.$refs.btnBuscarMarcador.focus();
        },
        abrirModal: function abrirModal() {
            this.$refs.btnBuscarMarcador.click();
        },
        focoNomeMarcador: function focoNomeMarcador() {
            this.$nextTick(function () {
                this.$refs.inputMarcador.focus();
            });
        },
        up: function up() {
            if (this.marcadorSelecionadoIndex > 0) {
                this.marcadorSelecionadoIndex--;
            }
        },
        down: function down() {
            if (this.marcadorSelecionadoIndex < this.dataTable.data.length - 1) {
                this.marcadorSelecionadoIndex++;
            }
        },
        enter: function enter() {
            if (!this.showFormAddMarcador) {
                if (this.dataTable.data[this.marcadorSelecionadoIndex]) {
                    this.seleciona(this.dataTable.data[this.marcadorSelecionadoIndex]);
                }
            }
        }
    },
    watch: {
        "$props.nomeMarcador": function $propsNomeMarcador(value) {
            if (value) {
                this.marcadorSelecionado.nome = value;
            }
        }
    }
};

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	props: ['nomeUsuario', 'nivel'],
	data: function data() {
		return {
			loading: false,
			usuarioSelecionado: {
				nome: null
			},
			filtros: {
				pesquisa: '',
				nivel: ''
			},
			showModal: false,
			dataTable: {
				data: []
			}
		};
	},
	mounted: function mounted() {
		this.getDataTable();
	},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}

			this.filtros.page = page;
			this.filtros.nivel = this.$props.nivel;
			this.$store.commit('TOGGLE_LOADING');

			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/usuario/getAllPaginate', config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				_this.$store.commit('throwException', error);
			});
		},
		limpar: function limpar() {
			this.seleciona({ id: null, name: '' });
		},
		seleciona: function seleciona(item) {
			this.usuarioSelecionado = item;
			this.showModal = false;
			this.$emit('setUsuarioSelecionado', item);
		}
	},
	watch: {
		"$props.nomeUsuario": function $propsNomeUsuario() {
			if (this.$props.nomeUsuario) {
				this.usuarioSelecionado.name = this.$props.nomeUsuario;
			}
		}
	},
	components: {}
};

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = {
	$_veeValidate: {
		name: function name() {
			return this.name;
		},
		value: function value() {
			return this.data;
		}
	},

	props: {
		placeholder: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		selecionado: {
			type: String,
			default: null
		}
	},

	data: function data() {
		return {
			data: null,
			data2: null,
			operador: this.selecionado
		};
	},
	computed: {},
	mounted: function mounted() {},

	methods: {
		formatDates: function formatDates(dateOne, dateTwo, ope) {
			var formattedDates = '';
			if (dateOne) {
				formattedDates = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dateOne).format("DD/MM/YYYY");
			}
			if (dateTwo && ope == '><') {
				formattedDates += ' a ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(dateTwo).format("DD/MM/YYYY");
			}
			return formattedDates;
		}
	},
	watch: {
		operador: function operador(value, oldValue) {
			this.$emit('operadorSelecionado', value);
			if (value != '><') {
				this.data2 = null;
				this.$emit('data2Selecionada', null);
			}
			if (!value) {
				this.data = null;
				this.data2 = null;
				this.$emit('input', null);
				this.$emit('dataSelecionada', null);
				this.$emit('data2Selecionada', null);
			}
		},
		data: function data(value, oldValue) {
			this.$emit('input', value);
			this.$emit('dataSelecionada', value);
		},
		data2: function data2(value, oldValue) {
			this.$emit('data2Selecionada', value);
		}
	}
};

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = {
	data: function data() {
		return {
			total_marcacao: 0,
			total_regulacao: 0,
			total_negativado: 0,
			visualizaArquivo: true,
			comunicados: []
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.$nextTick(function () {
			_this.getComunicados();
		});
	},

	methods: {
		getComunicados: function getComunicados() {
			var _this2 = this;

			var config = this.$store.getters.getHeaderAuth;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/administracao/comunicados", config).then(function (response) {
				_this2.comunicados = response.data;
			}).catch(function (error) {
				_this2.$store.commit("throwException", error);
			});
		}
	}
};

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bloquearModal__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bloquearModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__bloquearModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__criarModal__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__criarModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__criarModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__criarAtendimentoModal__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__criarAtendimentoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__criarAtendimentoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bloquearPeriodoModal__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bloquearPeriodoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__bloquearPeriodoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editarAtendimentoModal__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editarAtendimentoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__editarAtendimentoModal__);











/* harmony default export */ __webpack_exports__["default"] = {
    filters: {},
    computed: {
        SEXO: function SEXO() {
            return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SEXO */];
        }
    },
    data: function data() {
        return {
            showBloquear: false,
            showCriar: false,
            showCriarAtendimento: false,
            showEditarAtendimento: false,
            showBloquearPeriodo: false,
            atendimento_id: null,
            atendimento: {},
            itens: {},
            filtros: {
                nome_profissional: "",
                nome_procedimento: "",
                sexo: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SEXO */].AMBOS,
                tipo: 1,
                coluna: null,
                ordem: null,
                data_inicial: null,
                data_final: null
            },
            dataTable: {}
        };
    },
    mounted: function mounted() {
        this.getDataTable();
    },

    methods: {
        filtrar: function filtrar(filtros) {
            this.filtros = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtros, filtros);
            this.getDataTable();
        },
        bloquear: function bloquear(id) {
            this.showBloquear = true;
            this.atendimento_id = id;
        },
        criar: function criar(id) {
            this.showCriar = true;
            this.atendimento_id = id;
        },
        editar: function editar(atendimento) {
            this.showEditarAtendimento = true;
            var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, atendimento);
            this.atendimento = obj;
        },
        bloquearPeriodo: function bloquearPeriodo() {
            this.showBloquearPeriodo = true;
        },
        criarAtendimento: function criarAtendimento() {
            var dados = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';


            this.itens = dados;
            this.showCriarAtendimento = true;
        },
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.filtros.distribuicao_contrato_id = this.$route.params.distribuicaoContratoId;
            this.$store.commit("TOGGLE_LOADING");
            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/agenda/getProcedimentoAtendimentosAllPaginate", config).then(function (response) {
                _this.dataTable = response.data;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
            });
        }
    },
    watch: {
        page: function page(val) {
            this.getDataTable();
        }
    },
    components: {
        bloquearModal: __WEBPACK_IMPORTED_MODULE_3__bloquearModal___default.a,
        criarModal: __WEBPACK_IMPORTED_MODULE_4__criarModal___default.a,
        criarAtendimentoModal: __WEBPACK_IMPORTED_MODULE_5__criarAtendimentoModal___default.a,
        bloquearPeriodoModal: __WEBPACK_IMPORTED_MODULE_6__bloquearPeriodoModal___default.a,
        editarAtendimentoModal: __WEBPACK_IMPORTED_MODULE_7__editarAtendimentoModal___default.a
    }
};

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bloquearSubgruposModal__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bloquearSubgruposModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__bloquearSubgruposModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__criarSubgruposModal__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__criarSubgruposModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__criarSubgruposModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__criarAtendimentoSubgruposModal__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__criarAtendimentoSubgruposModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__criarAtendimentoSubgruposModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bloquearSubgruposPeriodoModal__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bloquearSubgruposPeriodoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__bloquearSubgruposPeriodoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editarAtendimentoModal__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editarAtendimentoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__editarAtendimentoModal__);











/* harmony default export */ __webpack_exports__["default"] = {
    filters: {},
    computed: {
        SEXO: function SEXO() {
            return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SEXO */];
        }
    },
    data: function data() {
        return {
            showBloquear: false,
            showCriar: false,
            showCriarAtendimento: false,
            showBloquearPeriodo: false,
            showEditarAtendimento: false,
            atendimento_id: null,
            atendimento: {},
            itens: {},
            filtros: {
                nome_subgrupo: "",
                sexo: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SEXO */].AMBOS,
                tipo: 1,
                coluna: null,
                ordem: null,
                data_inicial: null,
                data_final: null
            },
            dataTable: {}
        };
    },
    mounted: function mounted() {
        this.getDataTable();
    },

    methods: {
        filtrar: function filtrar(filtros) {
            this.filtros = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtros, filtros);
            this.getDataTable();
        },
        bloquear: function bloquear(id) {
            this.showBloquear = true;
            this.atendimento_id = id;
        },
        criar: function criar(id) {
            this.showCriar = true;
            this.atendimento_id = id;
        },
        editar: function editar(atendimento) {
            this.showEditarAtendimento = true;
            var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, atendimento);
            this.atendimento = obj;
        },
        bloquearPeriodo: function bloquearPeriodo() {
            this.showBloquearPeriodo = true;
        },
        criarAtendimento: function criarAtendimento() {
            var dados = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';


            this.itens = dados;
            this.showCriarAtendimento = true;
        },
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.filtros.distribuicao_contrato_id = this.$route.params.distribuicaoContratoId;
            this.$store.commit("TOGGLE_LOADING");
            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/agenda/getSubgrupoAtendimentosAllPaginate", config).then(function (response) {
                _this.dataTable = response.data;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
            });
        }
    },

    components: {
        bloquearModal: __WEBPACK_IMPORTED_MODULE_3__bloquearSubgruposModal___default.a,
        criarModal: __WEBPACK_IMPORTED_MODULE_4__criarSubgruposModal___default.a,
        criarAtendimentoModal: __WEBPACK_IMPORTED_MODULE_5__criarAtendimentoSubgruposModal___default.a,
        bloquearPeriodoModal: __WEBPACK_IMPORTED_MODULE_6__bloquearSubgruposPeriodoModal___default.a,
        editarAtendimentoModal: __WEBPACK_IMPORTED_MODULE_7__editarAtendimentoModal___default.a
    }
};

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},
	computed: {},
	props: ["show", "id"],
	data: function data() {
		return {
			filtros: {},
			bloqueados: {
				primeira: 0,
				retorno: 0,
				local: 0
			},
			dados: {
				quantidade_primeira: 0,
				quantidade_primeira_original: 0,
				quantidade_primeira_alterada: 0,
				quantidade_primeira_bloqueada: "",
				quantidade_retorno: 0,
				quantidade_retorno_original: 0,
				quantidade_retorno_alterada: 0,
				quantidade_retorno_bloqueada: "",
				quantidade_local: 0,
				quantidade_local_original: 0,
				quantidade_local_alterada: 0,
				quantidade_local_bloqueada: ""
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		document.body.addEventListener('keyup', function (e) {
			if (e.keyCode === 27) {
				_this.$emit('close');
			}
		});
	},

	methods: {
		getData: function getData(id) {
			var _this2 = this;

			this.$store.commit("TOGGLE_LOADING");
			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/agenda/getDistribuicaoContratoProcedimentoAtendimentosById/" + id, config).then(function (response) {
				_this2.dados = response.data;
				_this2.bloqueados.primeira = _this2.dados.quantidade_primeira_bloqueada ? _this2.dados.quantidade_primeira_bloqueada : 0;
				_this2.dados.quantidade_primeira_alterada = _this2.dados.quantidade_primeira;
				_this2.bloqueados.retorno = _this2.dados.quantidade_retorno_bloqueada ? _this2.dados.quantidade_retorno_bloqueada : 0;
				_this2.dados.quantidade_retorno_alterada = _this2.dados.quantidade_retorno;
				_this2.bloqueados.local = _this2.dados.quantidade_local_bloqueada ? _this2.dados.quantidade_local_bloqueada : 0;
				_this2.dados.quantidade_local_alterada = _this2.dados.quantidade_local;
				_this2.$store.commit("TOGGLE_LOADING");
			}).catch(function (error) {
				_this2.$store.commit("throwException", error);
			});
		},
		salvar: function salvar() {
			var _this3 = this;

			console.log("teste");
			this.$store.commit("TOGGLE_LOADING");
			var config = this.$store.getters.getHeaderAuth;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.serverURI + "/api/distribuicao/agenda/bloquearAtendimento/" + this.dados.id, this.dados, config).then(function (response) {
				_this3.$emit('atualizar');
				_this3.$emit('close');
				_this3.$store.commit("TOGGLE_LOADING");
			}).catch(function (error) {
				_this3.$store.commit("throwException", error);
			});
		}
	},
	watch: {
		'show': function show(value, oldValue) {
			if (value) {
				this.getData(this.id);
			}
		},
		'dados.quantidade_primeira_bloqueada': function dadosQuantidade_primeira_bloqueada(value, oldValue) {
			if (!value) {
				value = 0;
			}
			var qtd = parseInt(this.dados.quantidade_primeira) + parseInt(this.bloqueados.primeira);
			if (qtd >= parseInt(value)) {
				this.dados.quantidade_primeira_alterada = qtd - parseInt(value);
			} else {
				this.dados.quantidade_primeira_bloqueada = qtd;
			}
		},
		'dados.quantidade_retorno_bloqueada': function dadosQuantidade_retorno_bloqueada(value, oldValue) {
			if (!value) {
				value = 0;
			}
			var qtd = parseInt(this.dados.quantidade_retorno) + parseInt(this.bloqueados.retorno);
			if (qtd >= parseInt(value)) {
				this.dados.quantidade_retorno_alterada = qtd - parseInt(value);
			} else {
				this.dados.quantidade_retorno_bloqueada = qtd;
			}
		},
		'dados.quantidade_local_bloqueada': function dadosQuantidade_local_bloqueada(value, oldValue) {
			if (!value) {
				value = 0;
			}
			var qtd = parseInt(this.dados.quantidade_local) + parseInt(this.bloqueados.local);
			if (qtd >= parseInt(value)) {
				this.dados.quantidade_local_alterada = qtd - parseInt(value);
			} else {
				this.dados.quantidade_local_bloqueada = qtd;
			}
		}
	}
};

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contratos_selectDistribuicaoProcedimentosContrato__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contratos_selectDistribuicaoProcedimentosContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__contratos_selectDistribuicaoProcedimentosContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional__);







/* harmony default export */ __webpack_exports__["default"] = {
  filters: {},
  computed: {
    SEXO: function SEXO() {
      return __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SEXO */];
    }
  },
  props: ["show", "distribuicao_contrato_id"],
  data: function data() {
    return {
      ocorrencias: {
        registros: 0,
        atendimentos: 0,
        retornos: 0,
        locais: 0

      },
      filtros: {
        distribuicao_contrato_id: null,
        nome_profissional: "",
        nome_procedimento: "",
        sexo: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SEXO */].AMBOS,
        tipo: 1,
        coluna: null,
        ordem: null,
        data_inicial: null,
        data_final: null
      },
      dataTable: {},
      bloqueados: {
        primeira: 0,
        retorno: 0,
        local: 0
      },
      dados: {
        quantidade_primeira_bloqueada: "",
        quantidade_retorno_bloqueada: "",
        quantidade_local_bloqueada: ""
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    document.body.addEventListener("keyup", function (e) {
      if (e.keyCode === 27) {
        _this.$emit("close");
      }
    });
  },

  methods: {
    salvar: function salvar() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log("teste");
          _this2.$store.commit("TOGGLE_LOADING");
          var config = _this2.$store.getters.getHeaderAuth;
          _this2.dados.filtros = _this2.filtros;
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this2.$store.state.serverURI + "/api/distribuicao/agenda/bloquearPeriodo", _this2.dados, config).then(function (response) {
            _this2.$emit("atualizar");
            _this2.$emit("close");
            _this2.$store.commit("TOGGLE_LOADING");
          }).catch(function (error) {
            _this2.$store.commit("throwException", error);
          });
        }
      });
    },
    setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
      this.filtros.nome_procedimento = procedimentoSelecionado.procedimento.nome;
    },
    setProfissionalSelecionado: function setProfissionalSelecionado(profissionalSelecionado) {
      this.filtros.nome_profissional = profissionalSelecionado.nome;
    },
    getOcorrencias: function getOcorrencias() {
      var _this3 = this;

      this.filtros.distribuicao_contrato_id = this.$route.params.distribuicaoContratoId;
      this.$store.commit("TOGGLE_LOADING");
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/agenda/getCountProcedimentoAtendimentos", config).then(function (response) {
        var ocorrencias = response.data;
        var atendimentos = ocorrencias * _this3.dados.quantidade_primeira_bloqueada;
        var retornos = ocorrencias * _this3.dados.quantidade_retorno_bloqueada;
        var locais = ocorrencias * _this3.dados.quantidade_local_bloqueada;

        _this3.ocorrencias.registros = ocorrencias;
        _this3.ocorrencias.atendimentos = atendimentos;
        _this3.ocorrencias.retornos = retornos;
        _this3.ocorrencias.locais = locais;

        _this3.$store.commit("TOGGLE_LOADING");
      }).catch(function (error) {
        _this3.$store.commit("throwException", error);
      });
    }
  },
  watch: {
    show: function show(value, old) {
      if (value) {
        this.filtros.distribuicao_contrato_id = this.distribuicao_contrato_id;
      }
    }
  },
  components: {
    selectProcedimentoContrato: __WEBPACK_IMPORTED_MODULE_2__contratos_selectDistribuicaoProcedimentosContrato___default.a,
    selectProfissional: __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional___default.a
  }
};

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},
	computed: {},
	props: ["show", "id"],
	data: function data() {
		return {
			filtros: {},
			bloqueados: {
				atendimento: 0,
				paciente: 0,
				local: 0
			},
			dados: {
				quantidade_atendimento: 0,
				quantidade_atendimento_original: 0,
				quantidade_atendimento_alterada: 0,
				quantidade_atendimento_bloqueada: "",
				quantidade_local: 0,
				quantidade_local_original: 0,
				quantidade_local_alterada: 0,
				quantidade_local_bloqueada: "",
				quantidade_paciente: 0,
				quantidade_paciente_original: 0,
				quantidade_paciente_alterada: 0,
				quantidade_paciente_bloqueada: ""
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		document.body.addEventListener('keyup', function (e) {
			if (e.keyCode === 27) {
				_this.$emit('close');
			}
		});
	},

	methods: {
		getData: function getData(id) {
			var _this2 = this;

			this.$store.commit("TOGGLE_LOADING");
			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/agenda/getDistribuicaoContratoSubgrupoAtendimentosById/" + id, config).then(function (response) {
				_this2.dados = response.data;
				_this2.bloqueados.atendimento = _this2.dados.quantidade_atendimento_bloqueada ? _this2.dados.quantidade_atendimento_bloqueada : 0;
				_this2.dados.quantidade_atendimento_alterada = _this2.dados.quantidade_atendimento;
				_this2.bloqueados.local = _this2.dados.quantidade_local_bloqueada ? _this2.dados.quantidade_local_bloqueada : 0;
				_this2.dados.quantidade_local_alterada = _this2.dados.quantidade_local;
				_this2.bloqueados.paciente = _this2.dados.quantidade_paciente_bloqueada ? _this2.dados.quantidade_paciente_bloqueada : 0;
				_this2.dados.quantidade_paciente_alterada = _this2.dados.quantidade_paciente;
				_this2.$store.commit("TOGGLE_LOADING");
			}).catch(function (error) {
				_this2.$store.commit("throwException", error);
			});
		},
		salvar: function salvar() {
			var _this3 = this;

			console.log("teste");
			this.$store.commit("TOGGLE_LOADING");
			var config = this.$store.getters.getHeaderAuth;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.serverURI + "/api/distribuicao/agenda/bloquearAtendimentoSubgrupo/" + this.dados.id, this.dados, config).then(function (response) {
				_this3.$emit('atualizar');
				_this3.$emit('close');
				_this3.$store.commit("TOGGLE_LOADING");
			}).catch(function (error) {
				_this3.$store.commit("throwException", error);
			});
		}
	},
	watch: {
		'show': function show(value, oldValue) {
			if (value) {
				this.getData(this.id);
			}
		},
		'dados.quantidade_atendimento_bloqueada': function dadosQuantidade_atendimento_bloqueada(value, oldValue) {
			if (!value) {
				value = 0;
			}
			var qtd = parseInt(this.dados.quantidade_atendimento) + parseInt(this.bloqueados.atendimento);
			if (qtd >= parseInt(value)) {
				this.dados.quantidade_atendimento_alterada = qtd - parseInt(value);
			} else {
				this.dados.quantidade_atendimento_bloqueada = qtd;
			}
		},
		'dados.quantidade_local_bloqueada': function dadosQuantidade_local_bloqueada(value, oldValue) {
			if (!value) {
				value = 0;
			}
			var qtd = parseInt(this.dados.quantidade_local) + parseInt(this.bloqueados.local);
			if (qtd >= parseInt(value)) {
				this.dados.quantidade_local_alterada = qtd - parseInt(value);
			} else {
				this.dados.quantidade_local_bloqueada = qtd;
			}
		},
		'dados.quantidade_paciente_bloqueada': function dadosQuantidade_paciente_bloqueada(value, oldValue) {
			if (!value) {
				value = 0;
			}
			var qtd = parseInt(this.dados.quantidade_paciente) + parseInt(this.bloqueados.paciente);
			if (qtd >= parseInt(value)) {
				this.dados.quantidade_paciente_alterada = qtd - parseInt(value);
			} else {
				this.dados.quantidade_paciente_bloqueada = qtd;
			}
		}
	}
};

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contratos_selectDistribuicaoSubgruposContrato__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contratos_selectDistribuicaoSubgruposContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__contratos_selectDistribuicaoSubgruposContrato__);






/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},
	computed: {
		SEXO: function SEXO() {
			return __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SEXO */];
		}
	},
	props: ["show", "distribuicao_contrato_id"],
	data: function data() {
		return {
			filtros: {
				distribuicao_contrato_id: null,
				nome_subgrupo: '',
				sexo: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SEXO */].AMBOS,
				tipo: 1,
				coluna: null,
				ordem: null,
				data_inicial: null,
				data_final: null
			},
			dataTable: {},
			bloqueados: {
				primeira: 0,
				local: 0
			},
			dados: {
				quantidade_atendimento_bloqueada: "",
				quantidade_local_bloqueada: ""
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		document.body.addEventListener('keyup', function (e) {
			if (e.keyCode === 27) {
				_this.$emit('close');
			}
		});
	},

	methods: {
		salvar: function salvar() {
			var _this2 = this;

			this.$validator.validateAll().then(function (result) {
				if (result) {
					_this2.$store.commit("TOGGLE_LOADING");
					var config = _this2.$store.getters.getHeaderAuth;
					_this2.dados.filtros = _this2.filtros;
					__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this2.$store.state.serverURI + "/api/distribuicao/agenda/bloquearPeriodoSubgrupo", _this2.dados, config).then(function (response) {
						_this2.$emit('atualizar');
						_this2.$emit('close');
						_this2.$store.commit("TOGGLE_LOADING");
					}).catch(function (error) {
						_this2.$store.commit("throwException", error);
					});
				}
			});
		},
		setSubgrupoSelecionado: function setSubgrupoSelecionado(subgrupoSelecionado) {
			this.filtros.nome_subgrupo = subgrupoSelecionado.subgrupo.nome;
		}
	},
	watch: {
		show: function show(value, old) {
			if (value) {
				this.filtros.distribuicao_contrato_id = this.distribuicao_contrato_id;
			}
		}
	},
	components: {
		selectSubgrupo: __WEBPACK_IMPORTED_MODULE_2__contratos_selectDistribuicaoSubgruposContrato___default.a
	}
};

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contratos_selectDistribuicaoProcedimentosContrato__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contratos_selectDistribuicaoProcedimentosContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__contratos_selectDistribuicaoProcedimentosContrato__);








/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},
	props: ["show", "item"],
	data: function data() {
		return {
			dados: {
				profissional_id: '',
				nome_profissional: '',
				distribuicao_contrato_procedimento_id: '',
				nome_procedimento: '',
				sexo: 0,
				idade_maxima: '',
				idade_minima: '',
				quantidade_primeira: '',
				quantidade_retorno: '',
				quantidade_local: '',
				hora_inicial: '',
				hora_final: '',
				data_atendimento: '',
				exibiInput: false
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		document.body.addEventListener('keyup', function (e) {
			if (e.keyCode === 27) {
				e.stopPropagation();
				_this.$emit('close');
			}
		});
	},

	methods: {
		setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
			this.dados.nome_procedimento = procedimentoSelecionado.procedimento.nome;
			this.dados.distribuicao_contrato_procedimento_id = procedimentoSelecionado.id;
		},
		setProfissionalSelecionado: function setProfissionalSelecionado(profissionalSelecionado) {
			this.dados.nome_profissional = profissionalSelecionado.nome;
			this.dados.profissional_id = profissionalSelecionado.id;
		},
		salvar: function salvar() {
			var _this2 = this;

			this.$validator.validateAll().then(function (result) {
				if (result) {
					_this2.$store.commit('TOGGLE_LOADING');
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$store.state.serverURI + "/api/distribuicao/agenda/createProcedimentoAtendimento", _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
						_this2.$store.commit('TOGGLE_LOADING');
						_this2.$swal({
							type: "success",
							title: "Atendimento criado com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});

						_this2.$emit('atualizar');
						_this2.$emit('close');
					}).catch(function (error) {
						_this2.$store.commit('TOGGLE_LOADING');
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;

						try {
							for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var erro = _step.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}

						_this2.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				}
			});
		},
		isEmpty: function isEmpty(valor) {
			return valor === '';
		},
		hasDay: function hasDay() {
			return false;
		}
	},
	watch: {
		item: {

			immediate: true,
			handler: function handler(value) {

				this.dados.exibiInput = false;
				this.dados.idade_minima = '';
				this.dados.idade_maxima = '';
				this.dados.sexo = '';

				this.dados.nome_procedimento = '';
				this.dados.distribuicao_contrato_procedimento_id = '';

				this.dados.nome_profissional = '';
				this.dados.profissional_id = '';
				console.log(value);
				if (value.profissional && value.contrato_procedimento) {
					this.dados.exibiInput = value.autoChange;
					this.dados.idade_minima = value.idade_minima;
					this.dados.idade_maxima = value.idade_maxima;
					this.dados.sexo = value.sexo;

					this.dados.nome_procedimento = value.contrato_procedimento.procedimento.nome;
					this.dados.distribuicao_contrato_procedimento_id = value.distribuicao_contrato_procedimento_id;

					this.dados.nome_profissional = value.profissional.nome;
					this.dados.profissional_id = value.profissional.id;
				}
			}
		}

	},
	components: {
		selectProfissional: __WEBPACK_IMPORTED_MODULE_3__cadastros_profissionais_selectProfissional___default.a,
		selectProcedimentoContrato: __WEBPACK_IMPORTED_MODULE_4__contratos_selectDistribuicaoProcedimentosContrato___default.a
	}
};

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contratos_selectDistribuicaoSubgruposContrato__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contratos_selectDistribuicaoSubgruposContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__contratos_selectDistribuicaoSubgruposContrato__);







/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},
	props: ["show", "item"],
	data: function data() {
		return {
			showTextDangerSubgrupo: false,
			dados: {
				distribuicao_contrato_subgrupo_id: null,
				nome_subgrupo: '',
				sexo: 0,
				idade_maxima: '',
				idade_minima: '',
				tipo_consumo: 0,
				quantidade_atendimento: '',
				quantidade_local: '',
				quantidade_paciente: '',
				hora_inicial: '',
				hora_final: '',
				data_atendimento: '',
				exibiInput: false
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		document.body.addEventListener('keyup', function (e) {
			if (e.keyCode === 27) {
				e.stopPropagation();
				_this.$emit('close');
			}
		});
	},

	methods: {
		validar: function validar() {
			var validou = true;
			if (this.dados.distribuicao_contrato_subgrupo_id === null) {
				this.showTextDangerSubgrupo = true;
				validou = false;
			}
			return validou;
		},
		setSubgrupoSelecionado: function setSubgrupoSelecionado(subgrupoSelecionado) {
			console.log(subgrupoSelecionado);
			subgrupoSelecionado.subgrupo.nome ? this.showTextDangerSubgrupo = false : this.showTextDangerSubgrupo = true;
			this.dados.nome_subgrupo = subgrupoSelecionado.subgrupo.nome;
			this.dados.distribuicao_contrato_subgrupo_id = subgrupoSelecionado.id;
		},
		salvar: function salvar() {
			var _this2 = this;

			var validado = this.validar();
			this.$validator.validateAll().then(function (result) {
				if (result && validado) {
					_this2.$store.commit('TOGGLE_LOADING');
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$store.state.serverURI + "/api/distribuicao/agenda/createProcedimentoAtendimentoSubgrupo", _this2.dados, _this2.$store.getters.getHeaderAuth).then(function (response) {
						_this2.$store.commit('TOGGLE_LOADING');
						_this2.$swal({
							type: "success",
							title: "Atendimento subgrupo criado com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
						_this2.$emit('atualizar');
						_this2.$emit('close');
					}).catch(function (error) {
						_this2.$store.commit('TOGGLE_LOADING');
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;

						try {
							for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var erro = _step.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}

						_this2.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				}
			});
		},
		isEmpty: function isEmpty(valor) {
			return valor === '';
		},
		hasDay: function hasDay() {
			return false;
		}
	},
	watch: {
		'show': function show(value, oldValue) {},
		'dados.distribuicao_contrato_subgrupo_id': function dadosDistribuicao_contrato_subgrupo_id(value) {
			if (value) {
				this.showTextDangerSubgrupo = false;
			}
		},
		item: {
			immediate: true,
			handler: function handler(value) {

				this.dados.exibiInput = false;
				this.dados.idade_minima = '';
				this.dados.idade_maxima = '';
				this.dados.sexo = '';

				this.dados.nome_subgrupo = '';
				this.dados.distribuicao_contrato_subgrupo_id = '';

				if (value.contrato_subgrupo) {
					this.dados.exibiInput = value.autoChange;
					this.dados.idade_minima = value.idade_minima;
					this.dados.idade_maxima = value.idade_maxima;
					this.dados.sexo = value.sexo;

					this.dados.nome_subgrupo = value.contrato_subgrupo.subgrupo.nome;
					this.dados.distribuicao_contrato_subgrupo_id = value.distribuicao_contrato_subgrupo_id;
				}
			}
		}

	},
	components: {
		selectSubgrupo: __WEBPACK_IMPORTED_MODULE_3__contratos_selectDistribuicaoSubgruposContrato___default.a
	}
};

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
    filters: {},
    computed: {},
    props: ["show", "id"],
    data: function data() {
        return {
            filtros: {},
            desbloquear: {
                label: "Não",
                value: "false"
            },
            bloqueados: {
                primeira: 0,
                retorno: 0,
                local: 0
            },
            dados: {
                quantidade_primeira: 0,
                quantidade_primeira_original: 0,
                quantidade_primeira_alterada: 0,
                quantidade_primeira_bloqueada: "",
                quantidade_primeira_criada: "",
                quantidade_retorno: 0,
                quantidade_retorno_original: 0,
                quantidade_retorno_alterada: 0,
                quantidade_retorno_bloqueada: "",
                quantidade_retorno_criada: "",
                quantidade_local: 0,
                quantidade_local_original: 0,
                quantidade_local_alterada: 0,
                quantidade_local_bloqueada: "",
                quantidade_local_criada: ""
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        document.body.addEventListener("keyup", function (e) {
            if (e.keyCode === 27) {
                _this.$emit("close");
            }
        });
    },

    methods: {
        getData: function getData(id) {
            var _this2 = this;

            this.$store.commit("TOGGLE_LOADING");
            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/agenda/getDistribuicaoContratoProcedimentoAtendimentosById/" + id, config).then(function (response) {
                _this2.dados = response.data;
                _this2.bloqueados.primeira = _this2.dados.quantidade_primeira_bloqueada || 0;
                _this2.dados.quantidade_primeira_alterada = _this2.dados.quantidade_primeira;
                _this2.bloqueados.retorno = _this2.dados.quantidade_retorno_bloqueada || 0;
                _this2.dados.quantidade_retorno_alterada = _this2.dados.quantidade_retorno;
                _this2.bloqueados.local = _this2.dados.quantidade_local_bloqueada || 0;
                _this2.dados.quantidade_local_alterada = _this2.dados.quantidade_local;
                _this2.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this2.$store.commit("throwException", error);
            });
        },
        salvar: function salvar() {
            var _this3 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this3.$store.commit("TOGGLE_LOADING");
                    var config = _this3.$store.getters.getHeaderAuth;
                    _this3.dados.desbloquear = _this3.desbloquear.value;
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this3.$store.state.serverURI + "/api/distribuicao/agenda/criarAtendimento/" + _this3.dados.id, _this3.dados, config).then(function (response) {
                        _this3.$emit("atualizar");
                        _this3.$emit("close");
                        _this3.$store.commit("TOGGLE_LOADING");
                    }).catch(function (error) {
                        _this3.$store.commit("throwException", error);
                    });
                }
            });
        }
    },
    watch: {
        show: function show(value, oldValue) {
            if (value) {
                this.getData(this.id);
            }
            this.desbloquear = {
                label: "Não",
                value: "false"
            };
            this.quantidade_primeira_criada = "";
            this.quantidade_retorno_criada = "";
            this.quantidade_local_criada = "";
        },
        desbloquear: function desbloquear(value, oldValue) {
            if (value) {
                if (value.value == "true") {
                    this.dados.quantidade_primeira_alterada = this.dados.quantidade_primeira + this.bloqueados.primeira + (parseInt(this.dados.quantidade_primeira_criada) || 0);
                    this.dados.quantidade_primeira_bloqueada = 0;
                    this.dados.quantidade_local_alterada = this.dados.quantidade_local + this.bloqueados.local + (parseInt(this.dados.quantidade_local_criada) || 0);
                    this.dados.quantidade_local_bloqueada = 0;
                    this.dados.quantidade_retorno_alterada = this.dados.quantidade_retorno + this.bloqueados.retorno + (parseInt(this.dados.quantidade_retorno_criada) || 0);
                    this.dados.quantidade_retorno_bloqueada = 0;
                } else {
                    this.dados.quantidade_primeira_alterada = this.dados.quantidade_primeira + (parseInt(this.dados.quantidade_primeira_criada) || 0);
                    this.dados.quantidade_primeira_bloqueada = this.bloqueados.primeira;
                    this.dados.quantidade_primeira_criada = this.bloqueados.primeira == 0 ? this.dados.quantidade_primeira_criada : "";
                    this.dados.quantidade_local_alterada = this.dados.quantidade_local + (parseInt(this.dados.quantidade_local_criada) || 0);
                    this.dados.quantidade_local_bloqueada = this.bloqueados.local;
                    this.dados.quantidade_local_criada = this.bloqueados.local == 0 ? this.dados.quantidade_local_criada : "";
                    this.dados.quantidade_retorno_alterada = this.dados.quantidade_retorno + (parseInt(this.dados.quantidade_retorno_criada) || 0);
                    this.dados.quantidade_retorno_bloqueada = this.bloqueados.retorno;
                    this.dados.quantidade_retorno_criada = this.bloqueados.retorno == 0 ? this.dados.quantidade_retorno_criada : "";
                }
            }
        },
        "dados.quantidade_primeira_criada": function dadosQuantidade_primeira_criada(value, oldValue) {
            var qtd = parseInt(this.dados.quantidade_primeira) + parseInt(this.bloqueados.primeira);
            this.dados.quantidade_primeira_alterada = qtd + (parseInt(value) || 0);
        },
        "dados.quantidade_retorno_criada": function dadosQuantidade_retorno_criada(value, oldValue) {
            var qtd = parseInt(this.dados.quantidade_retorno) + parseInt(this.bloqueados.retorno);
            this.dados.quantidade_retorno_alterada = qtd + (parseInt(value) || 0);
        },
        "dados.quantidade_local_criada": function dadosQuantidade_local_criada(value, oldValue) {
            var qtd = parseInt(this.dados.quantidade_local) + parseInt(this.bloqueados.local);
            this.dados.quantidade_local_alterada = qtd + (parseInt(value) || 0);
        }
    }
};

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	filters: {},
	computed: {},
	props: ["show", "id"],
	data: function data() {
		return {
			filtros: {},
			desbloquear: {
				label: 'Não',
				value: 'false'
			},
			bloqueados: {
				atendimento: 0,
				local: 0,
				paciente: 0
			},
			dados: {
				quantidade_atendimento: 0,
				quantidade_atendimento_original: 0,
				quantidade_atendimento_alterada: 0,
				quantidade_atendimento_bloqueada: "",
				quantidade_atendimento_criada: "",
				quantidade_local: 0,
				quantidade_local_original: 0,
				quantidade_local_alterada: 0,
				quantidade_local_bloqueada: "",
				quantidade_local_criada: "",
				quantidade_paciente_original: 0,
				quantidade_paciente_alterada: 0,
				quantidade_paciente_bloqueada: "",
				quantidade_paciente_criada: "",
				tipo_consumo: 0
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		document.body.addEventListener('keyup', function (e) {
			if (e.keyCode === 27) {
				_this.$emit('close');
			}
		});
	},

	methods: {
		getData: function getData(id) {
			var _this2 = this;

			this.$store.commit("TOGGLE_LOADING");
			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/agenda/getDistribuicaoContratoSubgrupoAtendimentosById/" + id, config).then(function (response) {
				_this2.dados = response.data;
				_this2.bloqueados.atendimento = _this2.dados.quantidade_atendimento_bloqueada || 0;
				_this2.dados.quantidade_atendimento_alterada = _this2.dados.quantidade_atendimento;
				_this2.bloqueados.local = _this2.dados.quantidade_local_bloqueada || 0;
				_this2.dados.quantidade_local_alterada = _this2.dados.quantidade_local;
				_this2.bloqueados.paciente = _this2.dados.quantidade_paciente_bloqueada || 0;
				_this2.dados.quantidade_paciente_alterada = _this2.dados.quantidade_paciente;
				_this2.$store.commit("TOGGLE_LOADING");
			}).catch(function (error) {
				_this2.$store.commit("throwException", error);
			});
		},
		salvar: function salvar() {
			var _this3 = this;

			this.$store.commit("TOGGLE_LOADING");
			var config = this.$store.getters.getHeaderAuth;
			this.dados.desbloquear = this.desbloquear.value;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.serverURI + "/api/distribuicao/agenda/criarAtendimentoSubgrupo/" + this.dados.id, this.dados, config).then(function (response) {
				_this3.$emit('atualizar');
				_this3.$emit('close');
				_this3.$store.commit("TOGGLE_LOADING");
			}).catch(function (error) {
				_this3.$store.commit("throwException", error);
			});
		}
	},
	watch: {
		'show': function show(value, oldValue) {
			if (value) {
				this.getData(this.id);
			}
			this.desbloquear = {
				label: 'Não',
				value: 'false'
			};
			this.quantidade_atendimento_criada = '';
			this.quantidade_local_criada = '';
			this.quantidade_paciente_criada = '';
		},
		'desbloquear': function desbloquear(value, oldValue) {
			if (value) {
				if (value.value == 'true') {
					this.dados.quantidade_atendimento_alterada = this.dados.quantidade_atendimento + this.bloqueados.atendimento + (parseInt(this.dados.quantidade_atendimento_criada) || 0);
					this.dados.quantidade_atendimento_bloqueada = 0;
					this.dados.quantidade_local_alterada = this.dados.quantidade_local + this.bloqueados.local + (parseInt(this.dados.quantidade_local_criada) || 0);
					this.dados.quantidade_local_bloqueada = 0;
				} else {
					this.dados.quantidade_atendimento_alterada = this.dados.quantidade_atendimento + (parseInt(this.dados.quantidade_atendimento_criada) || 0);
					this.dados.quantidade_atendimento_bloqueada = this.bloqueados.atendimento;
					this.dados.quantidade_atendimento_criada = this.bloqueados.atendimento == 0 ? this.dados.quantidade_atendimento_criada : '';
					this.dados.quantidade_local_alterada = this.dados.quantidade_local + (parseInt(this.dados.quantidade_local_criada) || 0);
					this.dados.quantidade_local_bloqueada = this.bloqueados.local;
					this.dados.quantidade_local_criada = this.bloqueados.local == 0 ? this.dados.quantidade_local_criada : '';
				}
			}
		},
		'dados.quantidade_atendimento_criada': function dadosQuantidade_atendimento_criada(value, oldValue) {
			var qtd = parseInt(this.dados.quantidade_atendimento) + parseInt(this.bloqueados.atendimento);
			this.dados.quantidade_atendimento_alterada = qtd + (parseInt(value) || 0);
		},
		'dados.quantidade_paciente_criada': function dadosQuantidade_paciente_criada(value, oldValue) {
			var qtd = parseInt(this.dados.quantidade_paciente) + parseInt(this.bloqueados.paciente);
			this.dados.quantidade_paciente_alterada = qtd + (parseInt(value) || 0);
		},
		'dados.quantidade_local_criada': function dadosQuantidade_local_criada(value, oldValue) {
			var qtd = parseInt(this.dados.quantidade_local) + parseInt(this.bloqueados.local);
			this.dados.quantidade_local_alterada = qtd + (parseInt(value) || 0);
		}
	}
};

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = {
	props: ["show", "item", "tipo"],
	data: function data() {
		return {};
	},
	mounted: function mounted() {},

	methods: {
		salvar: function salvar() {
			var _this = this;

			this.$validator.validateAll().then(function (result) {
				if (result) {
					if (_this.$props.tipo == "procedimento") {

						_this.$swal({
							type: "warning",
							title: "ATENÇÃO!",
							text: "Modificar dia(s) e horário(s) dessa agenda mudará também o que já foi marcado\". Deseja realmente alterar?",
							showCancelButton: true,
							confirmButtonText: 'SIM',
							cancelButtonText: 'NÃO',
							showCloseButton: true,
							showLoaderOnConfirm: true
						}).then(function (result) {
							if (result.value) {

								__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this.$store.state.serverURI + "/api/distribuicao/agenda/editarAtendimento/" + _this.$props.item.id, _this.$props.item, _this.$store.getters.getHeaderAuth).then(function (response) {
									_this.$store.commit("TOGGLE_LOADING");
									_this.$swal({
										type: "success",
										title: "Atendimento atualizado com sucesso!",
										showConfirmButton: false,
										timer: 1500
									});
									_this.$emit("atualizar");
									_this.$emit("close");
								}).catch(function (error) {
									_this.$store.commit("TOGGLE_LOADING");
									var erros = error.response.data.message + " ";
									var _iteratorNormalCompletion = true;
									var _didIteratorError = false;
									var _iteratorError = undefined;

									try {
										for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
											var erro = _step.value;

											erros += erro + " \n";
										}
									} catch (err) {
										_didIteratorError = true;
										_iteratorError = err;
									} finally {
										try {
											if (!_iteratorNormalCompletion && _iterator.return) {
												_iterator.return();
											}
										} finally {
											if (_didIteratorError) {
												throw _iteratorError;
											}
										}
									}

									_this.$swal({
										type: "error",
										title: "Houve uma falha!",
										text: erros
									});
								});
							} else {
								_this.$props.item.autoChange = true;
								_this.$emit("close");
								_this.$emit("criarAtendimento", _this.$props.item);
							}
						});
					} else {
						_this.$swal({
							type: "warning",
							title: "ATENÇÃO!",
							text: "Modificar dia(s) e horário(s) dessa agenda mudará também o que já foi marcado\". Deseja realmente alterar?",
							showCancelButton: true,
							confirmButtonText: 'SIM',
							cancelButtonText: 'NÃO',
							showCloseButton: true,
							showLoaderOnConfirm: true
						}).then(function (result) {
							if (result.value) {
								__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this.$store.state.serverURI + "/api/distribuicao/agenda/editarAtendimentoSubgrupo/" + _this.$props.item.id, _this.$props.item, _this.$store.getters.getHeaderAuth).then(function (response) {
									_this.$store.commit("TOGGLE_LOADING");
									_this.$swal({
										type: "success",
										title: "Atendimento atualizado com sucesso!",
										showConfirmButton: false,
										timer: 1500
									});
									_this.$emit("atualizar");
									_this.$emit("close");
								}).catch(function (error) {
									_this.$store.commit("TOGGLE_LOADING");
									var erros = error.response.data.message + " ";
									var _iteratorNormalCompletion2 = true;
									var _didIteratorError2 = false;
									var _iteratorError2 = undefined;

									try {
										for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
											var erro = _step2.value;

											erros += erro + " \n";
										}
									} catch (err) {
										_didIteratorError2 = true;
										_iteratorError2 = err;
									} finally {
										try {
											if (!_iteratorNormalCompletion2 && _iterator2.return) {
												_iterator2.return();
											}
										} finally {
											if (_didIteratorError2) {
												throw _iteratorError2;
											}
										}
									}

									_this.$swal({
										type: "error",
										title: "Houve uma falha!",
										text: erros
									});
								});
							} else {
								_this.$props.item.autoChange = true;
								_this.$emit("close");
								_this.$emit("criarAtendimento", _this.$props.item);
							}
						});
					}
					_this.$store.commit("TOGGLE_LOADING");
				}
			});
		}
	},
	watch: {}
};

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
    filters: {},
    computed: {},
    data: function data() {
        return {
            filtros: {},
            bloqueados: {
                primeira: 0,
                retorno: 0,
                local: 0
            },
            dados: {
                quantidade_primeira: 0,
                quantidade_primeira_original: 0,
                quantidade_primeira_alterada: 0,
                quantidade_primeira_bloqueada: "",
                quantidade_retorno: 0,
                quantidade_retorno_original: 0,
                quantidade_retorno_alterada: 0,
                quantidade_retorno_bloqueada: "",
                quantidade_local: 0,
                quantidade_local_original: 0,
                quantidade_local_alterada: 0,
                quantidade_local_bloqueada: ""
            },
            label_titulo: "",
            label_acao: ""
        };
    },
    mounted: function mounted() {
        this.label_titulo = this.$route.meta.titulo;
        this.label_acao = this.$route.meta.acao;
        this.getDataTable(this.$route.params.id);
    },

    methods: {
        getDataTable: function getDataTable(id) {
            var _this = this;

            this.$store.commit("TOGGLE_LOADING");
            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/agenda/getDistribuicaoContratoProcedimentoAtendimentosById/" + id, config).then(function (response) {
                _this.dados = response.data;
                _this.bloqueados.primeira = _this.dados.quantidade_primeira_bloqueada ? _this.dados.quantidade_primeira_bloqueada : 0;
                _this.dados.quantidade_primeira_alterada = _this.dados.quantidade_primeira;
                _this.bloqueados.retorno = _this.dados.quantidade_retorno_bloqueada ? _this.dados.quantidade_retorno_bloqueada : 0;
                _this.dados.quantidade_retorno_alterada = _this.dados.quantidade_retorno;
                _this.bloqueados.local = _this.dados.quantidade_local_bloqueada ? _this.dados.quantidade_local_bloqueada : 0;
                _this.dados.quantidade_local_alterada = _this.dados.quantidade_local;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
            });
        },
        salvar: function salvar() {
            var _this2 = this;

            console.log("teste");
            this.$store.commit("TOGGLE_LOADING");
            var config = this.$store.getters.getHeaderAuth;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.serverURI + "/api/distribuicao/agenda/bloquearAtendimento/" + this.dados.id, this.dados, config).then(function (response) {
                _this2.$router.go(-1);
                _this2.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this2.$store.commit("throwException", error);
            });
        }
    },
    watch: {
        'dados.quantidade_primeira_bloqueada': function dadosQuantidade_primeira_bloqueada(value, oldValue) {
            if (typeof oldValue != 'undefined') {
                if (!value) {
                    value = 0;
                }
                var qtd = parseInt(this.dados.quantidade_primeira) + parseInt(this.bloqueados.primeira);
                if (qtd >= parseInt(value)) {
                    this.dados.quantidade_primeira_alterada = qtd - parseInt(value);
                } else {
                    this.dados.quantidade_primeira_bloqueada = qtd;
                }
            }
        },
        'dados.quantidade_retorno_bloqueada': function dadosQuantidade_retorno_bloqueada(value, oldValue) {
            if (!value) {
                value = 0;
            }
            var qtd = parseInt(this.dados.quantidade_retorno) + parseInt(this.bloqueados.retorno);
            if (qtd >= parseInt(value)) {
                this.dados.quantidade_retorno_alterada = qtd - parseInt(value);
            } else {
                this.dados.quantidade_retorno_bloqueada = qtd;
            }
        },
        'dados.quantidade_local_bloqueada': function dadosQuantidade_local_bloqueada(value, oldValue) {
            if (!value) {
                value = 0;
            }
            var qtd = parseInt(this.dados.quantidade_local) + parseInt(this.bloqueados.local);
            if (qtd >= parseInt(value)) {
                this.dados.quantidade_local_alterada = qtd - parseInt(value);
            } else {
                this.dados.quantidade_local_bloqueada = qtd;
            }
        }
    },
    components: {}
};

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Alert__);






/* harmony default export */ __webpack_exports__["default"] = {
    data: function data() {
        return {
            distribuicoes: [],
            filtros: {
                distribuicao_id: "",
                pesquisa: "",
                tipo: 1,
                coluna: null,
                ordem: null
            },
            dataTable: {},
            dados: {}
        };
    },
    mounted: function mounted() {
        this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";

        this.getDistribuicoes();
    },

    methods: {
        filtrar: function filtrar(filtros) {
            this.filtros = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtros, filtros);
            this.getDataTable();
        },
        sortByKey: function sortByKey(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getDataTable();
        },
        getDataTable: function getDataTable(page) {
            var _this = this;

            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");
            this.$router.push({ query: this.filtros });
            var config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/contratos/getAllPaginate", config).then(function (response) {
                _this.dataTable = response.data;
                _this.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                _this.$store.commit("throwException", error);
            });
        },
        getDistribuicoes: function getDistribuicoes() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
                _this2.distribuicoes = response.data;
                _this2.filtros.distribuicao_id = _this2.distribuicoes[0].id;
                _this2.getDataTable();
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    watch: {
        page: function page(val) {
            this.getDataTable();
        }
    },
    components: { Alert: __WEBPACK_IMPORTED_MODULE_2__Alert___default.a }
};

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['contratoId'],
  filters: {},
  data: function data() {
    return {
      contratoSelecionado: {
        tipo: null,
        data_inicial: null,
        data_final: null,
        limite_geral: null,

        unidade: {
          nome: ''
        }
      }
    };
  },
  mounted: function mounted() {
    this.getDataContrato(this.$props.contratoId);
  },

  methods: {
    getDataContrato: function getDataContrato(contratoId) {
      var _this = this;

      var config = this.$store.getters.getHeaderAuth;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/distribuicao/contratos/getById/' + contratoId, config).then(function (response) {
        _this.contratoSelecionado = response.data;
        _this.$store.commit('TOGGLE_LOADING');
      }).catch(function (error) {
        _this.$store.commit('throwException', error);
      });
    }
  },
  watch: {},
  components: {}
};

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cabecarioContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtroContratoProcedimento__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtroContratoProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filtroContratoProcedimento__);








/* harmony default export */ __webpack_exports__["default"] = {
  filters: {
    tipo_limite: function tipo_limite(val) {
      if (val == 0) {
        return "Procedimento";
      } else if (val == 1) {
        return "Subgrupo";
      } else if (val == 2) {
        return "Geral";
      }
    }
  },
  data: function data() {
    return {
      filtros: {
        distribuicao_contrato_id: null
      },

      dataTable: {}
    };
  },

  mounted: function mounted() {
    this.filtros.distribuicao_contrato_id = this.$route.params.contrato_id;
    this.getDataTable();
  },


  methods: {
    sortByKey: function sortByKey(field) {
      this.dados.coluna = field;
      if (this.dados.ordem == "asc") {
        this.dados.ordem = "desc";
      } else {
        this.dados.ordem = "asc";
      }
    },

    filtrar: function filtrar(filtros) {
      this.filtros = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtros, filtros);
      this.getDataTable();
    },

    getDataTable: function getDataTable(page) {
      var _this = this;

      if (typeof page === "undefined") {
        page = 1;
      }

      this.filtros.page = page;
      this.$store.commit("TOGGLE_LOADING");

      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/contratos/getContratoProcedimentosPaginate", config).then(function (response) {
        _this.dataTable = response.data;
        _this.$store.commit("TOGGLE_LOADING");
      }).catch(function (error) {
        _this.$store.commit("throwException", error);
      });
    },
    deletar: function deletar(item, index) {
      var _this2 = this;

      this.$swal({
        title: "Confirma exclus\xE3o do procedimento " + item.procedimento.nome + "?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this2.$swal({
            title: "Aguarde...",
            imageUrl: "/static/img/Rolling-green.gif",
            showConfirmButton: false,
            allowOutsideClick: false
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(_this2.$store.state.serverURI + "/api/distribuicao/contratos/deleteContratoProcedimento/" + item.id, _this2.$store.getters.getHeaderAuth).then(function (response) {
            _this2.getDataTable();
            _this2.$swal({
              type: "success",
              title: "Procedimento excluído com sucesso!",
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    }
  },
  watch: {
    page: function page(val) {
      this.getDataTable();
    }
  },

  components: {
    Alert: __WEBPACK_IMPORTED_MODULE_2__Alert___default.a,
    CabecarioContrato: __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato___default.a,
    FiltroContratoProcedimento: __WEBPACK_IMPORTED_MODULE_4__filtroContratoProcedimento___default.a
  }
};

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_selectProcedimento__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_selectProcedimento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_selectProcedimento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_preparos_selectPreparo__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastros_preparos_selectPreparo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cadastros_preparos_selectPreparo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_v_money__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_v_money__);









/* harmony default export */ __webpack_exports__["default"] = {
	props: ['contratoId'],
	filters: {},
	data: function data() {
		return {
			atualizacao: false,
			showTextDangerValor: false,
			showTextDangerProcedimento: false,
			showTextDangerPreparo: false,
			showTextDangerTipoLimite: false,
			showTextDangerLimite: false,

			procedimentoSelecionado: {},
			preparoSelecionado: {},
			money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				precision: 2,
				masked: false
			},
			dados: {
				valor: 0,
				tipo_limite: null,
				procedimento_id: null,
				distribuicao_contrato_id: null,
				distribuicao_preparo_id: null,
				situacao: null,
				procedimento: {
					nome: null
				},
				preparo: {
					nome: null
				},
				limite: {
					quantidade_original: 0,
					quantidade: null
				}
			},

			controle: {
				limite_financeiro: null
			}

		};
	},
	mounted: function mounted() {

		if (this.$route.params.contrato_procedimento_id) {
			this.getById(this.$route.params.contrato_procedimento_id);
			this.atualizacao = true;
		} else {
			this.dados.distribuicao_contrato_id = this.$route.params.contrato_id;
		}
	},

	methods: {
		salvar: function salvar() {
			var _this = this;

			if (this.validar()) {
				if (this.atualizacao) {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/distribuicao/contratos/updateContratoProcedimento/" + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
						_this.$swal({
							type: "success",
							title: "Procedimento atualizado com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
						_this.$router.push("/distribuicoes/contratos/procedimentos/" + _this.dados.distribuicao_contrato_id);
					}).catch(function (error) {
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;

						try {
							for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var erro = _step.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}

						_this.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				} else {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/distribuicao/contratos/createContratoProcedimento", this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
						if (response.data.status) {
							_this.$swal({
								type: "success",
								title: response.data.msg,
								showConfirmButton: false,
								timer: 1500
							});
							_this.$router.push("/distribuicoes/contratos/procedimentos/" + _this.dados.distribuicao_contrato_id);
						} else {
							_this.$swal({
								type: "error",
								title: response.data.titulo_msg,
								text: response.data.msg,
								showConfirmButton: true
							}).then(function () {
								_this.$router.push("/distribuicoes/contratos/procedimentos/" + _this.dados.distribuicao_contrato_id);
							});
						}
					}).catch(function (error) {
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {
							for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var erro = _step2.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}

						_this.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				}
			} else {
				this.$swal({
					type: "error",
					title: "Informações pendentes",
					text: "Preencha corretamente os campos destacados em vermelho!"
				});
			}
		},
		getById: function getById(contratoProcedimentoId) {
			var _this2 = this;

			this.$store.commit('TOGGLE_LOADING');
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/contratos/getContratoProcedimentoById/" + contratoProcedimentoId, this.$store.getters.getHeaderAuth).then(function (response) {
				if (!response.data.limite) {
					response.data.limite = {
						quantidade: null,
						quantidade_original: null
					};
				}
				if (!response.data.preparo) {
					response.data.preparo = {
						nome: ''
					};
				}
				_this2.dados = response.data;
				_this2.procedimentoSelecionado = _this2.dados.procedimento;
				_this2.preparoSelecionado = _this2.dados.preparo;

				_this2.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			});
		},
		setProcedimentoSelecionado: function setProcedimentoSelecionado(procedimentoSelecionado) {
			this.procedimentoSelecionado = procedimentoSelecionado;
			this.dados.procedimento_id = procedimentoSelecionado.id;
			this.dados.valor = procedimentoSelecionado.valor_referencia;

			if (procedimentoSelecionado.tipo_atendimento == 0) {
				this.dados.tipo_limite = 0;
			} else if (procedimentoSelecionado.tipo_atendimento == 1) {
				this.dados.tipo_limite = 1;
			}
		},
		setPreparoSelecionado: function setPreparoSelecionado(preparoSelecionado) {
			this.preparoSelecionado = preparoSelecionado;
			this.dados.distribuicao_preparo_id = preparoSelecionado.id;
		},
		validar: function validar() {
			var validou = true;
			if (this.dados.valor === '') {
				this.showTextDangerValor = true;
				validou = false;
			}
			if (this.dados.tipo_limite === null) {
				this.showTextDangerTipoLimite = true;
				validou = false;
			}
			if (this.dados.procedimento_id === null) {
				this.showTextDangerProcedimento = true;
				validou = false;
			}
			if (this.dados.tipo_limite === 0 && this.dados.limite.quantidade === null) {
				this.showTextDangerLimite = true;
				validou = false;
			}

			return validou;
		}
	},
	watch: {
		"dados.valor": function dadosValor(newValue) {
			if (this.dados.valor && this.dados.limite.quantidade) {
				this.controle.limite_financeiro = this.dados.valor * this.dados.limite.quantidade;
			}
		},

		"dados.limite.quantidade": function dadosLimiteQuantidade(newValue) {
			if (this.dados.valor && this.dados.limite.quantidade) {
				this.controle.limite_financeiro = this.dados.valor * this.dados.limite.quantidade;
			}
		},

		"dados.tipo_limite": function dadosTipo_limite(newValue) {
			var _this3 = this;

			if (newValue > 0) {
				this.dados.limite.quantidade = null;
				this.controle.limite_financeiro = null;
			}
			this.$nextTick(function () {
				_this3.$refs.limite_fisico.focus();
			});
		}
	},
	components: {
		selectProcedimento: __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_selectProcedimento___default.a,
		Money: __WEBPACK_IMPORTED_MODULE_5_v_money__["Money"],
		selectPreparo: __WEBPACK_IMPORTED_MODULE_4__cadastros_preparos_selectPreparo___default.a
	}
};

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cabecarioContrato__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtroContratoSubgrupo__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtroContratoSubgrupo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filtroContratoSubgrupo__);








/* harmony default export */ __webpack_exports__["default"] = {
  filters: {},
  data: function data() {
    return {
      filtros: {
        distribuicao_contrato_id: null
      },

      dataTable: {}
    };
  },

  mounted: function mounted() {
    this.filtros.distribuicao_contrato_id = this.$route.params.contrato_id;
    this.getDataTable();
  },


  methods: {
    sortByKey: function sortByKey(field) {
      this.dados.coluna = field;
      if (this.dados.ordem == "asc") {
        this.dados.ordem = "desc";
      } else {
        this.dados.ordem = "asc";
      }
    },

    filtrar: function filtrar(filtros) {
      this.filtros = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtros, filtros);
      this.getDataTable();
    },

    getDataTable: function getDataTable(page) {
      var _this = this;

      if (typeof page === "undefined") {
        page = 1;
      }

      this.filtros.page = page;
      this.$store.commit("TOGGLE_LOADING");

      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/contratos/getContratoSubgruposPaginate", config).then(function (response) {
        _this.dataTable = response.data;
        _this.$store.commit("TOGGLE_LOADING");
      }).catch(function (error) {
        _this.$store.commit("throwException", error);
      });
    },
    deletar: function deletar(item, index) {
      var _this2 = this;

      this.$swal({
        title: "Confirma exclus\xE3o do subgrupo " + item.subgrupo.nome + "?",
        text: "Todos os procedimentos do contrato vinculado a esse subgrupo ser\xE3o exclu\xEDdos",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          _this2.$swal({
            title: "Aguarde...",
            imageUrl: "/static/img/Rolling-green.gif",
            showConfirmButton: false,
            allowOutsideClick: false
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(_this2.$store.state.serverURI + "/api/distribuicao/contratos/deleteContratoSubgrupo/" + item.id, _this2.$store.getters.getHeaderAuth).then(function (response) {
            _this2.getDataTable();
            _this2.$swal({
              type: "success",
              title: "Subgrupo excluído com sucesso!",
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    }
  },


  components: {
    Alert: __WEBPACK_IMPORTED_MODULE_2__Alert___default.a,
    CabecarioContrato: __WEBPACK_IMPORTED_MODULE_3__cabecarioContrato___default.a,
    FiltroContratoSubgrupo: __WEBPACK_IMPORTED_MODULE_4__filtroContratoSubgrupo___default.a
  }
};

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_subgrupos_selectSubgrupo__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_subgrupos_selectSubgrupo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_subgrupos_selectSubgrupo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_money__);








/* harmony default export */ __webpack_exports__["default"] = {
	props: ['contratoId'],
	filters: {},
	data: function data() {
		return {
			showTextDangerSubgrupo: false,
			showTextDangerLimite: false,

			procedimentoSelecionado: {},
			money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				precision: 2,
				masked: false
			},
			dados: {
				limite: {
					valor: 0
				},
				procedimento_subgrupo_id: null,
				distribuicao_contrato_id: null,
				subgrupo: {
					nome: null
				}
			}

		};
	},
	mounted: function mounted() {

		if (this.$route.params.contrato_subgrupo_id) {
			this.getById(this.$route.params.contrato_subgrupo_id);
			this.atualizacao = true;
		} else {
			this.dados.distribuicao_contrato_id = this.$route.params.contrato_id;
		}
	},

	methods: {
		salvar: function salvar() {
			var _this = this;

			if (this.validar()) {
				if (this.atualizacao) {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/distribuicao/contratos/updateContratoSubgrupo/" + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
						_this.$swal({
							type: "success",
							title: "Subgrupo atualizado com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
						_this.$router.push("/distribuicoes/contratos/subgrupos/" + _this.dados.distribuicao_contrato_id);
					}).catch(function (error) {
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;

						try {
							for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var erro = _step.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}

						_this.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				} else {
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/distribuicao/contratos/createContratoSubgrupo", this.dados, this.$store.getters.getHeaderAuth).then(function (response) {

						if (response.data.status) {
							_this.$swal({
								type: "success",
								title: response.data.msg,
								showConfirmButton: false,
								timer: 1500
							});
							_this.$router.push("/distribuicoes/contratos/subgrupos/" + _this.dados.distribuicao_contrato_id);
						} else {
							_this.$swal({
								type: "error",
								title: response.data.titulo_msg,
								text: response.data.msg,
								showConfirmButton: true
							}).then(function () {
								_this.$router.push("/distribuicoes/contratos/subgrupos/" + _this.dados.distribuicao_contrato_id);
							});
						}
					}).catch(function (error) {
						var erros = error.response.data.message + " ";
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {
							for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var erro = _step2.value;

								erros += erro + " \n";
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}

						_this.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				}
			} else {
				this.$swal({
					type: "error",
					title: "Informações pendentes",
					text: "Preencha corretamente os campos destacados em vermelho!"
				});
			}
		},
		getById: function getById(contratoSubgrupoId) {
			var _this2 = this;

			this.$store.commit('TOGGLE_LOADING');
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/contratos/getContratoSubgrupoById/" + contratoSubgrupoId, this.$store.getters.getHeaderAuth).then(function (response) {

				_this2.dados = response.data;

				_this2.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			});
		},
		setSubgrupoSelecionado: function setSubgrupoSelecionado(subgrupoSelecionado) {
			this.subgrupoSelecionado = subgrupoSelecionado;
			this.dados.procedimento_subgrupo_id = subgrupoSelecionado.id;
		},
		validar: function validar() {

			var validou = true;
			if (this.dados.procedimento_subgrupo_id === null) {
				this.showTextDangerSubgrupo = true;
				validou = false;
			}
			if (this.dados.limite.valor === null) {
				this.showTextDangerLimite = true;
				validou = false;
			}
			return validou;
		}
	},
	watch: {},
	components: {
		selectSubgrupo: __WEBPACK_IMPORTED_MODULE_3__cadastros_procedimentos_subgrupos_selectSubgrupo___default.a,
		Money: __WEBPACK_IMPORTED_MODULE_4_v_money__["Money"]
	}
};

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  filters: {},
  data: function data() {
    return {
      filtros: {
        pesquisa: '',
        tipo_limite: ''
      }
    };
  },

  mounted: function mounted() {},


  methods: {
    filtrar: function filtrar() {
      this.$emit('filtrar', this.filtros);
    }
  },
  watch: {},

  components: {}

};

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  filters: {},
  data: function data() {
    return {
      filtros: {
        pesquisa: ''
      }
    };
  },

  mounted: function mounted() {},


  methods: {
    filtrar: function filtrar() {
      this.$emit('filtrar', this.filtros);
    }
  },
  watch: {},

  components: {}

};

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_unidades_selectUnidade__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastros_unidades_selectUnidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastros_unidades_selectUnidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_money__);








/* harmony default export */ __webpack_exports__["default"] = {
    filters: {},
    data: function data() {
        return {
            atualizacao: false,

            showTextDangerDataInicial: false,
            showTextDangerDataFinal: false,
            showTextDangerSituacao: false,
            showTextDangerTipoPessoa: false,
            showTextDangerTipo: false,
            showTextDangerLimiteCancelamento: false,
            showTextDangerLimiteRegulacao: false,
            showTextDangerLimiteGeral: false,
            showTextDangerUnidade: false,

            money: {
                decimal: ",",
                thousands: ".",
                prefix: "R$ ",
                precision: 2,
                masked: false
            },
            dados: {
                data_inicial: "",
                data_final: "",
                situacao: 1,
                tipo_pessoa: "",
                tipo: 0,
                limite_cancelamento: 0,
                limite_regulacao: 0,
                limite_geral: 0,
                unidade_id: "",
                unidade: {
                    nome: null
                }
            }
        };
    },
    mounted: function mounted() {
        if (this.$route.params.contrato_id) {
            this.getById(this.$route.params.contrato_id);
            this.atualizacao = true;
        }
    },

    methods: {
        salvar: function salvar() {
            var _this = this;

            if (this.validar()) {
                if (this.atualizacao) {
                    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/distribuicao/contratos/update/" + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
                        _this.$swal({
                            type: "success",

                            title: "Contrato atualizado com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        _this.$router.push("/distribuicao/controle-contratos/");
                    }).catch(function (error) {
                        var erros = error.response.data.message + " ";
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var erro = _step.value;

                                erros += erro + " \n";
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this.$swal({
                            type: "error",
                            title: "Houve uma falha!",
                            text: erros
                        });
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.serverURI + "/api/distribuicao/contratos/create", this.dados, this.$store.getters.getHeaderAuth).then(function (response) {
                        if (response.data.status) {
                            _this.$swal({
                                type: "success",
                                title: response.data.msg,
                                showConfirmButton: false,
                                timer: 1500
                            });
                            _this.$router.push("/distribuicao/controle-contratos/");
                        } else {
                            _this.$swal({
                                type: "error",
                                title: response.data.titulo_msg,
                                text: response.data.msg,
                                showConfirmButton: true
                            }).then(function () {
                                _this.$router.push("/distribuicao/controle-contratos/");
                            });
                        }
                    }).catch(function (error) {
                        var erros = error.response.data.message + " ";
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error.response.data.errors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var erro = _step2.value;

                                erros += erro + " \n";
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        _this.$swal({
                            type: "error",
                            title: "Houve uma falha!",
                            text: erros
                        });
                    });
                }
            } else {
                this.$swal({
                    type: "error",
                    title: "Informações pendentes",
                    text: "Preencha corretamente os campos destacados em vermelho!"
                });
            }
        },
        getById: function getById(contratoId) {
            var _this2 = this;

            this.$store.commit("TOGGLE_LOADING");
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/contratos/getById/" + contratoId, this.$store.getters.getHeaderAuth).then(function (response) {
                _this2.dados = response.data;
                _this2.$store.commit("TOGGLE_LOADING");
            }).catch(function (error) {
                console.log(error);
            });
        },
        setUnidadeSelecionada: function setUnidadeSelecionada(unidadeSelecionada) {
            this.dados.unidade_id = unidadeSelecionada.id;
        },
        validar: function validar() {
            var validou = true;
            if (this.dados.tipo_pessoa != "0" && this.dados.tipo_pessoa != "1") {
                this.showTextDangerTipoPessoa = true;
                validou = false;
            }
            if (this.dados.data_inicial === "") {
                this.showTextDangerDataInicial = true;
                validou = false;
            }
            if (this.dados.data_final === "") {
                this.showTextDangerDataFinal = true;
                validou = false;
            }
            if (this.dados.situacao === "") {
                this.showTextDangerSituacao = true;
                validou = false;
            }
            if (this.dados.tipo === "") {
                this.showTextDangerTipo = true;
                validou = false;
            }
            if (this.dados.limite_cancelamento === "") {
                this.showTextDangerLimiteCancelamento = true;
                validou = false;
            }
            if (this.dados.limite_regulacao === "") {
                this.showTextDangerLimiteRegulacao = true;
                validou = false;
            }
            if (this.dados.limite_geral === "") {
                this.showTextDangerLimiteGeral = true;
                validou = false;
            }
            if (this.dados.unidade_id === "") {
                this.showTextDangerUnidade = true;
                validou = false;
            }

            return validou;
        }
    },
    watch: {},
    components: {
        selectUnidade: __WEBPACK_IMPORTED_MODULE_3__cadastros_unidades_selectUnidade___default.a,
        Money: __WEBPACK_IMPORTED_MODULE_4_v_money__["Money"]
    }
};

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
  filters: {},
  data: function data() {
    return {
      distribuicoes: [],
      filtros: {
        distribuicao_id: "",
        pesquisa: "",
        categoria_unidade: "",
        tipo: "",
        situacao: "",
        coluna: null,
        ordem: null
      },
      dataTable: {}
    };
  },
  mounted: function mounted() {
    this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
    this.getDistribuicoes();
  },

  methods: {
    getDistribuicoes: function getDistribuicoes() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getAll", this.$store.getters.getHeaderAuth).then(function (response) {
        _this.distribuicoes = response.data;
        _this.filtros.distribuicao_id = _this.distribuicoes[0].id;
        _this.getDataTable();
      }).catch(function (error) {
        console.log(error);
      });
    },

    sortByKey: function sortByKey(field) {
      this.filtros.coluna = field;
      if (this.filtros.ordem == "asc") {
        this.filtros.ordem = "desc";
      } else {
        this.filtros.ordem = "asc";
      }
      this.getDataTable();
    },

    getDataTable: function getDataTable(page) {
      var _this2 = this;

      if (typeof page === "undefined") {
        page = 1;
      }

      this.filtros.page = page;
      this.$store.commit("TOGGLE_LOADING");
      this.$router.push({ query: this.filtros });

      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/contratos/getAllPaginate", config).then(function (response) {
        _this2.dataTable = response.data;
        _this2.$store.commit("TOGGLE_LOADING");
      }).catch(function (error) {
        _this2.$store.commit("throwException", error);
      });
    },
    delete: function _delete(id, nome) {}
  },
  watch: {
    page: function page(val) {
      this.getDataTable();
    }
  },

  components: {}
};

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	$_veeValidate: {
		name: function name() {
			return this.name;
		},
		value: function value() {
			return this.procedimentoSelecionado.procedimento.nome;
		}
	},

	filters: {},

	props: {
		contratoId: {},
		nomeProcedimento: {},
		showTextDangerProcedimento: {
			default: false
		},
		semAgrupados: {},
		placeholder: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		}
	},
	data: function data() {
		return {
			loading: false,
			validado: false,
			procedimentoSelecionado: {
				procedimento: {
					nome: ''
				}
			},
			filtros: {
				pesquisa: ''
			},
			showModal: false,
			dataTable: {
				data: []
			}
		};
	},
	mounted: function mounted() {
		this.validado = this.showTextDangerSubgrupo;
		this.getDataTable();
	},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}

			this.filtros.page = page;
			this.filtros.distribuicao_contrato_id = this.$props.contratoId;
			this.$store.commit('TOGGLE_LOADING');

			var config = this.$store.getters.getHeaderAuth;
			this.filtros.semAgrupados = this.semAgrupados;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/distribuicao/contratos/getContratoProcedimentosPaginate', config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			});
		},
		limpar: function limpar() {
			this.seleciona({ id: null, procedimento: { nome: '' } });
		},
		seleciona: function seleciona(item) {
			this.$emit("input", item.procedimento.nome);
			this.procedimentoSelecionado = item;
			this.showModal = false;
			this.$emit('setProcedimentoSelecionado', item);
		}
	},
	watch: {
		"$props.nomeProcedimento": function $propsNomeProcedimento() {
			if (this.$props.nomeProcedimento) {
				this.procedimentoSelecionado.procedimento.nome = this.$props.nomeProcedimento;
			}
		},
		procedimentoSelecionado: function procedimentoSelecionado(value) {
			if (value.procedimento.nome) {
				this.showTextDangerProcedimento = false;
			} else if (this.validado) {
				this.showTextDangerProcedimento = true;
			}
		}
	},
	components: {}
};

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	$_veeValidate: {
		name: function name() {
			return this.name;
		},
		value: function value() {
			return this.subgrupoSelecionado.subgrupo.nome;
		}
	},
	filters: {},

	props: {
		contratoId: {},
		nomeSubgrupo: {},
		showTextDangerSubgrupo: {
			default: false
		},
		placeholder: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		}
	},
	data: function data() {
		return {
			loading: false,
			validado: false,
			subgrupoSelecionado: {
				subgrupo: {
					nome: ''
				}
			},
			filtros: {
				pesquisa: ''
			},
			showModal: false,
			dataTable: {
				data: []
			}
		};
	},
	mounted: function mounted() {
		this.validado = this.showTextDangerSubgrupo;
		this.getDataTable();
	},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}

			this.filtros.page = page;
			this.filtros.distribuicao_contrato_id = this.$props.contratoId;
			this.$store.commit('TOGGLE_LOADING');

			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/distribuicao/contratos/getContratoSubgruposPaginate', config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			});
		},
		limpar: function limpar() {
			this.seleciona({ id: null, subgrupo: { nome: '' } });
		},
		seleciona: function seleciona(item) {
			this.$emit("input", item.subgrupo.nome);
			this.subgrupoSelecionado = item;
			this.showModal = false;
			this.$emit('setSubgrupoSelecionado', item);
		}
	},
	watch: {
		"$props.nomeSubgrupo": function $propsNomeSubgrupo() {
			if (this.$props.nomeSubgrupo) {
				this.subgrupoSelecionado.subgrupo.nome = this.$props.nomeSubgrupo;
			}
		},
		subgrupoSelecionado: function subgrupoSelecionado(value) {
			if (value.subgrupo.nome) {
				this.showTextDangerSubgrupo = false;
			} else if (this.validado) {
				this.showTextDangerSubgrupo = true;
			}
		}
	},
	components: {}
};

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Alert__);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      filtros: {
        pesquisa: "",
        tipo: 1,
        coluna: null,
        ordem: null
      },
      dataTable: {}
    };
  },
  mounted: function mounted() {
    this.getDataTable();
  },

  methods: {
    distribuir: function distribuir() {
      var _this = this;

      var config = this.$store.getters.getHeaderAuth;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getProximaCompetencia", config).then(function (response) {
        var competencia = _this.$options.filters.competencia(response.data);
        _this.$swal({
          title: "Deseja distribuir a compet\xEAncia " + competencia + "?",
          type: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
          cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            _this.$swal({
              title: "Aguarde...",
              imageUrl: "/static/img/Rolling-green.gif",
              showConfirmButton: false,
              allowOutsideClick: false
            });
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this.$store.state.serverURI + "/api/distribuicao/create", null, _this.$store.getters.getHeaderAuth).then(function (response) {
              if (response.data.status) {
                _this.$swal({
                  type: "success",
                  title: "Competência distribuida com sucesso!",
                  showConfirmButton: false,
                  timer: 1500
                });
                _this.getDataTable();
              } else {
                _this.$swal({
                  type: "error",
                  title: response.data.msg
                });
              }
            }).catch(function (error) {
              _this.$swal({
                type: "error",
                title: error
              });
            });
          }
        });
      }).catch(function (error) {
        _this.$store.commit("throwException", error);
        console.log(error);
      });
    },
    getDataTable: function getDataTable(page) {
      var _this2 = this;

      if (typeof page === "undefined") {
        page = 1;
      }
      this.filtros.page = page;
      this.$store.commit("TOGGLE_LOADING");
      var config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + "/api/distribuicao/getAllPaginate", config).then(function (response) {
        _this2.dataTable = response.data;
        console.log(_this2.dataTable);
        _this2.$store.commit("TOGGLE_LOADING");
      }).catch(function (error) {
        _this2.$store.commit("throwException", error);
      });
    }
  },
  watch: {
    page: function page(val) {
      this.getDataTable();
    }
  },
  components: {
    Alert: __WEBPACK_IMPORTED_MODULE_1__Alert___default.a
  }
};

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = {
	data: function data() {
		return {
			paciente: {
				cd_bairro: '',
				cd_cbo: '',
				cd_cidadao: '',
				cd_distrito: '',
				cd_escolaridade: '',
				cd_familia: '',
				cd_logradouro: '',
				cd_municipio: '',
				cd_nacionalidade: '',
				cd_naturalidade: '',
				cd_ocupacao: '',
				cd_pessoa: '',
				cd_religiao: '',
				cd_situacao_familiar_conjugal: '',
				cd_unidade_origem: '',
				cd_usuario: '',
				codigo_fam: '',
				codigo_int: '',
				ds_observacao: '',
				dt_cadastro: '',
				dt_chegada_pais: '',
				dt_emissao_certidao: '',
				dt_emissao_crpee: '',
				dt_emissao_ctps: '',
				dt_emissao_rg: '',
				dt_entrada_brasil: '',
				dt_nascimento: '',
				dt_validade_cartao_sus: '',
				dt_validade_crpee: '',
				gn_pessoa: '',
				id_cidadao: '',
				id_pessoa: '',
				im_pessoa: '',
				lg_enderecamento_familia: '',
				lg_fumante: '',
				nm_apelido: '',
				nm_bairro: '',
				nm_cartorio_certidao: '',
				nm_complemento: '',
				nm_distrito: '',
				nm_email: '',
				nm_estado: '',
				nm_login: '',
				nm_logradouro: '',
				nm_logradouro2: '',
				nm_mae: '',
				nm_municipio: '',
				nm_naturalidade: '',
				nm_pai: '',
				nm_pessoa: '',
				nm_pessoa1: '',
				nm_responsavel: '',
				nm_tipo_logradouro: '',
				nm_unidade: '',
				nm_url: '',
				nr_cartao_crpee: '',
				nr_cartao_sus: '',
				nr_cartao_temp: '',
				nr_cep: '',
				nr_cpf: '',
				nr_ctps: '',
				nr_domicilio: '',
				nr_externo_prontuario: '',
				nr_fax: '',
				nr_folha_certidao: '',
				nr_livro_certidao: '',
				nr_pis_pasep: '',
				nr_rg: '',
				nr_secao_eleitoral: '',
				nr_serie_ctps: '',
				nr_telefone: '',
				nr_termo_certidao: '',
				nr_titulo_eleitoral: '',
				nr_zona_eleitoral: '',
				sg_estado: '',
				sg_orgao_rg: '',
				sg_uf_ctps: '',
				sg_uf_rg: '',
				st_cadastro: '',
				st_cartao_sus: '',
				st_cidadao: '',
				st_estado_civil: '',
				tp_cartao: '',
				tp_cartao_crpee: '',
				tp_certidao: '',
				tp_raca: '',
				tp_sexo: '',
				txt_observacao: ''
			}
		};
	},
	mounted: function mounted() {
		this.getPaciente();
	},

	methods: {
		getPaciente: function getPaciente() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/integracao/pacientes/getById/' + this.$route.params.cdPessoa, this.$store.getters.getHeaderAuth).then(function (response) {
				console.log(response.data);
				_this.paciente = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		}
	},
	filters: {
		estadoCivil: function estadoCivil(value) {
			switch (value) {
				case '':
					return 'NÃO DECLARADO';
				case 0:
					return 'SOLTEIRO(A)';
				case 1:
					return 'CASADO(A)';
				case 2:
					return 'DESQUITADO(A)';
				case 3:
					return 'DIVORCIADO(A)';
				case 4:
					return 'VIUVO(A)';
			}
		},
		tipoCertidao: function tipoCertidao(value) {
			switch (value) {
				case 91:
					return 'NASCIMENTO';
				case 92:
					return 'CASAMENTO';
				case 93:
					return 'SEPARAÇÃO / DIVÓRCIO';
			}
		}
	}
};

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_integracao_pacientes_modalImportarHistorico__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_integracao_pacientes_modalImportarHistorico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_integracao_pacientes_modalImportarHistorico__);





/* harmony default export */ __webpack_exports__["default"] = {
	data: function data() {
		return {
			historico: {
				data: []
			},
			showModalImportarHistorico: false,
			disableBtnImportar: true
		};
	},
	mounted: function mounted() {
		this.getHistorico();
		this.checarImportacao();
	},

	methods: {
		getHistorico: function getHistorico(page) {
			var _this = this;

			if (typeof page === 'undefined') {
				page = 1;
			}

			var config = this.$store.getters.getHeaderAuth;
			config.params = {
				page: page,
				cd_pessoa: this.$route.params.cdPessoa
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/integracao/pacientes/historico', config).then(function (response) {
				_this.historico = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		},
		historicoImportado: function historicoImportado() {
			this.checarImportacao();
			this.showModalImportarHistorico = false;
		},
		checarImportacao: function checarImportacao() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/integracao-historico/checarImportacao/' + this.$route.params.cdPessoa, this.$store.getters.getHeaderAuth).then(function (response) {
				if (response.data.status) {
					_this2.disableBtnImportar = true;
				} else {
					_this2.disableBtnImportar = false;
				}
			}).catch(function (error) {
				console.log(error);
			});
		},
		situacao: function situacao(item) {
			switch (item.st_solicitacao) {
				case 1:
					return 'EM ANALISE';
				case 2:
					return 'APROVADA';
				case 3:
					return 'CONFIRMADA';
				case 4:
					return 'NEGADA';
				case 5:
					return 'EM PERÍCIA';
				case 6:
					return 'CANCELADA';
				case 7:
					return 'REALIZADA';
				case 8:
					return 'FALTA';
				case 9:
					return 'EM SUPERVISÃO';
				case 10:
					return 'SUPERVISIONADO';
				case 11:
					return 'EM EXTRAPOLACAO';
				case 12:
					return 'TFD';
				case 18:
					return 'FALTA AUTOMÁTICA';
			}
		}
	},
	watch: {},
	components: {
		modalImportarHistorico: __WEBPACK_IMPORTED_MODULE_1__components_integracao_pacientes_modalImportarHistorico___default.a
	}
};

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = {
	components: {},
	filters: {},
	data: function data() {
		return {
			filtros: {
				nm_pessoa: '',
				nm_mae: '',
				dt_nascimento: '',
				nr_rg: '',
				nr_cartao_sus: ''
			},
			dataTable: {}
		};
	},
	mounted: function mounted() {},

	methods: {
		getDataTable: function getDataTable(page) {
			var _this = this;

			this.$swal({
				title: "Buscando, aguarde...",
				imageUrl: "/static/img/Rolling-green.gif",
				showConfirmButton: false,
				allowOutsideClick: false
			});
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.filtros.page = page;
			this.$store.commit('TOGGLE_LOADING');
			var config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.serverURI + '/api/integracao/pacientes/getAllPaginate', config).then(function (response) {
				_this.dataTable = response.data;
				_this.$store.commit('TOGGLE_LOADING');
			}).catch(function (error) {
				console.log(error);
			}).finally(function () {
				_this.$swal.close();
			});
		}
	},
	watch: {}
};

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_pacientes_selectPaciente__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cadastros_pacientes_selectPaciente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cadastros_pacientes_selectPaciente__);





/* harmony default export */ __webpack_exports__["default"] = {
	props: ["show", "cdPessoa"],
	filters: {},
	data: function data() {
		return {
			paciente: {}
		};
	},
	mounted: function mounted() {},

	methods: {
		confirmar: function confirmar() {
			var _this = this;

			if (this.isEmpty(this.paciente)) {
				this.$swal({
					type: "warning",
					title: "Atenção!",
					text: "É necessário selecionar um paciente!"
				});
				return;
			}

			this.$swal({
				title: 'Vincular este histórico ao paciente ' + this.paciente.nome + '?',
				text: 'Esta ação não poderá ser desfeita.',
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
				cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					_this.$swal({
						title: "Importando, aguarde...",
						text: "Esta ação pode demorar um pouco.",
						imageUrl: "/static/img/Rolling-green.gif",
						showConfirmButton: false,
						allowOutsideClick: false
					});
					var dados = {
						cd_pessoa: _this.$props.cdPessoa,
						paciente_id: _this.paciente.id
					};
					__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this.$store.state.serverURI + "/api/cadastros/pacientes/importarHistorico", dados, _this.$store.getters.getHeaderAuth).then(function (response) {
						_this.$swal({
							type: "success",
							title: "Histórico importado com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
						_this.$emit('historicoImportado');
					}).catch(function () {
						_this.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: "Entre em contato com o administrador do sistema."
						});
					});
				}
			});
		},
		setPacienteSelecionado: function setPacienteSelecionado(paciente) {
			this.paciente = paciente;
		},
		close: function close() {
			this.$emit('close');
			this.paciente = {};
			this.$refs.selectPacienteRef.limpar();
		},
		isEmpty: function isEmpty(objeto) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(objeto).every(function (valor) {
				return valor === '';
			});
		}
	},
	watch: {},
	components: {
		selectPaciente: __WEBPACK_IMPORTED_MODULE_2__components_cadastros_pacientes_selectPaciente___default.a
	}
};

/***/ }),
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 125,
	"./af.js": 125,
	"./ar": 132,
	"./ar-dz": 126,
	"./ar-dz.js": 126,
	"./ar-kw": 127,
	"./ar-kw.js": 127,
	"./ar-ly": 128,
	"./ar-ly.js": 128,
	"./ar-ma": 129,
	"./ar-ma.js": 129,
	"./ar-sa": 130,
	"./ar-sa.js": 130,
	"./ar-tn": 131,
	"./ar-tn.js": 131,
	"./ar.js": 132,
	"./az": 133,
	"./az.js": 133,
	"./be": 134,
	"./be.js": 134,
	"./bg": 135,
	"./bg.js": 135,
	"./bm": 136,
	"./bm.js": 136,
	"./bn": 137,
	"./bn.js": 137,
	"./bo": 138,
	"./bo.js": 138,
	"./br": 139,
	"./br.js": 139,
	"./bs": 140,
	"./bs.js": 140,
	"./ca": 141,
	"./ca.js": 141,
	"./cs": 142,
	"./cs.js": 142,
	"./cv": 143,
	"./cv.js": 143,
	"./cy": 144,
	"./cy.js": 144,
	"./da": 145,
	"./da.js": 145,
	"./de": 148,
	"./de-at": 146,
	"./de-at.js": 146,
	"./de-ch": 147,
	"./de-ch.js": 147,
	"./de.js": 148,
	"./dv": 149,
	"./dv.js": 149,
	"./el": 150,
	"./el.js": 150,
	"./en-au": 151,
	"./en-au.js": 151,
	"./en-ca": 152,
	"./en-ca.js": 152,
	"./en-gb": 153,
	"./en-gb.js": 153,
	"./en-ie": 154,
	"./en-ie.js": 154,
	"./en-il": 155,
	"./en-il.js": 155,
	"./en-nz": 156,
	"./en-nz.js": 156,
	"./eo": 157,
	"./eo.js": 157,
	"./es": 160,
	"./es-do": 158,
	"./es-do.js": 158,
	"./es-us": 159,
	"./es-us.js": 159,
	"./es.js": 160,
	"./et": 161,
	"./et.js": 161,
	"./eu": 162,
	"./eu.js": 162,
	"./fa": 163,
	"./fa.js": 163,
	"./fi": 164,
	"./fi.js": 164,
	"./fo": 165,
	"./fo.js": 165,
	"./fr": 168,
	"./fr-ca": 166,
	"./fr-ca.js": 166,
	"./fr-ch": 167,
	"./fr-ch.js": 167,
	"./fr.js": 168,
	"./fy": 169,
	"./fy.js": 169,
	"./gd": 170,
	"./gd.js": 170,
	"./gl": 171,
	"./gl.js": 171,
	"./gom-latn": 172,
	"./gom-latn.js": 172,
	"./gu": 173,
	"./gu.js": 173,
	"./he": 174,
	"./he.js": 174,
	"./hi": 175,
	"./hi.js": 175,
	"./hr": 176,
	"./hr.js": 176,
	"./hu": 177,
	"./hu.js": 177,
	"./hy-am": 178,
	"./hy-am.js": 178,
	"./id": 179,
	"./id.js": 179,
	"./is": 180,
	"./is.js": 180,
	"./it": 181,
	"./it.js": 181,
	"./ja": 182,
	"./ja.js": 182,
	"./jv": 183,
	"./jv.js": 183,
	"./ka": 184,
	"./ka.js": 184,
	"./kk": 185,
	"./kk.js": 185,
	"./km": 186,
	"./km.js": 186,
	"./kn": 187,
	"./kn.js": 187,
	"./ko": 188,
	"./ko.js": 188,
	"./ky": 189,
	"./ky.js": 189,
	"./lb": 190,
	"./lb.js": 190,
	"./lo": 191,
	"./lo.js": 191,
	"./lt": 192,
	"./lt.js": 192,
	"./lv": 193,
	"./lv.js": 193,
	"./me": 194,
	"./me.js": 194,
	"./mi": 195,
	"./mi.js": 195,
	"./mk": 196,
	"./mk.js": 196,
	"./ml": 197,
	"./ml.js": 197,
	"./mn": 198,
	"./mn.js": 198,
	"./mr": 199,
	"./mr.js": 199,
	"./ms": 201,
	"./ms-my": 200,
	"./ms-my.js": 200,
	"./ms.js": 201,
	"./mt": 202,
	"./mt.js": 202,
	"./my": 203,
	"./my.js": 203,
	"./nb": 204,
	"./nb.js": 204,
	"./ne": 205,
	"./ne.js": 205,
	"./nl": 207,
	"./nl-be": 206,
	"./nl-be.js": 206,
	"./nl.js": 207,
	"./nn": 208,
	"./nn.js": 208,
	"./pa-in": 209,
	"./pa-in.js": 209,
	"./pl": 210,
	"./pl.js": 210,
	"./pt": 212,
	"./pt-br": 211,
	"./pt-br.js": 211,
	"./pt.js": 212,
	"./ro": 213,
	"./ro.js": 213,
	"./ru": 214,
	"./ru.js": 214,
	"./sd": 215,
	"./sd.js": 215,
	"./se": 216,
	"./se.js": 216,
	"./si": 217,
	"./si.js": 217,
	"./sk": 218,
	"./sk.js": 218,
	"./sl": 219,
	"./sl.js": 219,
	"./sq": 220,
	"./sq.js": 220,
	"./sr": 222,
	"./sr-cyrl": 221,
	"./sr-cyrl.js": 221,
	"./sr.js": 222,
	"./ss": 223,
	"./ss.js": 223,
	"./sv": 224,
	"./sv.js": 224,
	"./sw": 225,
	"./sw.js": 225,
	"./ta": 226,
	"./ta.js": 226,
	"./te": 227,
	"./te.js": 227,
	"./tet": 228,
	"./tet.js": 228,
	"./tg": 229,
	"./tg.js": 229,
	"./th": 230,
	"./th.js": 230,
	"./tl-ph": 231,
	"./tl-ph.js": 231,
	"./tlh": 232,
	"./tlh.js": 232,
	"./tr": 233,
	"./tr.js": 233,
	"./tzl": 234,
	"./tzl.js": 234,
	"./tzm": 236,
	"./tzm-latn": 235,
	"./tzm-latn.js": 235,
	"./tzm.js": 236,
	"./ug-cn": 237,
	"./ug-cn.js": 237,
	"./uk": 238,
	"./uk.js": 238,
	"./ur": 239,
	"./ur.js": 239,
	"./uz": 241,
	"./uz-latn": 240,
	"./uz-latn.js": 240,
	"./uz.js": 241,
	"./vi": 242,
	"./vi.js": 242,
	"./x-pseudo": 243,
	"./x-pseudo.js": 243,
	"./yo": 244,
	"./yo.js": 244,
	"./zh-cn": 245,
	"./zh-cn.js": 245,
	"./zh-hk": 246,
	"./zh-hk.js": 246,
	"./zh-tw": 247,
	"./zh-tw.js": 247
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 662;


/***/ }),
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MARCA 1.9951216.png";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg_vca.ad7b792.png";

/***/ }),
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(792),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(833),
  /* scopeId */
  "data-v-412d838f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(584)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(865),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(610)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(891),
  /* scopeId */
  "data-v-a4cf296e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(577)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(858),
  /* scopeId */
  "data-v-654594dd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(821),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(794),
  /* scopeId */
  "data-v-0ccafc05",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(835),
  /* scopeId */
  "data-v-4521d419",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(588)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(869),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(537)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(814),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(849),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(562)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(842),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(850),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(863),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(579)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(860),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(786),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(825),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(893),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(558)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(838),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(820),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(848),
  /* scopeId */
  "data-v-51ca4a65",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(606)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(887),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(617)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(899),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(598)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(879),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  "data-v-009ae4f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(560)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(840),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(856),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(602)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(883),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(855),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(828),
  /* scopeId */
  "data-v-3651f592",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(533)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(810),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(832),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(603)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(884),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(816),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(613)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(895),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(536)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(813),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(534)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(811),
  /* scopeId */
  "data-v-1ca930a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(611)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(892),
  /* scopeId */
  "data-v-a52b2c0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(795),
  /* scopeId */
  "data-v-0d46e2d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  "data-v-0f345d62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(546)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(826),
  /* scopeId */
  "data-v-35e33ad8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(528)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(805),
  /* scopeId */
  "data-v-17e312ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(866),
  /* scopeId */
  "data-v-70aac661",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(596)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(877),
  /* scopeId */
  "data-v-7d00458d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  "data-v-076768d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(544)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(823),
  /* scopeId */
  "data-v-2e3f5cf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(784),
  /* scopeId */
  "data-v-028b87ab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(591)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(872),
  /* scopeId */
  "data-v-788e3706",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(539)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(818),
  /* scopeId */
  "data-v-28868c77",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(538)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(815),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(600)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(881),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(595)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(876),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(834),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(597)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(878),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(601)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(882),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(844),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(583)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(864),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(604)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(885),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(787),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(800),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(845),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(843),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(532)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(809),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(587)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(868),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(830),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(793),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(608)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(889),
  /* scopeId */
  "data-v-a26ebf02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(599)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(880),
  /* scopeId */
  "data-v-820bc12e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(807),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(551)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(831),
  /* scopeId */
  "data-v-38747502",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(804),
  /* scopeId */
  "data-v-1663747f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(535)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(812),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(607)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(888),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(543)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(822),
  /* scopeId */
  "data-v-2d8b230c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(853),
  /* scopeId */
  "data-v-5f62ae42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(589)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(870),
  /* scopeId */
  "data-v-78745b34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(593)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(874),
  /* scopeId */
  "data-v-7a6748d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(783),
  /* scopeId */
  "data-v-0175d2bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(829),
  /* scopeId */
  "data-v-36b1d73e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(616)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(898),
  /* scopeId */
  "data-v-dd4b2dd0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(561)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(841),
  /* scopeId */
  "data-v-4c52e988",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(854),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(801),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(614)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(896),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(531)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(808),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(559)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(839),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(817),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(851),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(612)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(894),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(586)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(867),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(799),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(819),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(847),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(857),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(557)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(837),
  /* scopeId */
  "data-v-4573ebde",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "tipo": _vm.TIPO_CONTRATO.PRESTADOR
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional")]), _vm._v(" "), _c('select-profissional', {
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSelecionado(profissionalSelecionado)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "situacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO.ATIVA
    }
  }, [_vm._v("Ativas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO.INATIVA
    }
  }, [_vm._v("Inativas")])])])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "box-footer text-right"
  }, [(_vm.pdf) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_vm._v("Recarregar PDF "), _c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Escalas por Unidade",
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])]), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, _vm._l((_vm.dataTable.data), function(unidade, index) {
    return _c('table', {
      key: index,
      staticClass: "table table-bordered",
      attrs: {
        "role": "grid"
      }
    }, [_c('thead', [_c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('th', [_vm._v("Unidade: " + _vm._s(unidade.nome))])])]), _vm._v(" "), _c('tbody', [_c('tr', [(unidade.profissionais && unidade.profissionais.length == 0) ? _c('td', [_c('h4', [_vm._v("Nenhum profissional encontrado!")])]) : _vm._e()]), _vm._v(" "), _vm._l((unidade.profissionais), function(profissional, index) {
      return _c('tr', {
        key: index,
        staticClass: "even",
        attrs: {
          "role": "row"
        }
      }, [_c('td', [_c('table', {
        staticClass: "table table-bordered table-striped",
        attrs: {
          "role": "grid"
        }
      }, [_c('thead', [_c('tr', {
        attrs: {
          "role": "row"
        }
      }, [_c('th', {
        attrs: {
          "colspan": "5"
        }
      }, [_vm._v("Profissional: " + _vm._s(profissional.nome) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('tbody', [_c('tr', [(profissional.contrato_procedimento_atendimentos && profissional.contrato_procedimento_atendimentos.length == 0) ? _c('td', {
        attrs: {
          "colspan": "5"
        }
      }, [_c('h4', [_vm._v("Nenhum procedimento encontrado!")])]) : _vm._e()]), _vm._v(" "), _vm._l((profissional.contrato_procedimento_atendimentos), function(agenda, index) {
        return _c('tr', {
          key: index,
          staticClass: "even",
          attrs: {
            "role": "row"
          }
        }, [_c('td', {
          staticStyle: {
            "width": "60%"
          }
        }, [_vm._v(_vm._s(agenda.contrato_procedimento.procedimento.codigo) + " - " + _vm._s(agenda.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(_vm._f("dia")(agenda.dia)))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(agenda.hora_inicial) + " às " + _vm._s(agenda.hora_final))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(agenda.quantidade_primeira))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(agenda.quantidade_retorno))])])
      })], 2)])])])
    })], 2)])
  })), _vm._v(" "), (_vm.dataTable.data && _vm.dataTable.data.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tMostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF")])])]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Escalas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("Agenda")]), _vm._v(" "), _c('th', [_vm._v("Dia")]), _vm._v(" "), _c('th', [_vm._v("Horário")]), _vm._v(" "), _c('th', [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Retorno")])])
}]}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Histórico do paciente " + _vm._s(_vm.historico.data[0] ? _vm.historico.data[0].solicitacao.paciente.nome : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Histórico do sistema novo")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.historico.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.profissional.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.usuario.name))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\tMostrando " + _vm._s(this.historico.from) + " até " + _vm._s(this.historico.to) + " de " + _vm._s(this.historico.total) + " registros encontrados.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historico
    },
    on: {
      "pagination-change-page": _vm.getHistorico
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Histórico importado da base de dados anterior")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoAntigo.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacaoAntiga")(item.situacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade_realizadora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_realizacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_realizador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_solicitacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_marcador))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\tMostrando " + _vm._s(this.historicoAntigo.from) + " até " + _vm._s(this.historicoAntigo.to) + " de " + _vm._s(this.historicoAntigo.total) + " registros encontrados.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historicoAntigo
    },
    on: {
      "pagination-change-page": _vm.getHistoricoAntigo
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
}]}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        $event.stopPropagation();
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Novo atendimento de procedimento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('profissional')
    }
  }, [_c('label', [_vm._v("Profissional")]), _vm._v(" "), (!_vm.dados.exibiInput) ? _c('select-profissional', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "profissional",
      "placeholder": "PROFISSIONAL"
    },
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSelecionado(profissionalSelecionado)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dados.exibiInput) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "true",
      "type": "text"
    },
    domProps: {
      "value": _vm.dados.nome_profissional
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('profissional')),
      expression: "errors.has('profissional')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('profissional')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('procedimento')
    }
  }, [_c('label', [_vm._v("Procedimento")]), _vm._v(" "), (!_vm.dados.exibiInput) ? _c('select-procedimento-contrato', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "procedimento",
      "semAgrupados": 1,
      "contrato-id": _vm.$route.params.distribuicaoContratoId,
      "placeholder": "PROCEDIMENTO"
    },
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dados.exibiInput) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "true",
      "type": "text"
    },
    domProps: {
      "value": _vm.dados.nome_procedimento
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('procedimento')),
      expression: "errors.has('procedimento')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('procedimento')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.sexo),
      expression: "dados.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Feminino")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('idade_minima')
    }
  }, [_c('label', [_vm._v("Idade mínima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_minima),
      expression: "dados.idade_minima"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.idade_maxima ? 'required|max_value:' + _vm.dados.idade_maxima : '')),
      expression: "(dados.idade_maxima ? 'required|max_value:' + dados.idade_maxima : '')"
    }],
    ref: "idade_minima",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "idade_minima"
    },
    domProps: {
      "value": (_vm.dados.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_minima", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('idade_minima')),
      expression: "errors.has('idade_minima')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Deve ser menor que a idade máxima")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('idade_maxima')
    }
  }, [_c('label', [_vm._v("Idade máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_maxima),
      expression: "dados.idade_maxima"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.idade_minima ? 'required|min_value:' + _vm.dados.idade_minima : '')),
      expression: " (dados.idade_minima ? 'required|min_value:' + dados.idade_minima : '')"
    }],
    ref: "idade_maxima",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "110",
      "name": "idade_maxima"
    },
    domProps: {
      "value": (_vm.dados.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_maxima", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('idade_maxima')),
      expression: "errors.has('idade_maxima')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Deve ser maior que a idade mínima")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('atendimento')
    }
  }, [_c('label', [_vm._v("Atendimentos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_primeira),
      expression: "dados.quantidade_primeira"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.quantidade_retorno === '') && (_vm.dados.quantidade_local === '') ? 'required' : ''),
      expression: "(dados.quantidade_retorno === '') && (dados.quantidade_local === '') ?'required' : ''"
    }],
    ref: "atendimento",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "atendimento"
    },
    domProps: {
      "value": (_vm.dados.quantidade_primeira)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_primeira", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('atendimento')),
      expression: "errors.has('atendimento')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos uma vaga")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('retorno')
    }
  }, [_c('label', [_vm._v("Retorno")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_retorno),
      expression: "dados.quantidade_retorno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.quantidade_primeira === '') && (_vm.dados.quantidade_local === '') ? 'required' : ''),
      expression: "(dados.quantidade_primeira === '') && (dados.quantidade_local === '') ?'required' : ''"
    }],
    ref: "retorno",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "retorno"
    },
    domProps: {
      "value": (_vm.dados.quantidade_retorno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_retorno", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('retorno')),
      expression: "errors.has('retorno')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos uma vaga")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('local')
    }
  }, [_c('label', [_vm._v("Local")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_local),
      expression: "dados.quantidade_local"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.quantidade_primeira === '') && (_vm.dados.quantidade_retorno === '') ? 'required' : ''),
      expression: "(dados.quantidade_primeira === '') && (dados.quantidade_retorno === '') ?'required' : ''"
    }],
    ref: "local",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "local"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('local')),
      expression: "errors.has('local')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos uma vaga")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('data')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_atendimento),
      expression: "dados.data_atendimento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "data",
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "DATA",
      "name": "data"
    },
    domProps: {
      "value": (_vm.dados.data_atendimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_atendimento", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data')),
      expression: "errors.has('data')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('data')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('hora_inicial')
    }
  }, [_c('label', [_vm._v("Hora inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.hora_inicial),
      expression: "dados.hora_inicial"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "hora_inicial",
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "name": "hora_inicial"
    },
    domProps: {
      "value": (_vm.dados.hora_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "hora_inicial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hora_inicial')),
      expression: "errors.has('hora_inicial')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('hora_inicial')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('hora_final')
    }
  }, [_c('label', [_vm._v("Hora final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.hora_final),
      expression: "dados.hora_final"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "hora_final",
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "name": "hora_final"
    },
    domProps: {
      "value": (_vm.dados.hora_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "hora_final", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hora_final')),
      expression: "errors.has('hora_final')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('hora_final')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Paciente")]), _vm._v(" "), _c('select-paciente', {
    on: {
      "setPacienteSelecionado": function (paciente) {
        _vm.setPacienteSelecionado(paciente);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código da solicitação")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.codigo),
      expression: "filtros.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "codigo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Solicitado de")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataInicial),
      expression: "filtros.dataInicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.dataInicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dataInicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Até")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataFinal),
      expression: "filtros.dataFinal"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.dataFinal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dataFinal", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação da solicitação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.MARCADA
    }
  }, [_vm._v("Marcada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.EM_REGULACAO
    }
  }, [_vm._v("Em regulação")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REGULADA
    }
  }, [_vm._v("Regulada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE
    }
  }, [_vm._v("Informação pendente")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL
    }
  }, [_vm._v("Informação adicional")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.NEGATIVADA
    }
  }, [_vm._v("Negativada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CONFIRMADA
    }
  }, [_vm._v("Confirmada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CANCELADA
    }
  }, [_vm._v("Cancelada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.FALTA
    }
  }, [_vm._v("Falta")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REALIZADA
    }
  }, [_vm._v("Realizada")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Regulado dia:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataRegulacao),
      expression: "filtros.dataRegulacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.dataRegulacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dataRegulacao", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "tipo-profissional": "Solicitante"
    },
    on: {
      "setProfissionalSolicitanteSelecionado": function (profissional) {
        _vm.setProfissionalSolicitanteSelecionado(profissional);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Usuario marcador")]), _vm._v(" "), _c('select-usuario', {
    attrs: {
      "nivel": "marcador"
    },
    on: {
      "setUsuarioSelecionado": function (usuario) {
        _vm.setUsuarioSelecionado(usuario);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional realizador")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "tipo-profissional": "Realizador"
    },
    on: {
      "setProfissionalRealizadorSelecionado": function (profissional) {
        _vm.setProfissionalRealizadorSelecionado(profissional);
      }
    }
  })], 1)])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "hand",
      on: {
        "click": function($event) {
          _vm.detalheSolicitacao(item)
        }
      }
    }, [_c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(_vm._f("formatarCodigo")(item.id)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(_vm._f("tipoAtendimento")(item.tipo_atendimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoConsulta")(item.itens[0].tipo_consulta)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(item.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itens[0].contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.paciente.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("sexo")(item.paciente.sexo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional.nome))]), _vm._v(" "), (item.itens[0].contrato_procedimento_atendimento) ? _c('td', [_vm._v(_vm._s(item.itens[0].contrato_procedimento_atendimento.profissional.nome))]) : _c('td', [_vm._v("SEM PROFISSIONAL")]), _vm._v(" "), (item.itens[0].contrato_procedimento_atendimento || item.itens[0].contrato_subgrupo_atendimento) ? _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.itens[0].contrato_procedimento_atendimento ? item.itens[0].contrato_procedimento_atendimento.data_atendimento : item.itens[0].contrato_subgrupo_atendimento.data_atendimento)) + " a partir das " + _vm._s(item.itens[0].contrato_procedimento_atendimento ? item.itens[0].contrato_procedimento_atendimento.hora_inicial : item.itens[0].contrato_subgrupo_atendimento.hora_inicial))]) : _c('td', [_vm._v("SEM DATA DEFINIDA")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.usuario.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("mesPorExtenso")(item.itens[0].contrato_procedimento.contrato.distribuicao.data_competencia)))]), _vm._v(" "), _c('td', [_c('strong', {
      class: _vm._f("situacaoSolicitacaoColor")(item.situacao)
    }, [_vm._v(_vm._s(_vm.verificarCancelamento(item)))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])]), _vm._v(" "), _c('modal-detalhes-solicitacao', {
    attrs: {
      "solicitacao": _vm.solicitacao,
      "show": _vm.showModalDetalhesSolicitacao
    },
    on: {
      "close": function($event) {
        _vm.showModalDetalhesSolicitacao = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Verificação de atendimentos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right"
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Código da solicitação")]), _vm._v(" "), _c('th', [_vm._v("Tipo Atendimento")]), _vm._v(" "), _c('th', [_vm._v("Tipo Consulta")]), _vm._v(" "), _c('th', [_vm._v("Data da solicitação")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Paciente")]), _vm._v(" "), _c('th', [_vm._v("Sexo")]), _vm._v(" "), _c('th', [_vm._v("Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Realizador")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Marcador")]), _vm._v(" "), _c('th', [_vm._v("Competência")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("Situação")])])])
}]}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contratoSelecionado.unidade.nome),
      expression: "contratoSelecionado.unidade.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.contratoSelecionado.unidade.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contratoSelecionado.unidade, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo do Contrato")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("tipoContrato")(_vm.contratoSelecionado.tipo)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.contratoSelecionado.data_inicial)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.contratoSelecionado.data_final)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Limite Geral")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("numberFormat")(_vm.contratoSelecionado.limite_geral, 2, ',', '.')
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecario-contrato', {
    attrs: {
      "contratoId": _vm.$route.params.contrato_id ? _vm.$route.params.contrato_id : _vm.dados.contrato.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerSubgrupo
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), _c('select-subgrupo', {
    attrs: {
      "show-text-danger-subgrupo": _vm.showTextDangerSubgrupo,
      "nomeSubgrupo": _vm.dados.subgrupo.nome
    },
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimite
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimite
    }
  }, [_vm._v("Limite Financeiro (R$)")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "autofocus": ""
    },
    model: {
      value: (_vm.dados.limite.valor),
      callback: function($$v) {
        _vm.$set(_vm.dados.limite, "valor", $$v)
      },
      expression: "dados.limite.valor"
    }
  }, 'money', _vm.money, false))], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo Subgrupo do Contrato")])])])
}]}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/cadastros/grupos-procedimento/novo"
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código do grupo."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "hand",
      attrs: {
        "tag": "tr",
        "to": '/cadastros/grupos-procedimento/editar/' + item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Grupos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Nome")])])])
}]}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSolicitante(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Competência")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.distribuicao_id),
      expression: "filtros.distribuicao_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "distribuicao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.distribuicoes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(_vm._f("competencia")(item.data_competencia)))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.MARCADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.MARCADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.MARCADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Marcada\n              ")]), _vm._v(" "), (this.$store.state.user.nivel == 'administrador') ? _c('div', [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.EM_REGULACAO,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.EM_REGULACAO) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.EM_REGULACAO,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Em regulação\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REGULADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.REGULADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.REGULADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Regulada\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.NEGATIVADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.NEGATIVADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.NEGATIVADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Negativada\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Informação pendente\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Informação adicional\n                ")])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CONFIRMADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.CONFIRMADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.CONFIRMADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Confirmada\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CANCELADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.CANCELADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.CANCELADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Cancelada\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.FALTA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.FALTA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.FALTA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Falta\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REALIZADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.REALIZADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.REALIZADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Realizada\n              ")])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": !_vm.finalizado,
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Solicitação",
      "id": "resultado"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar\n              ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.unidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("competencia")(item.competencia)))])])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Solicitações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Quantidade solicitada")]), _vm._v(" "), _c('th', [_vm._v("Mês/Ano")])])])
}]}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": ("/distribuicoes/contratos/subgrupos/novo/" + (_vm.$route.params.contrato_id))
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar Subgrupo\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecario-contrato', {
    attrs: {
      "contratoId": _vm.$route.params.contrato_id
    }
  }), _vm._v(" "), _c('filtro-contrato-subgrupo', {
    on: {
      "filtrar": function (filtros) {
        _vm.filtrar(filtros);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subgrupo.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subgrupo.nome))]), _vm._v(" "), _c('td', [_c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Limite Distribuído (Modelo)"
      }
    }, [_vm._v(_vm._s(_vm._f("numberFormat")(item.limite.valor_original, 2, ",", ".")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Limite Disponível"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")(item.limite.valor, 2, ",", ".")))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Limite Consumido"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")(item.limite_consumido, 2, ",", ".")))])])])])])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/distribuicoes/contratos/subgrupos/atualizacao/" + (item.id)),
        "title": " Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Subgrupos do Contrato")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Controle")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "45%"
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "34%"
    }
  }, [_vm._v("Limite Financeiro")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1%"
    }
  }, [_vm._v("Ação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "34%"
    }
  }, [_vm._v("M")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("D")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("C")])])])
}]}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showModalEnviarRegulacao) ? _c('modal-enviar-regulacao', {
    on: {
      "close": function($event) {
        _vm.showModalEnviarRegulacao = false
      },
      "enviaRegulacao": function (motivo) { return _vm.enviaRegulacao(motivo); }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table overflow-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima"
  }, _vm._l((_vm.vagas_unidade), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.getAtendimentosByUnidade(item[0].unidade_id)
        }
      }
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      class: {
        ativa: _vm.selecionados.indexUnidadeAtiva === item[0].unidade_id
      }
    }, [_c('strong', [_vm._v(" " + _vm._s(_vm.getQtdProcedimentosAtendidos(item[0].unidade_id)) + " ")]), _vm._v(" " + _vm._s(_vm._f("uppercase")(item[0].unidade.nome))), _c('br'), _vm._v(" "), _c('span')])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "260px"
    }
  }, [(_vm.optionsCalendario.enabledDates) ? _c('date-picker', {
    attrs: {
      "config": _vm.optionsCalendario
    },
    on: {
      "dp-change": _vm.getUnidadesByDia
    },
    model: {
      value: (_vm.selecionados.data),
      callback: function($$v) {
        _vm.$set(_vm.selecionados, "data", $$v)
      },
      expression: "selecionados.data"
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table overflow-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima"
  }, _vm._l((_vm.atendimentos_unidade), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      staticStyle: {
        "cursor": "default"
      }
    }, [_vm._v(" " + _vm._s(_vm._f("uppercase")(item[0].procedimento_nome))), _c('br')])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table overflow-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima"
  }, _vm._l((_vm.procedimentos), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.ativo) ? _c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-success",
      staticStyle: {
        "cursor": "default"
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(_vm._f("uppercase")(item.procedimento_nome)) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Unidade: "), _c('strong', [_vm._v(" " + _vm._s(_vm._f("uppercase")(item.unidade.nome)) + " ")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Data: "), _c('strong', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)))]), _vm._v(" à partir das "), _c('b', [_vm._v(_vm._s(_vm._f("horaFormatada")(item.hora_inicial)))]), _vm._v(" horas.")]), _c('br')]) : _c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      staticStyle: {
        "cursor": "default"
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("uppercase")(item.procedimento_nome)))]), _c('br')])])
  }))])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 margin-bottom"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "pull-left btn btn-default",
    on: {
      "click": function($event) {
        _vm.selecionaProcedimentos()
      }
    }
  }, [_vm._v("Selecionar "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [(!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.disableBtConfirmar
    },
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v(" Confirmar")])]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.informacaoPendente
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" Solicitar informação pendente")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.negativar
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Negativar")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Regular")]) : _vm._e(), _vm._v(" "), (!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.showModalEnviarRegulacao = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Regulação")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Selecione uma unidade")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('b', [_vm._v("Selecione uma data")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Atendimentos da Unidade")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Procedimentos")])])])])])
}]}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$props.solicitacao
    .solicitacao_historicos), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.usuario.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.situacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(item.created_at)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-transform": "none"
      }
    }, [_vm._v(_vm._s(item.observacao))])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Usuário")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Observação")])])])
}]}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes],
    attrs: {
      "refs": "box-wrapper"
    }
  }, [_c('header', {
    ref: "mainHeader",
    staticClass: "main-header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "tag": "a",
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "logo-mini",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("NTI")])]), _vm._v(" "), _vm._v("\n      PMVC - CMC\n    ")]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.user_current.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user_current.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.user_current.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user_current.displayName))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.user_current.setor))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.hasPermission('usuario.updatePassword')),
      expression: "this.hasPermission('usuario.updatePassword')"
    }],
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "to": "/cadastros/usuarios/alterar-senha"
    }
  }, [_vm._v("Alterar Senha")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("Sair")])])])])])])])])], 1), _vm._v(" "), _c('aside', {
    ref: "mainSideBar",
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('sidebar-menu')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper",
    style: ({
      'min-height': _vm.fullHeight + 'px'
    })
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        CMC\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
    ref: "mainFooter",
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("\n      Copyright © " + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("NTI")]), _vm._v(".\n    ")]), _vm._v(" Todos os direitos reservados.\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/cadastros/unidades/novo"
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade/CNPJ/CNES")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.categoria),
      expression: "filtros.categoria"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Pública (Local)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Município Pactuado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Privada")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de Unidade")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo_unidade_id),
      expression: "filtros.tipo_unidade_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo_unidade_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.tiposUnidade), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cnpj))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cnes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("categoriaUnidade")(item.categoria)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacao")(item.situacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tipo_unidade.nome))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/cadastros/unidades/editar/" + (item.id)),
        "title": "Editar Unidade"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": '/cadastros/users/atualizacao/' + item.id,
        "title": "Profissionais da Unidade"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-users",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Unidades")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("CNES")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Situacao")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ação")])])])
}]}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Editar Atendimento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Profissional")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "nome-profissional": _vm.$props.atendimento.profissional.nome,
      "disableClear": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    attrs: {
      "disableClear": true,
      "nome-procedimento": _vm.$props.atendimento.contrato_procedimento.procedimento.nome,
      "contrato-id": _vm.$route.params.contratoId
    },
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.sexo),
      expression: "$props.atendimento.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$props.atendimento, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Feminino")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade mínima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.idade_minima),
      expression: "$props.atendimento.idade_minima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.$props.atendimento.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "idade_minima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.idade_maxima),
      expression: "$props.atendimento.idade_maxima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.$props.atendimento.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "idade_maxima", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Atendimentos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.quantidade_primeira),
      expression: "$props.atendimento.quantidade_primeira"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.$props.atendimento.quantidade_primeira)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "quantidade_primeira", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Retorno")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.quantidade_retorno),
      expression: "$props.atendimento.quantidade_retorno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.$props.atendimento.quantidade_retorno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "quantidade_retorno", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Local")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.quantidade_local),
      expression: "$props.atendimento.quantidade_local"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.$props.atendimento.quantidade_local)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "quantidade_local", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Hora inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.hora_inicial),
      expression: "$props.atendimento.hora_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.$props.atendimento.hora_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "hora_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Hora final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.hora_final),
      expression: "$props.atendimento.hora_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.$props.atendimento.hora_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "hora_final", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n                        Salvar\n                    ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['esc']),
      expression: "['esc']"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.up()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.down()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.enter()
      }],
      "shortkey": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Adicionar Procedimento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [((_vm.contratoSolicitanteSelecionado && _vm.contratoSolicitanteSelecionado.unidade) && _vm.profissionalSolicitanteSelecionado) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.$props.contratoSolicitanteSelecionado.unidade.nome
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.$props.profissionalSolicitanteSelecionado.nome
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['ctrl', 'b']),
      expression: "['ctrl', 'b']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    ref: "nmProcedimento",
    staticClass: "form-control",
    attrs: {
      "title": "pressione ctrl + b para pesquisar",
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código do procedimento e pressione ctrl + b."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "shortkey": function($event) {
        _vm.getDataTable()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Controle")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Tipo")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      class: {
        ativa: index === _vm.procedimentoSelecionadoIndex
      },
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipo_atendimento")(item.procedimento.tipo_atendimento)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Dados do Boleto")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm pull-right",
    attrs: {
      "to": ("/boleto/" + (_vm.$props.solicitacao.id)),
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  })])], 1)]), _vm._v(" "), (_vm.$props.solicitacao != null) ? _c('solicitacao-boleto', {
    attrs: {
      "solicitacao": _vm.$props.solicitacao
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": _vm.logo,
      "alt": "ALMOX"
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("Ops! Você se perdeu! ")]), _vm._v(" "), _c('h4', [_vm._v("Esta página não existe.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Voltar para o início.")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("formatarCodigo")(_vm.$props.solicitacao.id)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data da solicitação")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("dataHoraFormatada")(_vm.$props.solicitacao.created_at)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de atendimento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("tipoAtendimento")(_vm.$props.solicitacao.tipo_atendimento)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("situacaoSolicitacao")(_vm.$props.solicitacao.situacao)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimentos da solicitação")]), _vm._v(" "), _c('table', {
    staticClass: "table table-stripped table-condensed table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$props.solicitacao.itens), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoConsulta")(item.tipo_consulta)))])])
  }))])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Paciente "), (_vm.showInfo) ? _c('a', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Paciente possui agendamentos ainda não realizados.",
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('showModalNaoRealizados')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-info-circle"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cartão do SUS")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.$props.solicitacao.paciente.cartao_sus
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.$props.solicitacao.paciente.nome
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de nascimento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.$props.solicitacao.paciente.data_nascimento)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("sexo")(_vm.$props.solicitacao.paciente.sexo)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome da mãe")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.$props.solicitacao.paciente.nome_mae
    }
  })])])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Marcação")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.$props.solicitacao.itens[0].contrato_procedimento.contrato.unidade.nome
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.$props.solicitacao.profissional.nome
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Usuário marcador")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.$props.solicitacao.usuario.name
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Tipo de consulta")])])])
}]}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert'), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.distribuir
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt-square"
  }), _vm._v(" Distribuir\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("competencia")(item.data_competencia)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.usuario.name) + ", em " + _vm._s(_vm._f("dataFormatada")(item.created_at)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Distribuições")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("Competência")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Distribuído por")])])])
}]}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/cadastros/procedimentos/novo"
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código do procedimento."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "hand",
      attrs: {
        "tag": "tr",
        "to": '/cadastros/procedimentos/editar/' + item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoAtendimento")(item.tipo_atendimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.forma_organizacao.subgrupo.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacao")(item.situacao)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Procedimentos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Subgrupo")]), _vm._v(" "), _c('th', [_vm._v("Situação")])])])
}]}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Entre com NOME, CNPJ ou CNES da UNIDADE"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filtrar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Competência")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.distribuicao_id),
      expression: "filtros.distribuicao_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "distribuicao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.distribuicoes), function(distribuicao, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": distribuicao.id
      }
    }, [_vm._v(_vm._s(_vm._f("competencia")(distribuicao.data_competencia)))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.filtrar
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                                            ID\n                                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('distribuicao_contratos.id')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'distribuicao_contratos.id' ? ("fa fa-sort-numeric" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                                            Unidade\n                                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('unidades.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'unidades.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/distribuicao/controle-atendimentos/visualizar-procedimentos/" + (item.id)),
        "title": "Agenda de Procedimentos"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/distribuicao/controle-atendimentos/visualizar-subgrupos/" + (item.id)),
        "title": "Agenda de Subgrupos"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list-alt",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Controle da Agenda")])])])
}]}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        $event.stopPropagation();
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.procedimentoSelecionado.procedimento.nome),
      expression: "procedimentoSelecionado.procedimento.nome"
    }],
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerProcedimento
    },
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.procedimentoSelecionado.procedimento.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.procedimentoSelecionado.procedimento, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerProcedimento,
      'btn-default': !_vm.$props.showTextDangerProcedimento
    },
    attrs: {
      "disabled": _vm.$props.nomeProcedimento != undefined,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerProcedimento,
      'btn-default': !_vm.$props.showTextDangerProcedimento
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask not-valited"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Procedimento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código do procedimento e pressione enter."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Tipo")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.procedimento.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoAtendimento")(item.procedimento.tipo_atendimento)))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t\t")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subgrupoSelecionado.nome),
      expression: "subgrupoSelecionado.nome"
    }],
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerSubgrupo
    },
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.subgrupoSelecionado.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subgrupoSelecionado, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerSubgrupo,
      'btn-default': !_vm.$props.showTextDangerSubgrupo
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerSubgrupo,
      'btn-default': !_vm.$props.showTextDangerSubgrupo
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Subgrupo")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome do subgrupo e pressione enter."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.hasPermission('usuario.read')) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Atendimentos Marcados")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.total_marcacao))])])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('usuario.read')) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Atendimentos Regulados")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.total_regulacao))])])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('usuario.read')) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Atendimentos Negativados")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.total_negativado))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("COMUNICADOS IMPORTANTES")]), _vm._v(" "), _vm._l((_vm.comunicados.data), function(comunicado, index) {
    return [(comunicado[((_vm.$store.state.user.nivel) + "_visualiza")]) ? _c('div', {
      key: index,
      staticClass: "box box-success"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h3', {
      staticClass: "box-title"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("dataFormatada")(comunicado.data_inicial)) + " - " + _vm._s(comunicado.titulo))])])]), _vm._v(" "), _c('div', {
      staticClass: "box-body",
      domProps: {
        "innerHTML": _vm._s(comunicado.descricao)
      }
    })]) : _vm._e()]
  }), _vm._v(" "), (_vm.comunicados.data.length == 0) ? _c('div', [_vm._v("\n\t\t\tNenhum comunicado vigente.\n\t\t")]) : _vm._e()], 2), _vm._v(" "), (_vm.visualizaArquivo) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("DOCUMENTOS COMPARTILHADOS")]), _vm._v(" "), _vm._m(3)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-warning"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('p', [_c('strong', [_vm._v("10/12/2020")]), _vm._v("  - "), _c('a', {
    attrs: {
      "href": "/static/docs/profissionais-cemae.pdf",
      "download": ""
    }
  }, [_vm._v("Relação de profissionais do CEMAE no mês de Novembro 2020 (3ª fase de reabertura)")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("04/10/2019")]), _vm._v("  - "), _c('a', {
    attrs: {
      "href": "/static/docs/circular6.pdf",
      "download": ""
    }
  }, [_vm._v("OFÍCIO CIRCULAR Nº. 006/2019-GAB/SMS")])])])])
}]}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.titulo))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("ATENÇÃO:")]), _vm._v(" Haverá extrapolação do "), _c('strong', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" após a confirmação.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Para continuar assim mesmo, informe uma\n          "), _c('strong', [_vm._v("JUSTIFICATIVA")]), _vm._v(" e sua\n          "), _c('strong', [_vm._v("SENHA")]), _vm._v(" nos campos abaixo, e clique em confirmar:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justificativa),
      expression: "justificativa"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.justificativa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.justificativaInvalida),
      expression: "justificativaInvalida"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Informe uma justificativa")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Digite sua senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senha),
      expression: "senha"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center",
      "font-size": "20px",
      "padding": "20px"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.senha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.senha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.senhaInvalida),
      expression: "senhaInvalida"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Senha inválida")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert'), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/cadastros/usuarios/novo"
    }
  }, [_vm._v("Novo")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    ref: "filtro_pesquisa",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Busca: Entre com o nome do usuário",
      "name": "filtro_pesquisa",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUsers($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                                            Nome\n                                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('name')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'name' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                                            Usuário\n                                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('usuario')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'usuario' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("\n                                            Nível\n                                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('nivel')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'nivel' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                                            Unidades\n                                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('setor')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'setor' ? ("fa fa-sort-amount" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("Ação")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.apiData.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nivel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("unidades")(item.unidades)))]), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('td', [(_vm.hasPermission('usuario.update')) ? _c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": '/cadastros/usuarios/atualizacao/' + item.id,
        "title": "Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit"
    })]) : _vm._e(), _vm._v(" "), (item.situacao == 1 && _vm.hasPermission('usuario.delete')) ? _c('a', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Desativar"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.desativarUsuario(item.id, item.name)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-times"
    })]) : _vm._e(), _vm._v(" "), (item.situacao == 0 && _vm.hasPermission('usuario.delete')) ? _c('a', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "title": "Ativar"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.ativarUsuario(item.id, item.name)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-check"
    })]) : _vm._e()], 1) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.apiData.from) + " até " + _vm._s(this.apiData.to) + " de " + _vm._s(this.apiData.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.apiData
    },
    on: {
      "pagination-change-page": _vm.getUsers
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Usuários do Sistema")])])
}]}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerProcedimento
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    attrs: {
      "show-text-danger-procedimento": _vm.showTextDangerProcedimento,
      "nomeProcedimento": _vm.dados.procedimento.nome
    },
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerPreparo
    }
  }, [_vm._v("Preparo")]), _vm._v(" "), _c('select-preparo', {
    attrs: {
      "show-text-danger-preparo": _vm.showTextDangerPreparo,
      "nomePreparo": _vm.dados.preparo.nome
    },
    on: {
      "setPreparoSelecionado": function (preparoSelecionado) {
        _vm.setPreparoSelecionado(preparoSelecionado)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerValor
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerValor
    }
  }, [_vm._v("Valor (R$)")]), _vm._v(" "), _c('money', _vm._b({
    ref: "valor",
    staticClass: "form-control",
    attrs: {
      "autofocus": ""
    },
    model: {
      value: (_vm.dados.valor),
      callback: function($$v) {
        _vm.$set(_vm.dados, "valor", $$v)
      },
      expression: "dados.valor"
    }
  }, 'money', _vm.money, false))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerTipoLimite
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTipoLimite
    }
  }, [_vm._v("Tipo de Limite")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_limite),
      expression: "dados.tipo_limite"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": false,
      "placeholder": "Selecione"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_limite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.procedimentoSelecionado.tipo_atendimento == 0) ? _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Procedimento")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), (_vm.procedimentoSelecionado.tipo_atendimento == 0) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Geral")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerLimite
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimite
    }
  }, [_vm._v("Limite Físico")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.limite.quantidade),
      expression: "dados.limite.quantidade"
    }],
    ref: "limite_fisico",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.dados.tipo_limite == 0 ? false : true,
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.limite.quantidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados.limite, "quantidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Valor Total (R$)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": _vm._f("numberFormat")(_vm.controle.limite_financeiro, 2, ',', '.')
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerSituacao
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerSituacao
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": false,
      "placeholder": "Selecione"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo Procedimento do Contrato")])])])
}]}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.boxTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Conselho")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.conselho),
      expression: "dados.conselho"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "conselho"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "conselho", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "CRM"
    }
  }, [_vm._v("CRM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CREFITO"
    }
  }, [_vm._v("CREFITO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CRO"
    }
  }, [_vm._v("CRO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CRN"
    }
  }, [_vm._v("CRN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CRP"
    }
  }, [_vm._v("CRP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CRFA"
    }
  }, [_vm._v("CRFA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OUTRO"
    }
  }, [_vm._v("OUTRO")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('conselho')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nº Registro Conselho")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.registro_conselho),
      expression: "dados.registro_conselho"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "registro_conselho",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.registro_conselho)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "registro_conselho", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('registro_conselho')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("CNS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cns),
      expression: "dados.cns"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cns",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cns", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cns')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.email),
      expression: "dados.email"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "name": "email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##)#####-####', '(##)####-####']),
      expression: "['(##)#####-####', '(##)####-####']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.telefone),
      expression: "dados.telefone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "telefone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.sexo),
      expression: "dados.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("Feminino")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_nascimento),
      expression: "dados.data_nascimento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_nascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_nascimento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de admissão")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_admissao),
      expression: "dados.data_admissao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_admissao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_admissao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de desligamento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_desligamento),
      expression: "dados.data_desligamento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_desligamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_desligamento", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cpf),
      expression: "dados.cpf"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cpf", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cpf')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##########'),
      expression: "'##########'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.rg),
      expression: "dados.rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Orgão emissor do RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.orgao_emissor_rg),
      expression: "dados.orgao_emissor_rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.orgao_emissor_rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "orgao_emissor_rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("UF do RG")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.uf_rg),
      expression: "dados.uf_rg"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "uf_rg", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o UF...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AC"
    }
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    }
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    }
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    }
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    }
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("TO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de emissão do RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_emissao_rg),
      expression: "dados.data_emissao_rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_emissao_rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_emissao_rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "situacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SITUACAO.ATIVA
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO.INATIVA
    }
  }, [_vm._v("Inativo")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('situacao')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('solicitacao-boleto', {
    attrs: {
      "solicitacao": _vm.solicitacao
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', '1']),
      expression: "['alt', '1']"
    }],
    staticClass: "labe-telca-atalho",
    on: {
      "shortkey": function($event) {
        _vm.focoUnidades()
      }
    }
  }, [_vm._v("alt + 1")]), _vm._v(" "), _c('v-select', {
    ref: "selectUnidade",
    attrs: {
      "placeholder": "SELECIONE A UNIDADE SOLICITANTE...",
      "label": "nome",
      "options": _vm.unidades
    },
    on: {
      "change": function($event) {
        _vm.limparProcedimentos()
      }
    },
    model: {
      value: (_vm.contratoSolicitanteSelecionado),
      callback: function($$v) {
        _vm.contratoSolicitanteSelecionado = $$v
      },
      expression: "contratoSolicitanteSelecionado"
    }
  })], 1)])]), _vm._v(" "), (_vm.contratoSolicitanteSelecionado) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerPaciente
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do paciente")]), _vm._v(" "), _c('label', {
    staticClass: "labe-telca-atalho"
  }, [_vm._v("alt + 2")]), _vm._v(" "), _c('select-paciente', {
    ref: "btnPaciente",
    attrs: {
      "nome-paciente-recuperado": _vm.dados.paciente.nome,
      "cidadeUnidadeSolicitante": _vm.contratoSolicitanteSelecionado.unidade.cidade_id,
      "unidadeSolicitante": _vm.contratoSolicitanteSelecionado.unidade,
      "show-text-danger-paciente": _vm.showTextDangerPaciente
    },
    on: {
      "limpar": function($event) {
        (_vm.historico = {}), (_vm.historicoAntigo = {})
      },
      "setPacienteSelecionado": function (paciente) {
        _vm.setPacienteSelecionado(paciente);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerPaciente
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CNS do paciente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.dados.paciente.cartao_sus),
      expression: "this.dados.paciente.cartao_sus"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (this.dados.paciente.cartao_sus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(this.dados.paciente, "cartao_sus", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerPaciente
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Município do paciente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.dados.paciente.cidade.nome),
      expression: "this.dados.paciente.cidade.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (this.dados.paciente.cidade.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(this.dados.paciente.cidade, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerProfissional
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('label', {
    staticClass: "labe-telca-atalho"
  }, [_vm._v("alt + 3")]), _vm._v(" "), _c('select-profissional', {
    ref: "btnProfissional",
    attrs: {
      "nome-profissional-recuperado": _vm.dados.profissionalSolicitante.nome,
      "unidade-solicitante-selecionada": _vm.contratoSolicitanteSelecionado.unidade,
      "show-text-danger-profissional": _vm.showTextDangerProfissional
    },
    on: {
      "setProfissionalSelecionado": function (profissional) {
        _vm.setProfissionalSelecionado(profissional);
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('historicos', {
    ref: "historicos",
    attrs: {
      "show-info": _vm.showInfo,
      "pacienteId": _vm.dados.paciente.id
    },
    on: {
      "showModalNaoRealizados": function($event) {
        _vm.showModalNaoRealizados = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box",
    class: {
      'box-danger': _vm.showTextDangerProcedimento
    }
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    class: {
      'erro-validacao': _vm.showTextDangerProcedimento
    }
  }, [_vm._v("Procedimentos da solicitação")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', '4']),
      expression: "['alt', '4']"
    }],
    staticClass: "btn btn-sm",
    class: {
      'btn-danger': _vm.showTextDangerProcedimento
    },
    attrs: {
      "type": "button"
    },
    on: {
      "shortkey": function($event) {
        _vm.mostrarModalProcedimento()
      },
      "click": function($event) {
        _vm.mostrarModalProcedimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar")]), _vm._v(" "), _c('label', {
    staticClass: "labe-telca-atalho"
  }, [_vm._v("alt + 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dados.procedimentos), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.procedimento.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipo_consulta")(item.procedimento.tipo_consulta)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.removerProcedimento(index)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Diagnósticos indicados")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', '5']),
      expression: "['alt', '5']"
    }],
    ref: "btnAdicionarDiagnostico",
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "shortkey": function($event) {
        _vm.showModalAddDiagnosticos = true
      },
      "click": function($event) {
        _vm.showModalAddDiagnosticos = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar")]), _vm._v(" "), _c('label', {
    staticClass: "labe-telca-atalho"
  }, [_vm._v("alt + 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dados.diagnosticos), function(diagnostico, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(diagnostico.cid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnostico.nome))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.removerDiagnostico(index)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', 'r']),
      expression: "['alt', 'r']"
    }],
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "title": "pressione alt + r para resolver"
    },
    on: {
      "click": _vm.resolver,
      "shortkey": _vm.resolver
    }
  }, [_c('span', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v(" Resolver")])])])], 1)])])]), _vm._v(" "), _c('modal-add-procedimentos', {
    attrs: {
      "contrato-solicitante-selecionado": _vm.contratoSolicitanteSelecionado,
      "profissional-solicitante-selecionado": _vm.dados.profissionalSolicitante,
      "show": _vm.showModalAddProcedimentos
    },
    on: {
      "close": function($event) {
        (_vm.showModalAddProcedimentos = false), (_vm.focusAdicionarDiagnositico = true)
      },
      "incluirProcedimentoSelecionado": function (contratoProcedimento) {
        _vm.incluirProcedimentoSelecionado(contratoProcedimento);
      }
    }
  }), _vm._v(" "), _c('modal-quantidade-procedimentos', {
    attrs: {
      "show": _vm.showModalQuantidadeProcedimentos,
      "contrato-procedimento": _vm.contratoProcedimentoTemp
    },
    on: {
      "close": function($event) {
        _vm.showModalQuantidadeProcedimentos = false
      },
      "addProcedimentoSelecionado": function (contratoProcedimento) {
        _vm.addProcedimentoSelecionado(contratoProcedimento);
      }
    }
  }), _vm._v(" "), _c('modal-add-diagnosticos', {
    attrs: {
      "show": _vm.showModalAddDiagnosticos
    },
    on: {
      "close": function($event) {
        _vm.showModalAddDiagnosticos = false
      },
      "addDiagnosticoSelecionado": function (diagnostico) {
        _vm.addDiagnosticoSelecionado(diagnostico);
      }
    }
  }), _vm._v(" "), _c('modal-nao-realizados', {
    attrs: {
      "regulacao": false,
      "nao-realizados": _vm.naoRealizados,
      "show": _vm.showModalNaoRealizados
    },
    on: {
      "selecionarProfissional": function($event) {
        _vm.showModalNaoRealizados = false;
        _vm.$refs.btnProfissional.abrirModal();
      },
      "close": function($event) {
        _vm.showModalNaoRealizados = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Marcação de Atendimentos")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Consulta")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "1%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Código CID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "1%"
    }
  })])])
}]}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('bloquear-modal', {
    attrs: {
      "id": _vm.atendimento_id,
      "show": _vm.showBloquear
    },
    on: {
      "close": function($event) {
        _vm.showBloquear = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('criar-modal', {
    attrs: {
      "id": _vm.atendimento_id,
      "show": _vm.showCriar
    },
    on: {
      "close": function($event) {
        _vm.showCriar = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('criar-atendimento-modal', {
    attrs: {
      "id": _vm.atendimento_id,
      "item": _vm.itens,
      "show": _vm.showCriarAtendimento
    },
    on: {
      "close": function($event) {
        _vm.showCriarAtendimento = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('bloquear-periodo-modal', {
    attrs: {
      "show": _vm.showBloquearPeriodo,
      "distribuicao_contrato_id": this.$route.params.distribuicaoContratoId
    },
    on: {
      "close": function($event) {
        _vm.showBloquearPeriodo = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('editar-atendimento-modal', {
    attrs: {
      "tipo": "procedimento",
      "item": _vm.atendimento,
      "show": _vm.showEditarAtendimento
    },
    on: {
      "criarAtendimento": function($event) {
        _vm.criarAtendimento($event)
      },
      "close": function($event) {
        _vm.showEditarAtendimento = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": "Bloquear por período"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.bloquearPeriodo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ban",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v(" Bloquear por período")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "title": "Criar atendimento"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.criarAtendimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v(" Criar atendimento")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome_procedimento),
      expression: "filtros.nome_procedimento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "PROCEDIMENTO"
    },
    domProps: {
      "value": (_vm.filtros.nome_procedimento)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filtrar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome_procedimento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome_profissional),
      expression: "filtros.nome_profissional"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "PROFISSIONAL"
    },
    domProps: {
      "value": (_vm.filtros.nome_profissional)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filtrar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome_profissional", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sexo),
      expression: "filtros.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.AMBOS
    }
  }, [_vm._v("AMBOS")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("MASCULINO")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("FEMININO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Período (De)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_inicial),
      expression: "filtros.data_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "PERÍODO DE"
    },
    domProps: {
      "value": (_vm.filtros.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Período (Até)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_final),
      expression: "filtros.data_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "PERÍODO DE"
    },
    domProps: {
      "value": (_vm.filtros.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_final", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.filtrar
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("sexo")(item.sexo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("intervaloIdade")([item.idade_minima, item.idade_maxima])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)) + " "), _c('br'), _vm._v(" (" + _vm._s(_vm._f("diaDaSemana")(item.data_atendimento)) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("intervaloHoras")([item.hora_inicial, item.hora_final])))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "2px",
        "margin": "0"
      }
    }, [_c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos Distribuídos (Modelo)"
      }
    }, [_vm._v(_vm._s(item.quantidade_primeira_original))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos Disponíveis"
      }
    }, [_vm._v(_vm._s(item.quantidade_primeira))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c40233",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos Bloqueados"
      }
    }, [_vm._v(_vm._s(item.quantidade_primeira_bloqueada))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Atendimentos Consumidos"
      }
    }, [_vm._v(_vm._s(item.quantidade_primeira_consumida))])])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "2px",
        "margin": "0"
      }
    }, [_c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(4, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Retornos Distribuídos (Modelo)"
      }
    }, [_vm._v(_vm._s(item.quantidade_retorno_original))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Retornos Disponíveis"
      }
    }, [_vm._v(_vm._s(item.quantidade_retorno))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c40233",
        "color": "white"
      },
      attrs: {
        "title": "Retornos Bloquados"
      }
    }, [_vm._v(_vm._s(item.quantidade_retorno_bloqueada))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Retornos Consumidos"
      }
    }, [_vm._v(_vm._s(item.quantidade_retorno_consumida))])])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "2px",
        "margin": "0"
      }
    }, [_c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(5, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Locais Distribuídos (Modelo)"
      }
    }, [_vm._v(_vm._s(item.quantidade_local_original))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Locais Disponíveis"
      }
    }, [_vm._v(_vm._s(item.quantidade_local))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c40233",
        "color": "white"
      },
      attrs: {
        "title": "Locais Bloqueados"
      }
    }, [_vm._v(_vm._s(item.quantidade_local_bloqueada))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Locais Consumidos"
      }
    }, [_vm._v(_vm._s(item.quantidade_local_consumida))])])])])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Bloquear Atendimentos"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.bloquear(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-ban",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "title": "Criar Atendimentos"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.criar(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-plus",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "title": "Editar Atendimento"
      },
      on: {
        "click": function($event) {
          _vm.editar(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Atendimentos de procedimento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Filtros:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("Controle")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Profissional")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Idade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Horário")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Atendimentos")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Retornos")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Locais")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("M")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("M")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("M")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")])])])
}]}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box collapsed-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico do paciente "), (_vm.showInfo) ? _c('a', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Paciente possui agendamentos ainda não realizados.",
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('showModalNaoRealizados')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-info-circle"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade Solicitante")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSolicitante(unidadeSelecionada);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadePrestadora(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "tipo-profissional": "Solicitante"
    },
    on: {
      "setProfissionalSolicitanteSelecionado": function (profissional) {
        _vm.setProfissionalSolicitanteSelecionado(profissional);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional realizador")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "tipo-profissional": "Realizador"
    },
    on: {
      "setProfissionalRealizadorSelecionado": function (profissional) {
        _vm.setProfissionalRealizadorSelecionado(profissional);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional marcador")]), _vm._v(" "), _c('select-usuario', {
    attrs: {
      "nivel": "marcador"
    },
    on: {
      "setUsuarioSelecionado": function (usuario) {
        _vm.setUsuarioSelecionado(usuario);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação da solicitação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.MARCADA
    }
  }, [_vm._v("Marcada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.EM_REGULACAO
    }
  }, [_vm._v("Em regulação")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REGULADA
    }
  }, [_vm._v("Regulada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE
    }
  }, [_vm._v("Informação pendente")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL
    }
  }, [_vm._v("Informação adicional")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.NEGATIVADA
    }
  }, [_vm._v("Negativada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CONFIRMADA
    }
  }, [_vm._v("Confirmada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CANCELADA
    }
  }, [_vm._v("Cancelada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.FALTA
    }
  }, [_vm._v("Falta")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REALIZADA
    }
  }, [_vm._v("Realizada")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data da solicitação ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_solicitacao),
      expression: "filtros.data_solicitacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "",
      "id": ""
    },
    domProps: {
      "value": (_vm.filtros.data_solicitacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_solicitacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de realização")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_realizacao),
      expression: "filtros.data_realizacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "",
      "id": ""
    },
    domProps: {
      "value": (_vm.filtros.data_realizacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_realizacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getHistorico()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Histórico do sistema novo")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.historico.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('strong', {
      class: _vm._f("situacaoSolicitacaoColor")(item.solicitacao.situacao)
    }, [_vm._v("\n                            " + _vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)) + "\n                        ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.profissional.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.usuario.name))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.historico.from) + " até " + _vm._s(this.historico.to) + " de " + _vm._s(this.historico.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historico
    },
    on: {
      "pagination-change-page": _vm.getHistorico
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade Solicitante")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.unidade_solicitante),
      expression: "filtrosAntigo.unidade_solicitante"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.unidade_solicitante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "unidade_solicitante", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.unidade_realizadora),
      expression: "filtrosAntigo.unidade_realizadora"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.unidade_realizadora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "unidade_realizadora", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.procedimento),
      expression: "filtrosAntigo.procedimento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.procedimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "procedimento", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.profissional_solicitante),
      expression: "filtrosAntigo.profissional_solicitante"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.profissional_solicitante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "profissional_solicitante", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional realizador")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.profissional_realizador),
      expression: "filtrosAntigo.profissional_realizador"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.profissional_realizador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "profissional_realizador", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional marcador")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.profissional_marcador),
      expression: "filtrosAntigo.profissional_marcador"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.profissional_marcador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "profissional_marcador", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação da solicitação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.situacao),
      expression: "filtrosAntigo.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtrosAntigo, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.EM_ANALISE
    }
  }, [_vm._v("Em análise")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.APROVADA
    }
  }, [_vm._v("Aprovada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.CONFIRMADA
    }
  }, [_vm._v("Confirmada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.NEGADA
    }
  }, [_vm._v("Negada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.EM_PERICIA
    }
  }, [_vm._v("Em perícia")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.CANCELADA
    }
  }, [_vm._v("Cancelada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.REALIZADA
    }
  }, [_vm._v("Confirmada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.FALTA
    }
  }, [_vm._v("Falta")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.EM_SUPERVISAO
    }
  }, [_vm._v("Em supervisão")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.SUPERVISIONADO
    }
  }, [_vm._v("Supervisionado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.EM_EXTRAPOLACAO
    }
  }, [_vm._v("Em extrapolação")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.TFD
    }
  }, [_vm._v("TFD")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.FALTA_AUTOMATICA
    }
  }, [_vm._v("Falta automática")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data da solicitação ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.data_solicitacao),
      expression: "filtrosAntigo.data_solicitacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.data_solicitacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "data_solicitacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de realização")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.data_realizacao),
      expression: "filtrosAntigo.data_realizacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.data_realizacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "data_realizacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getHistoricoAntigo()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Histórico importado da base de dados anterior")]), _vm._v(" "), (this.hasPermission('paciente.read')) ? _c('router-link', {
    staticClass: "btn btn-sm btn-warning",
    staticStyle: {
      "margin": "0px 0px 5px 10px"
    },
    attrs: {
      "tag": "a",
      "to": "/integracao/pacientes"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Ir para o CADASTRO DE PACIENTES no módulo de integração com o sistema antigo ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoAntigo.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('strong', {
      class: _vm._f("situacaoSolicitacaoAntigaColor")(item.situacao)
    }, [_vm._v("\n                            " + _vm._s(_vm._f("situacaoSolicitacaoAntiga")(item.situacao)) + "\n                        ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade_realizadora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_realizacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_realizador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_solicitacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_marcador))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.historicoAntigo.from) + " até " + _vm._s(this.historicoAntigo.to) + " de " + _vm._s(this.historicoAntigo.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historicoAntigo
    },
    on: {
      "pagination-change-page": _vm.getHistoricoAntigo
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
}]}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecalho-contrato', {
    attrs: {
      "contrato-id": _vm.$route.params.contratoId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subgrupo")]), _vm._v(" "), _c('select-subgrupo', {
    attrs: {
      "contrato-id": _vm.$route.params.contratoId
    },
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.sexo),
      expression: "dados.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Feminino")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade mínima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_minima),
      expression: "dados.idade_minima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_minima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_maxima),
      expression: "dados.idade_maxima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_maxima", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo Consumo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_consumo),
      expression: "dados.tipo_consumo"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_consumo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.trocaTipoConsumo]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Por Procedimento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Por Paciente")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Atendimentos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_atendimento),
      expression: "dados.quantidade_atendimento"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.dados.tipo_consumo != 0,
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_atendimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_atendimento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Local")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_local),
      expression: "dados.quantidade_local"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.dados.tipo_consumo != 0,
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Max. Pacientes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_paciente),
      expression: "dados.quantidade_paciente"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.dados.tipo_consumo != 1,
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_paciente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_paciente", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Dia(s)")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Dia da semana: ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "select-dias",
      "placeholder": "Clique para selecionar o(s) dia(s)...",
      "multiple": "",
      "options": _vm.selectDias
    },
    model: {
      value: (_vm.dias),
      callback: function($$v) {
        _vm.dias = $$v
      },
      expression: "dias"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Hora inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.hora_inicial),
      expression: "dados.hora_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.hora_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "hora_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Hora final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.hora_final),
      expression: "dados.hora_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.hora_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "hora_final", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-reply"
  }), _vm._v("\tVoltar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")])])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo atendimento de subgrupo")])])])
}]}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.boxTitle))])]), _vm._v(" "), (_vm.dados.logs && _vm.dados.logs.length > 0) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.showHistorico = !_vm.showHistorico
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _vm._v(" Histórico de Atualizações\n          ")]) : _vm._e()]), _vm._v(" "), (!_vm.showHistorico) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("CPF "), (this.$store.state.user.nivel == 'regulador' || this.$store.state.user.nivel == 'administrador') ? _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "right",
      "margin": "0px 0px 0px 15px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.withoutCpf),
      expression: "withoutCpf"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.withoutCpf) ? _vm._i(_vm.withoutCpf, null) > -1 : (_vm.withoutCpf)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.withoutCpf,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.withoutCpf = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.withoutCpf = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.withoutCpf = $$c
        }
      }
    }
  }), _vm._v("Não informar CPF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.dados.cpf),
      expression: "dados.cpf",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.withoutCpf ? '' : 'required|validarCpf'),
      expression: "withoutCpf ? '' : 'required|validarCpf'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$store.state.user.nivel == 'marcador',
      "type": "text",
      "name": "cpf"
    },
    domProps: {
      "value": (_vm.dados.cpf)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.dados, "cpf", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("cpf")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("nome")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome Social")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome_social),
      expression: "dados.nome_social"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome_social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome_social)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome_social", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nº CEMAE")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cemae),
      expression: "dados.cemae"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cemae",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cemae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cemae", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("cemae")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cartão SUS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cartao_sus),
      expression: "dados.cartao_sus"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "15",
      "name": "cartao-sus",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cartao_sus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cartao_sus", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("cartao-sus")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_nascimento),
      expression: "dados.data_nascimento"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data-nascimento",
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_nascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_nascimento", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("data-nascimento")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Naturalidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.naturalidade),
      expression: "dados.naturalidade"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "naturalidade",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.naturalidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "naturalidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##########'),
      expression: "'##########'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.rg),
      expression: "dados.rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Orgão emissor do RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.orgao_emissor_rg),
      expression: "dados.orgao_emissor_rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.orgao_emissor_rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "orgao_emissor_rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("UF do RG")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.uf_rg),
      expression: "dados.uf_rg"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "uf_rg", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o UF...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AC"
    }
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    }
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    }
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GO"
    }
  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    }
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    }
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("TO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de emissão do RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_emissao_rg),
      expression: "dados.data_emissao_rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_emissao_rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_emissao_rg", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.sexo),
      expression: "dados.sexo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "sexo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("Feminino")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("sexo")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Estado civil")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.estado_civil),
      expression: "dados.estado_civil"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estado-civil"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "estado_civil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.ESTADO_CIVIL.SOLTEIRO
    }
  }, [_vm._v("Solteiro (a)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.ESTADO_CIVIL.CASADO
    }
  }, [_vm._v("Casado (a)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.ESTADO_CIVIL.DESQUITADO
    }
  }, [_vm._v("Desquitado (a)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.ESTADO_CIVIL.DIVORCIADO
    }
  }, [_vm._v("Divorciado (a)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.ESTADO_CIVIL.VIUVO
    }
  }, [_vm._v("Viúvo (a)")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("estado-civil")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:13'),
      expression: "'required|min:13'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['(##)#####-####', '(##)####-####']),
      expression: "['(##)#####-####', '(##)####-####']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.telefone),
      expression: "dados.telefone"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "telefone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "telefone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("telefone")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ocupação")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.ocupacao),
      expression: "dados.ocupacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.ocupacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "ocupacao", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome da mãe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome_mae),
      expression: "dados.nome_mae"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$store.state.user.nivel == 'marcador',
      "name": "nome-mae",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome_mae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome_mae", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("nome-mae")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome do pai")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome_pai),
      expression: "dados.nome_pai"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome_pai)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome_pai", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome do responsável")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome_responsavel),
      expression: "dados.nome_responsavel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome_responsavel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome_responsavel", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['#####-###']),
      expression: "['#####-###']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cep),
      expression: "dados.cep"
    }],
    ref: "cep",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$store.state.user.nivel == 'marcador',
      "name": "cep",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cep)
    },
    on: {
      "blur": function($event) {
        _vm.getEndereco()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cep", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("cep")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.endereco),
      expression: "dados.endereco"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.numero_endereco),
      expression: "dados.numero_endereco"
    }],
    ref: "numero_endereco",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.numero_endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "numero_endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.bairro),
      expression: "dados.bairro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "bairro", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.complemento_endereco),
      expression: "dados.complemento_endereco"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.complemento_endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "complemento_endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cidade),
      expression: "dados.cidade"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("UF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.uf),
      expression: "dados.uf"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.uf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "uf", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de certidão")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_certidao_auxiliar),
      expression: "dados.tipo_certidao_auxiliar"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_certidao_auxiliar", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_CERTIDAO.NASCIMENTO
    }
  }, [_vm._v("Nascimento")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_CERTIDAO.CASAMENTO
    }
  }, [_vm._v("Casamento")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_CERTIDAO.SEPARACAO
    }
  }, [_vm._v("Separação/Divórcio")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cartório")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cartorio_auxiliar),
      expression: "dados.cartorio_auxiliar"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cartorio_auxiliar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cartorio_auxiliar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Livro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.livro_auxiliar),
      expression: "dados.livro_auxiliar"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.livro_auxiliar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "livro_auxiliar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Folha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.folha_auxiliar),
      expression: "dados.folha_auxiliar"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.folha_auxiliar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "folha_auxiliar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Registro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.registro_auxiliar),
      expression: "dados.registro_auxiliar"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.registro_auxiliar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "registro_auxiliar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de emissão")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_emissao_auxiliar),
      expression: "dados.data_emissao_auxiliar"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_emissao_auxiliar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_emissao_auxiliar", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "situacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SITUACAO.ATIVA
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO.INATIVA
    }
  }, [_vm._v("Inativo")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("situacao")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Anotações")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.withoutCpf ? 'required' : ''),
      expression: "withoutCpf ? 'required' : ''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.anotacoes),
      expression: "dados.anotacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7"
    },
    domProps: {
      "value": (_vm.dados.anotacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "anotacoes", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.withoutCpf) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Justifique por qual motivo o cadastro está sendo realizado sem CPF")]) : _vm._e()])])]), _vm._v(" "), (_vm.withoutCpf) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("GEP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.gep),
      expression: "dados.gep"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.gep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "gep", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Informe o número do GEP referente ao cadastro SEM CPF")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showHistorico) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.dados.logs), function(log) {
    return _c('div', {
      key: log.id,
      staticClass: "box box-default"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h4', [_c('b', [_vm._v(_vm._s(log.usuario.name) + " - " + _vm._s(_vm._f("dataFormatadaHora")(log.created_at)))])])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('p', {
      staticStyle: {
        "white-space": "pre-line"
      }
    }, [_vm._v(_vm._s(log.descricao))])])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_c('strong', [_vm._v("Art. 299")]), _vm._v(" - Omitir, em documento público ou particular, declaração que dele devia constar, ou nele inserir ou fazer inserir declaração falsa ou diversa da que devia ser escrita, com o fim de prejudicar direito, criar obrigação ou alterar a verdade sobre fato juridicamente relevante:")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Pena")]), _vm._v(" - reclusão, de um a cinco anos, e multa, se o documento é público, e reclusão de um a três anos, e multa, se o documento é particular. (Vide Lei n° 7.209, de 1984)")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Parágrafo único")]), _vm._v(" - Se o agente é funcionário público, e comete o crime prevalecendo-se do cargo, ou se a falsificação ou alteração é de assentamento de registro civil, aumenta-se a pena de sexta parte.\n                (Decreto-Lei nº 2.848/40)\n              ")])])])
}]}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('solicitacao-detalhes', {
    attrs: {
      "show-info": _vm.showInfo,
      "solicitacao": _vm.solicitacao
    },
    on: {
      "showModalNaoRealizados": function($event) {
        _vm.showModalNaoRealizados = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box collapsed-box "
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body altura-hostorico"
  }, [_c('solicitacao-historico', {
    attrs: {
      "solicitacao": _vm.solicitacao
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box collapsed-box "
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Histórico do sistema novo")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.historico.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.profissional.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.usuario.name))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.historico.from) + " até " + _vm._s(this.historico.to) + " de " + _vm._s(this.historico.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historico
    },
    on: {
      "pagination-change-page": _vm.getHistorico
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Histórico do sistema antigo")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoAntigo.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacaoAntiga")(item.situacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade_realizadora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_realizacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_realizador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_solicitacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_marcador))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.historicoAntigo.from) + " até " + _vm._s(this.historicoAntigo.to) + " de " + _vm._s(this.historicoAntigo.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historicoAntigo
    },
    on: {
      "pagination-change-page": _vm.getHistoricoAntigo
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])]), _vm._v(" "), (_vm.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.EM_REGULACAO || _vm.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.informacaoPendente
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" Solicitar informação pendente")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.negativar
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Negativar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.agendar
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Atendimentos")])])]) : _vm._e()])])])])]), _vm._v(" "), _c('modal-nao-realizados', {
    attrs: {
      "regulacao": true,
      "nao-realizados": _vm.naoRealizados,
      "show": _vm.showModalNaoRealizados
    },
    on: {
      "close": function($event) {
        _vm.showModalNaoRealizados = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Solicitação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico da Solicitação")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico do Paciente")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
}]}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com NOME ou CÓDIGO do procedimento"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filtrar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo_limite),
      expression: "filtros.tipo_limite"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo_limite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Tipo de Limite--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Geral")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.filtrar
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])])])
},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Detalhes da solicitação")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab"
    }
  }, [_vm._v("Solicitação")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab"
    }
  }, [_vm._v("Boleto")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#tab_3",
      "data-toggle": "tab"
    }
  }, [_vm._v("Histórico")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1"
    }
  }, [_c('solicitacao-detalhes', {
    attrs: {
      "solicitacao": _vm.$props.solicitacao
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_2"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm pull-right",
    attrs: {
      "to": '/boleto/' + _vm.$props.solicitacao.id,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  })])], 1)]), _vm._v(" "), _c('solicitacao-boleto', {
    attrs: {
      "solicitacao": _vm.$props.solicitacao
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_3"
    }
  }, [_c('solicitacao-historico', {
    attrs: {
      "solicitacao": _vm.$props.solicitacao
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE),
      expression: "$props.solicitacao.situacao == SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE"
    }],
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.addInformacao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" Adicionar informação")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.REGULADA),
      expression: "$props.solicitacao.situacao == SITUACAO_SOLICITACAO.REGULADA"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.confirmarSolicitacao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar solicitação")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.verificarCancelamento()),
      expression: "verificarCancelamento()"
    }],
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.cancelarSolicitacao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar solicitação")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")])])])])])]), _vm._v(" "), _c('modal-confirmar-cancelar', {
    attrs: {
      "solicitacao": _vm.$props.solicitacao,
      "adicionar-informacao": _vm.adicionarInformacao,
      "confirmar": _vm.confirmar,
      "cancelar": _vm.cancelar,
      "show": _vm.showModalConfirmarCancelar
    },
    on: {
      "informacaoAdicionada": function (solicitacao) { return _vm.informacaoAdicionada(solicitacao); },
      "solicitacaoConfirmada": function (solicitacao) { return _vm.solicitacaoConfirmada(solicitacao); },
      "solicitacaoCancelada": function (solicitacao) { return _vm.solicitacaoCancelada(solicitacao); },
      "close": function($event) {
        _vm.showModalConfirmarCancelar = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade de Origem do Cadastro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_unidade
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cadastrado por")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_login
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("situacao")(_vm.paciente.st_cidadao)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_pessoa
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nr_telefone
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cartão SUS")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nr_cartao_sus
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de nascimento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.paciente.dt_nascimento)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.tp_sexo == 0 ? 'Masculino' : 'Feminino'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Estado civil")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("estadoCivil")(_vm.paciente.st_estado_civil)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Naturalidade")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_naturalidade
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de certidão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("tipoCertidao")(_vm.paciente.tp_certidao)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cartório")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_cartorio_certidao
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Livro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nr_livro_certidao
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nº da folha")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nr_folha_certidao
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nº registro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nr_termo_certidao
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Emissão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.paciente.dt_emissao_certidao)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nr_cpf
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("RG")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nr_rg
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Dt. Emissão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.paciente.dt_emissao_rg)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Orgão emissor")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.sg_orgao_rg
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("UF")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.sg_uf_rg
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do responsável")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_responsavel
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ocupação")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_ocupacao
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome da mãe")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_mae
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do pai")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_pai
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nr_cep
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de logradouro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_tipo_logradouro
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Logradouro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_logradouro
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_complemento
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nr_domicilio
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_bairro
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Distrito")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_distrito
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Município")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.nm_municipio
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("UF")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.paciente.sg_estado
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "a",
      "to": '/integracao/pacientes'
    }
  }, [_c('span', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Detalhes do cadastro")])])])
}]}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/administracao/contratos/novo"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com NOME DA UNIDADE"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.categoria_unidade),
      expression: "filtros.categoria_unidade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "categoria_unidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Categoria da Unidade--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Pública (Local)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Município Pactuado (PPI)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Privada")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo),
      expression: "filtros.tipo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Tipo do Contrato--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Solicitante")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Prestador")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Situação--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.getDataTable
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('contratos.id')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'contratos.id' ? ("fa fa-sort-numeric" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                                                Unidade\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('unidades.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'unidades.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Ação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("categoriaUnidade")(item.categoria)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoContrato")(item.tipo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_inicial)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_final)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacao")(item.situacao)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/contratos/atualizacao/" + (item.id)),
        "title": "Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/contratos/procedimentos/" + (item.id)),
        "title": " Procedimentos do Contrato"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/contratos/subgrupos/" + (item.id)),
        "title": "Subgrupos do Contrato"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list-alt",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Contratos")])])
}]}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Entre com NOME, CNPJ ou CNES da UNIDADE"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.getDataTable
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                                            ID\n                                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('contratos.id')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'contratos.id' ? ("fa fa-sort-numeric" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                                            Unidade\n                                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('unidades.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'unidades.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/agendas/visualizar-procedimentos/" + (item.id)),
        "title": "Procedimentos do Contrato"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/agendas/visualizar-subgrupos/" + (item.id)),
        "title": "Subgrupos do Contrato"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list-alt",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Agenda")])])])
}]}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Bloquear Atendimentos de Procedimento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_primeira_original
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_primeira_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_primeira_bloqueada),
      expression: "dados.quantidade_primeira_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_primeira_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_primeira_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_retorno_original
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_retorno_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_retorno_bloqueada),
      expression: "dados.quantidade_retorno_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_retorno_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_retorno_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_local_original
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_local_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_local_bloqueada),
      expression: "dados.quantidade_local_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.showModalEnviarRegulacao) ? _c('modal-enviar-regulacao', {
    on: {
      "close": function($event) {
        _vm.showModalEnviarRegulacao = false
      },
      "enviaRegulacao": function (motivo) { return _vm.enviaRegulacao(motivo); }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nav-tabs-custom"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-bottom": "20px",
      "z-index": "9999999"
    }
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")]), _vm._v(" "), (!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar ")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.informacaoPendente
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" Solicitar informação pendente")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.negativar
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Negativar")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Regular")]) : _vm._e(), _vm._v(" "), (!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.showModalEnviarRegulacao = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Regulação")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table listbox"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima"
  }, _vm._l((_vm.vagas_unidade), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.getProfissionaisAndDiasByUnidade(index, item[0].unidade_id)
        }
      }
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      class: {
        'ativa': _vm.selecionados.indexUnidadeAtiva === index
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("uppercase")(item[0].unidade.nome)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.state.user.nivel == 'regulador' || _vm.$store.state.user.nivel == 'administrador'),
        expression: "$store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador'"
      }]
    }, [_vm._v("Atendimentos Disponíveis:\n                           "), (_vm.$props.tipoVaga == 0) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasPrimeira(item)))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 1) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasRetorno(item)))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 2) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasLocal(item)))]) : _vm._e()])])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table listbox"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima"
  }, _vm._l((_vm.vagas_profissional), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.getDiasByUnidadeAndProfissional(index, item[0].profissional_id)
        }
      }
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      class: {
        'ativa': _vm.selecionados.indexProfissionalAtivo === index
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("uppercase")(item[0].profissional.nome)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.state.user.nivel == 'regulador' || _vm.$store.state.user.nivel == 'administrador'),
        expression: "$store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador'"
      }]
    }, [_vm._v("Atendimentos Disponíveis:\n                           "), (_vm.$props.tipoVaga == 0) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasPrimeira(item)))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 1) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasRetorno(item)))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 2) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasLocal(item)))]) : _vm._e()])])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "260px"
    }
  }, [(_vm.optionsCalendario.enabledDates) ? _c('date-picker', {
    attrs: {
      "config": _vm.optionsCalendario
    },
    on: {
      "dp-change": _vm.getProfissionaisByUnidadeAndDia
    },
    model: {
      value: (_vm.selecionados.data),
      callback: function($$v) {
        _vm.$set(_vm.selecionados, "data", $$v)
      },
      expression: "selecionados.data"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table listbox"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima listbox"
  }, _vm._l((_vm.vagas_filtradas), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.selecionaVaga(index)
        }
      }
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      class: {
        'ativa': _vm.selecionados.indexVagaAtiva === index
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("uppercase")(item.unidade.nome)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Data:")]), _vm._v("\n                            " + _vm._s(_vm._f("dataFormatada")(item.data_atendimento)) + " à partir das\n                            "), _c('b', [_vm._v(_vm._s(_vm._f("horaFormatada")(item.hora_inicial)))]), _vm._v(" horas.\n                          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Profissional:")]), _vm._v("\n                            " + _vm._s(item.profissional.nome) + "\n                          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.state.user.nivel == 'regulador' || _vm.$store.state.user.nivel == 'administrador'),
        expression: "$store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador'"
      }]
    }, [_c('strong', [_vm._v("Atendimentos Disponíveis:")]), _vm._v(" "), (_vm.$props.tipoVaga == 0) ? _c('strong', [_vm._v(" " + _vm._s(item.quantidade_primeira))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 1) ? _c('strong', [_vm._v(" " + _vm._s(item.quantidade_retorno))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 2) ? _c('strong', [_vm._v(" " + _vm._s(item.quantidade_local))]) : _vm._e()]), _vm._v(" "), ((_vm.$store.state.user.nivel == 'regulador' || _vm.$store.state.user.nivel == 'administrador') && (_vm.idadePacienteSelecionado < item.idade_minima || _vm.idadePacienteSelecionado > item.idade_maxima)) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('span', [_c('strong', [_vm._v("Idade Mínima:")]), _vm._v("\n                                " + _vm._s(item.idade_minima) + "\n                              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Idade Máxima:")]), _vm._v("\n                                " + _vm._s(item.idade_maxima) + "\n                              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "alert alert-warning alert-dismissible"
    }, [_vm._m(5, true), _vm._v("\n                                A idade do paciente (" + _vm._s(_vm.idadePacienteSelecionado) + ") não obedece os limites do atendimento.\n                              ")])])]) : _vm._e(), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.$store.state.user.nivel == 'regulador' || _vm.$store.state.user.nivel == 'administrador') && (item.cotaSolicitante == false || item.cotaPrestador == false || item.vagaPrestador == false)),
        expression: "($store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador') && (item.cotaSolicitante == false || item.cotaPrestador == false || item.vagaPrestador == false)"
      }],
      staticStyle: {
        "color": "red"
      }
    }, [_c('strong', [_vm._v("ATENÇÃO (EXTRAPOLAÇÃO): O atendimento selecionado possui as seguintes restrições: ")]), _vm._v(" "), _c('ul', [(item.cotaSolicitante == false) ? _c('li', [_c('strong', [_vm._v("Não há limite (cota) para a unidade solicitante!")])]) : _vm._e(), _vm._v(" "), (item.cotaPrestador == false) ? _c('li', [_c('strong', [_vm._v("Não há limite (cota) para a unidade prestadora!")])]) : _vm._e(), _vm._v(" "), (item.vagaPrestador == false) ? _c('li', [_c('strong', {
      staticStyle: {
        "font-size": "30px",
        "text-decoration": "blink"
      }
    }, [_vm._v("Não há atendimento (vaga) disponível!")])]) : _vm._e()])])])])
  }))])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-bottom": "20px",
      "z-index": "9999999"
    }
  }, [(!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar\n\t\t\t  ")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.informacaoPendente
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" Solicitar informação pendente")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.negativar
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Negativar")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Regular\n\t\t\t  ")]) : _vm._e(), _vm._v(" "), (!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.showModalEnviarRegulacao = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Regulação\n\t\t\t  ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar\n      ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab"
    }
  }, [_vm._v("Selecione o atendimento")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Selecione uma unidade")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Selecione um profissional")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('b', [_vm._v("Selecione uma data")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Atendimentos")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "icon fa fa-warning"
  }), _vm._v(" Atenção!\n                                ")])
}]}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Editar Atendimento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.item.sexo),
      expression: "$props.item.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$props.item, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Feminino")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('idade_minima')
    }
  }, [_c('label', [_vm._v("Idade mínima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.item.idade_minima),
      expression: "$props.item.idade_minima"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$props.item.idade_maxima ? 'required|max_value:' + _vm.$props.item.idade_maxima : ''),
      expression: "$props.item.idade_maxima ? 'required|max_value:' + $props.item.idade_maxima : ''"
    }],
    ref: "idade_minima",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "idade_minima"
    },
    domProps: {
      "value": (_vm.$props.item.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.item, "idade_minima", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('idade_minima')),
      expression: "errors.has('idade_minima')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Deve ser menor que a idade máxima")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('idade_maxima')
    }
  }, [_c('label', [_vm._v("Idade máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.item.idade_maxima),
      expression: "$props.item.idade_maxima"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$props.item.idade_minima ? 'required|min_value:' + _vm.$props.item.idade_minima : ''),
      expression: "$props.item.idade_minima ? 'required|min_value:' + $props.item.idade_minima : ''"
    }],
    ref: "idade_maxima",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "110",
      "name": "idade_maxima"
    },
    domProps: {
      "value": (_vm.$props.item.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.item, "idade_maxima", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('idade_maxima')),
      expression: "errors.has('idade_maxima')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Deve ser maior que a idade mínima")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('data')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.item.data_atendimento),
      expression: "$props.item.data_atendimento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "data",
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "DATA",
      "name": "data"
    },
    domProps: {
      "value": (_vm.$props.item.data_atendimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.item, "data_atendimento", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data')),
      expression: "errors.has('data')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("data")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('hora_inicial')
    }
  }, [_c('label', [_vm._v("Hora inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.item.hora_inicial),
      expression: "$props.item.hora_inicial"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "hora_inicial",
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "name": "hora_inicial"
    },
    domProps: {
      "value": (_vm.$props.item.hora_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.item, "hora_inicial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hora_inicial')),
      expression: "errors.has('hora_inicial')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("hora_inicial")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('hora_final')
    }
  }, [_c('label', [_vm._v("Hora final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.item.hora_final),
      expression: "$props.item.hora_final"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "hora_final",
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "name": "hora_final"
    },
    domProps: {
      "value": (_vm.$props.item.hora_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.item, "hora_final", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hora_final')),
      expression: "errors.has('hora_final')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("hora_final")))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar\n\t\t\t\t\t\t")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com NOME ou CÓDIGO do procedimento"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filtrar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo_limite),
      expression: "filtros.tipo_limite"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo_limite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Tipo de Limite--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Geral")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.filtrar
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])])])
},staticRenderFns: []}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Duplicação de Marcação")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('strong', [_vm._v("ATENÇÃO:")]), _vm._v(" Encontra-se em aberto uma ou mais marcações com o procedimento selecionado para esse paciente, conforme pode ser visto na tabela abaixo:\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Número")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Data da Solicitação")]), _vm._v(" "), _c('th', [_vm._v("Situação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.solicitacoesNaoResolvidas), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itens[0].contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(item.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.situacao)))])])
  }))]), _vm._v(" "), _c('p', [_vm._v("\n          Para continuar assim mesmo, informe uma\n          "), _c('strong', [_vm._v("JUSTIFICATIVA")]), _vm._v(" e sua\n          "), _c('strong', [_vm._v("SENHA")]), _vm._v(" nos campos abaixo, e clique em confirmar:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justificativa),
      expression: "justificativa"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.justificativa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.justificativaInvalida),
      expression: "justificativaInvalida"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Informe uma justificativa")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Digite sua senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senha),
      expression: "senha"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center",
      "font-size": "20px",
      "padding": "20px"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.senha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.senha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.senhaInvalida),
      expression: "senhaInvalida"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Senha inválida")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioSelecionado.name),
      expression: "usuarioSelecionado.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.usuarioSelecionado.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuarioSelecionado, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Usuário")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome do usuário e pressione enter."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t\t")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "tipo": _vm.TIPO_CONTRATO.PRESTADOR
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(
          unidadeSelecionada
        );
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('nivel'),
    }
  }, [_c('label', {
    attrs: {
      "for": "nivel"
    }
  }, [_vm._v("Perfil:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nivel),
      expression: "filtros.nivel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nivel",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "nivel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "administrador"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tAdministrador\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "regulador"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tRegulador\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "marcador"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tMarcador\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "prestador"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tPrestador\n\t\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('situacao'),
    }
  }, [_c('label', {
    attrs: {
      "for": "situacao"
    }
  }, [_vm._v("Situação:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "situacao",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "box-footer text-right"
  }, [(_vm.pdf) ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tRecarregar PDF\n\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Usuários",
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar\n\t\t\t\t\t\t")])]), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nivel))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("unidades")(item.unidades)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("situacao")(item.situacao)) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])
  }))]), _vm._v(" "), (
    _vm.dataTable.data &&
    _vm.dataTable.data.length > 0
  ) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tMostrando\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(this.dataTable.from) + " até\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(this.dataTable.to) + " de\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(this.dataTable.total) + " registros\n\t\t\t\t\t\t\t\t\t\tencontrados.\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tPDF\n\t\t\t\t\t\t\t\t\t\t")])])]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Usuários")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tUsuário\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tEmail\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tNível\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tUnidades\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tSituação\n\t\t\t\t\t\t\t\t\t\t\t")])])])
}]}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        $event.stopPropagation();
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Novo atendimento de subgrupo")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('subgrupo')
    }
  }, [_c('label', [_vm._v("Subgrupo")]), _vm._v(" "), (!_vm.dados.exibiInput) ? _c('select-subgrupo', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "subgrupo",
      "show-text-danger-subgrupo": _vm.showTextDangerSubgrupo,
      "contrato-id": _vm.$route.params.distribuicaoContratoId
    },
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dados.exibiInput) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "true",
      "type": "text"
    },
    domProps: {
      "value": _vm.dados.nome_subgrupo
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subgrupo')),
      expression: "errors.has('subgrupo')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('subgrupo')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.sexo),
      expression: "dados.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Feminino")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('idade_minima')
    }
  }, [_c('label', [_vm._v("Idade mínima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_minima),
      expression: "dados.idade_minima"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.idade_maxima ? 'required|max_value:' + _vm.dados.idade_maxima : '')),
      expression: "(dados.idade_maxima ? 'required|max_value:' + dados.idade_maxima : '')"
    }],
    ref: "idade_minima",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "idade_minima"
    },
    domProps: {
      "value": (_vm.dados.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_minima", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('idade_minima')),
      expression: "errors.has('idade_minima')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Deve ser menor que a idade máxima")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('idade_maxima')
    }
  }, [_c('label', [_vm._v("Idade máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_maxima),
      expression: "dados.idade_maxima"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.idade_minima ? 'required|min_value:' + _vm.dados.idade_minima : '')),
      expression: " (dados.idade_minima ? 'required|min_value:' + dados.idade_minima : '')"
    }],
    ref: "idade_maxima",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "110",
      "name": "idade_maxima"
    },
    domProps: {
      "value": (_vm.dados.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_maxima", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('idade_maxima')),
      expression: "errors.has('idade_maxima')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Deve ser maior que a idade mínima")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo Consumo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_consumo),
      expression: "dados.tipo_consumo"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_consumo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.trocaTipoConsumo]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Por Procedimento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Por Paciente")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Atendimentos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_atendimento),
      expression: "dados.quantidade_atendimento"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.dados.tipo_consumo != 0,
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_atendimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_atendimento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Local")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_local),
      expression: "dados.quantidade_local"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.dados.tipo_consumo != 0,
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Max. Pacientes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_paciente),
      expression: "dados.quantidade_paciente"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.dados.tipo_consumo != 1,
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_paciente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_paciente", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('data')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_atendimento),
      expression: "dados.data_atendimento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "data",
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "DATA",
      "name": "data"
    },
    domProps: {
      "value": (_vm.dados.data_atendimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_atendimento", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data')),
      expression: "errors.has('data')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('data')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('hora_inicial')
    }
  }, [_c('label', [_vm._v("Hora inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.hora_inicial),
      expression: "dados.hora_inicial"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "hora_inicial",
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "name": "hora_inicial"
    },
    domProps: {
      "value": (_vm.dados.hora_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "hora_inicial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hora_inicial')),
      expression: "errors.has('hora_inicial')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('hora_inicial')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('hora_final')
    }
  }, [_c('label', [_vm._v("Hora final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.hora_final),
      expression: "dados.hora_final"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "hora_final",
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "name": "hora_final"
    },
    domProps: {
      "value": (_vm.dados.hora_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "hora_final", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hora_final')),
      expression: "errors.has('hora_final')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('hora_final')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert'), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.boxTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de Unidade")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.unidade_tipo_id),
      expression: "dados.unidade_tipo_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "unidade_tipo_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Selecione --")]), _vm._v(" "), _vm._l((_vm.tiposUnidade), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.categoria),
      expression: "dados.categoria"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Pública (Local)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Município Pactuado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Privada")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("CNPJ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##.###.###/####-##'),
      expression: "'##.###.###/####-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cnpj),
      expression: "dados.cnpj"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cnpj", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("CNES")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cnes),
      expression: "dados.cnes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.cnes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cnes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##)#####-####', '(##)####-####']),
      expression: "['(##)#####-####', '(##)####-####']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.telefone),
      expression: "dados.telefone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "telefone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['#####-###']),
      expression: "['#####-###']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cep),
      expression: "dados.cep"
    }],
    ref: "cep",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cep)
    },
    on: {
      "blur": function($event) {
        _vm.getEndereco()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cep", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.endereco),
      expression: "dados.endereco"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.numero_endereco),
      expression: "dados.numero_endereco"
    }],
    ref: "numero_endereco",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.numero_endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "numero_endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.bairro),
      expression: "dados.bairro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "bairro", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.complemento_endereco),
      expression: "dados.complemento_endereco"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.complemento_endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "complemento_endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ponto de referência")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.ponto_referencia),
      expression: "dados.ponto_referencia"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.ponto_referencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "ponto_referencia", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cidade),
      expression: "dados.cidade"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("UF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.uf),
      expression: "dados.uf"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.uf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "uf", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    class: {
      'has-error': _vm.showTextDangerTipo
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTipo
    }
  }, [_vm._v("Permite agendamentos para pacientes de outros municípios?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.paciente_outro_municipio),
      expression: "dados.paciente_outro_municipio"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "paciente_outro_municipio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("SIM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("NÃO")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Anotações")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.anotacoes),
      expression: "dados.anotacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7"
    },
    domProps: {
      "value": (_vm.dados.anotacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "anotacoes", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['esc']),
      expression: "['esc']"
    }],
    on: {
      "shortkey": function($event) {
        _vm.showModal = false
      },
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.up()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.down()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.enter()
      }]
    }
  }, [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerMarcador
    },
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.$props.nomeMarcadorRecuperado ? _vm.$props.nomeMarcadorRecuperado : _vm.marcadorSelecionado.nome
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', '2']),
      expression: "['alt', '2']"
    }],
    ref: "btnBuscarMarcador",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerMarcador,
      'btn-default': !_vm.$props.showTextDangerMarcador
    },
    attrs: {
      "type": "button"
    },
    on: {
      "shortkey": function($event) {
        (_vm.showModal = true), _vm.focoNomeMarcador()
      },
      "click": function($event) {
        (_vm.showModal = true), _vm.focoNomeMarcador()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerMarcador,
      'btn-default': !_vm.$props.showTextDangerMarcador
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Marcador")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do Marcador")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.name),
      expression: "filtros.name"
    }],
    ref: "inputMarcador",
    staticClass: "form-control",
    attrs: {
      "title": "[ ctrl + b ] Para pesquisar",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Login do Marcador")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.login),
      expression: "filtros.login"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "login", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['ctrl', 'b']),
      expression: "['ctrl', 'b']"
    }],
    staticClass: "btn btn-default btn-block",
    attrs: {
      "title": "[ ctrl + b ] Para pesquisar"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      },
      "shortkey": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      class: {
        ativa: index === _vm.marcadorSelecionadoIndex
      },
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    ref: "btnMarcador",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getById()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código da solicitação")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigo),
      expression: "codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Paciente")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cartão do SUS")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.solicitacao.paciente.cartao_sus
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.solicitacao.paciente.nome
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nascimento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.solicitacao.paciente.data_nascimento)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("sexo")(_vm.solicitacao.paciente.sexo)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.solicitacao.paciente.endereco != '' ? ((_vm.solicitacao.paciente.endereco) + ", " + (_vm.solicitacao.paciente.numero_endereco) + " - B. " + (_vm.solicitacao.paciente.bairro) + " - " + (_vm.solicitacao.paciente.cidade.nome) + "-" + (_vm.solicitacao.paciente.cidade.uf.uf)) : ''
    }
  })])])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Solicitação")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data da solicitação")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("dataHoraFormatada")(_vm.solicitacao.created_at)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de consulta")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("tipoConsulta")(_vm.solicitacao.itens[0].tipo_consulta)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("situacaoSolicitacao")(_vm.solicitacao.situacao)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.solicitacao.itens[0].contrato_procedimento.contrato.unidade.nome
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.solicitacao.profissional.nome
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimentos")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.solicitacao.itens), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))])])
  }))])])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Agendamento / Internação")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.solicitacao.itens[0].contrato_procedimento_atendimento.profissional.nome : 'Sem profissional'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.dataRealizacao)
    }
  })])])])])]), _vm._v(" "), (_vm.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.MARCADA || _vm.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CONFIRMADA) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-8 col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block pull-right",
    attrs: {
      "v-show": true
    },
    on: {
      "click": function($event) {
        _vm.atualizarSituacao(_vm.SITUACAO_SOLICITACAO.REALIZADA, 'Confirmar atendimento?')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-check"
  }), _vm._v(" Atendido")])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Atendido / Falta")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Nome")])])])
}]}

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-container"
    }
  }, [_c('div', {
    staticClass: "login login-with-news-feed"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitLogin($event)
      }
    }
  }, [_c('flash-message', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "transitionIn": "animated swing"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group m-b-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    ref: "username",
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": "Usuário",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-b-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "password",
      "placeholder": "Senha",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-buttons"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.finalizado
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tEntrar\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("© PMVC - 2018")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('head', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "../../static/css/style.min.css"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-feed"
  }, [_c('div', {
    staticClass: "news-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(675),
      "data-id": "login-cover-image",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "news-caption"
  }, [_c('h4', {
    staticClass: "caption-title"
  }, [_c('i', {
    staticClass: "ion-asterisk m-r-15 fa-2x pull-left"
  }), _vm._v("\n\t\t\t\t\t\t\tCentral de Marcação de Consultas\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "brand"
  }, [_c('img', {
    staticClass: "logo-protocolo",
    attrs: {
      "src": __webpack_require__(674)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-t-20 m-b-40 p-b-40 text-inverse"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEsqueci minha\n\t\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modal-recuperar-senha"
    }
  }, [_vm._v("senha.")])])
}]}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.boxTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Descrição ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.descricao),
      expression: "dados.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "8",
      "name": "descricao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "descricao", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('descricao')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Editar Atendimento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Procedimento")]), _vm._v(" "), _c('select-subgrupo', {
    attrs: {
      "disableClear": true,
      "nome-subgrupo": _vm.$props.atendimento.contrato_subgrupo.subgrupo.nome,
      "contrato-id": _vm.$route.params.contratoId
    },
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.sexo),
      expression: "$props.atendimento.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$props.atendimento, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Feminino")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade mínima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.idade_minima),
      expression: "$props.atendimento.idade_minima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.$props.atendimento.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "idade_minima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.idade_maxima),
      expression: "$props.atendimento.idade_maxima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.$props.atendimento.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "idade_maxima", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo Consumo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.tipo_consumo),
      expression: "$props.atendimento.tipo_consumo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$props.atendimento, "tipo_consumo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Por Procedimento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Por Paciente")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Atendimentos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.quantidade_atendimento),
      expression: "$props.atendimento.quantidade_atendimento"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$props.atendimento.tipo_consumo != 0,
      "type": "number"
    },
    domProps: {
      "value": (_vm.$props.atendimento.quantidade_atendimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "quantidade_atendimento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Local")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.quantidade_local),
      expression: "$props.atendimento.quantidade_local"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$props.atendimento.tipo_consumo != 0,
      "type": "number"
    },
    domProps: {
      "value": (_vm.$props.atendimento.quantidade_local)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "quantidade_local", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Max. Pacientes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.quantidade_paciente),
      expression: "$props.atendimento.quantidade_paciente"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$props.atendimento.tipo_consumo != 1,
      "type": "number"
    },
    domProps: {
      "value": (_vm.$props.atendimento.quantidade_paciente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "quantidade_paciente", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Hora inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.hora_inicial),
      expression: "$props.atendimento.hora_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.$props.atendimento.hora_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "hora_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Hora final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$props.atendimento.hora_final),
      expression: "$props.atendimento.hora_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.$props.atendimento.hora_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$props.atendimento, "hora_final", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n\t\t\t\t\t\t\t\tSalvar\n\t\t\t\t\t\t\t")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preparoSelecionado.nome),
      expression: "preparoSelecionado.nome"
    }],
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerPreparo
    },
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.preparoSelecionado.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preparoSelecionado, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerPreparo,
      'btn-default': !_vm.$props.showTextDangerPreparo
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerPreparo,
      'btn-default': !_vm.$props.showTextDangerPreparo
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Preparo")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.id),
      expression: "filtros.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do preparo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Nome")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t                ")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Importar histórico")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Selecione o paciente para o qual deseja vincular este histórico")]), _vm._v(" "), _c('select-paciente', {
    ref: "selectPacienteRef",
    on: {
      "setPacienteSelecionado": function (paciente) {
        _vm.setPacienteSelecionado(paciente)
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.confirmar()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar\n\t\t\t\t\t\t\t\t\t\t")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.atualizacao) ? _c('b', [_vm._v("Editar Contrato")]) : _c('b', [_vm._v("Novo Contrato")])]), _vm._v(" "), (_vm.atualizacao && _vm.hasPermission('usuario.write')) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.showModalCopiarContrato = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  }), _vm._v(" Copiar de outro contrato ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-error': _vm.showTextDangerUnidade
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerUnidade
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "show-text-danger-unidade": _vm.showTextDangerUnidade,
      "nomeUnidade": _vm.dados.unidade.nome
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerTipoPessoa
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTipoPessoa
    }
  }, [_vm._v("Tipo de pessoa")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_pessoa),
      expression: "dados.tipo_pessoa"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_pessoa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Física")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jurídica")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerTipo
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTipo
    }
  }, [_vm._v("Tipo de Contrato")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo),
      expression: "dados.tipo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Solicitante")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Prestador")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerDataInicial
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDataInicial
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_inicial),
      expression: "dados.data_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerDataFinal
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDataFinal
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_final),
      expression: "dados.data_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_final", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimiteGeral
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimiteGeral
    }
  }, [_vm._v("Limite Geral (R$)")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: (_vm.dados.limite_geral),
      callback: function($$v) {
        _vm.$set(_vm.dados, "limite_geral", $$v)
      },
      expression: "dados.limite_geral"
    }
  }, 'money', _vm.money, false))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimiteCancelamento
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimiteCancelamento
    }
  }, [_vm._v("Limite de Cancelamentos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.limite_cancelamento),
      expression: "dados.limite_cancelamento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.limite_cancelamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "limite_cancelamento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimiteRegulacao
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimiteRegulacao
    }
  }, [_vm._v("Limite de Regulações")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.limite_regulacao),
      expression: "dados.limite_regulacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.limite_regulacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "limite_regulacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerSituacao
    }
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerSituacao
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])])])]), _vm._v(" "), (_vm.dados.tipo == 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de Restrição do Solicitante")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.restricao),
      expression: "dados.restricao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "restricao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Solicita em qualquer unidade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Solicita somente nas unidades selecionadas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Solicita em todas unidades, exceto nas selecionadas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidades Selecionadas")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "select-dias",
      "placeholder": "Clique para selecionar a(s) unidade(s)...",
      "multiple": "",
      "options": _vm.selectUnidades,
      "disabled": _vm.dados.restricao == 0
    },
    model: {
      value: (_vm.dados.restricao_unidades),
      callback: function($$v) {
        _vm.$set(_vm.dados, "restricao_unidades", $$v)
      },
      expression: "dados.restricao_unidades"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.dados.tipo == 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de Restrição do Prestador")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.restricao),
      expression: "dados.restricao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "restricao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Presta para qualquer unidade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Presta somente para unidades selecionadas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Presta para todas unidades, exceto nas selecionadas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidades Selecionadas")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "select-dias",
      "placeholder": "Clique para selecionar a(s) unidade(s)...",
      "multiple": "",
      "options": _vm.selectUnidades,
      "disabled": _vm.dados.restricao == 0
    },
    model: {
      value: (_vm.dados.restricao_unidades),
      callback: function($$v) {
        _vm.$set(_vm.dados, "restricao_unidades", $$v)
      },
      expression: "dados.restricao_unidades"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])]), _vm._v(" "), (_vm.atualizacao) ? _c('modal-copiar-contrato', {
    attrs: {
      "contrato-atual-id": _vm.$route.params.contrato_id,
      "show": _vm.showModalCopiarContrato
    },
    on: {
      "close": function($event) {
        _vm.showModalCopiarContrato = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerSubgrupo
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), _c('select-subgrupo', {
    attrs: {
      "show-text-danger-subgrupo": _vm.showTextDangerSubgrupo,
      "nomeSubgrupo": _vm.dados.subgrupo.nome
    },
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimite
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimite
    }
  }, [_vm._v("Limite Financeiro (R$)")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "autofocus": ""
    },
    model: {
      value: (_vm.dados.limite.valor),
      callback: function($$v) {
        _vm.$set(_vm.dados.limite, "valor", $$v)
      },
      expression: "dados.limite.valor"
    }
  }, 'money', _vm.money, false))], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo Subgrupo do Contrato")])])])
}]}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional")]), _vm._v(" "), _c('select-profissional', {
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSelecionado(profissionalSelecionado)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Grupo de Procedimento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grupoSelecionado),
      expression: "grupoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "grupo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grupoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setGrupoSelecionado()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o grupo...")]), _vm._v(" "), _vm._l((_vm.grupos), function(grupo, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": grupo
      }
    }, [_vm._v(_vm._s(grupo.codigo) + " - " + _vm._s(grupo.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sub-Grupo")]), _vm._v(" "), _c('select-subgrupo', {
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "data_de"
    }
  }, [_vm._v("Período")]), _vm._v(" "), _c('data-filtro', {
    attrs: {
      "name": "periodo"
    },
    on: {
      "operadorSelecionado": function($event) {
        _vm.filtros.periodoOperador = $event
      },
      "dataSelecionada": function($event) {
        _vm.filtros.periodo = $event
      },
      "data2Selecionada": function($event) {
        _vm.filtros.periodo2 = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Agrupar por:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.agrupamento),
      expression: "filtros.agrupamento"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "agrupamento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "agrupamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Não agrupar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unidade"
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "procedimento"
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dia"
    }
  }, [_vm._v("Dia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Separar por:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.separacao),
      expression: "filtros.separacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "separacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "separacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nenhum")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "data"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dia"
    }
  }, [_vm._v("Dia da Semana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "horario"
    }
  }, [_vm._v("Horários")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.ignorar_prestador),
      expression: "filtros.ignorar_prestador"
    }],
    staticStyle: {
      "margin-top": "0.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.ignorar_prestador) ? _vm._i(_vm.filtros.ignorar_prestador, null) > -1 : (_vm.filtros.ignorar_prestador)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.ignorar_prestador,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "ignorar_prestador", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "ignorar_prestador", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "ignorar_prestador", $$c)
        }
      }
    }
  }), _vm._v(" Ignorar prestador\n\t\t\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.ignorar_profissional),
      expression: "filtros.ignorar_profissional"
    }],
    staticStyle: {
      "margin-left": "3.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.ignorar_profissional) ? _vm._i(_vm.filtros.ignorar_profissional, null) > -1 : (_vm.filtros.ignorar_profissional)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.ignorar_profissional,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "ignorar_profissional", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "ignorar_profissional", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "ignorar_profissional", $$c)
        }
      }
    }
  }), _vm._v(" Ignorar profissional\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.disponivel.toogle),
      expression: "filtros.contadores.disponivel.toogle"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.disponivel.toogle) ? _vm._i(_vm.filtros.contadores.disponivel.toogle, null) > -1 : (_vm.filtros.contadores.disponivel.toogle)
    },
    on: {
      "click": function($event) {
        _vm.toogleAll('disponivel')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.disponivel.toogle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.disponivel, "toogle", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.disponivel, "toogle", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.disponivel, "toogle", $$c)
        }
      }
    }
  }), _vm._v(" Disponível")]), _vm._v(" "), _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.agendado.toogle),
      expression: "filtros.contadores.agendado.toogle"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.agendado.toogle) ? _vm._i(_vm.filtros.contadores.agendado.toogle, null) > -1 : (_vm.filtros.contadores.agendado.toogle)
    },
    on: {
      "click": function($event) {
        _vm.toogleAll('agendado')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.agendado.toogle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.agendado, "toogle", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.agendado, "toogle", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.agendado, "toogle", $$c)
        }
      }
    }
  }), _vm._v(" Agendado")]), _vm._v(" "), _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.bloqueado.toogle),
      expression: "filtros.contadores.bloqueado.toogle"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.bloqueado.toogle) ? _vm._i(_vm.filtros.contadores.bloqueado.toogle, null) > -1 : (_vm.filtros.contadores.bloqueado.toogle)
    },
    on: {
      "click": function($event) {
        _vm.toogleAll('bloqueado')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.bloqueado.toogle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.bloqueado, "toogle", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.bloqueado, "toogle", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.bloqueado, "toogle", $$c)
        }
      }
    }
  }), _vm._v(" Bloqueado")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.toogle.primeira),
      expression: "filtros.contadores.toogle.primeira"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.toogle.primeira) ? _vm._i(_vm.filtros.contadores.toogle.primeira, null) > -1 : (_vm.filtros.contadores.toogle.primeira)
    },
    on: {
      "click": function($event) {
        _vm.toogleLinhaAll('primeira')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.toogle.primeira,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.toogle, "primeira", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.toogle, "primeira", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.toogle, "primeira", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.disponivel.primeira),
      expression: "filtros.contadores.disponivel.primeira"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.disponivel.primeira) ? _vm._i(_vm.filtros.contadores.disponivel.primeira, null) > -1 : (_vm.filtros.contadores.disponivel.primeira)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.disponivel.primeira,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.disponivel, "primeira", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.disponivel, "primeira", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.disponivel, "primeira", $$c)
        }
      }
    }
  }), _vm._v(" Primeira")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.agendado.primeira),
      expression: "filtros.contadores.agendado.primeira"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.agendado.primeira) ? _vm._i(_vm.filtros.contadores.agendado.primeira, null) > -1 : (_vm.filtros.contadores.agendado.primeira)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.agendado.primeira,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.agendado, "primeira", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.agendado, "primeira", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.agendado, "primeira", $$c)
        }
      }
    }
  }), _vm._v(" Primeira")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.bloqueado.primeira),
      expression: "filtros.contadores.bloqueado.primeira"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.bloqueado.primeira) ? _vm._i(_vm.filtros.contadores.bloqueado.primeira, null) > -1 : (_vm.filtros.contadores.bloqueado.primeira)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.bloqueado.primeira,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.bloqueado, "primeira", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.bloqueado, "primeira", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.bloqueado, "primeira", $$c)
        }
      }
    }
  }), _vm._v(" Primeira")])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.toogle.retorno),
      expression: "filtros.contadores.toogle.retorno"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.toogle.retorno) ? _vm._i(_vm.filtros.contadores.toogle.retorno, null) > -1 : (_vm.filtros.contadores.toogle.retorno)
    },
    on: {
      "click": function($event) {
        _vm.toogleLinhaAll('retorno')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.toogle.retorno,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.toogle, "retorno", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.toogle, "retorno", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.toogle, "retorno", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.disponivel.retorno),
      expression: "filtros.contadores.disponivel.retorno"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.disponivel.retorno) ? _vm._i(_vm.filtros.contadores.disponivel.retorno, null) > -1 : (_vm.filtros.contadores.disponivel.retorno)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.disponivel.retorno,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.disponivel, "retorno", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.disponivel, "retorno", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.disponivel, "retorno", $$c)
        }
      }
    }
  }), _vm._v(" Retorno")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.agendado.retorno),
      expression: "filtros.contadores.agendado.retorno"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.agendado.retorno) ? _vm._i(_vm.filtros.contadores.agendado.retorno, null) > -1 : (_vm.filtros.contadores.agendado.retorno)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.agendado.retorno,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.agendado, "retorno", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.agendado, "retorno", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.agendado, "retorno", $$c)
        }
      }
    }
  }), _vm._v(" Retorno")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.bloqueado.retorno),
      expression: "filtros.contadores.bloqueado.retorno"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.bloqueado.retorno) ? _vm._i(_vm.filtros.contadores.bloqueado.retorno, null) > -1 : (_vm.filtros.contadores.bloqueado.retorno)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.bloqueado.retorno,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.bloqueado, "retorno", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.bloqueado, "retorno", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.bloqueado, "retorno", $$c)
        }
      }
    }
  }), _vm._v(" Retorno")])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.toogle.local),
      expression: "filtros.contadores.toogle.local"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.toogle.local) ? _vm._i(_vm.filtros.contadores.toogle.local, null) > -1 : (_vm.filtros.contadores.toogle.local)
    },
    on: {
      "click": function($event) {
        _vm.toogleLinhaAll('local')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.toogle.local,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.toogle, "local", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.toogle, "local", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.toogle, "local", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.disponivel.local),
      expression: "filtros.contadores.disponivel.local"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.disponivel.local) ? _vm._i(_vm.filtros.contadores.disponivel.local, null) > -1 : (_vm.filtros.contadores.disponivel.local)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.disponivel.local,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.disponivel, "local", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.disponivel, "local", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.disponivel, "local", $$c)
        }
      }
    }
  }), _vm._v(" Local")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.agendado.local),
      expression: "filtros.contadores.agendado.local"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.agendado.local) ? _vm._i(_vm.filtros.contadores.agendado.local, null) > -1 : (_vm.filtros.contadores.agendado.local)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.agendado.local,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.agendado, "local", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.agendado, "local", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.agendado, "local", $$c)
        }
      }
    }
  }), _vm._v(" Local")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.bloqueado.local),
      expression: "filtros.contadores.bloqueado.local"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.bloqueado.local) ? _vm._i(_vm.filtros.contadores.bloqueado.local, null) > -1 : (_vm.filtros.contadores.bloqueado.local)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.bloqueado.local,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.bloqueado, "local", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.bloqueado, "local", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.bloqueado, "local", $$c)
        }
      }
    }
  }), _vm._v(" Local")])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.toogle.total),
      expression: "filtros.contadores.toogle.total"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.toogle.total) ? _vm._i(_vm.filtros.contadores.toogle.total, null) > -1 : (_vm.filtros.contadores.toogle.total)
    },
    on: {
      "click": function($event) {
        _vm.toogleLinhaAll('total')
      },
      "change": function($event) {
        var $$a = _vm.filtros.contadores.toogle.total,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.toogle, "total", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.toogle, "total", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.toogle, "total", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.disponivel.total),
      expression: "filtros.contadores.disponivel.total"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.disponivel.total) ? _vm._i(_vm.filtros.contadores.disponivel.total, null) > -1 : (_vm.filtros.contadores.disponivel.total)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.disponivel.total,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.disponivel, "total", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.disponivel, "total", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.disponivel, "total", $$c)
        }
      }
    }
  }), _vm._v(" Total")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.agendado.total),
      expression: "filtros.contadores.agendado.total"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.agendado.total) ? _vm._i(_vm.filtros.contadores.agendado.total, null) > -1 : (_vm.filtros.contadores.agendado.total)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.agendado.total,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.agendado, "total", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.agendado, "total", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.agendado, "total", $$c)
        }
      }
    }
  }), _vm._v(" Total")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.contadores.bloqueado.total),
      expression: "filtros.contadores.bloqueado.total"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.contadores.bloqueado.total) ? _vm._i(_vm.filtros.contadores.bloqueado.total, null) > -1 : (_vm.filtros.contadores.bloqueado.total)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.contadores.bloqueado.total,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros.contadores.bloqueado, "total", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros.contadores.bloqueado, "total", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros.contadores.bloqueado, "total", $$c)
        }
      }
    }
  }), _vm._v(" Total")])])])])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "box-footer text-right"
  }, [(_vm.pdf) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_vm._v("Recarregar PDF "), _c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Oferta de Procedimentos",
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])]), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable) && !_vm.pdf) ? _c('div', {
    staticClass: "row overflow",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, _vm._l((_vm.dataTable), function(itens, nome) {
    return _c('table', {
      key: nome,
      staticClass: "table table-bordered table-striped"
    }, [_c('thead', [_c('tr', [(_vm.filtros.agrupamento == 'dia') ? _c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(" " + _vm._s(_vm._f("dataFormatada")(nome)))]) : _vm._e(), _vm._v(" "), (_vm.filtros.agrupamento == 'procedimento') ? _c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Procedimento: " + _vm._s(nome))]) : _vm._e(), _vm._v(" "), (_vm.filtros.agrupamento == 'unidade' && !_vm.filtros.ignorar_prestador) ? _c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Unidade: " + _vm._s(nome))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "table table-bordered table-striped table-hover"
    }, [_c('thead', [_c('tr', [(_vm.filtros.separacao == 'data') ? _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Dia")]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'dia') ? _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Dia da semana")]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'horario') ? _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Horário")]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_prestador) ? _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Unidade")]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_profissional) ? _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Profissional")]) : _vm._e(), _vm._v(" "), _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("Agenda")]), _vm._v(" "), (_vm.isVisible('disponivel')) ? _c('th', {
      staticStyle: {
        "text-align": "center",
        "width": "10%"
      },
      attrs: {
        "colspan": _vm.getColSpan('disponivel')
      }
    }, [_vm._v("Disponível")]) : _vm._e(), _vm._v(" "), (_vm.isVisible('agendado')) ? _c('th', {
      staticStyle: {
        "text-align": "center",
        "width": "10%"
      },
      attrs: {
        "colspan": _vm.getColSpan('agendado')
      }
    }, [_vm._v("Agendado")]) : _vm._e(), _vm._v(" "), (_vm.isVisible('bloqueado') && !itens[0].paciente) ? _c('th', {
      staticStyle: {
        "text-align": "center",
        "width": "10%"
      },
      attrs: {
        "colspan": _vm.getColSpan('bloqueado')
      }
    }, [_vm._v("Bloqueado")]) : _vm._e()]), _vm._v(" "), (!itens[0].paciente) ? _c('tr', [(_vm.filtros.contadores.disponivel.primeira) ? _c('th', [_vm._v("P")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.retorno) ? _c('th', [_vm._v("R")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.local) ? _c('th', [_vm._v("L")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.total) ? _c('th', [_vm._v("T")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.primeira) ? _c('th', [_vm._v("P")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.retorno) ? _c('th', [_vm._v("R")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.local) ? _c('th', [_vm._v("L")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.total) ? _c('th', [_vm._v("T")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.primeira) ? _c('th', [_vm._v("P")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.retorno) ? _c('th', [_vm._v("R")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.local) ? _c('th', [_vm._v("L")]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.total) ? _c('th', [_vm._v("T")]) : _vm._e()]) : _c('tr', [_c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Pacientes")]), _vm._v(" "), _c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Pacientes")])])]), _vm._v(" "), (!itens[0].paciente) ? _c('tbody', _vm._l((itens), function(item, index) {
      return _c('tr', {
        key: index
      }, [(_vm.filtros.separacao == 'dia') ? _c('td', [_vm._v(_vm._s(_vm._f("dia")(parseInt(item.dia_semana))))]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'data') ? _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)))]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'horario') ? _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)) + " das " + _vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final))]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_prestador) ? _c('td', [_vm._v(_vm._s(item.contrato_procedimento ? item.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo.contrato.unidade.nome))]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_profissional) ? _c('td', [_vm._v(_vm._s(item.profissional ? item.profissional.nome : "Agenda sem profissional"))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento ? item.contrato_procedimento.procedimento.codigo : item.contrato_subgrupo.subgrupo.codigo) + " - " + _vm._s(item.contrato_procedimento ? item.contrato_procedimento.procedimento.nome : item.contrato_subgrupo.subgrupo.nome))]), _vm._v(" "), (_vm.filtros.contadores.disponivel.primeira) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_primeira))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.retorno) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_retorno ? item.quantidade_retorno : "0"))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.local) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_local))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.disponivel.total) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_c('strong', [_vm._v(_vm._s(item.quantidade_total))])]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.primeira) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_primeira_agendada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.retorno) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_retorno_agendada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.local) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_local_agendada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.agendado.total) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_c('strong', [_vm._v(_vm._s(item.quantidade_total_agendada))])]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.primeira) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_primeira_bloqueada == null ? 0 : item.quantidade_primeira_bloqueada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.retorno) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_retorno_bloqueada == null ? 0 : item.quantidade_retorno_bloqueada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.local) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(item.quantidade_local_bloqueada == null ? 0 : item.quantidade_local_bloqueada))]) : _vm._e(), _vm._v(" "), (_vm.filtros.contadores.bloqueado.total) ? _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_c('strong', [_vm._v(_vm._s(item.quantidade_total_bloqueada == null ? 0 : item.quantidade_total_bloqueada))])]) : _vm._e()])
    })) : _c('tbody', _vm._l((itens), function(item, index) {
      return _c('tr', {
        key: index
      }, [(_vm.filtros.separacao == 'dia') ? _c('td', [_vm._v(_vm._s(_vm._f("dia")(parseInt(item.dia_semana))))]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'data') ? _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)))]) : _vm._e(), _vm._v(" "), (_vm.filtros.separacao == 'horario') ? _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)) + " das " + _vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final))]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_prestador) ? _c('td', [_vm._v(_vm._s(item.contrato_procedimento ? item.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo.contrato.unidade.nome))]) : _vm._e(), _vm._v(" "), (!_vm.filtros.ignorar_profissional) ? _c('td', [_vm._v(_vm._s(item.profissional ? item.profissional.nome : "Agenda sem profissional"))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento ? item.contrato_procedimento.procedimento.codigo : item.contrato_subgrupo.subgrupo.codigo) + " - " + _vm._s(item.contrato_procedimento ? item.contrato_procedimento.procedimento.nome : item.contrato_subgrupo.subgrupo.nome))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v(_vm._s(item.quantidade_paciente))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v(_vm._s(item.quantidade_paciente_agendada))])])
    }))])])])])])
  }))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-10 col-sm-2 text-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pdf),
      expression: "!pdf"
    }],
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF")])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Oferta de Procedimentos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', [_c('strong', [_vm._v("Contadores a exibir")])])])
}]}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Criar Atendimentos de Subgrupo")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.dados.tipo_consumo == 1) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos distribuídos (Por paciente)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_paciente_original)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos disponíveis (Por paciente)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_paciente_alterada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos bloqueados (Por paciente)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_paciente_bloqueada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos criados (Por paciente)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_paciente_criada),
      expression: "dados.quantidade_paciente_criada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.dados.quantidade_paciente_bloqueada > 0
    },
    domProps: {
      "value": (_vm.dados.quantidade_paciente_criada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_paciente_criada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])] : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_atendimento_original)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_atendimento_alterada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos bloqueados")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_atendimento_bloqueada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos criados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_atendimento_criada),
      expression: "dados.quantidade_atendimento_criada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.dados.quantidade_atendimento_bloqueada > 0
    },
    domProps: {
      "value": (_vm.dados.quantidade_atendimento_criada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_atendimento_criada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_local_original)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_local_alterada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais bloqueados")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_local_bloqueada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais criados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_local_criada),
      expression: "dados.quantidade_local_criada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.dados.quantidade_local_bloqueada > 0
    },
    domProps: {
      "value": (_vm.dados.quantidade_local_criada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local_criada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button",
      "disabled": _vm.dados.quantidade_local_bloqueada > 0 && _vm.dados.quantidade_atendimento_bloqueada > 0
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/administracao/comunicados/novo"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o título do comunicado"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Situação--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ATIVO"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INATIVO"
    }
  }, [_vm._v("Inativo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.getDataTable
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\tFiltrar\n\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [(
    _vm.dataTable.data && _vm.dataTable.data.length > 0
  ) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("dataFormatada")(item.data_inicial)) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("dataFormatada")(item.data_final)) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.situacao))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/comunicados/atualizacao/" + (item.id)),
        "title": "Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Excluir"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-times",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tMostrando " + _vm._s(this.dataTable.from) + " até\n\t\t\t\t\t\t\t\t\t" + _vm._s(this.dataTable.to) + " de\n\t\t\t\t\t\t\t\t\t" + _vm._s(this.dataTable.total) + " registros\n\t\t\t\t\t\t\t\t\tencontrados.\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])]) : _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n\t\t\t\t\t\t\tNenhum comunicado foi encontrado.\n\t\t\t\t\t\t")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Comunicados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Título")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tData Inicial\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tData Final\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tSituação\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tAção\n\t\t\t\t\t\t\t\t\t\t")])])])
}]}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/cadastros/subgrupos-procedimento/novo"
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código do subgrupo."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "hand",
      attrs: {
        "tag": "tr",
        "to": '/cadastros/subgrupos-procedimento/editar/' + item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.grupo.nome))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Subgrupos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Grupo")])])])
}]}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.boxTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Código")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.codigo),
      expression: "dados.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "codigo",
      "maxlength": "2",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "codigo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('codigo')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subgrupo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.procedimento_subgrupo_id),
      expression: "dados.procedimento_subgrupo_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "subgrupo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "procedimento_subgrupo_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o subgrupo...")]), _vm._v(" "), _vm._l((_vm.subgrupos), function(subgrupo, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": subgrupo.id
      }
    }, [_vm._v(_vm._s(subgrupo.codigo) + " - " + _vm._s(subgrupo.nome))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subgrupo')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.boxTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Código")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.codigo),
      expression: "dados.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "codigo",
      "maxlength": "2",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "codigo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('codigo')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Grupo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.procedimento_grupo_id),
      expression: "dados.procedimento_grupo_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "grupo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "procedimento_grupo_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o grupo...")]), _vm._v(" "), _vm._l((_vm.grupos), function(grupo, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": grupo.id
      }
    }, [_vm._v(_vm._s(grupo.codigo) + " - " + _vm._s(grupo.nome))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('grupo')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.$store.state.alert_success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v("\n\t\t\t" + _vm._s(_vm.$store.state.alert_message != '' ? _vm.$store.state.alert_message : 'Operação realizada com sucesso!') + "\n\t")]) : _vm._e(), _vm._v(" "), (this.$store.state.alert_error) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v("\n\t\t\t" + _vm._s(_vm.$store.state.alert_message != '' ? _vm.$store.state.alert_message : 'Ocorreu um erro ao realizar a operação!') + "\n\t")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" Sucesso! ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" Erro! ")])
}]}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Histórico do paciente " + _vm._s(_vm.historico.data[0] ? _vm.historico.data[0].nm_paciente : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.historico.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacaoAntiga")(item.st_solicitacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_unidade_realizadora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.dt_realizacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_profissional_realizador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_procedimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.dt_solicitacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_unidade_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_profissional_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_profissional_marcador))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\tMostrando " + _vm._s(this.historico.from) + " até " + _vm._s(this.historico.to) + " de " + _vm._s(this.historico.total) + " registros encontrados.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historico
    },
    on: {
      "pagination-change-page": _vm.getHistorico
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(this.hasPermission('paciente-integracao.write')) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disableBtnImportar
    },
    on: {
      "click": function($event) {
        _vm.showModalImportarHistorico = true
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-arrow-down"
  }), _vm._v(" Importar histórico")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "a",
      "to": '/integracao/pacientes'
    }
  }, [_c('span', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])], 1)])])])])]), _vm._v(" "), _c('modal-importar-historico', {
    attrs: {
      "cdPessoa": _vm.$route.params.cdPessoa,
      "show": _vm.showModalImportarHistorico
    },
    on: {
      "close": function($event) {
        _vm.showModalImportarHistorico = false
      },
      "historicoImportado": function($event) {
        _vm.historicoImportado()
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
}]}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }, {
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['esc']),
      expression: "['esc']"
    }],
    staticClass: "modal-mask",
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.up()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.down()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.enter()
      }],
      "shortkey": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Copiar procedimentos e subgrupos de outro contrato")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com NOME DA UNIDADE"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.categoria_unidade),
      expression: "filtros.categoria_unidade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "categoria_unidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Categoria da Unidade--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Pública (Local)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Município Pactuado (PPI)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Privada")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo),
      expression: "filtros.tipo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Tipo do Contrato--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Solicitante")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Prestador")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.getDataTable
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                                        ID\n                                        "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('contratos.id')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'contratos.id' ? ("fa fa-sort-numeric" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                                        Unidade\n                                        "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('unidades.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'unidades.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Tipo")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: item.id,
      staticClass: "even hand",
      class: {
        ativa: index === _vm.contratoSelecionadoIndex
      },
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.copiar(item, index)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("categoriaUnidade")(item.categoria)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoContrato")(item.tipo)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.atualizacao) ? _c('b', [_vm._v("Atualizar Comunicado")]) : _c('b', [_vm._v("Novo Comunicado")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6",
    class: {
      'has-error': _vm.showTextDangerTitulo
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTitulo
    }
  }, [_vm._v("Título")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.titulo),
      expression: "dados.titulo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "titulo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerDataInicial
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDataInicial
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_inicial),
      expression: "dados.data_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerDataFinal
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDataFinal
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_final),
      expression: "dados.data_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_final", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerSituacao
    }
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerSituacao
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ATIVO"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INATIVO"
    }
  }, [_vm._v("Inativo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerDescricao
    }
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDescricao
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('vue-editor', {
    model: {
      value: (_vm.dados.descricao),
      callback: function($$v) {
        _vm.$set(_vm.dados, "descricao", $$v)
      },
      expression: "dados.descricao"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Visível para")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.marcador_visualiza),
      expression: "dados.marcador_visualiza"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.marcador_visualiza) ? _vm._i(_vm.dados.marcador_visualiza, null) > -1 : (_vm.dados.marcador_visualiza)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dados.marcador_visualiza,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "marcador_visualiza", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "marcador_visualiza", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "marcador_visualiza", $$c)
        }
      }
    }
  }), _vm._v(" Marcadores\n\t\t\t\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.prestador_visualiza),
      expression: "dados.prestador_visualiza"
    }],
    staticStyle: {
      "margin-left": "3.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.prestador_visualiza) ? _vm._i(_vm.dados.prestador_visualiza, null) > -1 : (_vm.dados.prestador_visualiza)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dados.prestador_visualiza,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "prestador_visualiza", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "prestador_visualiza", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "prestador_visualiza", $$c)
        }
      }
    }
  }), _vm._v(" Prestadores\n\t\t\t\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.regulador_visualiza),
      expression: "dados.regulador_visualiza"
    }],
    staticStyle: {
      "margin-left": "3.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.regulador_visualiza) ? _vm._i(_vm.dados.regulador_visualiza, null) > -1 : (_vm.dados.regulador_visualiza)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dados.regulador_visualiza,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "regulador_visualiza", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "regulador_visualiza", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "regulador_visualiza", $$c)
        }
      }
    }
  }), _vm._v(" Reguladores\n\t\t\t\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.administrador_visualiza),
      expression: "dados.administrador_visualiza"
    }],
    staticStyle: {
      "margin-left": "3.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.administrador_visualiza) ? _vm._i(_vm.dados.administrador_visualiza, null) > -1 : (_vm.dados.administrador_visualiza)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dados.administrador_visualiza,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "administrador_visualiza", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "administrador_visualiza", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "administrador_visualiza", $$c)
        }
      }
    }
  }), _vm._v(" Administradores\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": ("/administracao/contratos/procedimentos/novo/" + (_vm.$route.params.contrato_id))
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar Procedimento")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecario-contrato', {
    attrs: {
      "contratoId": _vm.$route.params.contrato_id
    }
  }), _vm._v(" "), _c('filtro-contrato-procedimento', {
    on: {
      "filtrar": function (filtros) {
        _vm.filtrar(filtros);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                                                Procedimento\n                                                "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('procedimentos.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'procedimentos.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Tipo de Limite")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Limite Físico")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Valor Total")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.valor, 2, ",", ".")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipo_limite")(item.tipo_limite)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tipo_limite > 0 ? "Não Possui" : item.quantidade))]), _vm._v(" "), _c('td', [(item.tipo_limite == 0) ? _c('span', [_vm._v(_vm._s(_vm._f("numberFormat")((item.quantidade * item.valor), 2, ",", ".")))]) : _vm._e(), _vm._v(" "), (item.tipo_limite == 1) ? _c('span', [_vm._v("No Subgrupo")]) : _vm._e(), _vm._v(" "), (item.tipo_limite == 2) ? _c('span', [_vm._v("Não Possui")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/contratos/procedimentos/atualizacao/" + (item.id)),
        "title": " Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Excluir"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-close",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Procedimentos do Contrato")])])
}]}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com NOME ou CÓDIGO do subgrupo"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filtrar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.filtrar
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])])])
},staticRenderFns: []}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        $event.stopPropagation();
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.procedimentoSelecionado.procedimento.nome),
      expression: "procedimentoSelecionado.procedimento.nome"
    }],
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerProcedimento
    },
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.procedimentoSelecionado.procedimento.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.procedimentoSelecionado.procedimento, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerProcedimento,
      'btn-default': !_vm.$props.showTextDangerProcedimento
    },
    attrs: {
      "disabled": _vm.$props.nomeProcedimento != undefined,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerProcedimento,
      'btn-default': !_vm.$props.showTextDangerProcedimento
    },
    attrs: {
      "disabled": _vm.disableClear,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Procedimento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código do procedimento e pressione enter."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Tipo")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.procedimento.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoAtendimento")(item.procedimento.tipo_atendimento)))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Bloquear Atendimentos por Período")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Filtros:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select-procedimento-contrato', {
    attrs: {
      "semAgrupados": 1,
      "contrato-id": _vm.$route.params.distribuicaoContratoId,
      "placeholder": "PROCEDIMENTO"
    },
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select-profissional', {
    attrs: {
      "placeholder": "PROFISSIONAL"
    },
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSelecionado(profissionalSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sexo),
      expression: "filtros.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.AMBOS
    }
  }, [_vm._v("AMBOS")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("MASCULINO")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("FEMININO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('periodo_de')
    }
  }, [_c('label', [_vm._v("Período (De)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_inicial),
      expression: "filtros.data_inicial"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "periodo_de",
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "PERÍODO DE",
      "name": "periodo_de"
    },
    domProps: {
      "value": (_vm.filtros.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_inicial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('periodo_de')),
      expression: "errors.has('periodo_de')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('periodo_de')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('periodo_ate')
    }
  }, [_c('label', [_vm._v("Período (Até)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_final),
      expression: "filtros.data_final"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "periodo_ate",
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "PERÍODO DE",
      "name": "periodo_ate"
    },
    domProps: {
      "value": (_vm.filtros.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_final", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('periodo_ate')),
      expression: "errors.has('periodo_ate')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('periodo_ate')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('atendimento')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Quantidade de ATENDIMENTOS a bloquear em cada ocorrência")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_primeira_bloqueada),
      expression: "dados.quantidade_primeira_bloqueada",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.quantidade_retorno_bloqueada === '') && (_vm.dados.quantidade_local_bloqueada === '') ? 'required' : ''),
      expression: "(dados.quantidade_retorno_bloqueada === '') && (dados.quantidade_local_bloqueada === '') ?'required' : ''"
    }],
    ref: "atendimento",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "atendimento"
    },
    domProps: {
      "value": (_vm.dados.quantidade_primeira_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_primeira_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('atendimento')),
      expression: "errors.has('atendimento')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos um bloqueio")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('retorno')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Quantidade de RETORNOS a bloquear em cada ocorrência")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_retorno_bloqueada),
      expression: "dados.quantidade_retorno_bloqueada",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.quantidade_primeira_bloqueada === '') && (_vm.dados.quantidade_local_bloqueada === '') ? 'required' : ''),
      expression: "(dados.quantidade_primeira_bloqueada === '') && (dados.quantidade_local_bloqueada === '') ?'required' : ''"
    }],
    ref: "retorno",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "retorno"
    },
    domProps: {
      "value": (_vm.dados.quantidade_retorno_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_retorno_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('retorno')),
      expression: "errors.has('retorno')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos um bloqueio")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('local')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Quantidade de atendimentos LOCAIS a bloquear em cada ocorrência")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_local_bloqueada),
      expression: "dados.quantidade_local_bloqueada",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.dados.quantidade_primeira_bloqueada === '') && (_vm.dados.quantidade_retorno_bloqueada === '') ? 'required' : ''),
      expression: "(dados.quantidade_primeira_bloqueada === '') && (dados.quantidade_retorno_bloqueada === '') ?'required' : ''"
    }],
    ref: "local",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "local"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('local')),
      expression: "errors.has('local')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos um bloqueio")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.getOcorrencias
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Calcular número total de ocorrências e bloqueios")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', [_vm._v("\n              Total de registros encontrados no período:\n              "), _c('strong', [_vm._v(_vm._s(_vm.ocorrencias.registros))])]), _vm._v(" "), _c('p', [_vm._v("\n              Total de atendimentos que serão bloqueados no período:\n              "), _c('strong', [_vm._v(_vm._s(_vm.ocorrencias.atendimentos))])]), _vm._v(" "), _c('p', [_vm._v("\n              Total de retornos que serão bloqueados no período:\n              "), _c('strong', [_vm._v(_vm._s(_vm.ocorrencias.retornos))])]), _vm._v(" "), _c('p', [_vm._v("\n              Total de atendimentos locais que serão bloqueados no período:\n              "), _c('strong', [_vm._v(_vm._s(_vm.ocorrencias.locais))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Confirmar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar\n            ")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.label_titulo) + " Atendimentos")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_primeira_original
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_primeira_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.label_acao == 'bloquear') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_primeira_bloqueada),
      expression: "dados.quantidade_primeira_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_primeira_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_primeira_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_retorno
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_retorno_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.label_acao == 'bloquear') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_retorno_bloqueada),
      expression: "dados.quantidade_retorno_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_retorno_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_retorno_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_local
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_local_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.label_acao == 'bloquear') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_local_bloqueada),
      expression: "dados.quantidade_local_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade Solicitante")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "show-text-danger-unidade": _vm.showTextDangerUnidadeSolicitante
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSolicitante(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional Solicitante")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "show-text-danger-profissional": _vm.showTextDangerProfissionalSolicitante
    },
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSolicitante(profissionalSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade Prestadora")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "show-text-danger-unidade": _vm.showTextDangerUnidadeSolicitante
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadePrestadora(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional Prestador")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "show-text-danger-profissional": _vm.showTextDangerProfissionalSolicitante
    },
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalPrestador(profissionalSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Paciente")]), _vm._v(" "), _c('select-paciente', {
    on: {
      "setPacienteSelecionado": function (paciente) {
        _vm.setPacienteSelecionado(paciente);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Grupo de Procedimento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grupoSelecionado),
      expression: "grupoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "grupo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grupoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setGrupoSelecionado()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o grupo...")]), _vm._v(" "), _vm._l((_vm.grupos), function(grupo, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": grupo
      }
    }, [_vm._v(_vm._s(grupo.codigo) + " - " + _vm._s(grupo.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sub-Grupo")]), _vm._v(" "), _c('select-subgrupo', {
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Marcador")]), _vm._v(" "), _c('select-usuario', {
    attrs: {
      "nivel": "marcador"
    },
    on: {
      "setUsuarioSelecionado": function (usuario) {
        _vm.setUsuarioMarcadorSelecionado(usuario);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Regulador")]), _vm._v(" "), _c('select-usuario', {
    attrs: {
      "nivel": "regulador"
    },
    on: {
      "setUsuarioSelecionado": function (usuario) {
        _vm.setUsuarioReguladorSelecionado(usuario);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo_atendimento),
      expression: "filtros.tipo_atendimento"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "tp_solicitacao",
      "id": "tp_solicitacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo_atendimento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_ATENDIMENTO.INDIVIDUAL
    }
  }, [_vm._v("Individual")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_ATENDIMENTO.AGRUPADO
    }
  }, [_vm._v("Agrupado")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de Unidade")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo_unidade),
      expression: "filtros.tipo_unidade"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo_unidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_UNIDADE.UNIDADE_BASICA
    }
  }, [_vm._v("Unidade básica de saúde")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_UNIDADE.HOSPITAL
    }
  }, [_vm._v("Hospital")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dt_nascimento"
    }
  }, [_vm._v("Solicitado")]), _vm._v(" "), _c('data-filtro', {
    attrs: {
      "name": "solicitado"
    },
    on: {
      "operadorSelecionado": function($event) {
        _vm.filtros.solicitadoOperador = $event
      },
      "dataSelecionada": function($event) {
        _vm.filtros.solicitado = $event
      },
      "data2Selecionada": function($event) {
        _vm.filtros.solicitado2 = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dt_nascimento"
    }
  }, [_vm._v("Agendado")]), _vm._v(" "), _c('data-filtro', {
    attrs: {
      "name": "agendado"
    },
    on: {
      "operadorSelecionado": function($event) {
        _vm.filtros.agendadoOperador = $event
      },
      "dataSelecionada": function($event) {
        _vm.filtros.agendado = $event
      },
      "data2Selecionada": function($event) {
        _vm.filtros.agendado2 = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dt_nascimento"
    }
  }, [_vm._v("Regulado")]), _vm._v(" "), _c('data-filtro', {
    attrs: {
      "name": "regulado"
    },
    on: {
      "operadorSelecionado": function($event) {
        _vm.filtros.reguladoOperador = $event
      },
      "dataSelecionada": function($event) {
        _vm.filtros.regulado = $event
      },
      "data2Selecionada": function($event) {
        _vm.filtros.regulado2 = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.MARCADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.MARCADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.MARCADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Marcada ")]), _vm._v(" "), (this.$store.state.user.nivel == 'administrador') ? _c('div', [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.EM_REGULACAO,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.EM_REGULACAO) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.EM_REGULACAO,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Em regulação ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REGULADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.REGULADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.REGULADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Regulada ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.NEGATIVADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.NEGATIVADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.NEGATIVADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Negativada ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Informação pendente ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Informação adicional ")])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CONFIRMADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.CONFIRMADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.CONFIRMADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Confirmada ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CANCELADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.CANCELADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.CANCELADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Cancelada ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.FALTA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.FALTA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.FALTA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Falta ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REALIZADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.REALIZADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.REALIZADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Realizada ")])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "box-footer text-right"
  }, [(_vm.pdf) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.getPDF()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Recarregar PDF")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.finalizado,
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Solicitação",
      "id": "resultado"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable) && !_vm.pdf && !_vm.filtros.sintetico) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.situacao),
      expression: "ativos.situacao"
    }]
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.tipo),
      expression: "ativos.tipo"
    }]
  }, [_vm._v("Tipo")]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.dt_solicitacao),
      expression: "ativos.dt_solicitacao"
    }]
  }, [_vm._v("Dt. Solicitação")]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.dt_realizacao),
      expression: "ativos.dt_realizacao"
    }]
  }, [_vm._v("Dt. Realização")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.cidadao),
      expression: "ativos.cidadao"
    }]
  }, [_vm._v("Paciente")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.endereco),
      expression: "ativos.endereco"
    }]
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.cidade),
      expression: "ativos.cidade"
    }]
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.bairro),
      expression: "ativos.bairro"
    }]
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.telefone),
      expression: "ativos.telefone"
    }]
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.rg),
      expression: "ativos.rg"
    }]
  }, [_vm._v("RG")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.nome_mae),
      expression: "ativos.nome_mae"
    }]
  }, [_vm._v("Nome da Mãe")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.dt_nascimento),
      expression: "ativos.dt_nascimento"
    }]
  }, [_vm._v("Dt. Nasc")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.idade),
      expression: "ativos.idade"
    }]
  }, [_vm._v("Idade")]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.id),
      expression: "ativos.id"
    }]
  }, [_vm._v("ID")]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.quantidade),
      expression: "ativos.quantidade"
    }]
  }, [_vm._v("Qtd.")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.tipo_consulta),
      expression: "ativos.tipo_consulta"
    }]
  }, [_vm._v("Consulta")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.procedimento),
      expression: "ativos.procedimento"
    }]
  }, [_vm._v("Procedimento")]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.valor_prestador),
      expression: "ativos.valor_prestador"
    }]
  }, [_vm._v("Valor Prestador")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.valor),
      expression: "ativos.valor"
    }]
  }, [_vm._v("Valor Solicitante")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.valor_s),
      expression: "ativos.valor_s"
    }]
  }, [_vm._v("Valor de referência")]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.unid_solic),
      expression: "ativos.unid_solic"
    }]
  }, [_vm._v("Unid. Solicitante")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.unid_prest),
      expression: "ativos.unid_prest"
    }]
  }, [_vm._v("Unid. Realizadora")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.prof_prest),
      expression: "ativos.prof_prest"
    }]
  }, [_vm._v("Prof. Prestador")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.prof_solic),
      expression: "ativos.prof_solic"
    }]
  }, [_vm._v("Prof. Solicitante")]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.marcador),
      expression: "ativos.marcador"
    }]
  }, [_vm._v("Marcador")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.regulador),
      expression: "ativos.regulador"
    }]
  }, [_vm._v("Regulador")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.agp_unidades),
      expression: "ativos.agp_unidades"
    }]
  }, [_vm._v("Agrupamento de Unidades")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.usu_cancelamento),
      expression: "ativos.usu_cancelamento"
    }]
  }, [_vm._v("Usuário Cancelamento")]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.dt_cancelamento),
      expression: "ativos.dt_cancelamento"
    }]
  }, [_vm._v("Dt. Cancelamento")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.situacao),
        expression: "ativos.situacao"
      }]
    }, [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.tipo),
        expression: "ativos.tipo"
      }]
    }, [_vm._v(_vm._s(_vm._f("tipoAtendimento")(item.solicitacao.tipo_atendimento)))]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.dt_solicitacao),
        expression: "ativos.dt_solicitacao"
      }]
    }, [_vm._v(_vm._s(_vm._f("dataFormatadaHora")(item.solicitacao.created_at)))]) : _vm._e(), _vm._v(" "), (item.contrato_procedimento_atendimento || item.contrato_subgrupo_atendimento) ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.dt_realizacao),
        expression: "ativos.dt_realizacao"
      }]
    }, [_vm._v(_vm._s(_vm._f("dataFormatadaHora")((item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento + " " + item.contrato_procedimento_atendimento.hora_inicial : item.contrato_subgrupo_atendimento.data_atendimento + " " + item.contrato_subgrupo_atendimento.hora_inicial))))]) : _c('td', [_vm._v("SEM DATA DEFINIDA")]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.cidadao),
        expression: "ativos.cidadao"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.cidadao),
        expression: "ativos.cidadao"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.endereco) + ", " + _vm._s(item.solicitacao.paciente.numero_endereco))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.cidade),
        expression: "ativos.cidade"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.cidade.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.bairro),
        expression: "ativos.bairro"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.bairro))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.telefone),
        expression: "ativos.telefone"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.telefone))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.rg),
        expression: "ativos.rg"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.rg))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.nome_mae),
        expression: "ativos.nome_mae"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.nome_mae))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.dt_nascimento),
        expression: "ativos.dt_nascimento"
      }]
    }, [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.paciente.data_nascimento)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.idade),
        expression: "ativos.idade"
      }]
    }, [_vm._v(_vm._s(_vm._f("idade")(item.solicitacao.paciente.data_nascimento)))]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.id),
        expression: "ativos.id"
      }]
    }, [_vm._v(_vm._s(_vm._f("formatarCodigo")(item.solicitacao.id)))]) : _vm._e(), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.quantidade),
        expression: "ativos.quantidade"
      }]
    }, [_vm._v(_vm._s(item.quantidade))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.tipo_consulta),
        expression: "ativos.tipo_consulta"
      }]
    }, [_vm._v(_vm._s(_vm._f("tipoConsulta")(item.tipo_consulta)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.procedimento),
        expression: "ativos.procedimento"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('div', [(item.contrato_procedimento_atendimento) ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.valor_prestador),
        expression: "ativos.valor_prestador"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento_atendimento.contrato_procedimento.valor))]) : _c('td', [_vm._v("SEM VALOR DEFINIDO")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.valor),
        expression: "ativos.valor"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.valor))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.valor_s),
        expression: "ativos.valor_s"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.procedimento.valor_referencia))]) : _vm._e(), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.unid_solic),
        expression: "ativos.unid_solic"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), (item.contrato_procedimento_atendimento || item.contrato_subgrupo_atendimento) ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.unid_prest),
        expression: "ativos.unid_prest"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))]) : _c('td', [_vm._v("SEM UNIDADE DEFINIDA")]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.prof_prest),
        expression: "ativos.prof_prest"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.prof_solic),
        expression: "ativos.prof_solic"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.profissional.nome))]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.marcador),
        expression: "ativos.marcador"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.usuario.name))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.regulador),
        expression: "ativos.regulador"
      }]
    }, [_vm._v(_vm._s(_vm.verificarRegulacao(item.solicitacao)))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.agp_unidades),
        expression: "ativos.agp_unidades"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.tipo_unidade.nome))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.usu_cancelamento),
        expression: "ativos.usu_cancelamento"
      }]
    }, [_vm._v(_vm._s(_vm.verificarCancelamento(item.solicitacao).text))]) : _vm._e(), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.dt_cancelamento),
        expression: "ativos.dt_cancelamento"
      }]
    }, [_vm._v(_vm._s(_vm.verificarCancelamento(item.solicitacao).data))])])
  }))])]), _vm._v(" "), (_vm.dataTable.data && _vm.dataTable.data.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getCSV($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" CSV")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.situacao),
      expression: "ativos.situacao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.situacao) ? _vm._i(_vm.ativos.situacao, null) > -1 : (_vm.ativos.situacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.situacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "situacao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "situacao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "situacao", $$c)
        }
      }
    }
  }), _vm._v("Situação ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.tipo),
      expression: "ativos.tipo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.tipo) ? _vm._i(_vm.ativos.tipo, null) > -1 : (_vm.ativos.tipo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.tipo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "tipo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "tipo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "tipo", $$c)
        }
      }
    }
  }), _vm._v("Tipo ")])]), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.dt_solicitacao),
      expression: "ativos.dt_solicitacao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.dt_solicitacao) ? _vm._i(_vm.ativos.dt_solicitacao, null) > -1 : (_vm.ativos.dt_solicitacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.dt_solicitacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "dt_solicitacao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "dt_solicitacao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "dt_solicitacao", $$c)
        }
      }
    }
  }), _vm._v("Dt. Solicitação ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.dt_realizacao),
      expression: "ativos.dt_realizacao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.dt_realizacao) ? _vm._i(_vm.ativos.dt_realizacao, null) > -1 : (_vm.ativos.dt_realizacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.dt_realizacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "dt_realizacao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "dt_realizacao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "dt_realizacao", $$c)
        }
      }
    }
  }), _vm._v("Dt. Realização ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.cidadao),
      expression: "ativos.cidadao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.cidadao) ? _vm._i(_vm.ativos.cidadao, null) > -1 : (_vm.ativos.cidadao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.cidadao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "cidadao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "cidadao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "cidadao", $$c)
        }
      }
    }
  }), _vm._v("Cidadão ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.cidade),
      expression: "ativos.cidade"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.cidade) ? _vm._i(_vm.ativos.cidade, null) > -1 : (_vm.ativos.cidade)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.cidade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "cidade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "cidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "cidade", $$c)
        }
      }
    }
  }), _vm._v("Cidade ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.bairro),
      expression: "ativos.bairro"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.bairro) ? _vm._i(_vm.ativos.bairro, null) > -1 : (_vm.ativos.bairro)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.bairro,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "bairro", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "bairro", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "bairro", $$c)
        }
      }
    }
  }), _vm._v("Bairro ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.telefone),
      expression: "ativos.telefone"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.telefone) ? _vm._i(_vm.ativos.telefone, null) > -1 : (_vm.ativos.telefone)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.telefone,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "telefone", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "telefone", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "telefone", $$c)
        }
      }
    }
  }), _vm._v("Telefone ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.rg),
      expression: "ativos.rg"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.rg) ? _vm._i(_vm.ativos.rg, null) > -1 : (_vm.ativos.rg)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.rg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "rg", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "rg", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "rg", $$c)
        }
      }
    }
  }), _vm._v("RG ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.nome_mae),
      expression: "ativos.nome_mae"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.nome_mae) ? _vm._i(_vm.ativos.nome_mae, null) > -1 : (_vm.ativos.nome_mae)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.nome_mae,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "nome_mae", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "nome_mae", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "nome_mae", $$c)
        }
      }
    }
  }), _vm._v("Nome da Mãe ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.dt_nascimento),
      expression: "ativos.dt_nascimento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.dt_nascimento) ? _vm._i(_vm.ativos.dt_nascimento, null) > -1 : (_vm.ativos.dt_nascimento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.dt_nascimento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "dt_nascimento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "dt_nascimento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "dt_nascimento", $$c)
        }
      }
    }
  }), _vm._v("Dt. Nasc ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.idade),
      expression: "ativos.idade"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.idade) ? _vm._i(_vm.ativos.idade, null) > -1 : (_vm.ativos.idade)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.idade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "idade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "idade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "idade", $$c)
        }
      }
    }
  }), _vm._v("Idade ")])]), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.id),
      expression: "ativos.id"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.id) ? _vm._i(_vm.ativos.id, null) > -1 : (_vm.ativos.id)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "id", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "id", $$c)
        }
      }
    }
  }), _vm._v("ID ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.quantidade),
      expression: "ativos.quantidade"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.quantidade) ? _vm._i(_vm.ativos.quantidade, null) > -1 : (_vm.ativos.quantidade)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.quantidade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "quantidade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "quantidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "quantidade", $$c)
        }
      }
    }
  }), _vm._v("Quantidade")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.tipo_consulta),
      expression: "ativos.tipo_consulta"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.tipo_consulta) ? _vm._i(_vm.ativos.tipo_consulta, null) > -1 : (_vm.ativos.tipo_consulta)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.tipo_consulta,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "tipo_consulta", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "tipo_consulta", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "tipo_consulta", $$c)
        }
      }
    }
  }), _vm._v("Consulta")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.procedimento),
      expression: "ativos.procedimento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.procedimento) ? _vm._i(_vm.ativos.procedimento, null) > -1 : (_vm.ativos.procedimento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.procedimento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "procedimento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "procedimento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "procedimento", $$c)
        }
      }
    }
  }), _vm._v("Procedimento ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [(this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.valor),
      expression: "ativos.valor"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.valor) ? _vm._i(_vm.ativos.valor, null) > -1 : (_vm.ativos.valor)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.valor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "valor", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "valor", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "valor", $$c)
        }
      }
    }
  }), _vm._v("Valor ")])]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.valor_s),
      expression: "ativos.valor_s"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.valor_s) ? _vm._i(_vm.ativos.valor_s, null) > -1 : (_vm.ativos.valor_s)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.valor_s,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "valor_s", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "valor_s", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "valor_s", $$c)
        }
      }
    }
  }), _vm._v("Valor S ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.unid_solic),
      expression: "ativos.unid_solic"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.unid_solic) ? _vm._i(_vm.ativos.unid_solic, null) > -1 : (_vm.ativos.unid_solic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.unid_solic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "unid_solic", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "unid_solic", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "unid_solic", $$c)
        }
      }
    }
  }), _vm._v("Unid. Solicitante ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.unid_prest),
      expression: "ativos.unid_prest"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.unid_prest) ? _vm._i(_vm.ativos.unid_prest, null) > -1 : (_vm.ativos.unid_prest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.unid_prest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "unid_prest", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "unid_prest", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "unid_prest", $$c)
        }
      }
    }
  }), _vm._v("Unid. Realizadora ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.prof_prest),
      expression: "ativos.prof_prest"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.prof_prest) ? _vm._i(_vm.ativos.prof_prest, null) > -1 : (_vm.ativos.prof_prest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.prof_prest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "prof_prest", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "prof_prest", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "prof_prest", $$c)
        }
      }
    }
  }), _vm._v("Prof. Prestador ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.prof_solic),
      expression: "ativos.prof_solic"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.prof_solic) ? _vm._i(_vm.ativos.prof_solic, null) > -1 : (_vm.ativos.prof_solic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.prof_solic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "prof_solic", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "prof_solic", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "prof_solic", $$c)
        }
      }
    }
  }), _vm._v("Prof. Solicitante ")])]), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.marcador),
      expression: "ativos.marcador"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.marcador) ? _vm._i(_vm.ativos.marcador, null) > -1 : (_vm.ativos.marcador)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.marcador,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "marcador", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "marcador", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "marcador", $$c)
        }
      }
    }
  }), _vm._v("Marcador ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [(this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.regulador),
      expression: "ativos.regulador"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.regulador) ? _vm._i(_vm.ativos.regulador, null) > -1 : (_vm.ativos.regulador)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.regulador,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "regulador", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "regulador", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "regulador", $$c)
        }
      }
    }
  }), _vm._v("Regulador ")])]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.agp_unidades),
      expression: "ativos.agp_unidades"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.agp_unidades) ? _vm._i(_vm.ativos.agp_unidades, null) > -1 : (_vm.ativos.agp_unidades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.agp_unidades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "agp_unidades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "agp_unidades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "agp_unidades", $$c)
        }
      }
    }
  }), _vm._v("Agrupamento de Unidades ")])]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.usu_cancelamento),
      expression: "ativos.usu_cancelamento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.usu_cancelamento) ? _vm._i(_vm.ativos.usu_cancelamento, null) > -1 : (_vm.ativos.usu_cancelamento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.usu_cancelamento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "usu_cancelamento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "usu_cancelamento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "usu_cancelamento", $$c)
        }
      }
    }
  }), _vm._v("Usuário Cancelamento ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.dt_cancelamento),
      expression: "ativos.dt_cancelamento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.dt_cancelamento) ? _vm._i(_vm.ativos.dt_cancelamento, null) > -1 : (_vm.ativos.dt_cancelamento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.dt_cancelamento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "dt_cancelamento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "dt_cancelamento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "dt_cancelamento", $$c)
        }
      }
    }
  }), _vm._v("Data Cancelamento ")])]), _vm._v(" "), _c('br')])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Solicitações")])])])
}]}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ano")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.ano),
      expression: "filtros.ano"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ano"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "ano", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2026"
    }
  }, [_vm._v("2026")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2025"
    }
  }, [_vm._v("2025")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2024"
    }
  }, [_vm._v("2024")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2023"
    }
  }, [_vm._v("2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2021"
    }
  }, [_vm._v("2021")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2020"
    }
  }, [_vm._v("2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mês")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.mes),
      expression: "filtros.mes"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "mes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- TODOS --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v("Janeiro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("Fevereiro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "03"
    }
  }, [_vm._v("Março")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "04"
    }
  }, [_vm._v("Abril")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("Maio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("Junho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("Julho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("Agosto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("Setembro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Outubro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Novembro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Dezembro")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 form-group"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary form-control",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Buscar"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Buscar\n              ")])])]), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable) && !_vm.pdf) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.ano))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "0"
      }
    }, [_c('table', {
      staticClass: "table table-bordered table-striped",
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidade_disponivel_primeira))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidade_disponivel_retorno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidade_disponivel_local))])])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "0"
      }
    }, [_c('table', {
      staticClass: "table table-bordered table-striped",
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidade_agendada_primeira))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidade_agendada_retorno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidade_agendada_local))])])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "0"
      }
    }, [_c('table', {
      staticClass: "table table-bordered table-striped",
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidade_realizada_primeira))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidade_realizada_retorno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidade_realizada_local))])])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.oferta))])])
  }))])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-10 col-sm-2 text-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pdf),
      expression: "!pdf"
    }],
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF\n                ")])])]) : _c('div', [_vm._v("Nenhum registro encontrado.")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Oferta Anual de Procedimentos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th', [_vm._v("Mês")]), _vm._v(" "), _c('th', [_vm._v("Unidade")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Profissional")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Quantidade Disponível")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Quantidade Agendada")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Quantidade Realizada")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Total da Oferta")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("P")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("R")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("L")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("P")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("R")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("L")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("P")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("R")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("L")])])])
}]}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do paciente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nm_pessoa),
      expression: "filtros.nm_pessoa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.nm_pessoa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nm_pessoa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome da mãe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nm_mae),
      expression: "filtros.nm_mae"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.nm_mae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nm_mae", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de nascimento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dt_nascimento),
      expression: "filtros.dt_nascimento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.dt_nascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dt_nascimento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nr_rg),
      expression: "filtros.nr_rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.nr_rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nr_rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CNS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nr_cartao_sus),
      expression: "filtros.nr_cartao_sus"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.nr_cartao_sus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nr_cartao_sus", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.dataTable.data) ? _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.nr_cartao_sus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nr_rg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.dt_nascimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("idade")(item.dt_nascimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nm_mae))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-sm btn-warning",
      attrs: {
        "tag": "a",
        "target": "_blank",
        "to": '/integracao/pacientes/visualizar/' + item.cd_pessoa,
        "title": "Visualizar detalhes"
      }
    }, [_c('span', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-sm btn-success",
      attrs: {
        "tag": "a",
        "target": "_blank",
        "to": '/integracao/pacientes/historico/' + item.cd_pessoa,
        "title": "Visualizar histórico do paciente"
      }
    }, [_c('span', {
      staticClass: "fa fa-history"
    })])], 1)])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\tMostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Cadastros de pacientes do sistema antigo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Buscar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("CNS")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("RG")]), _vm._v(" "), _c('th', [_vm._v("Data de nascimento")]), _vm._v(" "), _c('th', [_vm._v("Idade")]), _vm._v(" "), _c('th', [_vm._v("Nome da mãe")]), _vm._v(" "), _c('th', [_vm._v("Ação")])])])
}]}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": '/administracao/agendas/novo-subgrupo/' + _vm.$route.params.contratoId
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecalho-contrato', {
    attrs: {
      "contrato-id": _vm.$route.params.contratoId
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome_subgrupo),
      expression: "filtros.nome_subgrupo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Subgrupo"
    },
    domProps: {
      "value": (_vm.filtros.nome_subgrupo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome_subgrupo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sexo),
      expression: "filtros.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--SEXO--")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.AMBOS
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("Feminino")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.idade_minima),
      expression: "filtros.idade_minima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Idade Mínima"
    },
    domProps: {
      "value": (_vm.filtros.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "idade_minima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.idade_maxima),
      expression: "filtros.idade_maxima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Idade Máxima"
    },
    domProps: {
      "value": (_vm.filtros.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "idade_maxima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped",
    staticStyle: {
      "margin": "15px 0 0 0"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      class: {
        'ativa': _vm.indexAtivo === index
      },
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.getAtendimentos(index, item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.contrato_subgrupo.subgrupo.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("sexo")(item.sexo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.idade_minima))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.idade_maxima))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-5",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tMostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexAtivo != undefined),
      expression: "indexAtivo != undefined"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 1)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [(item.tipo_consumo == 1) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_paciente) + " Pacientes ")]) : _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_atendimento) + " P  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 2)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [(item.tipo_consumo == 1) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_paciente) + " Pacientes ")]) : _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_atendimento) + " P  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 3)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [(item.tipo_consumo == 1) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_paciente) + " Pacientes ")]) : _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_atendimento) + " P  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 4)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [(item.tipo_consumo == 1) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_paciente) + " Pacientes ")]) : _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_atendimento) + " P  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 5)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [(item.tipo_consumo == 1) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_paciente) + " Pacientes ")]) : _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_atendimento) + " P  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 6)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [(item.tipo_consumo == 1) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_paciente) + " Pacientes ")]) : _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_atendimento) + " P  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 0)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [(item.tipo_consumo == 1) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_paciente) + " Pacientes ")]) : _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_atendimento) + " P  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])]), _vm._v(" "), _c('modal-editar-subgrupo-atendimento', {
    attrs: {
      "atendimento": _vm.atendimento,
      "show": _vm.showModalEditarSubgrupo
    },
    on: {
      "close": function($event) {
        _vm.showModalEditarSubgrupo = false
      },
      "subgrupoAtendimentoAtualizado": function (subgrupo) {
        _vm.subgrupoAtendimentoAtualizado(subgrupo)
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Atendimentos de subgrupo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Filtros: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Subgrupo")]), _vm._v(" "), _c('th', [_vm._v("Sexo")]), _vm._v(" "), _c('th', [_vm._v("Idade Mínima")]), _vm._v(" "), _c('th', [_vm._v("Idade Máxima")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Segunda-feira")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Terça-feira")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Quarta-feira")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Quinta-feira")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Sexta-feira")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Sábado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v("Domingo")])])])
}]}

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['esc']),
      expression: "['esc']"
    }],
    on: {
      "shortkey": function($event) {
        _vm.showModal = false
      },
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.up()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.down()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.enter()
      }]
    }
  }, [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerPaciente
    },
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.$props.nomePacienteRecuperado ? _vm.$props.nomePacienteRecuperado : _vm.pacienteSelecionado.nome
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', '2']),
      expression: "['alt', '2']"
    }],
    ref: "btnBuscarPaciente",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerPaciente,
      'btn-default': !_vm.$props.showTextDangerPaciente
    },
    attrs: {
      "type": "button"
    },
    on: {
      "shortkey": function($event) {
        (_vm.showModal = true), _vm.focoNomePaciente()
      },
      "click": function($event) {
        (_vm.showModal = true), _vm.focoNomePaciente()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), (!_vm.regulador) ? _c('router-link', {
    attrs: {
      "target": "_blank",
      "to": '/cadastros/pacientes/editar/' + this.pacienteSelecionado.id
    }
  }, [_c('button', {
    ref: "btnBuscarEditar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerPaciente,
      'btn-default': !_vm.$props.showTextDangerPaciente
    },
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])]) : _vm._e(), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerPaciente,
      'btn-default': !_vm.$props.showTextDangerPaciente
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showFormAddPaciente),
      expression: "!showFormAddPaciente"
    }],
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Paciente")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do paciente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome),
      expression: "filtros.nome"
    }],
    ref: "inputPaciente",
    staticClass: "form-control",
    attrs: {
      "title": "[ ctrl + b ] Para pesquisar",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome da mãe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome_mae),
      expression: "filtros.nome_mae"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.nome_mae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome_mae", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.cpf),
      expression: "filtros.cpf"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "cpf", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Dt. Nasc")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_nascimento),
      expression: "filtros.data_nascimento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.data_nascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_nascimento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.rg),
      expression: "filtros.rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CNS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.cartao_sus),
      expression: "filtros.cartao_sus"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.cartao_sus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "cartao_sus", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Municipio")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.municipio),
      expression: "filtros.municipio"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.municipio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "municipio", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['ctrl', 'b']),
      expression: "['ctrl', 'b']"
    }],
    staticClass: "btn btn-default btn-block",
    attrs: {
      "title": "[ ctrl + b ] Para pesquisar"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      },
      "shortkey": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("CNS")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("RG")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Dt. Nascimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Idade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Mãe")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Município")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      class: {
        ativa: index === _vm.pacienteSelecionadoIndex
      },
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.cartao_sus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sexo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_nascimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("idade")(item.data_nascimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome_mae))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cpf))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cidade.nome))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    ref: "btnPaciente",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")]), _vm._v(" "), (!_vm.regulador) ? _c('button', {
    ref: "btnPaciente",
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showFormAddPaciente = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo paciente")]) : _vm._e()])])]), _vm._v(" "), (!_vm.regulador) ? _c('form-add-paciente', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFormAddPaciente),
      expression: "showFormAddPaciente"
    }],
    attrs: {
      "cidade-unidade-solicitante": _vm.$props.cidadeUnidadeSolicitante
    },
    on: {
      "pacienteSelecionado": function (paciente) {
        _vm.seleciona(paciente);
      },
      "close": function($event) {
        _vm.showFormAddPaciente = false
      }
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": ("/administracao/contratos/subgrupos/novo/" + (_vm.$route.params.contrato_id))
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar Subgrupo")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecario-contrato', {
    attrs: {
      "contratoId": _vm.$route.params.contrato_id
    }
  }), _vm._v(" "), _c('filtro-contrato-subgrupo', {
    on: {
      "filtrar": function (filtros) {
        _vm.filtrar(filtros);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                Subgrupo\n                                                "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('procedimento_subgrupos.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'procedimento_subgrupos.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Limite Financeiro")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.valor, 2, ",", ".")))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/contratos/subgrupos/atualizacao/" + (item.id)),
        "title": " Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Excluir"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-close",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Subgrupos do Contratos")])])
}]}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        $event.stopPropagation();
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subgrupoSelecionado.subgrupo.nome),
      expression: "subgrupoSelecionado.subgrupo.nome"
    }],
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerSubgrupo
    },
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.subgrupoSelecionado.subgrupo.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subgrupoSelecionado.subgrupo, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerSubgrupo,
      'btn-default': !_vm.$props.showTextDangerSubgrupo
    },
    attrs: {
      "disabled": _vm.$props.nomeSubgrupo != undefined,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerSubgrupo,
      'btn-default': !_vm.$props.showTextDangerSubgrupo
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask not-valited"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Subgrupo")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código do subgrupo e pressione enter."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.subgrupo.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subgrupo.nome))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t\t")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unidadeSelecionada.nome),
      expression: "unidadeSelecionada.nome"
    }],
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerUnidade
    },
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.unidadeSelecionada.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unidadeSelecionada, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerUnidade,
      'btn-default': !_vm.$props.showTextDangerUnidade
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerProfissional,
      'btn-default': !_vm.$props.showTextDangerProfissional
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Unidade")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome da unidade e pressione enter."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Categoria")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cnpj))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("categoria")(item.categoria)))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t\t\t\t\t")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecario-contrato', {
    attrs: {
      "contratoId": _vm.$route.params.contrato_id ? _vm.$route.params.contrato_id : _vm.dados.contrato.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerProcedimento
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    attrs: {
      "show-text-danger-procedimento": _vm.showTextDangerProcedimento,
      "nomeProcedimento": _vm.dados.procedimento.nome
    },
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerPreparo
    }
  }, [_vm._v("Preparo")]), _vm._v(" "), _c('select-preparo', {
    attrs: {
      "show-text-danger-preparo": _vm.showTextDangerPreparo,
      "nomePreparo": _vm.dados.preparo.nome
    },
    on: {
      "setPreparoSelecionado": function (preparoSelecionado) {
        _vm.setPreparoSelecionado(preparoSelecionado)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerValor
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerValor
    }
  }, [_vm._v("Valor (R$)")]), _vm._v(" "), _c('money', _vm._b({
    ref: "valor",
    staticClass: "form-control",
    attrs: {
      "autofocus": ""
    },
    model: {
      value: (_vm.dados.valor),
      callback: function($$v) {
        _vm.$set(_vm.dados, "valor", $$v)
      },
      expression: "dados.valor"
    }
  }, 'money', _vm.money, false))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerTipoLimite
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTipoLimite
    }
  }, [_vm._v("Tipo de Limite")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_limite),
      expression: "dados.tipo_limite"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Selecione"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_limite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.procedimentoSelecionado.tipo_atendimento == 0) ? _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Procedimento")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), (_vm.procedimentoSelecionado.tipo_atendimento == 0) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Geral")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimite
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimite
    }
  }, [_vm._v("Limite Físico")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.limite.quantidade),
      expression: "dados.limite.quantidade"
    }],
    ref: "limite_fisico",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.dados.tipo_limite == 0 ? false : true,
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.limite.quantidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados.limite, "quantidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Valor Total (R$)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": _vm._f("numberFormat")(_vm.controle.limite_financeiro, 2, ',', '.')
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo Procedimento do Contrato")])])])
}]}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/cadastros/formas-organizacao-procedimento/novo"
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código da forma de organização."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "hand",
      attrs: {
        "tag": "tr",
        "to": '/cadastros/formas-organizacao-procedimento/editar/' + item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subgrupo.nome))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Formas de organização")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Subgrupo")])])])
}]}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MENU DE NAVEGAÇÃO")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Início")])])]), _vm._v(" "), (this.hasPermission(['contrato.read', 'agenda.read', 'relatorio.solicitacao', 'relatorio.escalas', 'relatorio.ofertas', 'relatorio.usuarios'])) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("ADMINISTRAÇÃO")]) : _vm._e(), _vm._v(" "), (this.hasPermission('contrato.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/contratos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Contratos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('agenda.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/agendas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Agenda")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission(['relatorio.solicitacao', 'relatorio.escalas', 'relatorio.ofertas', 'relatorio.usuarios', 'relatorio.agenda.prestador'])) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.hasPermission('relatorio.escalas')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/escalas"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Escalas")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.ofertas')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.hasPermission('relatorio.ofertas')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/ofertas"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Procedimentos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.ofertas')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/ofertas-anual"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Procedimentos (Anual)")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.ofertas')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/ofertas-subgrupos-anual"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Subgrupos (Anual)")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.usuarios')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/usuarios"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Relação de Usuários")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.agenda.prestador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/agenda-prestador"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Agenda do prestador")])])]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel == 'administrador') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/consumo-limites"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Consumo Limites")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.solicitacao')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.hasPermission('relatorio.solicitacao')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/solicitacoes"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Analítico")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('relatorio.solicitacao')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/relatorios/solicitacoes-sintetico"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Sintético")])])]) : _vm._e()], 1)]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (this.hasPermission('contrato.write')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/parametros"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Parâmetros Gerais")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('contrato.write')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/comunicados"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Comunicados")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission(['distribuicao.read', 'distribuicao.contrato.read', 'distribuicao.agenda.read'])) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("DISTRIBUIÇÃO")]) : _vm._e(), _vm._v(" "), (this.hasPermission('distribuicao.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/distribuicao/distribuir"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-share-alt-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Distribuir")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('distribuicao.contrato.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/distribuicao/controle-contratos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Controle de Contratos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('distribuicao.agenda.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/distribuicao/controle-atendimentos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Controle da Agenda")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission(['solicitacao.write', 'solicitacao.read', 'solicitacao.regular', 'solicitacao.atendidoFalta'])) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("ATENDIMENTOS")]) : _vm._e(), _vm._v(" "), (this.hasPermission('solicitacao.write')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/atendimentos/solicitacao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Solicitar")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('solicitacao.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/atendimentos/verificacao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Verificar")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('solicitacao.regular')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/atendimentos/regulacao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-stethoscope"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Regular")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('solicitacao.atendidoFalta')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/atendimentos/atendido-falta"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Atendido/Falta")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission(['paciente.read', 'profissional.read', 'unidade.read', 'grupo.read', 'subgrupo.read', 'forma.organizacao.read', 'procedimento.read'])) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("CADASTROS")]) : _vm._e(), _vm._v(" "), (this.hasPermission('paciente.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/pacientes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pacientes")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('profissional.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/profissionais"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Profissionais")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('unidade.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/unidades"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bank"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Unidades")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('unidade.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/preparos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bolt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Preparos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission(['grupo.read', 'subgrupo.read', 'forma.organizacao.read', 'procedimento.read'])) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.hasPermission('grupo.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/grupos-procedimento"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Grupos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('subgrupo.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/subgrupos-procedimento"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Subgrupos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('forma.organizacao.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/formas-organizacao-procedimento"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Forma de Organização")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('procedimento.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/procedimentos"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Procedimentos")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (this.hasPermission('usuario.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/usuarios"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuários do Sistema")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('paciente-integracao.read')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("INTEGRAÇÃO COM O SISTEMA ANTIGO")]) : _vm._e(), _vm._v(" "), (this.hasPermission('paciente-integracao.read')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/integracao/pacientes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pacientes")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" "), _c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" "), _c('span', [_vm._v("Ofertas")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" "), _c('span', [_vm._v("Solicitações")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v(" "), _c('span', [_vm._v("Procedimentos")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
}]}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }, {
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['ctrl', 'enter']),
      expression: "['ctrl', 'enter']"
    }],
    staticClass: "modal-mask",
    on: {
      "shortkey": function($event) {
        _vm.adiciona()
      }
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Deseja incluir este procedimento na solicitação?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$props.contratoProcedimento.procedimento.codigo))])]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$props.contratoProcedimento.procedimento.nome))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantidade),
      expression: "quantidade"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$props.contratoProcedimento.procedimento.quantidade_maxima == 1 || this.$props.contratoProcedimento.procedimento.tipo_atendimento == 1,
      "type": "number"
    },
    domProps: {
      "value": (_vm.quantidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantidade = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de Atendimento:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoConsulta),
      expression: "tipoConsulta"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipoConsulta = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(this.$store.state.user.nivel != 'prestador') ? _c('option', {
    domProps: {
      "value": _vm.TIPO_CONSULTA.PRIMEIRA
    }
  }, [_vm._v("Primeira")]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('option', {
    domProps: {
      "value": _vm.TIPO_CONSULTA.RETORNO
    }
  }, [_vm._v("Retorno")]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel == 'prestador') ? _c('option', {
    domProps: {
      "value": _vm.TIPO_CONSULTA.LOCAL
    }
  }, [_vm._v("Local")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMsgQtdMax),
      expression: "showMsgQtdMax"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("A quantidade informada é maior que a quantidade máxima permitida para este procedimento.")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")]), _vm._v(" "), _c('button', {
    ref: "btnAdicionar",
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adiciona()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar ( ctrl + enter )")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/distribuicoes/contratos/novo"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com NOME DA UNIDADE"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.categoria_unidade),
      expression: "filtros.categoria_unidade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "categoria_unidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Categoria--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Pública (Local)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Município Pactuado (PPI)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Privada")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo),
      expression: "filtros.tipo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Tipo--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Solicitante")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Prestador")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Competência")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.distribuicao_id),
      expression: "filtros.distribuicao_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "distribuicao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.distribuicoes), function(distribuicao, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": distribuicao.id
      }
    }, [_vm._v(_vm._s(_vm._f("competencia")(distribuicao.data_competencia)))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Situação--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.getDataTable
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                        ID\n                        "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('distribuicao_contratos.id')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'distribuicao_contratos.id' ? ("fa fa-sort-numeric" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                        Unidade\n                        "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('unidades.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'unidades.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Ação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("categoriaUnidade")(item.categoria)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoContrato")(item.tipo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_inicial)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_final)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacao")(item.situacao)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/distribuicoes/contratos/atualizacao/" + (item.id)),
        "title": "Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/distribuicoes/contratos/procedimentos/" + (item.id)),
        "title": " Procedimentos do Contrato"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/distribuicoes/contratos/subgrupos/" + (item.id)),
        "title": "Subgrupos do Contrato"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list-alt",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Controle de Contratos")])])
}]}

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/cadastros/profissionais/novo"
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou CNS do profissional."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "hand",
      attrs: {
        "tag": "tr",
        "to": '/cadastros/profissionais/editar/' + item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cns))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacao")(item.situacao)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Profissionais")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("CNS")]), _vm._v(" "), _c('th', [_vm._v("Nome do profissional")]), _vm._v(" "), _c('th', [_vm._v("Situação")])])])
}]}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecalho-contrato', {
    attrs: {
      "contrato-id": _vm.$route.params.contratoId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('profissional')
    }
  }, [_c('label', [_vm._v("Profissional")]), _vm._v(" "), _c('select-profissional', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "profissional",
      "show-text-danger-profissional": _vm.showTextDangerProfissional
    },
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSelecionado(profissionalSelecionado)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('profissional')),
      expression: "errors.has('profissional')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('profissional')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    class: {
      'has-error': _vm.showTextDangerProcedimento
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerProcedimento
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento-contrato', {
    attrs: {
      "semAgrupados": 1,
      "show-text-danger-procedimento": _vm.showTextDangerProcedimento,
      "contrato-id": _vm.$route.params.contratoId
    },
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.sexo),
      expression: "dados.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Feminino")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade mínima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_minima),
      expression: "dados.idade_minima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_minima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_maxima),
      expression: "dados.idade_maxima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_maxima", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Atendimentos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_primeira),
      expression: "dados.quantidade_primeira"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_primeira)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_primeira", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Retorno")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_retorno),
      expression: "dados.quantidade_retorno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_retorno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_retorno", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Local")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_local),
      expression: "dados.quantidade_local"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Dia(s)")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Dia da semana: ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "select-dias",
      "placeholder": "Clique para selecionar o(s) dia(s)...",
      "multiple": "",
      "options": _vm.selectDias
    },
    model: {
      value: (_vm.dias),
      callback: function($$v) {
        _vm.dias = $$v
      },
      expression: "dias"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerHoraInicial
    }
  }, [_c('label', [_vm._v("Hora inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.hora_inicial),
      expression: "dados.hora_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.hora_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "hora_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerHoraFinal
    }
  }, [_c('label', [_vm._v("Hora final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.hora_final),
      expression: "dados.hora_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.hora_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "hora_final", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-reply"
  }), _vm._v("\tVoltar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")])])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo atendimento de procedimento")])])])
}]}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Bloquear Atendimentos de Subgrupo")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.dados.tipo_consumo == 1) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos distribuidos (Por paciente)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_paciente_original
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos disponíveis (Por paciente)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_paciente_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos bloqueados (Por paciente)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_paciente_bloqueada),
      expression: "dados.quantidade_paciente_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_paciente_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_paciente_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])] : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_atendimento_original
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_atendimento_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_atendimento_bloqueada),
      expression: "dados.quantidade_atendimento_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_atendimento_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_atendimento_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_local_original
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_local_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_local_bloqueada),
      expression: "dados.quantidade_local_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Agendamentos ainda não realizados deste paciente")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$props.naoRealizados), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('strong', {
      class: _vm._f("situacaoSolicitacaoColor")(item.solicitacao.situacao)
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)) + "\n                                ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento)) + " às " + _vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.hora_inicial : item.contrato_subgrupo_atendimento.hora_inicial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.profissional.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.usuario.name))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      'pull-left': !_vm.$props.regulacao,
      'pull-right': _vm.$props.regulacao
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")]), _vm._v(" "), (!_vm.$props.regulacao) ? _c('button', {
    ref: "selecionarProfissional",
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.$emit('selecionarProfissional')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v(" Selecionar profissional")]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.cancelar),
      expression: "$props.cancelar"
    }]
  }, [_vm._v("Cancelar a solicitação?")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.confirmar),
      expression: "$props.confirmar"
    }]
  }, [_vm._v("Confirmar a solicitação?")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.adicionarInformacao),
      expression: "$props.adicionarInformacao"
    }]
  }, [_vm._v("Adicionar informações à solicitação?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.cancelar),
      expression: "$props.cancelar"
    }],
    attrs: {
      "for": ""
    }
  }, [_vm._v("Motivo do cancelamento:")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.confirmar),
      expression: "$props.confirmar"
    }],
    attrs: {
      "for": ""
    }
  }, [_vm._v("Observação (opcional):")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.adicionarInformacao),
      expression: "$props.adicionarInformacao"
    }],
    attrs: {
      "for": ""
    }
  }, [_vm._v("Informações:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.observacao),
      expression: "dados.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": (_vm.dados.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "observacao", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.cancelar),
      expression: "$props.cancelar"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelarSolicitacao()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.confirmar),
      expression: "$props.confirmar"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmarSolicitacao()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.adicionarInformacao),
      expression: "$props.adicionarInformacao"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addInformacao()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Enviar\n\t\t\t\t\t\t")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operador),
      expression: "operador"
    }],
    staticClass: "btn btn-default",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.operador = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ">"
    }
  }, [_vm._v("Depois de")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "="
    }
  }, [_vm._v("Igual a")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "<"
    }
  }, [_vm._v("Antes de")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "><"
    }
  }, [_vm._v("Período")])])]), _vm._v(" "), _c('div', {
    staticClass: "datepicker-trigger"
  }, [_c('button', {
    staticClass: "form-control",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "type": "text",
      "id": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": !_vm.operador
    }
  }, [_vm._v(_vm._s(_vm.formatDates(_vm.data, _vm.data2, _vm.operador)))]), _vm._v(" "), _c('AirbnbStyleDatepicker', {
    attrs: {
      "trigger-element-id": _vm.name,
      "mode": _vm.operador != '><' ? 'single' : 'range',
      "monthsToShow": _vm.operador != '><' ? 1 : 2,
      "fullscreen-mobile": true,
      "showActionButtons": false,
      "showShortcutsMenuTrigger": false,
      "date-one": _vm.data,
      "date-two": _vm.data2
    },
    on: {
      "date-one-selected": function (val) {
        _vm.data = val
      },
      "date-two-selected": function (val) {
        _vm.data2 = val
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Bloquear Atendimentos de Subgrupo por Período")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Filtros: ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select-subgrupo', {
    attrs: {
      "contrato-id": _vm.$route.params.distribuicaoContratoId,
      "placeholder": "SUBGRUPO"
    },
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sexo),
      expression: "filtros.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.AMBOS
    }
  }, [_vm._v("AMBOS")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("MASCULINO")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("FEMININO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('periodo_de')
    }
  }, [_c('label', [_vm._v("Período (De)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_inicial),
      expression: "filtros.data_inicial"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "periodo_de",
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "PERÍODO DE",
      "name": "periodo_de"
    },
    domProps: {
      "value": (_vm.filtros.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_inicial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('periodo_de')),
      expression: "errors.has('periodo_de')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('periodo_de')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('periodo_ate')
    }
  }, [_c('label', [_vm._v("Período (Até)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_final),
      expression: "filtros.data_final"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "periodo_ate",
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "PERÍODO DE",
      "name": "periodo_ate"
    },
    domProps: {
      "value": (_vm.filtros.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_final", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('periodo_ate')),
      expression: "errors.has('periodo_ate')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('periodo_ate')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('atendimento')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_atendimento_bloqueada),
      expression: "dados.quantidade_atendimento_bloqueada",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.dados.quantidade_local_bloqueada === '' ? 'required' : ''),
      expression: "dados.quantidade_local_bloqueada === '' ?'required' : ''"
    }],
    ref: "atendimento",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "atendimento"
    },
    domProps: {
      "value": (_vm.dados.quantidade_atendimento_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_atendimento_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('atendimento')),
      expression: "errors.has('atendimento')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos um bloqueio")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('local')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_local_bloqueada),
      expression: "dados.quantidade_local_bloqueada",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.dados.quantidade_atendimento_bloqueada === '' ? 'required' : ''),
      expression: "dados.quantidade_atendimento_bloqueada === '' ?'required' : ''"
    }],
    ref: "local",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "local"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('local')),
      expression: "errors.has('local')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Defina ao menos um bloqueio")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Confirmar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Envio para Regulação")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Motivo: ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.observacao),
      expression: "dados.observacao"
    }],
    ref: "motivo",
    staticClass: "form-control",
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": (_vm.dados.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "observacao", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.$emit('enviaRegulacao', _vm.dados.observacao)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Enviar\n\t\t\t\t\t")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/cadastros/pacientes/novo"
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do paciente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome),
      expression: "filtros.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome da mãe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome_mae),
      expression: "filtros.nome_mae"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.nome_mae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome_mae", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nº CEMAE")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.cemae),
      expression: "filtros.cemae"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.cemae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "cemae", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.cpf),
      expression: "filtros.cpf"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "cpf", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de nascimento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_nascimento),
      expression: "filtros.data_nascimento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.data_nascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_nascimento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Rg")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.rg),
      expression: "filtros.rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cartão do SUS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.cartao_sus),
      expression: "filtros.cartao_sus"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.cartao_sus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "cartao_sus", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Municipio")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.municipio),
      expression: "filtros.municipio"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.municipio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "municipio", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome_mae))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_nascimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cartao_sus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cpf))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-sm btn-warning",
      attrs: {
        "tag": "a",
        "to": '/cadastros/pacientes/editar/' + item.id,
        "title": "Editar paciente"
      }
    }, [_c('span', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-sm btn-success",
      attrs: {
        "tag": "a",
        "to": '/cadastros/pacientes/historico/' + item.id,
        "title": "Histórico do paciente"
      }
    }, [_c('span', {
      staticClass: "fa fa-history"
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Pacientes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome do paciente")]), _vm._v(" "), _c('th', [_vm._v("Nome da mãe")]), _vm._v(" "), _c('th', [_vm._v("Data de nascimento")]), _vm._v(" "), _c('th', [_vm._v("Rg")]), _vm._v(" "), _c('th', [_vm._v("Cartão do SUS")]), _vm._v(" "), _c('th', [_vm._v("CPF")]), _vm._v(" "), _c('th', [_vm._v("Ação")])])])
}]}

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.showModalBoleto && _vm.ultimaSolicitacao) ? _c('modal-boleto', {
    attrs: {
      "solicitacao": _vm.ultimaSolicitacao
    },
    on: {
      "close": function () {
        _vm.showModalBoleto = false;
        _vm.ultimaSolicitacao = null;
        this$1.selecionaProximo();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalDuplicacao) ? _c('modal-duplicacao', {
    attrs: {
      "solicitacoesNaoResolvidas": _vm.solicitacoesNaoResolvidas
    },
    on: {
      "confirma": function (justificativa) { return _vm.confirmaDuplicacao(justificativa); },
      "close": function () {
        _vm.showModalDuplicacao = false;
        _vm.solicitacoesNaoResolvidas = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalExtrapolacao) ? _c('modal-extrapolacao', {
    attrs: {
      "vagaSelecionada": _vm.vagaSelecionada
    },
    on: {
      "confirma": function (justificativa) { return _vm.confirmaExtrapolacao(justificativa); },
      "close": function () {
        _vm.showModalExtrapolacao = false;
        _vm.vagaSelecionada = null
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('pre', [_vm._v(_vm._s(_vm.vagaSelecionada))]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "panel panel-default panel-table"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        _vm.teste()
      }
    }
  }, [_c('b', [_vm._v("Procedimentos da Solicitação")]), _vm._v(" "), _c('small', [_vm._v("Selecione um procedimento para verificar os atendimentos disponíveis.")])])])])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped table-bordered table-list stripe table-hover table-seleciona-procedimento"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', {
    attrs: {
      "id": "corpo-table-procedimentos-agendados"
    }
  }, [_vm._l((_vm.procedimentos.individual), function(item, index) {
    return _c('tr', {
      key: index,
      class: {
        'ativa': _vm.procedimentoSelecionado.index === index,
        'resolvido': item.status == 'resolvido',
        'pendente': item.status == 'pendente'
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selecionaProcedimentoIndividual(index, item)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('i', {
      class: item.status == 'resolvido' ? 'fa fa-check' : 'fa fa-exclamation-triangle',
      attrs: {
        "title": item.status == 'resolvido' ? 'Resolvido' : 'Pendente'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento_quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento_codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("uppercase")(item.procedimento_nome)))]), _vm._v(" "), _c('td', [_vm._v("AGENDAMENTO")])])
  }), _vm._v(" "), _vm._l((_vm.procedimentos.agrupado), function(item, index) {
    return _c('tr', {
      key: item.id,
      class: {
        'ativa': _vm.procedimentoSelecionado.index === index,
        'resolvido': item[0].status == 'resolvido',
        'pendente': item[0].status == 'pendente'
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selecionaProcedimentoAgrupado(index, item)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle"
      }
    }, [_c('i', {
      class: item[0].status == 'resolvido' ? 'fa fa-check' : 'fa fa-exclamation-triangle',
      attrs: {
        "title": item[0].status == 'resolvido' ? 'Resolvido' : 'Pendente'
      }
    })]), _vm._v(" "), _c('td', _vm._l((item), function(proc) {
      return _c('span', [_vm._v("\n                            " + _vm._s(proc.procedimento_quantidade) + "\n                            "), _c('br')])
    })), _vm._v(" "), _c('td', _vm._l((item), function(proc) {
      return _c('span', [_vm._v("\n                            " + _vm._s(proc.procedimento_codigo) + "\n                            "), _c('br')])
    })), _vm._v(" "), _c('td', _vm._l((item), function(proc) {
      return _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("uppercase")(proc.procedimento_nome)) + "\n                            "), _c('br')])
    })), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_c('span', [_vm._v("[" + _vm._s(_vm._f("tipoAgrupamento")(item[0].procedimento_tipo_agrupamento)) + "] SELEÇÃO DE UNIDADES PARA AGRUPADOS")])])])
  })], 2)])])])]), _vm._v(" "), (_vm.procedimentoSelecionado.tipo == 'agrupado') ? _c('resolucao-agrupado', {
    attrs: {
      "solicitacao-id": _vm.solicitacaoId,
      "vagasApi": _vm.vagasApi,
      "dataNascimentoPaciente": this.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento
    },
    on: {
      "confirma": function (vagasSelecionadas) {
        _vm.confirmaAgrupado(vagasSelecionadas)
      },
      "enviaRegulacao": function (vagasSelecionadas, motivo) {
        _vm.enviaRegulacaoAgrupado(vagasSelecionadas, motivo)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.procedimentoSelecionado.tipo == 'individual') ? _c('resolucao-individual', {
    attrs: {
      "solicitacao-id": _vm.solicitacaoId,
      "vagasApi": _vm.vagasApi,
      "tipoVaga": _vm.procedimentoSelecionado.tipo_consulta,
      "dataNascimentoPaciente": this.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento
    },
    on: {
      "confirma": function (vagaSelecionada) {
        _vm.confirmaIndividual(vagaSelecionada)
      },
      "enviaRegulacao": function (vagaSelecionada, motivo) {
        _vm.enviaRegulacaoIndividual(vagaSelecionada, motivo)
      }
    }
  }) : _vm._e()], 1)])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Resolução da Solicitação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Qtd.")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Tipo de Pendência")])])])
}]}

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/cadastros/preparos/novo"
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.id),
      expression: "filtros.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do preparo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "hand",
      attrs: {
        "tag": "tr",
        "to": '/cadastros/preparos/editar/' + item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Preparos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Nome")])])])
}]}

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSolicitante(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Competência")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.distribuicao_id),
      expression: "filtros.distribuicao_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "distribuicao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.distribuicoes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(_vm._f("competencia")(item.data_competencia)))])
  }))])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": !_vm.finalizado,
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Solicitação",
      "id": "resultado"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar\n              ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.limite_geral) + parseFloat(item.total_consumido_geral)), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.total_consumido_geral), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.limite_geral), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_disponivel_procedimento) + parseFloat(item.total_consumido_procedimento)), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.total_consumido_procedimento), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.total_disponivel_procedimento), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_consumido_subgrupo)), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.total_consumido_subgrupo), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.total_disponivel_subgrupo), 2, ',', '.')))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.limite_geral) + parseFloat(item.total_consumido_geral) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.total_consumido_procedimento) + parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_consumido_subgrupo)), 2, ',', '.')))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_consumido_subgrupo) + parseFloat(item.total_consumido_procedimento) + parseFloat(item.total_consumido_geral)), 2, ',', '.')))])]), _vm._v(" "), _c('td', [((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) > 0) ? _c('strong', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)), 2, ',', '.')))]) : _vm._e(), _vm._v(" "), ((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) == 0) ? _c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)), 2, ',', '.')))]) : _vm._e(), _vm._v(" "), ((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) < 0) ? _c('strong', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)), 2, ',', '.')))]) : _vm._e()])])
  }))])]), _vm._v(" "), (_vm.dataTable.data && _vm.dataTable.data.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  })]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Consumo de Limites")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("UNIDADE")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("LIMITE POR GERAL")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("LIMITE POR PROCEDIMENTO")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("LIMITE POR SUBGRUPO")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("LIMITE TOTAL")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("---")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Consumido")]), _vm._v(" "), _c('th', [_vm._v("Disponível")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Consumido")]), _vm._v(" "), _c('th', [_vm._v("Disponível")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Consumido")]), _vm._v(" "), _c('th', [_vm._v("Disponível")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Consumido")]), _vm._v(" "), _c('th', [_vm._v("Disponível")])])])
}]}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    ref: "usuario",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.atualizarSenha($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('senha-atual')
    }
  }, [_c('label', {
    attrs: {
      "for": "usuario"
    }
  }, [_vm._v("Senha Atual:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.old_password),
      expression: "dados.old_password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "senha-atual",
      "type": "password"
    },
    domProps: {
      "value": (_vm.dados.old_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "old_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('senha-atual')),
      expression: "errors.has('senha-atual')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('senha-atual')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('senha')
    }
  }, [_c('label', {
    attrs: {
      "for": "senha"
    }
  }, [_vm._v("Nova Senha:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.password),
      expression: "dados.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "senha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.dados.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('senha')),
      expression: "errors.has('senha')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('senha')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('confirmacaoSenha')
    }
  }, [_c('label', {
    attrs: {
      "for": "confirmacaoSenha"
    }
  }, [_vm._v("Redigite a Nova Senha:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmacaoSenha),
      expression: "confirmacaoSenha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        is: _vm.dados.password
      }),
      expression: "{required:true, is:dados.password}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "confirmacaoSenha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmacaoSenha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmacaoSenha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmacaoSenha')),
      expression: "errors.has('confirmacaoSenha')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmacaoSenha')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-link', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a",
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancelar")]), _vm._v(" "), _vm._m(0)], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "fa fa-check"
  }), _vm._v(" Salvar")])
}]}

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("CPF "), (this.$store.state.user.nivel == 'regulador' || this.$store.state.user.nivel == 'administrador') ? _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "right",
      "margin": "0px 0px 0px 15px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.withoutCpf),
      expression: "withoutCpf"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.withoutCpf) ? _vm._i(_vm.withoutCpf, null) > -1 : (_vm.withoutCpf)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.withoutCpf,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.withoutCpf = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.withoutCpf = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.withoutCpf = $$c
        }
      }
    }
  }), _vm._v("Não informar CPF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.dados.cpf),
      expression: "dados.cpf",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.withoutCpf ? '' : 'required|validarCpf'),
      expression: "withoutCpf ? '' : 'required|validarCpf'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cpf"
    },
    domProps: {
      "value": (_vm.dados.cpf)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.dados, "cpf", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cpf')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome Social")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome_social),
      expression: "dados.nome_social"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome_social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome_social)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome_social", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cartão SUS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cartao_sus),
      expression: "dados.cartao_sus"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "15",
      "name": "cartao-sus",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cartao_sus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cartao_sus", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cartao-sus')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_nascimento),
      expression: "dados.data_nascimento"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data-nascimento",
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_nascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_nascimento", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('data-nascimento')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Naturalidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.naturalidade),
      expression: "dados.naturalidade"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "naturalidade",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.naturalidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "naturalidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##########'),
      expression: "'##########'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.rg),
      expression: "dados.rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Orgão emissor do RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.orgao_emissor_rg),
      expression: "dados.orgao_emissor_rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.orgao_emissor_rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "orgao_emissor_rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("UF do RG")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.uf_rg),
      expression: "dados.uf_rg"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "uf_rg", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o UF...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AC"
    }
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    }
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    }
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GO"
    }
  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    }
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    }
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("TO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de emissão do RG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_emissao_rg),
      expression: "dados.data_emissao_rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_emissao_rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_emissao_rg", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.sexo),
      expression: "dados.sexo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "sexo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("Feminino")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('sexo')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Estado civil")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.estado_civil),
      expression: "dados.estado_civil"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estado-civil"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "estado_civil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.ESTADO_CIVIL.SOLTEIRO
    }
  }, [_vm._v("Solteiro (a)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.ESTADO_CIVIL.CASADO
    }
  }, [_vm._v("Casado (a)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.ESTADO_CIVIL.DESQUITADO
    }
  }, [_vm._v("Desquitado (a)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.ESTADO_CIVIL.DIVORCIADO
    }
  }, [_vm._v("Divorciado (a)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.ESTADO_CIVIL.VIUVO
    }
  }, [_vm._v("Viúvo (a)")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('estado-civil')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:13'),
      expression: "'required|min:13'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['(##)#####-####', '(##)####-####']),
      expression: "['(##)#####-####', '(##)####-####']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.telefone),
      expression: "dados.telefone"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "telefone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "telefone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('telefone')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ocupação")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.ocupacao),
      expression: "dados.ocupacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.ocupacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "ocupacao", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome da mãe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome_mae),
      expression: "dados.nome_mae"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome-mae",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome_mae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome_mae", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nome-mae')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome do pai")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome_pai),
      expression: "dados.nome_pai"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome_pai)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome_pai", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome do responsável")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome_responsavel),
      expression: "dados.nome_responsavel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome_responsavel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome_responsavel", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['#####-###']),
      expression: "['#####-###']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cep),
      expression: "dados.cep"
    }],
    ref: "cep",
    staticClass: "form-control",
    attrs: {
      "name": "cep",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cep)
    },
    on: {
      "blur": function($event) {
        _vm.getEndereco()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cep", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cep')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.endereco),
      expression: "dados.endereco"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.numero_endereco),
      expression: "dados.numero_endereco"
    }],
    ref: "numero_endereco",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.numero_endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "numero_endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.bairro),
      expression: "dados.bairro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "bairro", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.complemento_endereco),
      expression: "dados.complemento_endereco"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.complemento_endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "complemento_endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cidade),
      expression: "dados.cidade"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("UF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.uf),
      expression: "dados.uf"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.uf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "uf", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de certidão")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_certidao_auxiliar),
      expression: "dados.tipo_certidao_auxiliar"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_certidao_auxiliar", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_CERTIDAO.NASCIMENTO
    }
  }, [_vm._v("Nascimento")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_CERTIDAO.CASAMENTO
    }
  }, [_vm._v("Casamento")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_CERTIDAO.SEPARACAO
    }
  }, [_vm._v("Separação/Divórcio")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cartório")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cartorio_auxiliar),
      expression: "dados.cartorio_auxiliar"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cartorio_auxiliar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cartorio_auxiliar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Livro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.livro_auxiliar),
      expression: "dados.livro_auxiliar"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.livro_auxiliar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "livro_auxiliar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Folha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.folha_auxiliar),
      expression: "dados.folha_auxiliar"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.folha_auxiliar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "folha_auxiliar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Registro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.registro_auxiliar),
      expression: "dados.registro_auxiliar"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.registro_auxiliar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "registro_auxiliar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de emissão")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_emissao_auxiliar),
      expression: "dados.data_emissao_auxiliar"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_emissao_auxiliar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_emissao_auxiliar", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "situacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SITUACAO.ATIVA
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO.INATIVA
    }
  }, [_vm._v("Inativo")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('situacao')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Anotações")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.anotacoes),
      expression: "dados.anotacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7"
    },
    domProps: {
      "value": (_vm.dados.anotacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "anotacoes", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.withoutCpf) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Justifique por qual motivo o cadastro está sendo realizado sem CPF")]) : _vm._e()])])]), _vm._v(" "), (_vm.withoutCpf) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("GEP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.gep),
      expression: "dados.gep"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.gep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "gep", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Informe o número do GEP referente ao cadastro SEM CPF")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    ref: "btnPaciente",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    ref: "btnPaciente",
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar\n\t\t\t\t\t")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Novo paciente")])])
}]}

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.boxTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Código")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.##.##.###-#'),
      expression: "'##.##.##.###-#'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.codigo),
      expression: "dados.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "codigo",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "codigo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('codigo')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de atendimento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_atendimento),
      expression: "dados.tipo_atendimento"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipo-de-atendimento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_atendimento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.TIPO_ATENDIMENTO.INDIVIDUAL
    }
  }, [_vm._v("Individual")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_ATENDIMENTO.AGRUPADO
    }
  }, [_vm._v("Agrupado")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tipo-de-atendimento')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "situacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SITUACAO.ATIVA
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO.INATIVA
    }
  }, [_vm._v("Inativo")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('situacao')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de agrupamento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_agrupamento),
      expression: "dados.tipo_agrupamento"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_agrupamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o agrupamento...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_AGRUPAMENTO.BIOQUIMICA
    }
  }, [_vm._v("Bioquimica")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_AGRUPAMENTO.OFTALMOLOGIA
    }
  }, [_vm._v("Oftalmologia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.sexo),
      expression: "dados.sexo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "sexo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.AMBOS
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("Feminino")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('situacao')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Qtd. máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_maxima),
      expression: "dados.quantidade_maxima"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "2",
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_maxima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade mínima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_minima),
      expression: "dados.idade_minima"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "2",
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_minima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_maxima),
      expression: "dados.idade_maxima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_maxima", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Valor de referência")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.valor_referencia),
      expression: "dados.valor_referencia"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "valor-de-referencia",
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.valor_referencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "valor_referencia", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('valor-de-referencia')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Complexidade")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.complexidade),
      expression: "dados.complexidade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "complexidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione a complexidade...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.COMPLEXIDADE.BAIXA
    }
  }, [_vm._v("Baixa")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.COMPLEXIDADE.MEDIA
    }
  }, [_vm._v("Média")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.COMPLEXIDADE.ALTA
    }
  }, [_vm._v("Alta")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de financiamento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_financiamento),
      expression: "dados.tipo_financiamento"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_financiamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione tipo de financiamento...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.ASSISTENCIA_FARMACEUTICA_E_MAC
    }
  }, [_vm._v("Assistência farmacêutica e MAC")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.FAEC
    }
  }, [_vm._v("FAEC - FUNDO DE Ações estratégicas e compensações")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.INCENTIVO
    }
  }, [_vm._v("Incentivo - MAC")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.MAC
    }
  }, [_vm._v("MAC - Média e alta complexidade")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.VIGILANCIA
    }
  }, [_vm._v("Vigilância em saude")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.AB
    }
  }, [_vm._v("AB - Atenção Básica")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.ASSISTENCIA_FARMACEUTICA
    }
  }, [_vm._v("Assistência farmacêutica")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Forma de organização")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.procedimento_forma_organizacao_id),
      expression: "dados.procedimento_forma_organizacao_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "forma-de-organizacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "procedimento_forma_organizacao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione a forma de organização...")]), _vm._v(" "), _vm._l((_vm.formasOrganizacao), function(formaOrganizacao, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": formaOrganizacao.id
      }
    }, [_vm._v(_vm._s(formaOrganizacao.codigo) + " - " + _vm._s(formaOrganizacao.nome))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('forma-de-organizacao')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ano")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.ano),
      expression: "filtros.ano"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ano"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "ano", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2026"
    }
  }, [_vm._v("2026")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2025"
    }
  }, [_vm._v("2025")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2024"
    }
  }, [_vm._v("2024")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2023"
    }
  }, [_vm._v("2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2021"
    }
  }, [_vm._v("2021")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2020"
    }
  }, [_vm._v("2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mês")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.mes),
      expression: "filtros.mes"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "mes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- TODOS --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v("Janeiro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("Fevereiro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "03"
    }
  }, [_vm._v("Março")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "04"
    }
  }, [_vm._v("Abril")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("Maio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("Junho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("Julho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("Agosto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("Setembro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Outubro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Novembro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Dezembro")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 form-group"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary form-control",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Buscar"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Buscar\n              ")])])]), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable) && !_vm.pdf) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.ano))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subgrupo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantidade_disponivel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantidade_agendada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantidade_realizada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.oferta))])])
  }))])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-10 col-sm-2 text-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pdf),
      expression: "!pdf"
    }],
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF\n                ")])])]) : _c('div', [_vm._v("Nenhum registro encontrado.")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Oferta Anual de Subgrupos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th', [_vm._v("Mês")]), _vm._v(" "), _c('th', [_vm._v("Unidade")]), _vm._v(" "), _c('th', [_vm._v("Subgrupo")]), _vm._v(" "), _c('th', [_vm._v("Quantidade Disponível")]), _vm._v(" "), _c('th', [_vm._v("Quantidade Agendada")]), _vm._v(" "), _c('th', [_vm._v("Quantidade Realizada")]), _vm._v(" "), _c('th', [_vm._v("Total da Oferta")])])])
}]}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1"
    }
  }, [_c('tabelaSolicitacoes', {
    attrs: {
      "situacao": [_vm.SITUACAO_SOLICITACAO.EM_REGULACAO, _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_2"
    }
  }, [_c('tabelaSolicitacoes', {
    attrs: {
      "situacao": [_vm.SITUACAO_SOLICITACAO.REGULADA]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_3"
    }
  }, [_c('tabelaSolicitacoes', {
    attrs: {
      "situacao": [_vm.SITUACAO_SOLICITACAO.NEGATIVADA]
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Solicitações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab"
    }
  }, [_vm._v("Em análise")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab"
    }
  }, [_vm._v("Reguladas do dia")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#tab_3",
      "data-toggle": "tab"
    }
  }, [_vm._v("Negativadas do dia")])])])])
}]}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.boxTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Código")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.codigo),
      expression: "dados.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "codigo",
      "maxlength": "2",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "codigo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('codigo')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento.contrato.unidade.nome))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CANCELADA),
      expression: "$props.solicitacao.situacao == SITUACAO_SOLICITACAO.CANCELADA"
    }]
  }, [_c('b', [_vm._v("Cancelada por: ")]), _vm._v(" " + _vm._s(_vm.nomeProfissionalCancelar(_vm.$props.solicitacao)))]), _vm._v(" "), _c('h1', {
    staticClass: "codigo-maior",
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm._f("formatarCodigo")(_vm.$props.solicitacao.id)))]), _vm._v(" "), _c('barcode', {
    attrs: {
      "marginBottom": "0",
      "align": "center",
      "displayValue": "false",
      "value": _vm.$props.solicitacao.id.toString().padStart(10, '0'),
      "format": "code39"
    }
  }, [_vm._v("\n            Erro no código de barras.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("tipoConsulta")(_vm.$props.solicitacao.itens[0].tipo_consulta)))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_c('b', {
    staticClass: "maior"
  }, [_vm._v("Nome: " + _vm._s(_vm.$props.solicitacao.paciente.nome.toUpperCase()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Nascimento: " + _vm._s(_vm._f("dataFormatada")(_vm.$props.solicitacao.paciente.data_nascimento)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Sexo: " + _vm._s(_vm._f("sexo")(_vm.$props.solicitacao.paciente.sexo)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Telefone: " + _vm._s(_vm.$props.solicitacao.paciente.telefone))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Município: " + _vm._s(_vm.$props.solicitacao.paciente.cidade.nome))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.EM_REGULACAO),
      expression: "$props.solicitacao.situacao == SITUACAO_SOLICITACAO.EM_REGULACAO"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('b', {
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n                        AGUARDAR ANÁLISE DO MÉDICO REGULADOR E DISPONIBILIDADE DE VAGA."), _c('br'), _vm._v("\n                        ESTARÁ DISPONÍVEL NO PERÍODO DE " + _vm._s(_vm._f("dataFormatada")(_vm.$props.solicitacao.created_at)) + " ATÉ " + _vm._s(_vm._f("dataFormatada")(_vm.adicionarDiasData(_vm.$props.solicitacao.created_at, 2))) + ".\n                    ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.diagnosticos.lenght > 0),
      expression: "$props.solicitacao.diagnosticos.lenght > 0"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(5), _vm._v(" "), _c('ul', _vm._l((_vm.$props.solicitacao.diagnosticos), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "margin-left": "-23px"
      }
    }, [_vm._v(_vm._s(item.nome))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(6), _vm._v(" "), _c('ul', _vm._l((_vm.$props.solicitacao.itens), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "margin-left": "-23px"
      }
    }, [_vm._v("\n                        " + _vm._s(item.quantidade) + " - " + _vm._s(item.contrato_procedimento.procedimento.codigo.replace(/[^\d]+/g, '')) + " - " + _vm._s(item.contrato_procedimento.procedimento.nome) + "\n                        "), (item.contrato_procedimento_atendimento) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.contrato_procedimento_atendimento.contrato_procedimento.preparo && _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.MARCADA) || _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CONFIRMADA),
        expression: "(item.contrato_procedimento_atendimento.contrato_procedimento.preparo && $props.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA) || $props.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA"
      }]
    }, [_c('b', [_vm._v("PREPARO (S):")])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.contrato_procedimento_atendimento.contrato_procedimento.preparo && _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.MARCADA) || _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CONFIRMADA),
        expression: "(item.contrato_procedimento_atendimento.contrato_procedimento.preparo && $props.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA) || $props.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA"
      }],
      attrs: {
        "align": "justify"
      }
    }, [_c('strong', [_vm._v(_vm._s(item.contrato_procedimento_atendimento.contrato_procedimento.preparo ? item.contrato_procedimento_atendimento.contrato_procedimento.preparo.descricao : ""))])])])]) : _vm._e()])
  }))])]), _vm._v(" "), ((_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento || _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento) && (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.MARCADA || _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CONFIRMADA)) ? _c('span', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(7), _vm._v(" "), (_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento) ? _c('p', [_c('b', {
    staticClass: "maior"
  }, [_vm._v(_vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome))])]) : _vm._e(), _vm._v(" "), (_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento) ? _c('p', [_c('b', {
    staticClass: "maior"
  }, [_vm._v(_vm._s(_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento) ? _c('b', [_c('p', {
    staticClass: "maior"
  }, [_vm._v(_vm._s(_vm._f("dataFormatada")(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento)) + ", " + _vm._s(_vm._f("diaDaSemana")(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento)) + ", às " + _vm._s(_vm._f("horaFormatada")(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.hora_inicial)) + "hrs")])]) : _vm._e(), _vm._v(" "), (_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento) ? _c('b', [_c('p', {
    staticClass: "maior"
  }, [_vm._v(_vm._s(_vm._f("dataFormatada")(_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento)) + ", " + _vm._s(_vm._f("diaDaSemana")(_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento)) + ", às " + _vm._s(_vm._f("horaFormatada")(_vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.hora_inicial)) + "hrs")])]) : _vm._e()])]), _vm._v(" "), (_vm.$props.solicitacao.tipo_atendimento != null) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("\n                            Endereço: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.endereco : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.endereco) + ",\n                            " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.numero_endereco : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.numero_endereco) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("Bairro: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.bairro : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.bairro))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("CEP: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.cep : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.cep))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("Município: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.cidade.nome : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.cidade.nome))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("Estado: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.cidade.uf.uf : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.cidade.uf.uf))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("Ponto de Referência: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.ponto_referencia : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.ponto_referencia))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_vm._v("Telefone: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.telefone : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.telefone))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Complemento: " + _vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.complemento_endereco : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.complemento_endereco))])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CANCELADA),
      expression: "$props.solicitacao.situacao == SITUACAO_SOLICITACAO.CANCELADA"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(8), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.justificativaCancelamento(_vm.$props.solicitacao)))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.solicitacao.tipo_atendimento !== 1 && (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.MARCADA || _vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.CONFIRMADA)),
      expression: "$props.solicitacao.tipo_atendimento !== 1 && ($props.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA || $props.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA)"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(9), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.profissional.nome : ""))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(10), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$props.solicitacao.profissional.nome))])])]), _vm._v(" "), (_vm.$props.solicitacao.situacao == _vm.SITUACAO_SOLICITACAO.REALIZADA) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(11), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("dataFormatada")(_vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? _vm.$props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento : _vm.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(12), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$props.solicitacao.usuario.name))])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('b', [_vm._v("Sec. Mun. de Saúde de Vitória da Conquista")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Unidade Solicitante:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('b', [_vm._v("AUTORIZAÇÃO DE PROCEDIMENTO")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Tipo de consulta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('b', [_vm._v("Paciente ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Diagnóstico(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Qt. - Procedimentos(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Realizar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Justificativa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Profissional Realizador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Profissional Solicitante")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Data da realização")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Marcador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('b', [_vm._v("Informações")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n                    CASO VOCÊ NÃO PUDER COMPARECER À CONSULTA MÉDICA OU PROCEDIMENTO AGENDADO, FAVOR LIGAR 48 HORAS ANTES PARA DEVOLVER/CANCELAR A VAGA.\n                ")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n                    PARA CANCELAMENTOS DE VAGAS, PROCURE SUA UNIDADE DE MARCAÇÃO.\n                ")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n                    PARA REALIZAÇÃO DESSE PROCEDIMENTO, É NECESSÁRIO ESTAR COM OS DOCUMENTOS PESSOAIS, SOLICITAÇÃO DE PROCEDIMENTO E TAMBÉM O CARTÃO SUS.\n                ")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n                    EXAMES PERDIDOS SÓ SERÃO REMARCADOS APÓS 30 DIAS.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticStyle: {
      "font-size": "10px"
    }
  })])])
}]}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Dias de visão das agendas para o regulador")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.dias_visao_regulador),
      expression: "dados.dias_visao_regulador"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "dias_visao_regulador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "35"
    }
  }, [_vm._v("35")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v("40")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("45")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Permite enviar procedimentos agrupados para a regulação?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.procedimentos_agrupados_regulador),
      expression: "dados.procedimentos_agrupados_regulador"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "procedimentos_agrupados_regulador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("SIM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("NÃO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('abertura_regulador')
    }
  }, [_c('label', [_vm._v("Horário de abertura")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.horario_abertura_regulador),
      expression: "dados.horario_abertura_regulador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "abertura_regulador",
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.horario_abertura_regulador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "horario_abertura_regulador", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('abertura_regulador')),
      expression: "errors.has('abertura_regulador')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Preencha o horário de abertura.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('fechamento_regulador')
    }
  }, [_c('label', [_vm._v("Horário de fechamento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.horario_fechamento_regulador),
      expression: "dados.horario_fechamento_regulador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required' + (_vm.dados.horario_fechamento_regulador <= _vm.dados.horario_abertura_regulador ? '|is:null' : '')),
      expression: "'required' + (dados.horario_fechamento_regulador <= dados.horario_abertura_regulador? '|is:null' : '')"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fechamento_regulador",
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.horario_fechamento_regulador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "horario_fechamento_regulador", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fechamento_regulador')),
      expression: "errors.has('fechamento_regulador')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Preencha o horário de fechamento também, sempre maior que o de abertura.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_2"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Habilita Marcação (PPI)?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.habilita_ppi_marcador),
      expression: "dados.habilita_ppi_marcador"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "habilita_ppi_marcador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("SIM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("NÃO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Habilita Marcação (Demais)?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.habilita_demais_marcador),
      expression: "dados.habilita_demais_marcador"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "habilita_demais_marcador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("SIM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("NÃO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Dias de visão das agendas para o marcador")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.dias_visao_marcador),
      expression: "dados.dias_visao_marcador"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.dias_visao_marcador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "dias_visao_marcador", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Dias de visão de procedimentos agrupados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.dias_visao_agrupados_marcador),
      expression: "dados.dias_visao_agrupados_marcador"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.dias_visao_agrupados_marcador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "dias_visao_agrupados_marcador", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Informar obrigatoriamente os diagnósticos (CID-10) na marcação?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.obriga_diagnosticos_marcador),
      expression: "dados.obriga_diagnosticos_marcador"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "obriga_diagnosticos_marcador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("SIM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("NÃO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('abertura_marcador')
    }
  }, [_c('label', [_vm._v("Horário de abertura")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.horario_abertura_marcador),
      expression: "dados.horario_abertura_marcador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "abertura_marcador",
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.horario_abertura_marcador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "horario_abertura_marcador", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('abertura_marcador')),
      expression: "errors.has('abertura_marcador')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Preencha o horário de abertura.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('fechamento_marcador')
    }
  }, [_c('label', [_vm._v("Horário de fechamento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.horario_fechamento_marcador),
      expression: "dados.horario_fechamento_marcador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required' + (_vm.dados.horario_fechamento_marcador <= _vm.dados.horario_abertura_marcador ? '|is:null' : '')),
      expression: "'required' + (dados.horario_fechamento_marcador <= dados.horario_abertura_marcador ? '|is:null' : '')"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fechamento_marcador",
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.horario_fechamento_marcador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "horario_fechamento_marcador", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fechamento_marcador')),
      expression: "errors.has('fechamento_marcador')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Preencha o horário de fechamento também, sempre maior que o de abertura.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_3"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('abertura_prestador')
    }
  }, [_c('label', [_vm._v("Horário de abertura")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.horario_abertura_prestador),
      expression: "dados.horario_abertura_prestador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "abertura_prestador",
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.horario_abertura_prestador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "horario_abertura_prestador", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('abertura_prestador')),
      expression: "errors.has('abertura_prestador')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Preencha o horário de abertura.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('fechamento_prestador')
    }
  }, [_c('label', [_vm._v("Horário de fechamento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.horario_fechamento_prestador),
      expression: "dados.horario_fechamento_prestador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required' + (_vm.dados.horario_fechamento_prestador <= _vm.dados.horario_abertura_prestador ? '|is:null' : '')),
      expression: "'required' + (dados.horario_fechamento_prestador <= dados.horario_abertura_prestador? '|is:null' : '')"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fechamento_prestador",
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.horario_fechamento_prestador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "horario_fechamento_prestador", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fechamento_prestador')),
      expression: "errors.has('fechamento_prestador')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Preencha o horário de fechamento também, sempre maior que o de abertura.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_4"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('abertura_admin')
    }
  }, [_c('label', [_vm._v("Horário de abertura")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.horario_abertura_admin),
      expression: "dados.horario_abertura_admin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "abertura_admin",
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.horario_abertura_admin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "horario_abertura_admin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('abertura_admin')),
      expression: "errors.has('abertura_admin')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Preencha o horário de abertura.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('fechamento_admin')
    }
  }, [_c('label', [_vm._v("Horário de fechamento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.horario_fechamento_admin),
      expression: "dados.horario_fechamento_admin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required' + (_vm.dados.horario_fechamento_admin <= _vm.dados.horario_abertura_admin ? '|is:null' : '')),
      expression: "'required' + (dados.horario_fechamento_admin <= dados.horario_abertura_admin? '|is:null' : '')"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fechamento_admin",
      "type": "time"
    },
    domProps: {
      "value": (_vm.dados.horario_fechamento_admin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "horario_fechamento_admin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fechamento_admin')),
      expression: "errors.has('fechamento_admin')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Preencha o horário de fechamento também, sempre maior que o de abertura.")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar\n\t\t\t\t\t\t\t")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Parâmetros Gerais")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("Regulador")])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Marcador")])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "href": "#tab_3",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Prestador")])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "href": "#tab_4",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Administrador")])])])
}]}

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('bloquear-modal', {
    attrs: {
      "id": _vm.atendimento_id,
      "show": _vm.showBloquear
    },
    on: {
      "close": function($event) {
        _vm.showBloquear = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('criar-modal', {
    attrs: {
      "id": _vm.atendimento_id,
      "show": _vm.showCriar
    },
    on: {
      "close": function($event) {
        _vm.showCriar = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('criar-atendimento-modal', {
    attrs: {
      "id": _vm.atendimento_id,
      "item": _vm.itens,
      "show": _vm.showCriarAtendimento
    },
    on: {
      "close": function($event) {
        _vm.showCriarAtendimento = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('bloquear-periodo-modal', {
    attrs: {
      "show": _vm.showBloquearPeriodo,
      "distribuicao_contrato_id": _vm.$route.params.distribuicaoContratoId
    },
    on: {
      "close": function($event) {
        _vm.showBloquearPeriodo = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('editar-atendimento-modal', {
    attrs: {
      "tipo": "subgrupo",
      "item": _vm.atendimento,
      "show": _vm.showEditarAtendimento
    },
    on: {
      "criarAtendimento": function($event) {
        _vm.criarAtendimento($event)
      },
      "close": function($event) {
        _vm.showEditarAtendimento = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": "Bloquear por período"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.bloquearPeriodo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ban",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v(" Bloquear por período")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "title": "Criar atendimento"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.criarAtendimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v(" Criar atendimento")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome_subgrupo),
      expression: "filtros.nome_subgrupo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Entre com NOME do SUBGRUPO"
    },
    domProps: {
      "value": (_vm.filtros.nome_subgrupo)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filtrar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome_subgrupo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sexo),
      expression: "filtros.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.AMBOS
    }
  }, [_vm._v("AMBOS")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("MASCULINO")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("FEMININO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Período (De)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_inicial),
      expression: "filtros.data_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Período (Até)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_final),
      expression: "filtros.data_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_final", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.filtrar
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_subgrupo.subgrupo.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("sexo")(item.sexo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("intervaloIdade")([item.idade_minima, item.idade_maxima])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)) + " "), _c('br'), _vm._v(" (" + _vm._s(_vm._f("diaDaSemana")(item.data_atendimento)) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("intervaloHoras")([item.hora_inicial, item.hora_final])))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "2px",
        "margin": "0",
        "text-align": "center"
      }
    }, [(item.tipo_consumo == 1) ? _c('strong', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("---")]) : _c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos Distribuídos (Modelo)"
      }
    }, [_vm._v(_vm._s(item.quantidade_atendimento_original))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos Disponíveis"
      }
    }, [_vm._v(_vm._s(item.quantidade_atendimento))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c40233",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos Bloqueados"
      }
    }, [_vm._v(_vm._s(item.quantidade_atendimento_bloqueada))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Atendimentos Consumidos"
      }
    }, [_vm._v(_vm._s(item.quantidade_atendimento_consumida))])])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "2px",
        "margin": "0",
        "text-align": "center"
      }
    }, [(item.tipo_consumo == 1) ? _c('strong', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("---")]) : _c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(4, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Locais Distribuídos (Modelo)"
      }
    }, [_vm._v(_vm._s(item.quantidade_local_original))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Locais Disponíveis"
      }
    }, [_vm._v(_vm._s(item.quantidade_local))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c40233",
        "color": "white"
      },
      attrs: {
        "title": "Locais Bloqueados"
      }
    }, [_vm._v(_vm._s(item.quantidade_local_bloqueada))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Locais Consumidos"
      }
    }, [_vm._v(_vm._s(item.quantidade_local_consumida))])])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "2px",
        "margin": "0",
        "text-align": "center"
      }
    }, [(item.tipo_consumo != 1) ? _c('strong', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("---")]) : _c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(5, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos por Paciente Distribuídos (Modelo)"
      }
    }, [_vm._v(_vm._s(item.quantidade_paciente_original))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos por Paciente Disponíveis"
      }
    }, [_vm._v(_vm._s(item.quantidade_paciente))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c40233",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos por Paciente Bloqueados"
      }
    }, [_vm._v(_vm._s(item.quantidade_paciente_bloqueada))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Atendimentos por Paciente Consumidos"
      }
    }, [_vm._v(_vm._s(item.quantidade_paciente_consumida))])])])])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Bloquear Atendimentos"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.bloquear(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-ban",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "title": "Criar Atendimentos"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.criar(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-plus",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "title": "Editar Atendimento"
      },
      on: {
        "click": function($event) {
          _vm.editar(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Atendimentos de Subgrupo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Filtros:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("Controle")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Idade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Horário")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Atendimentos")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Locais")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Pacientes")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Ação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("M")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("M")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("M")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")])])])
}]}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    ref: "usuario",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.commit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('nome')
    }
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome Completo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.name),
      expression: "dados.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nome')),
      expression: "errors.has('nome')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("nome")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.email),
      expression: "dados.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "name": "email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("email")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    class: {
      'form-group': true
    }
  }, [_c('label', {
    attrs: {
      "for": "telefone"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##)#####-####', '(##)####-####']),
      expression: "['(##)#####-####', '(##)####-####']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.telefone),
      expression: "dados.telefone"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "telefone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "telefone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('nivel')
    }
  }, [_c('label', {
    attrs: {
      "for": "nivel"
    }
  }, [_vm._v("Perfil:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nivel),
      expression: "dados.nivel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nivel",
      "type": "text",
      "disabled": _vm.atualizacao
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "nivel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "administrador"
    }
  }, [_vm._v("Administrador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "regulador"
    }
  }, [_vm._v("Regulador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "marcador"
    }
  }, [_vm._v("Marcador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "prestador"
    }
  }, [_vm._v("Prestador")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nivel')),
      expression: "errors.has('nivel')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("nivel")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('usuario')
    }
  }, [_c('label', {
    attrs: {
      "for": "usuario"
    }
  }, [_vm._v("Usuário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.login),
      expression: "dados.login"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "name": "usuario",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "login", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('usuario')),
      expression: "errors.has('usuario')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("usuario")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('senha')
    }
  }, [_c('label', {
    attrs: {
      "for": "senha"
    }
  }, [_vm._v("Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.password),
      expression: "dados.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.atualizacao
      }),
      expression: "{ required: !atualizacao }"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "name": "senha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.dados.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('senha')),
      expression: "errors.has('senha')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("senha")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('confirmacaoSenha')
    }
  }, [_c('label', {
    attrs: {
      "for": "confirmacaoSenha"
    }
  }, [_vm._v("Redigite a Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmacaoSenha),
      expression: "confirmacaoSenha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.atualizacao,
        is: _vm.dados.password
      }),
      expression: "{ required: !atualizacao, is: dados.password }"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "name": "confirmacaoSenha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmacaoSenha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmacaoSenha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmacaoSenha')),
      expression: "errors.has('confirmacaoSenha')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("confirmacaoSenha")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidades Vinculadas")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "select-dias",
      "placeholder": "Clique para selecionar a(s) unidade(s)...",
      "multiple": "",
      "options": _vm.selectUnidades
    },
    model: {
      value: (_vm.dados.unidades),
      callback: function($$v) {
        _vm.$set(_vm.dados, "unidades", $$v)
      },
      expression: "dados.unidades"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "anotacoes"
    }
  }, [_vm._v("Anotações")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.anotacoes),
      expression: "dados.anotacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "anotacoes",
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.dados.anotacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "anotacoes", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("CONTRATOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "contrato.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "contrato.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "contrato.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "contrato.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "contrato.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "contrato.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("AGENDA")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "agenda.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "agenda.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "agenda.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "agenda.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "agenda.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "agenda.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("RELATÓRIO DE SOLICITAÇÕES")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "relatorio.solicitacao"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "relatorio.solicitacao") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "relatorio.solicitacao",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("RELATÓRIO DE ESCALAS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "relatorio.escalas"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "relatorio.escalas") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "relatorio.escalas",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("RELATÓRIO DE OFERTAS DE PROCEDIMENTO")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "relatorio.ofertas"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "relatorio.ofertas") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "relatorio.ofertas",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("RELAÇÃO DE USUÁRIOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "relatorio.usuarios"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "relatorio.usuarios") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "relatorio.usuarios",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("RELATÓRIO AGENDA DO PRESTADOR")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "relatorio.agenda.prestador"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "relatorio.agenda.prestador") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "relatorio.agenda.prestador",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("DISTRIBUIR")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "distribuicao.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "distribuicao.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "distribuicao.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("CONTROLE DE CONTRATOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "distribuicao.contrato.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "distribuicao.contrato.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "distribuicao.contrato.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "distribuicao.contrato.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "distribuicao.contrato.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "distribuicao.contrato.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("CONTROLE DA AGENDA")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "distribuicao.agenda.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "distribuicao.agenda.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "distribuicao.agenda.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "distribuicao.agenda.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "distribuicao.agenda.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "distribuicao.agenda.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("SOLICITAR")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitacao.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "solicitacao.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitacao.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("VERIFICAR SOLITAÇÃO")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitacao.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "solicitacao.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitacao.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("CANCELAR SOLICITAÇÃO")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitacao.cancelar"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "solicitacao.cancelar") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitacao.cancelar",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("REGULAR SOLICITAÇÃO")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitacao.regular"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "solicitacao.regular") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitacao.regular",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("ATENDIDO/FALTA")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitacao.atendidoFalta"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "solicitacao.atendidoFalta") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitacao.atendidoFalta",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(8), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("PACIENTES")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "paciente.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "paciente.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "paciente.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "paciente.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "paciente.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "paciente.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("PROFISSIONAIS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "profissional.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "profissional.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "profissional.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "profissional.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "profissional.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "profissional.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("UNIDADES")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "unidade.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "unidade.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "unidade.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "unidade.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "unidade.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "unidade.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("GRUPOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "grupo.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "grupo.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "grupo.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "grupo.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "grupo.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "grupo.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("SUBGRUPOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "subgrupo.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "subgrupo.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "subgrupo.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "subgrupo.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "subgrupo.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "subgrupo.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("FORMAS DE ORGANIZAÇÃO")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "forma.organizacao.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "forma.organizacao.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "forma.organizacao.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "forma.organizacao.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "forma.organizacao.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "forma.organizacao.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("PROCEDIMENTOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "procedimento.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "procedimento.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "procedimento.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "procedimento.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "procedimento.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "procedimento.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(10), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("PACIENTES")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "paciente-integracao.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "paciente-integracao.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "paciente-integracao.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "paciente-integracao.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "paciente-integracao.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "paciente-integracao.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "a",
      "to": "/cadastros/usuarios"
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "type": "submit",
      "value": "Salvar",
      "disabled": _vm.finalizado
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Permissões do Usuário")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Administração")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("Funcionalidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ativar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Atualizar Dados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Distribuição")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_vm._v("\n                                                    -\n                                                    "), _c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("Funcionalidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ativar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Atualizar Dados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Atendimentos")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "90%"
    }
  }, [_vm._v("Funcionalidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ativar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cadastros")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("Funcionalidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ativar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Atualizar Dados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Integração com o sistema Antigo")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("Funcionalidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ativar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Atualizar Dados")])])])
}]}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['esc']),
      expression: "['esc']"
    }],
    on: {
      "shortkey": function($event) {
        _vm.showModal = false
      },
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.up()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.down()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.enter()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        $event.stopPropagation();
        _vm.showModal = false
      }]
    }
  }, [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerProfissional
    },
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.$props.nomeProfissionalRecuperado ? _vm.$props.nomeProfissionalRecuperado : _vm.profissionalSelecionado.nome
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', '3']),
      expression: "['alt', '3']"
    }],
    ref: "btnBuscarProfissional",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerProfissional,
      'btn-default': !_vm.$props.showTextDangerProfissional
    },
    attrs: {
      "disabled": _vm.$props.nomeProfissional != undefined,
      "type": "button"
    },
    on: {
      "shortkey": function($event) {
        _vm.showModal = true, _vm.focoNomeProfissional()
      },
      "click": function($event) {
        _vm.showModal = true, _vm.focoNomeProfissional()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerProfissional,
      'btn-default': !_vm.$props.showTextDangerProfissional
    },
    attrs: {
      "disabled": _vm.disableClear,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask not-valited"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Profissional")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.unidadeSolicitanteSelecionada) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.$props.unidadeSolicitanteSelecionada.nome
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['ctrl', 'b']),
      expression: "['ctrl', 'b']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    ref: "inputProfissional",
    staticClass: "form-control",
    attrs: {
      "title": "[ ctrl + b ] Para pesquisar",
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou CNS do profissional e pressione ctrl + b."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "shortkey": function($event) {
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("CNS")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      class: {
        'ativa': index === _vm.profissionalSelecionadoIndex
      },
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cns))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tMostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": '/administracao/agendas/novo-procedimento/' + _vm.$route.params.contratoId
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecalho-contrato', {
    attrs: {
      "contrato-id": _vm.$route.params.contratoId
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome_procedimento),
      expression: "filtros.nome_procedimento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Procedimento"
    },
    domProps: {
      "value": (_vm.filtros.nome_procedimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome_procedimento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome_profissional),
      expression: "filtros.nome_profissional"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Profissional"
    },
    domProps: {
      "value": (_vm.filtros.nome_profissional)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome_profissional", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.idade_minima),
      expression: "filtros.idade_minima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Idade Mínima"
    },
    domProps: {
      "value": (_vm.filtros.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "idade_minima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.idade_maxima),
      expression: "filtros.idade_maxima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Idade Máxima"
    },
    domProps: {
      "value": (_vm.filtros.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "idade_maxima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sexo),
      expression: "filtros.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Sexo--")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.AMBOS
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("Feminino")])])])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      class: {
        'ativa': _vm.indexAtivo === index
      },
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.getAtendimentos(index, item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("sexo")(item.sexo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.idade_minima))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.idade_maxima))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\tMostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexAtivo != undefined),
      expression: "indexAtivo != undefined"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 1)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_primeira) + " P  |  " + _vm._s(item.quantidade_retorno) + " R  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 2)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_primeira) + " P  |  " + _vm._s(item.quantidade_retorno) + " R  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 3)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_primeira) + " P  |  " + _vm._s(item.quantidade_retorno) + " R  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 4)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_primeira) + " P  |  " + _vm._s(item.quantidade_retorno) + " R  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 5)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_primeira) + " P  |  " + _vm._s(item.quantidade_retorno) + " R  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 6)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_primeira) + " P  |  " + _vm._s(item.quantidade_retorno) + " R  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "panel-body tamanho-fixo-box-agenda"
  }, _vm._l((_vm.atendimentos), function(item, index) {
    return _c('div', {
      key: index
    }, [((item.dia == 0)) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "dblclick": function($event) {
          _vm.editar(item)
        }
      }
    }, [_vm._v(_vm._s(item.hora_inicial) + " às " + _vm._s(item.hora_final) + " "), _c('br'), _vm._v(" " + _vm._s(item.quantidade_primeira) + " P  |  " + _vm._s(item.quantidade_retorno) + " R  |  " + _vm._s(item.quantidade_local) + " L ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_c('a', {
      attrs: {
        "title": "Excluir atendimento",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])]), _vm._v(" "), _c('modal-editar-procedimento-atendimento', {
    attrs: {
      "atendimento": _vm.atendimento,
      "show": _vm.showModalEditarProcedimento
    },
    on: {
      "close": function($event) {
        _vm.showModalEditarProcedimento = false
      },
      "atendimentoProcedimentoAtualizado": function (procedimento) {
        _vm.atendimentoProcedimentoAtualizado(procedimento)
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Atendimentos de procedimento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Filtros: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Profissional")]), _vm._v(" "), _c('th', [_vm._v("Sexo")]), _vm._v(" "), _c('th', [_vm._v("Idade Mínima")]), _vm._v(" "), _c('th', [_vm._v("Idade Máxima")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Segunda-feira")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Terça-feira")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Quarta-feira")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Quinta-feira")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Sexta-feira")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Sábado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('span', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v("Domingo")])])])
}]}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['esc']),
      expression: "['esc']"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.up()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.down()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.enter()
      }],
      "shortkey": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Adicionar Diagnostico")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['ctrl', 'b']),
      expression: "['ctrl', 'b']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    ref: "nmDiagnostico",
    staticClass: "form-control",
    attrs: {
      "title": "pressione ctrl + b para pesquisar",
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código CID do diagnóstico e pressione ctrl + b ."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "shortkey": function($event) {
        _vm.getDataTable()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Código CID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Sexo")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      class: {
        'ativa': index === _vm.diagnosticoSelecionadoIndex
      },
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.cid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("sexo")(item.sexo)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tMostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com NOME ou CÓDIGO do subgrupo"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filtrar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.filtrar
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])])])
},staticRenderFns: []}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-error': _vm.showTextDangerUnidade
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerUnidade
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "show-text-danger-unidade": _vm.showTextDangerUnidade,
      "nomeUnidade": _vm.dados.unidade.nome
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerTipoPessoa
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTipoPessoa
    }
  }, [_vm._v("Tipo de pessoa")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_pessoa),
      expression: "dados.tipo_pessoa"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_pessoa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Física")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jurídica")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerTipo
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTipo
    }
  }, [_vm._v("Tipo de Contrato")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo),
      expression: "dados.tipo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Solicitante")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Prestador")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerDataInicial
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDataInicial
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_inicial),
      expression: "dados.data_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerDataFinal
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDataFinal
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_final),
      expression: "dados.data_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_final", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimiteGeral
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimiteGeral
    }
  }, [_vm._v("Limite Geral (R$)")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: (_vm.dados.limite_geral),
      callback: function($$v) {
        _vm.$set(_vm.dados, "limite_geral", $$v)
      },
      expression: "dados.limite_geral"
    }
  }, 'money', _vm.money, false))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimiteCancelamento
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimiteCancelamento
    }
  }, [_vm._v("Limite de Cancelamentos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.limite_cancelamento),
      expression: "dados.limite_cancelamento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.limite_cancelamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "limite_cancelamento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimiteRegulacao
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimiteRegulacao
    }
  }, [_vm._v("Limite de Regulações")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.limite_regulacao),
      expression: "dados.limite_regulacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.limite_regulacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "limite_regulacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerSituacao
    }
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerSituacao
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo Contrato")])])])
}]}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "SELECIONE A UNIDADE SOLICITANTE",
      "label": "nome",
      "options": _vm.unidades
    },
    model: {
      value: (_vm.unidadeSelecionada),
      callback: function($$v) {
        _vm.unidadeSelecionada = $$v
      },
      expression: "unidadeSelecionada"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "SELECIONE O PROCEDIMENTO",
      "label": "nome",
      "options": _vm.procedimentos
    },
    model: {
      value: (_vm.procedimentoSelecionado),
      callback: function($$v) {
        _vm.procedimentoSelecionado = $$v
      },
      expression: "procedimentoSelecionado"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Categoria da unidade")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "SELECIONE A CATEGORIA",
      "label": "nome",
      "options": _vm.categorias
    },
    model: {
      value: (_vm.categoriaUnidadeSelecionada),
      callback: function($$v) {
        _vm.categoriaUnidadeSelecionada = $$v
      },
      expression: "categoriaUnidadeSelecionada"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Paciente")]), _vm._v(" "), _c('select-paciente', {
    attrs: {
      "nome-paciente-recuperado": _vm.$store.state.filtrosRegulador.pacienteSelecionado.nome,
      "regulador": true
    },
    on: {
      "setPacienteSelecionado": function (paciente) {
        _vm.setPacienteSelecionado(paciente);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Marcador")]), _vm._v(" "), _c('select-marcador', {
    attrs: {
      "nome-marcador-recuperado": _vm.$store.state.filtrosRegulador.marcadorSelecionado.name,
      "regulador": true
    },
    on: {
      "setMarcadorSelecionado": function (marcador) {
        _vm.setMarcadorSelecionado(marcador);
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Data da solicitação (Tempo)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("Tipo Consulta")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                            Solicitante\n                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('H.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'H.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                            Procedimento(s)\n                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('F.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'F.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                            Paciente\n                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('A.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'A.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Idade do paciente")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Competência")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Marcador")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('router-link', {
      key: item.id,
      staticClass: "even hand",
      attrs: {
        "role": "row",
        "tag": "tr",
        "to": '/atendimentos/regulacao/solicitacao/' + item.id
      }
    }, [_c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm._f("formatarCodigo")(item.id)) + " "), (item.situacao == 6) ? _c('i', {
      staticClass: "fa fa-comments"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm._f("dataFormatadaHora")(item.created_at)) + " (" + _vm._s(_vm._f("diasDaData")(item.created_at)) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoConsulta")(item.tipo_consulta)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v("\n                            " + _vm._s(item.codigo + " - " + item.procedimento) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(item.paciente))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm._f("idade")(item.data_nascimento)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm._f("mesPorExtenso")(item.data_competencia)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.marcador))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])
}]}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": ("/distribuicoes/contratos/procedimentos/novo/" + (_vm.$route.params.contrato_id))
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar Procedimento\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecario-contrato', {
    attrs: {
      "contratoId": _vm.$route.params.contrato_id
    }
  }), _vm._v(" "), _c('filtro-contrato-procedimento', {
    on: {
      "filtrar": function (filtros) {
        _vm.filtrar(filtros);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.valor, 2, ",", ".")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipo_limite")(item.tipo_limite)))]), _vm._v(" "), _c('td', [(item.tipo_limite > 0) ? _c('span', [_vm._v("Não Possui")]) : _c('span', [_c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Limite Distribuído (Modelo)"
      }
    }, [_vm._v(_vm._s(item.limite.quantidade_original))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Limite Disponível"
      }
    }, [_vm._v(_vm._s(item.limite.quantidade))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Limite Consumido"
      }
    }, [_vm._v(_vm._s(item.limite_consumido))])])])])])]), _vm._v(" "), _c('td', [(item.tipo_limite == 0) ? _c('span', [_c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Limite Distribuído (Modelo)"
      }
    }, [_vm._v(_vm._s(_vm._f("numberFormat")((item.limite.quantidade_original * item.valor), 2, ",", ".")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Limite Disponível"
      }
    }, [_vm._v(_vm._s(_vm._f("numberFormat")((item.limite.quantidade * item.valor), 2, ",", ".")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Limite Consumido"
      }
    }, [(item.limite_consumido != 0) ? _c('span', [_vm._v(_vm._s(_vm._f("numberFormat")((item.limite_consumido * item.valor), 2, ",", ".")))]) : _c('span', [_vm._v("0,00")])])])])])]) : _vm._e(), _vm._v(" "), (item.tipo_limite == 1) ? _c('span', [_vm._v("No Subgrupo")]) : _vm._e(), _vm._v(" "), (item.tipo_limite == 2) ? _c('span', [_vm._v("Não Possui")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacao")(item.situacao)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/distribuicoes/contratos/procedimentos/atualizacao/" + (item.id)),
        "title": " Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Procedimentos do Contrato")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Controle")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "21%"
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Tipo de Limite")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("Limite Físico")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Valor Total")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1%"
    }
  }, [_vm._v("Ação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "34%"
    }
  }, [_vm._v("M")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("D")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("C")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "34%"
    }
  }, [_vm._v("M")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("D")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("C")])])])
}]}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        $event.stopPropagation();
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subgrupoSelecionado.subgrupo.nome),
      expression: "subgrupoSelecionado.subgrupo.nome"
    }],
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerSubgrupo
    },
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.subgrupoSelecionado.subgrupo.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subgrupoSelecionado.subgrupo, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerSubgrupo,
      'btn-default': !_vm.$props.showTextDangerSubgrupo
    },
    attrs: {
      "disabled": _vm.$props.nomeSubgrupo != undefined,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerSubgrupo,
      'btn-default': !_vm.$props.showTextDangerSubgrupo
    },
    attrs: {
      "disabled": _vm.disableClear,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Subgrupo")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código do subgrupo e pressione enter."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.subgrupo.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subgrupo.nome))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n\t\t\t\t\t\t")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Criar Atendimentos de Procedimento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_primeira_original)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_primeira_alterada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos bloqueados")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_primeira_bloqueada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos criados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_primeira_criada),
      expression: "dados.quantidade_primeira_criada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.dados.quantidade_primeira_bloqueada > 0
    },
    domProps: {
      "value": (_vm.dados.quantidade_primeira_criada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_primeira_criada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_retorno_original)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_retorno_alterada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos bloqueados")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_retorno_bloqueada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos criados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_retorno_criada),
      expression: "dados.quantidade_retorno_criada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.dados.quantidade_retorno_bloqueada > 0
    },
    domProps: {
      "value": (_vm.dados.quantidade_retorno_criada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_retorno_criada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_local_original)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_local_alterada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais bloqueados")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("zero")(_vm.dados.quantidade_local_bloqueada)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais criados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_local_criada),
      expression: "dados.quantidade_local_criada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.dados.quantidade_local_bloqueada > 0
    },
    domProps: {
      "value": (_vm.dados.quantidade_local_criada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local_criada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button",
      "disabled": _vm.dados.quantidade_local_bloqueada > 0 && _vm.dados.quantidade_retorno_bloqueada > 0 && _vm.dados.quantidade_primeira_bloqueada > 0
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade prestadora")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional")]), _vm._v(" "), _c('select-profissional', {
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSelecionado(profissionalSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sub-Grupo")]), _vm._v(" "), _c('select-subgrupo', {
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "data_de"
    }
  }, [_vm._v("Período")]), _vm._v(" "), _c('data-filtro', {
    attrs: {
      "name": "periodo"
    },
    on: {
      "operadorSelecionado": function($event) {
        _vm.filtros.periodoOperador = $event
      },
      "dataSelecionada": function($event) {
        _vm.filtros.periodo = $event
      },
      "data2Selecionada": function($event) {
        _vm.filtros.periodo2 = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "box-footer text-right"
  }, [(_vm.pdf) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.getPDF(_vm.filtros.modelo)
      }
    }
  }, [_vm._v("Recarregar PDF "), _c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Pesquisar Agenda do Prestador",
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])]), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable) && !_vm.pdf) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Falta")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.situacao),
      expression: "ativos.situacao"
    }]
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.profissional),
      expression: "ativos.profissional"
    }]
  }, [_vm._v("Profissional")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.paciente),
      expression: "ativos.paciente"
    }]
  }, [_vm._v("Paciente")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.telefone),
      expression: "ativos.telefone"
    }]
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.procedimento),
      expression: "ativos.procedimento"
    }]
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.rg),
      expression: "ativos.rg"
    }]
  }, [_vm._v("RG")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.cartao_sus),
      expression: "ativos.cartao_sus"
    }]
  }, [_vm._v("Cartão SUS")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.data_nascimento),
      expression: "ativos.data_nascimento"
    }]
  }, [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.idade),
      expression: "ativos.idade"
    }]
  }, [_vm._v("Idade")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.sexo),
      expression: "ativos.sexo"
    }]
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.data_realizacao),
      expression: "ativos.data_realizacao"
    }]
  }, [_vm._v("Data do atendimento")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.tipo),
      expression: "ativos.tipo"
    }]
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.endereco),
      expression: "ativos.endereco"
    }]
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.municipio),
      expression: "ativos.municipio"
    }]
  }, [_vm._v("Município")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.unidade_solicitante),
      expression: "ativos.unidade_solicitante"
    }]
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.subgrupo),
      expression: "ativos.subgrupo"
    }]
  }, [_vm._v("Subgrupo")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Lançar falta",
        "disabled": _vm.disabledBtnFalta(item)
      },
      on: {
        "click": function($event) {
          _vm.lancarFalta(item)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-times"
    })])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.situacao),
        expression: "ativos.situacao"
      }]
    }, [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.profissional),
        expression: "ativos.profissional"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.paciente),
        expression: "ativos.paciente"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.telefone),
        expression: "ativos.telefone"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.telefone))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.procedimento),
        expression: "ativos.procedimento"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.rg),
        expression: "ativos.rg"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.rg))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.cartao_sus),
        expression: "ativos.cartao_sus"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.cartao_sus))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.data_nascimento),
        expression: "ativos.data_nascimento"
      }]
    }, [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.paciente.data_nascimento)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.idade),
        expression: "ativos.idade"
      }]
    }, [_vm._v(_vm._s(_vm._f("idade")(item.solicitacao.paciente.data_nascimento)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.sexo),
        expression: "ativos.sexo"
      }]
    }, [_vm._v(_vm._s(_vm._f("sexo")(item.solicitacao.paciente.sexo)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.data_realizacao),
        expression: "ativos.data_realizacao"
      }]
    }, [_vm._v(_vm._s(_vm._f("dataFormatada")(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento)) + " às " + _vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.hora_inicial : item.contrato_subgrupo_atendimento.hora_inicial))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.tipo),
        expression: "ativos.tipo"
      }]
    }, [_vm._v(_vm._s(_vm._f("tipoConsulta")(item.tipo_consulta)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.endereco),
        expression: "ativos.endereco"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.endereco) + ", nº" + _vm._s(item.solicitacao.paciente.numero_endereco) + ", " + _vm._s(item.solicitacao.paciente.bairro))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.municipio),
        expression: "ativos.municipio"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.cidade.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.unidade_solicitante),
        expression: "ativos.unidade_solicitante"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.subgrupo),
        expression: "ativos.subgrupo"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.procedimento.forma_organizacao.subgrupo.nome))])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.dataTable.data && _vm.dataTable.data.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-left"
  }, [_c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.getPDF(1)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Modelo 1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.getPDF(2)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Modelo 2")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.getPDF(3)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Modelo 3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.situacao),
      expression: "ativos.situacao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.situacao) ? _vm._i(_vm.ativos.situacao, null) > -1 : (_vm.ativos.situacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.situacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "situacao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "situacao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "situacao", $$c)
        }
      }
    }
  }), _vm._v("Situação ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.tipo),
      expression: "ativos.tipo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.tipo) ? _vm._i(_vm.ativos.tipo, null) > -1 : (_vm.ativos.tipo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.tipo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "tipo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "tipo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "tipo", $$c)
        }
      }
    }
  }), _vm._v("Tipo ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.data_realizacao),
      expression: "ativos.data_realizacao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.data_realizacao) ? _vm._i(_vm.ativos.data_realizacao, null) > -1 : (_vm.ativos.data_realizacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.data_realizacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "data_realizacao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "data_realizacao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "data_realizacao", $$c)
        }
      }
    }
  }), _vm._v("Data atendimento ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.paciente),
      expression: "ativos.paciente"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.paciente) ? _vm._i(_vm.ativos.paciente, null) > -1 : (_vm.ativos.paciente)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.paciente,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "paciente", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "paciente", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "paciente", $$c)
        }
      }
    }
  }), _vm._v("Paciente ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.rg),
      expression: "ativos.rg"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.rg) ? _vm._i(_vm.ativos.rg, null) > -1 : (_vm.ativos.rg)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.rg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "rg", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "rg", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "rg", $$c)
        }
      }
    }
  }), _vm._v("RG ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.cartao_sus),
      expression: "ativos.cartao_sus"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.cartao_sus) ? _vm._i(_vm.ativos.cartao_sus, null) > -1 : (_vm.ativos.cartao_sus)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.cartao_sus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "cartao_sus", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "cartao_sus", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "cartao_sus", $$c)
        }
      }
    }
  }), _vm._v("Cartão SUS ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.profissional),
      expression: "ativos.profissional"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.profissional) ? _vm._i(_vm.ativos.profissional, null) > -1 : (_vm.ativos.profissional)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.profissional,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "profissional", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "profissional", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "profissional", $$c)
        }
      }
    }
  }), _vm._v("Profissional ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.subgrupo),
      expression: "ativos.subgrupo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.subgrupo) ? _vm._i(_vm.ativos.subgrupo, null) > -1 : (_vm.ativos.subgrupo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.subgrupo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "subgrupo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "subgrupo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "subgrupo", $$c)
        }
      }
    }
  }), _vm._v("Subgrupo ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.data_nascimento),
      expression: "ativos.data_nascimento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.data_nascimento) ? _vm._i(_vm.ativos.data_nascimento, null) > -1 : (_vm.ativos.data_nascimento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.data_nascimento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "data_nascimento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "data_nascimento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "data_nascimento", $$c)
        }
      }
    }
  }), _vm._v("Data de nascimento ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.idade),
      expression: "ativos.idade"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.idade) ? _vm._i(_vm.ativos.idade, null) > -1 : (_vm.ativos.idade)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.idade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "idade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "idade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "idade", $$c)
        }
      }
    }
  }), _vm._v("Idade ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.procedimento),
      expression: "ativos.procedimento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.procedimento) ? _vm._i(_vm.ativos.procedimento, null) > -1 : (_vm.ativos.procedimento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.procedimento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "procedimento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "procedimento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "procedimento", $$c)
        }
      }
    }
  }), _vm._v("Procedimento ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.unidade_solicitante),
      expression: "ativos.unidade_solicitante"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.unidade_solicitante) ? _vm._i(_vm.ativos.unidade_solicitante, null) > -1 : (_vm.ativos.unidade_solicitante)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.unidade_solicitante,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "unidade_solicitante", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "unidade_solicitante", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "unidade_solicitante", $$c)
        }
      }
    }
  }), _vm._v("Unidade Solicitante ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.telefone),
      expression: "ativos.telefone"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.telefone) ? _vm._i(_vm.ativos.telefone, null) > -1 : (_vm.ativos.telefone)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.telefone,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "telefone", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "telefone", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "telefone", $$c)
        }
      }
    }
  }), _vm._v("Telefone ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.sexo),
      expression: "ativos.sexo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.sexo) ? _vm._i(_vm.ativos.sexo, null) > -1 : (_vm.ativos.sexo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.sexo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "sexo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "sexo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "sexo", $$c)
        }
      }
    }
  }), _vm._v("Sexo ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.endereco),
      expression: "ativos.endereco"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.endereco) ? _vm._i(_vm.ativos.endereco, null) > -1 : (_vm.ativos.endereco)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.endereco,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "endereco", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "endereco", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "endereco", $$c)
        }
      }
    }
  }), _vm._v("Endereço ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.municipio),
      expression: "ativos.municipio"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.municipio) ? _vm._i(_vm.ativos.municipio, null) > -1 : (_vm.ativos.municipio)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.municipio,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "municipio", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "municipio", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "municipio", $$c)
        }
      }
    }
  }), _vm._v("Município ")])])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Agenda do prestador")])])])
}]}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contratoSelecionado.unidade.nome),
      expression: "contratoSelecionado.unidade.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.contratoSelecionado.unidade.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contratoSelecionado.unidade, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo do Contrato")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("tipoContrato")(_vm.contratoSelecionado.tipo)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.contratoSelecionado.data_inicial)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("dataFormatada")(_vm.contratoSelecionado.data_final)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Limite Geral")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm._f("numberFormat")(_vm.contratoSelecionado.limite_geral, 2, ',', '.')
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group input-group-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.procedimentoSelecionado.nome),
      expression: "procedimentoSelecionado.nome"
    }],
    staticClass: "form-control",
    class: {
      'has-danger': _vm.$props.showTextDangerProcedimento
    },
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.procedimentoSelecionado.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.procedimentoSelecionado, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerProcedimento,
      'btn-default': !_vm.$props.showTextDangerProcedimento
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true, _vm.focoNomeProcedimentol()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    ref: "btnBuscarLimpar",
    staticClass: "btn btn-flat",
    class: {
      'btn-danger': _vm.$props.showTextDangerProcedimento,
      'btn-default': !_vm.$props.showTextDangerProcedimento
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Selecionar Procedimento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }, {
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['ctrl', 'b']),
      expression: "['ctrl', 'b']"
    }],
    ref: "inputProcedimento",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "title": "Pressione ctrl + b para pesquisar",
      "placeholder": "Pesquisa: Entre com o nome ou código do procedimento e pressione ctrl + b."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "shortkey": function($event) {
        _vm.getDataTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Aguarde, processando...")])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Tipo")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even hand",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          _vm.seleciona(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoAtendimento")(item.tipo_atendimento)))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n                ")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate_dist_locale_pt_BR__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate_dist_locale_pt_BR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vee_validate_dist_locale_pt_BR__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_dialog__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__routes__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_App_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_acl__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_acl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_acl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_interceptors__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_AppPlugin__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filters__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_sweetalert2__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_flash_message__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_flash_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_flash_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_airbnb_style_datepicker__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_airbnb_style_datepicker_dist_vue_airbnb_style_datepicker_min_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_airbnb_style_datepicker_dist_vue_airbnb_style_datepicker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_airbnb_style_datepicker_dist_vue_airbnb_style_datepicker_min_css__);

























__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_flash_message___default.a);
__webpack_require__(270);



var datepickerOptions = {
	sundayFirst: true,
	dateLabelFormat: 'dddd, MMMM D, YYYY',
	days: ['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'],
	daysShort: ['SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB', 'DOM'],
	monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
	colors: {
		selected: '#367fa9',
		inRange: '#00c0ef',
		selectedText: '#fff',
		text: '#565a5c',
		inRangeBorder: '#00acd6',
		disabled: '#fff'
	},
	texts: {
		apply: 'Ok',
		cancel: 'Cancelar',
		keyboardShortcuts: 'Atalhos de teclado'
	}
};
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_airbnb_style_datepicker__["a" /* default */], datepickerOptions);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_sweetalert2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* Validator */].localize('ptBR', __WEBPACK_IMPORTED_MODULE_6_vee_validate_dist_locale_pt_BR___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuejs_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__plugins_AppPlugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_19_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_acl__["AclInstaller"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__webpack_require__(279));
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* default */], {
	errorBagName: 'errors',
	fieldsBagName: 'fields',
	delay: 0,
	locale: 'ptBR',
	dictionary: null,
	strict: true,
	classes: false,
	classNames: {
		touched: 'touched',
		untouched: 'untouched',
		valid: 'is-success',
		invalid: 'is-danger',
		pristine: 'pristine',
		dirty: 'dirty' },
	events: 'input|blur',
	inject: true,
	validity: false,
	aria: true
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('laravue-pagination', __webpack_require__(271));

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router___default.a({
	routes: __WEBPACK_IMPORTED_MODULE_10__routes__["a" /* default */],
	mode: 'history',
	linkExactActiveClass: 'active',
	scrollBehavior: function scrollBehavior(to, from, savedPosition) {
		return savedPosition || { x: 0, y: 0 };
	}
});

router.beforeEach(function (to, from, next) {
	if (to.matched.some(function (record) {
		return record.meta.requiresAuth;
	})) {
		if (localStorage.getItem('token') && localStorage.getItem('token') != 'null') {
			next();
		} else {
			console.log('Not authenticated!');
			localStorage.setItem('route', to.path);
			localStorage.removeItem('token');
			localStorage.removeItem('user');
			next({ path: '/login' });
		}
	} else {
		next();
	}
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */], router);
if (window.localStorage) {
	var localUserString = window.localStorage.getItem('user') || 'null';
	var localUser = JSON.parse(localUserString);
	if (localUser && __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.user !== localUser) {
		__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('SET_USER', localUser);
		__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
	}
}

var permissoesIniciais = ['public'];
if (__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.user) {
	permissoesIniciais = ['public'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.user.permissoes));
}

var acl = new __WEBPACK_IMPORTED_MODULE_13_vue_acl__["AclCreate"]({
	initial: permissoesIniciais,
	notfound: '/error',
	router: router,
	acceptLocalRules: false
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
	useEslint: true,
	el: '#root',
	router: router,
	acl: acl,
	store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
	created: function created() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_interceptors__["a" /* default */])(this);
	},
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_12__components_App_vue___default.a);
	} });

/* harmony default export */ __webpack_exports__["default"] = acl;

/***/ })
],[905]);


// WEBPACK FOOTER //
// static/js/app.5f104345c2ee40c8d79b.js